
/** ********************** jquery ****************************** **/
 /*! jQuery v3.2.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.2.1",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null==a?f.call(this):a<0?this[a+this.length]:this[a]},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=Array.isArray(d)))?(e?(e=!1,f=c&&Array.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0&&("form"in a||"label"in a)},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+sa(o[h]);r=o.join(","),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return function(b){return"form"in b?b.parentNode&&b.disabled===!1?"label"in b?"label"in b.parentNode?b.parentNode.disabled===a:b.disabled===a:b.isDisabled===a||b.isDisabled!==!a&&ea(b)===a:b.disabled===a:"label"in b&&b.disabled===a}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}}):(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c,d,e,f=b.getElementById(a);if(f){if(c=f.getAttributeNode("id"),c&&c.value===a)return[f];e=b.getElementsByName(a),d=0;while(f=e[d++])if(c=f.getAttributeNode("id"),c&&c.value===a)return[f]}return[]}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+"").replace(ba,ca)},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[c<0?c+b:c]}),even:pa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e);return!1}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}return!1}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;d<e;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&ya(a.slice(i,e)),e<f&&ya(a=a.slice(e)),e<f&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,c,e){var f,i,j,k,l,m="function"==typeof a&&a,n=!e&&g(a=m.selector||a);if(c=c||[],1===n.length){if(i=n[0]=n[0].slice(0),i.length>2&&"ID"===(j=i[0]).type&&9===b.nodeType&&p&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(_,aa),b)||[])[0],!b)return c;m&&(b=b.parentNode),a=a.slice(i.shift().value.length)}f=V.needsContext.test(a)?0:i.length;while(f--){if(j=i[f],d.relative[k=j.type])break;if((l=d.find[k])&&(e=l(j.matches[0].replace(_,aa),$.test(i[0].type)&&qa(b.parentNode)||b))){if(i.splice(f,1),a=e.length&&sa(i),!a)return G.apply(c,e),c;break}}}return(m||h(a,n))(e,b,!p,c,!b||$.test(a)&&qa(b.parentNode)||b),c},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext;function B(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()}var C=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,D=/^.[^:#\[\.,]*$/;function E(a,b,c){return r.isFunction(b)?r.grep(a,function(a,d){return!!b.call(a,d,a)!==c}):b.nodeType?r.grep(a,function(a){return a===b!==c}):"string"!=typeof b?r.grep(a,function(a){return i.call(b,a)>-1!==c}):D.test(b)?r.filter(b,a,c):(b=r.filter(b,a),r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType}))}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(E(this,a||[],!1))},not:function(a){return this.pushStack(E(this,a||[],!0))},is:function(a){return!!E(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var F,G=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,H=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||F,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:G.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),C.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};H.prototype=r.fn,F=r(d);var I=/^(?:parents|prev(?:Until|All))/,J={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function K(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return K(a,"nextSibling")},prev:function(a){return K(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return B(a,"iframe")?a.contentDocument:(B(a,"template")&&(a=a.content||a),r.merge([],a.childNodes))}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(J[a]||r.uniqueSort(e),I.test(a)&&e.reverse()),this.pushStack(e)}});var L=/[^\x20\t\r\n\f]+/g;function M(a){var b={};return r.each(a.match(L)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?M(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=e||a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function N(a){return a}function O(a){throw a}function P(a,b,c,d){var e;try{a&&r.isFunction(e=a.promise)?e.call(a).done(b).fail(c):a&&r.isFunction(e=a.then)?e.call(a,b,c):b.apply(void 0,[a].slice(d))}catch(a){c.apply(void 0,[a])}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},"catch":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,N,e),g(f,c,O,e)):(f++,j.call(a,g(f,c,N,e),g(f,c,O,e),g(f,c,N,c.notifyWith))):(d!==N&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==O&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:N,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:N)),c[2][3].add(g(0,a,r.isFunction(d)?d:O))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(P(a,g.done(h(c)).resolve,g.reject,!b),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)P(e[c],h(c),g.reject);return g.promise()}});var Q=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&Q.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var R=r.Deferred();r.fn.ready=function(a){return R.then(a)["catch"](function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||R.resolveWith(d,[r]))}}),r.ready.then=R.then;function S(){d.removeEventListener("DOMContentLoaded",S),
a.removeEventListener("load",S),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",S),a.addEventListener("load",S));var T=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)T(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},U=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function V(){this.expando=r.expando+V.uid++}V.uid=1,V.prototype={cache:function(a){var b=a[this.expando];return b||(b={},U(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){Array.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(L)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var W=new V,X=new V,Y=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Z=/[A-Z]/g;function $(a){return"true"===a||"false"!==a&&("null"===a?null:a===+a+""?+a:Y.test(a)?JSON.parse(a):a)}function _(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Z,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c=$(c)}catch(e){}X.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return X.hasData(a)||W.hasData(a)},data:function(a,b,c){return X.access(a,b,c)},removeData:function(a,b){X.remove(a,b)},_data:function(a,b,c){return W.access(a,b,c)},_removeData:function(a,b){W.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=X.get(f),1===f.nodeType&&!W.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),_(f,d,e[d])));W.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){X.set(this,a)}):T(this,function(b){var c;if(f&&void 0===b){if(c=X.get(f,a),void 0!==c)return c;if(c=_(f,a),void 0!==c)return c}else this.each(function(){X.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){X.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=W.get(a,b),c&&(!d||Array.isArray(c)?d=W.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return W.get(a,c)||W.access(a,c,{empty:r.Callbacks("once memory").add(function(){W.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=W.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var aa=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ba=new RegExp("^(?:([+-])=|)("+aa+")([a-z%]*)$","i"),ca=["Top","Right","Bottom","Left"],da=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},ea=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function fa(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&ba.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ga={};function ha(a){var b,c=a.ownerDocument,d=a.nodeName,e=ga[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),ga[d]=e,e)}function ia(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=W.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&da(d)&&(e[f]=ha(d))):"none"!==c&&(e[f]="none",W.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ia(this,!0)},hide:function(){return ia(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){da(this)?r(this).show():r(this).hide()})}});var ja=/^(?:checkbox|radio)$/i,ka=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,la=/^$|\/(?:java|ecma)script/i,ma={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ma.optgroup=ma.option,ma.tbody=ma.tfoot=ma.colgroup=ma.caption=ma.thead,ma.th=ma.td;function na(a,b){var c;return c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[],void 0===b||b&&B(a,b)?r.merge([a],c):c}function oa(a,b){for(var c=0,d=a.length;c<d;c++)W.set(a[c],"globalEval",!b||W.get(b[c],"globalEval"))}var pa=/<|&#?\w+;/;function qa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(pa.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ka.exec(f)||["",""])[1].toLowerCase(),i=ma[h]||ma._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=na(l.appendChild(f),"script"),j&&oa(g),c){k=0;while(f=g[k++])la.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var ra=d.documentElement,sa=/^key/,ta=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,ua=/^([^.]*)(?:\.(.+)|)/;function va(){return!0}function wa(){return!1}function xa(){try{return d.activeElement}catch(a){}}function ya(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ya(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=wa;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(ra,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(L)||[""],j=b.length;while(j--)h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.hasData(a)&&W.get(a);if(q&&(i=q.events)){b=(b||"").match(L)||[""],j=b.length;while(j--)if(h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&W.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(W.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&!("click"===a.type&&a.button>=1))for(;j!==this;j=j.parentNode||this)if(1===j.nodeType&&("click"!==a.type||j.disabled!==!0)){for(f=[],g={},c=0;c<i;c++)d=b[c],e=d.selector+" ",void 0===g[e]&&(g[e]=d.needsContext?r(e,this).index(j)>-1:r.find(e,this,null,[j]).length),g[e]&&f.push(d);f.length&&h.push({elem:j,handlers:f})}return j=this,i<b.length&&h.push({elem:j,handlers:b.slice(i)}),h},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==xa()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===xa()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&B(this,"input"))return this.click(),!1},_default:function(a){return B(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?va:wa,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:wa,isPropagationStopped:wa,isImmediatePropagationStopped:wa,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=va,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=va,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=va,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&sa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ta.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return ya(this,a,b,c,d)},one:function(a,b,c,d){return ya(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=wa),this.each(function(){r.event.remove(this,a,c,b)})}});var za=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,Aa=/<script|<style|<link/i,Ba=/checked\s*(?:[^=]|=\s*.checked.)/i,Ca=/^true\/(.*)/,Da=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ea(a,b){return B(a,"table")&&B(11!==b.nodeType?b:b.firstChild,"tr")?r(">tbody",a)[0]||a:a}function Fa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Ga(a){var b=Ca.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Ha(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(W.hasData(a)&&(f=W.access(a),g=W.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}X.hasData(a)&&(h=X.access(a),i=r.extend({},h),X.set(b,i))}}function Ia(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ja.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ja(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&Ba.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ja(f,b,c,d)});if(m&&(e=qa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(na(e,"script"),Fa),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,na(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ga),l=0;l<i;l++)j=h[l],la.test(j.type||"")&&!W.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Da,""),k))}return a}function Ka(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(na(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&oa(na(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(za,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=na(h),f=na(a),d=0,e=f.length;d<e;d++)Ia(f[d],g[d]);if(b)if(c)for(f=f||na(a),g=g||na(h),d=0,e=f.length;d<e;d++)Ha(f[d],g[d]);else Ha(a,h);return g=na(h,"script"),g.length>0&&oa(g,!i&&na(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(U(c)){if(b=c[W.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[W.expando]=void 0}c[X.expando]&&(c[X.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ka(this,a,!0)},remove:function(a){return Ka(this,a)},text:function(a){return T(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.appendChild(a)}})},prepend:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(na(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return T(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!Aa.test(a)&&!ma[(ka.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(na(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ja(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(na(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var La=/^margin/,Ma=new RegExp("^("+aa+")(?!px)[a-z%]+$","i"),Na=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",ra.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,ra.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Oa(a,b,c){var d,e,f,g,h=a.style;return c=c||Na(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ma.test(g)&&La.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Pa(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Qa=/^(none|table(?!-c[ea]).+)/,Ra=/^--/,Sa={position:"absolute",visibility:"hidden",display:"block"},Ta={letterSpacing:"0",fontWeight:"400"},Ua=["Webkit","Moz","ms"],Va=d.createElement("div").style;function Wa(a){if(a in Va)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ua.length;while(c--)if(a=Ua[c]+b,a in Va)return a}function Xa(a){var b=r.cssProps[a];return b||(b=r.cssProps[a]=Wa(a)||a),b}function Ya(a,b,c){var d=ba.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Za(a,b,c,d,e){var f,g=0;for(f=c===(d?"border":"content")?4:"width"===b?1:0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+ca[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+ca[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+ca[f]+"Width",!0,e))):(g+=r.css(a,"padding"+ca[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+ca[f]+"Width",!0,e)));return g}function $a(a,b,c){var d,e=Na(a),f=Oa(a,b,e),g="border-box"===r.css(a,"boxSizing",!1,e);return Ma.test(f)?f:(d=g&&(o.boxSizingReliable()||f===a.style[b]),"auto"===f&&(f=a["offset"+b[0].toUpperCase()+b.slice(1)]),f=parseFloat(f)||0,f+Za(a,b,c||(g?"border":"content"),d,e)+"px")}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Oa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=Ra.test(b),j=a.style;return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:j[b]:(f=typeof c,"string"===f&&(e=ba.exec(c))&&e[1]&&(c=fa(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(j[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i?j.setProperty(b,c):j[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b),i=Ra.test(b);return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Oa(a,b,d)),"normal"===e&&b in Ta&&(e=Ta[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Qa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?$a(a,b,d):ea(a,Sa,function(){return $a(a,b,d)})},set:function(a,c,d){var e,f=d&&Na(a),g=d&&Za(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=ba.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Ya(a,c,g)}}}),r.cssHooks.marginLeft=Pa(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Oa(a,"marginLeft"))||a.getBoundingClientRect().left-ea(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+ca[d]+b]=f[d]||f[d-2]||f[0];return e}},La.test(a)||(r.cssHooks[a+b].set=Ya)}),r.fn.extend({css:function(a,b){return T(this,function(a,b,c){var d,e,f={},g=0;if(Array.isArray(b)){for(d=Na(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function _a(a,b,c,d,e){return new _a.prototype.init(a,b,c,d,e)}r.Tween=_a,_a.prototype={constructor:_a,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=_a.propHooks[this.prop];return a&&a.get?a.get(this):_a.propHooks._default.get(this)},run:function(a){var b,c=_a.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):_a.propHooks._default.set(this),this}},_a.prototype.init.prototype=_a.prototype,_a.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},_a.propHooks.scrollTop=_a.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=_a.prototype.init,r.fx.step={};var ab,bb,cb=/^(?:toggle|show|hide)$/,db=/queueHooks$/;function eb(){bb&&(d.hidden===!1&&a.requestAnimationFrame?a.requestAnimationFrame(eb):a.setTimeout(eb,r.fx.interval),r.fx.tick())}function fb(){return a.setTimeout(function(){ab=void 0}),ab=r.now()}function gb(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=ca[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function hb(a,b,c){for(var d,e=(kb.tweeners[b]||[]).concat(kb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&da(a),q=W.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],cb.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=W.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ia([a],!0),j=a.style.display||j,k=r.css(a,"display"),ia([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=W.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ia([a],!0),m.done(function(){p||ia([a]),W.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=hb(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],Array.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=kb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=ab||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(i||h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:ab||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);f<g;f++)if(d=kb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,hb,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j}r.Animation=r.extend(kb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return fa(c.elem,a,ba.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(L);for(var c,d=0,e=a.length;d<e;d++)c=a[d],kb.tweeners[c]=kb.tweeners[c]||[],kb.tweeners[c].unshift(b)},prefilters:[ib],prefilter:function(a,b){b?kb.prefilters.unshift(a):kb.prefilters.push(a)}}),r.speed=function(a,b,c){var d=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off?d.duration=0:"number"!=typeof d.duration&&(d.duration in r.fx.speeds?d.duration=r.fx.speeds[d.duration]:d.duration=r.fx.speeds._default),null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){r.isFunction(d.old)&&d.old.call(this),d.queue&&r.dequeue(this,d.queue)},d},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(da).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=kb(this,r.extend({},a),f);(e||W.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=W.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&db.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=W.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),r.each({slideDown:gb("show"),slideUp:gb("hide"),slideToggle:gb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(ab=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),ab=void 0},r.fx.timer=function(a){r.timers.push(a),r.fx.start()},r.fx.interval=13,r.fx.start=function(){bb||(bb=!0,eb())},r.fx.stop=function(){bb=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var lb,mb=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return T(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?lb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),
null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&B(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(L);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),lb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=mb[b]||r.find.attr;mb[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=mb[g],mb[g]=e,e=null!=c(a,b,d)?g:null,mb[g]=f),e}});var nb=/^(?:input|select|textarea|button)$/i,ob=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return T(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):nb.test(a.nodeName)||ob.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});function pb(a){var b=a.match(L)||[];return b.join(" ")}function qb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,qb(this)))});if("string"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&" "+pb(e)+" "){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=pb(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,qb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&" "+pb(e)+" "){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=pb(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,qb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(L)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=qb(this),b&&W.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":W.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+pb(qb(c))+" ").indexOf(b)>-1)return!0;return!1}});var rb=/\r/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":Array.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(rb,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:pb(r.text(a))}},select:{get:function(a){var b,c,d,e=a.options,f=a.selectedIndex,g="select-one"===a.type,h=g?null:[],i=g?f+1:e.length;for(d=f<0?i:g?f:0;d<i;d++)if(c=e[d],(c.selected||d===f)&&!c.disabled&&(!c.parentNode.disabled||!B(c.parentNode,"optgroup"))){if(b=r(c).val(),g)return b;h.push(b)}return h},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(Array.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var sb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!sb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,sb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(W.get(h,"events")||{})[b.type]&&W.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&U(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!U(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=W.access(d,b);e||d.addEventListener(a,c,!0),W.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=W.access(d,b)-1;e?W.access(d,b,e):(d.removeEventListener(a,c,!0),W.remove(d,b))}}});var tb=a.location,ub=r.now(),vb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var wb=/\[\]$/,xb=/\r?\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(Array.isArray(b))r.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)Ab(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(Array.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!ja.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:Array.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(xb,"\r\n")}}):{name:b.name,value:c.replace(xb,"\r\n")}}).get()}});var Bb=/%20/g,Cb=/#.*$/,Db=/([?&])_=[^&]*/,Eb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Fb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Gb=/^(?:GET|HEAD)$/,Hb=/^\/\//,Ib={},Jb={},Kb="*/".concat("*"),Lb=d.createElement("a");Lb.href=tb.href;function Mb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(L)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Nb(a,b,c,d){var e={},f=a===Jb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Ob(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Pb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Qb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:tb.href,type:"GET",isLocal:Fb.test(tb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Kb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Ob(Ob(a,r.ajaxSettings),b):Ob(r.ajaxSettings,a)},ajaxPrefilter:Mb(Ib),ajaxTransport:Mb(Jb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Eb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||tb.href)+"").replace(Hb,tb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(L)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Lb.protocol+"//"+Lb.host!=j.protocol+"//"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Nb(Ib,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Gb.test(o.type),f=o.url.replace(Cb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(Bb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(vb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Db,"$1"),n=(vb.test(f)?"&":"?")+"_="+ub++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Kb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Nb(Jb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,"No Transport");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Pb(o,y,d)),v=Qb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Rb={0:200,1223:204},Sb=r.ajaxSettings.xhr();o.cors=!!Sb&&"withCredentials"in Sb,o.ajax=Sb=!!Sb,r.ajaxTransport(function(b){var c,d;if(o.cors||Sb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Rb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Tb=[],Ub=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Tb.pop()||r.expando+"_"+ub++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Ub.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ub.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Ub,"$1"+e):b.jsonp!==!1&&(b.url+=(vb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Tb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=C.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=qa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=pb(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length},r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),b=f.ownerDocument,c=b.documentElement,e=b.defaultView,{top:d.top+e.pageYOffset-c.clientTop,left:d.left+e.pageXOffset-c.clientLeft}):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),B(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||ra})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return T(this,function(a,d,e){var f;return r.isWindow(a)?f=a:9===a.nodeType&&(f=a.defaultView),void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Pa(o.pixelPosition,function(a,c){if(c)return c=Oa(a,b),Ma.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return T(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.holdReady=function(a){a?r.readyWait++:r.ready(!0)},r.isArray=Array.isArray,r.parseJSON=JSON.parse,r.nodeName=B,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Vb=a.jQuery,Wb=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Wb),b&&a.jQuery===r&&(a.jQuery=Vb),r},b||(a.jQuery=a.$=r),r});
 
/** **************************************************** **/
/** ********************** jquery.cookie ****************************** **/
 /*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));
 
/** **************************************************** **/
/** ********************** jquery-mask-plugin ****************************** **/
 // jQuery Mask Plugin v1.14.0
// github.com/igorescobar/jQuery-Mask-Plugin
(function(b){"function"===typeof define&&define.amd?define(["jquery"],b):"object"===typeof exports?module.exports=b(require("jquery")):b(jQuery||Zepto)})(function(b){var y=function(a,e,d){var c={invalid:[],getCaret:function(){try{var r,b=0,e=a.get(0),d=document.selection,f=e.selectionStart;if(d&&-1===navigator.appVersion.indexOf("MSIE 10"))r=d.createRange(),r.moveStart("character",-c.val().length),b=r.text.length;else if(f||"0"===f)b=f;return b}catch(g){}},setCaret:function(r){try{if(a.is(":focus")){var c,
b=a.get(0);b.setSelectionRange?(b.focus(),b.setSelectionRange(r,r)):(c=b.createTextRange(),c.collapse(!0),c.moveEnd("character",r),c.moveStart("character",r),c.select())}}catch(e){}},events:function(){a.on("keydown.mask",function(c){a.data("mask-keycode",c.keyCode||c.which)}).on(b.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){a.keydown().keyup()},100)}).on("change.mask",function(){a.data("changed",!0)}).on("blur.mask",function(){n===
c.val()||a.data("changed")||a.trigger("change");a.data("changed",!1)}).on("blur.mask",function(){n=c.val()}).on("focus.mask",function(a){!0===d.selectOnFocus&&b(a.target).select()}).on("focusout.mask",function(){d.clearIfNotMatch&&!p.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],c,b,d,f,l=0;l<e.length;l++)(c=g.translation[e.charAt(l)])?(b=c.pattern.toString().replace(/.{1}$|^.{1}/g,""),d=c.optional,(c=c.recursive)?(a.push(e.charAt(l)),f={digit:e.charAt(l),pattern:b}):a.push(d||
c?b+"?":b)):a.push(e.charAt(l).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");f&&(a=a.replace(new RegExp("("+f.digit+"(.*"+f.digit+")?)"),"($1)?").replace(new RegExp(f.digit,"g"),f.pattern));return new RegExp(a)},destroyEvents:function(){a.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(c){var b=a.is("input")?"val":"text";if(0<arguments.length){if(a[b]()!==c)a[b](c);b=a}else b=a[b]();return b},getMCharsBeforeCount:function(a,c){for(var b=0,d=0,
f=e.length;d<f&&d<a;d++)g.translation[e.charAt(d)]||(a=c?a+1:a,b++);return b},caretPos:function(a,b,d,h){return g.translation[e.charAt(Math.min(a-1,e.length-1))]?Math.min(a+d-b-h,d):c.caretPos(a+1,b,d,h)},behaviour:function(d){d=d||window.event;c.invalid=[];var e=a.data("mask-keycode");if(-1===b.inArray(e,g.byPassKeys)){var m=c.getCaret(),h=c.val().length,f=c.getMasked(),l=f.length,k=c.getMCharsBeforeCount(l-1)-c.getMCharsBeforeCount(h-1),n=m<h;c.val(f);n&&(8!==e&&46!==e&&(m=c.caretPos(m,h,l,k)),
c.setCaret(m));return c.callbacks(d)}},getMasked:function(a,b){var m=[],h=void 0===b?c.val():b+"",f=0,l=e.length,k=0,n=h.length,q=1,p="push",u=-1,t,w;d.reverse?(p="unshift",q=-1,t=0,f=l-1,k=n-1,w=function(){return-1<f&&-1<k}):(t=l-1,w=function(){return f<l&&k<n});for(;w();){var x=e.charAt(f),v=h.charAt(k),s=g.translation[x];if(s)v.match(s.pattern)?(m[p](v),s.recursive&&(-1===u?u=f:f===t&&(f=u-q),t===u&&(f-=q)),f+=q):s.optional?(f+=q,k-=q):s.fallback?(m[p](s.fallback),f+=q,k-=q):c.invalid.push({p:k,
v:v,e:s.pattern}),k+=q;else{if(!a)m[p](x);v===x&&(k+=q);f+=q}}h=e.charAt(t);l!==n+1||g.translation[h]||m.push(h);return m.join("")},callbacks:function(b){var g=c.val(),m=g!==n,h=[g,b,a,d],f=function(a,b,c){"function"===typeof d[a]&&b&&d[a].apply(this,c)};f("onChange",!0===m,h);f("onKeyPress",!0===m,h);f("onComplete",g.length===e.length,h);f("onInvalid",0<c.invalid.length,[g,b,a,c.invalid,d])}};a=b(a);var g=this,n=c.val(),p;e="function"===typeof e?e(c.val(),void 0,a,d):e;g.mask=e;g.options=d;g.remove=
function(){var b=c.getCaret();c.destroyEvents();c.val(g.getCleanVal());c.setCaret(b-c.getMCharsBeforeCount(b));return a};g.getCleanVal=function(){return c.getMasked(!0)};g.getMaskedVal=function(a){return c.getMasked(!1,a)};g.init=function(e){e=e||!1;d=d||{};g.clearIfNotMatch=b.jMaskGlobals.clearIfNotMatch;g.byPassKeys=b.jMaskGlobals.byPassKeys;g.translation=b.extend({},b.jMaskGlobals.translation,d.translation);g=b.extend(!0,{},g,d);p=c.getRegexMask();!1===e?(d.placeholder&&a.attr("placeholder",d.placeholder),
a.data("mask")&&a.attr("autocomplete","off"),c.destroyEvents(),c.events(),e=c.getCaret(),c.val(c.getMasked()),c.setCaret(e+c.getMCharsBeforeCount(e,!0))):(c.events(),c.val(c.getMasked()))};g.init(!a.is("input"))};b.maskWatchers={};var A=function(){var a=b(this),e={},d=a.attr("data-mask");a.attr("data-mask-reverse")&&(e.reverse=!0);a.attr("data-mask-clearifnotmatch")&&(e.clearIfNotMatch=!0);"true"===a.attr("data-mask-selectonfocus")&&(e.selectOnFocus=!0);if(z(a,d,e))return a.data("mask",new y(this,
d,e))},z=function(a,e,d){d=d||{};var c=b(a).data("mask"),g=JSON.stringify;a=b(a).val()||b(a).text();try{return"function"===typeof e&&(e=e(a)),"object"!==typeof c||g(c.options)!==g(d)||c.mask!==e}catch(n){}};b.fn.mask=function(a,e){e=e||{};var d=this.selector,c=b.jMaskGlobals,g=c.watchInterval,c=e.watchInputs||c.watchInputs,n=function(){if(z(this,a,e))return b(this).data("mask",new y(this,a,e))};b(this).each(n);d&&""!==d&&c&&(clearInterval(b.maskWatchers[d]),b.maskWatchers[d]=setInterval(function(){b(document).find(d).each(n)},
g));return this};b.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};b.fn.unmask=function(){clearInterval(b.maskWatchers[this.selector]);delete b.maskWatchers[this.selector];return this.each(function(){var a=b(this).data("mask");a&&a.remove().removeData("mask")})};b.fn.cleanVal=function(){return this.data("mask").getCleanVal()};b.applyDataMask=function(a){a=a||b.jMaskGlobals.maskElements;(a instanceof b?a:b(a)).filter(b.jMaskGlobals.dataMaskAttr).each(A)};var p={maskElements:"input,td,span,div",
dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:function(a){var b=document.createElement("div"),d;a="on"+a;d=a in b;d||(b.setAttribute(a,"return;"),d="function"===typeof b[a]);return d}("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},S:{pattern:/[a-zA-Z]/}}};b.jMaskGlobals=b.jMaskGlobals||{};p=b.jMaskGlobals=b.extend(!0,{},p,b.jMaskGlobals);
p.dataMask&&b.applyDataMask();setInterval(function(){b.jMaskGlobals.watchDataMask&&b.applyDataMask()},p.watchInterval)});
 
/** **************************************************** **/
/** ********************** jquery-datepicker ****************************** **/
 /*! jQuery UI - v1.11.4 - 2016-06-28
* http://jqueryui.com
* Includes: core.js, datepicker.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
(function(e){typeof define=="function"&&define.amd?define(["jquery"],e):e(jQuery)})(function(e){function t(t,r){var i,s,o,u=t.nodeName.toLowerCase();return"area"===u?(i=t.parentNode,s=i.name,!t.href||!s||i.nodeName.toLowerCase()!=="map"?!1:(o=e("img[usemap='#"+s+"']")[0],!!o&&n(o))):(/^(input|select|textarea|button|object)$/.test(u)?!t.disabled:"a"===u?t.href||r:r)&&n(t)}function n(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return e.css(this,"visibility")==="hidden"}).length}function i(e){var t,n;while(e.length&&e[0]!==document){t=e.css("position");if(t==="absolute"||t==="relative"||t==="fixed"){n=parseInt(e.css("zIndex"),10);if(!isNaN(n)&&n!==0)return n}e=e.parent()}return 0}function s(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[""]),this.regional.en=e.extend(!0,{},this.regional[""]),this.regional["en-US"]=e.extend(!0,{},this.regional.en),this.dpDiv=o(e("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function o(t){var n="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.delegate(n,"mouseout",function(){e(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).removeClass("ui-datepicker-next-hover")}).delegate(n,"mouseover",u)}function u(){e.datepicker._isDisabledDatepicker(r.inline?r.dpDiv.parent()[0]:r.input[0])||(e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),e(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).addClass("ui-datepicker-next-hover"))}function a(t,n){e.extend(t,n);for(var r in n)n[r]==null&&(t[r]=n[r]);return t}e.ui=e.ui||{},e.extend(e.ui,{version:"1.11.4",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({scrollParent:function(t){var n=this.css("position"),r=n==="absolute",i=t?/(auto|scroll|hidden)/:/(auto|scroll)/,s=this.parents().filter(function(){var t=e(this);return r&&t.css("position")==="static"?!1:i.test(t.css("overflow")+t.css("overflow-y")+t.css("overflow-x"))}).eq(0);return n==="fixed"||!s.length?e(this[0].ownerDocument||document):s},uniqueId:function(){var e=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++e)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(n){return!!e.data(n,t)}}):function(t,n,r){return!!e.data(t,r[3])},focusable:function(n){return t(n,!isNaN(e.attr(n,"tabindex")))},tabbable:function(n){var r=e.attr(n,"tabindex"),i=isNaN(r);return(i||r>=0)&&t(n,!i)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(t,n){function o(t,n,i,s){return e.each(r,function(){n-=parseFloat(e.css(t,"padding"+this))||0,i&&(n-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(n-=parseFloat(e.css(t,"margin"+this))||0)}),n}var r=n==="Width"?["Left","Right"]:["Top","Bottom"],i=n.toLowerCase(),s={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+n]=function(t){return t===undefined?s["inner"+n].call(this):this.each(function(){e(this).css(i,o(this,t)+"px")})},e.fn["outer"+n]=function(t,r){return typeof t!="number"?s["outer"+n].call(this,t):this.each(function(){e(this).css(i,o(this,t,!0,r)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(e==null?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(n){return arguments.length?t.call(this,e.camelCase(n)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.fn.extend({focus:function(t){return function(n,r){return typeof n=="number"?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),r&&r.call(t)},n)}):t.apply(this,arguments)}}(e.fn.focus),disableSelection:function(){var e="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.bind(e+".ui-disableSelection",function(e){e.preventDefault()})}}(),enableSelection:function(){return this.unbind(".ui-disableSelection")},zIndex:function(t){if(t!==undefined)return this.css("zIndex",t);if(this.length){var n=e(this[0]),r,i;while(n.length&&n[0]!==document){r=n.css("position");if(r==="absolute"||r==="relative"||r==="fixed"){i=parseInt(n.css("zIndex"),10);if(!isNaN(i)&&i!==0)return i}n=n.parent()}}return 0}}),e.ui.plugin={add:function(t,n,r){var i,s=e.ui[t].prototype;for(i in r)s.plugins[i]=s.plugins[i]||[],s.plugins[i].push([n,r[i]])},call:function(e,t,n,r){var i,s=e.plugins[t];if(!s)return;if(!r&&(!e.element[0].parentNode||e.element[0].parentNode.nodeType===11))return;for(i=0;i<s.length;i++)e.options[s[i][0]]&&s[i][1].apply(e.element,n)}},e.extend(e.ui,{datepicker:{version:"1.11.4"}});var r;e.extend(s.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return a(this._defaults,e||{}),this},_attachDatepicker:function(t,n){var r,i,s;r=t.nodeName.toLowerCase(),i=r==="div"||r==="span",t.id||(this.uuid+=1,t.id="dp"+this.uuid),s=this._newInst(e(t),i),s.settings=e.extend({},n||{}),r==="input"?this._connectDatepicker(t,s):i&&this._inlineDatepicker(t,s)},_newInst:function(t,n){var r=t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:r,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:n,dpDiv:n?o(e("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,n){var r=e(t);n.append=e([]),n.trigger=e([]);if(r.hasClass(this.markerClassName))return;this._attachments(r,n),r.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(n),e.data(t,"datepicker",n),n.settings.disabled&&this._disableDatepicker(t)},_attachments:function(t,n){var r,i,s,o=this._get(n,"appendText"),u=this._get(n,"isRTL");n.append&&n.append.remove(),o&&(n.append=e("<span class='"+this._appendClass+"'>"+o+"</span>"),t[u?"before":"after"](n.append)),t.unbind("focus",this._showDatepicker),n.trigger&&n.trigger.remove(),r=this._get(n,"showOn"),(r==="focus"||r==="both")&&t.focus(this._showDatepicker);if(r==="button"||r==="both")i=this._get(n,"buttonText"),s=this._get(n,"buttonImage"),n.trigger=e(this._get(n,"buttonImageOnly")?e("<img/>").addClass(this._triggerClass).attr({src:s,alt:i,title:i}):e("<button type='button'></button>").addClass(this._triggerClass).html(s?e("<img/>").attr({src:s,alt:i,title:i}):i)),t[u?"before":"after"](n.trigger),n.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1})},_autoSize:function(e){if(this._get(e,"autoSize")&&!e.inline){var t,n,r,i,s=new Date(2009,11,20),o=this._get(e,"dateFormat");o.match(/[DM]/)&&(t=function(e){n=0,r=0;for(i=0;i<e.length;i++)e[i].length>n&&(n=e[i].length,r=i);return r},s.setMonth(t(this._get(e,o.match(/MM/)?"monthNames":"monthNamesShort"))),s.setDate(t(this._get(e,o.match(/DD/)?"dayNames":"dayNamesShort"))+20-s.getDay())),e.input.attr("size",this._formatDate(e,s).length)}},_inlineDatepicker:function(t,n){var r=e(t);if(r.hasClass(this.markerClassName))return;r.addClass(this.markerClassName).append(n.dpDiv),e.data(t,"datepicker",n),this._setDate(n,this._getDefaultDate(n),!0),this._updateDatepicker(n),this._updateAlternate(n),n.settings.disabled&&this._disableDatepicker(t),n.dpDiv.css("display","block")},_dialogDatepicker:function(t,n,r,i,s){var o,u,f,l,c,h=this._dialogInst;return h||(this.uuid+=1,o="dp"+this.uuid,this._dialogInput=e("<input type='text' id='"+o+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),e("body").append(this._dialogInput),h=this._dialogInst=this._newInst(this._dialogInput,!1),h.settings={},e.data(this._dialogInput[0],"datepicker",h)),a(h.settings,i||{}),n=n&&n.constructor===Date?this._formatDate(h,n):n,this._dialogInput.val(n),this._pos=s?s.length?s:[s.pageX,s.pageY]:null,this._pos||(u=document.documentElement.clientWidth,f=document.documentElement.clientHeight,l=document.documentElement.scrollLeft||document.body.scrollLeft,c=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[u/2-100+l,f/2-150+c]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),h.settings.onSelect=r,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],"datepicker",h),this},_destroyDatepicker:function(t){var n,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase(),e.removeData(t,"datepicker"),n==="input"?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):(n==="div"||n==="span")&&i.removeClass(this.markerClassName).empty(),r===s&&(r=null)},_enableDatepicker:function(t){var n,r,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase();if(n==="input")t.disabled=!1,s.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""});else if(n==="div"||n==="span")r=i.children("."+this._inlineClass),r.children().removeClass("ui-state-disabled"),r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e})},_disableDatepicker:function(t){var n,r,i=e(t),s=e.data(t,"datepicker");if(!i.hasClass(this.markerClassName))return;n=t.nodeName.toLowerCase();if(n==="input")t.disabled=!0,s.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"});else if(n==="div"||n==="span")r=i.children("."+this._inlineClass),r.children().addClass("ui-state-disabled"),r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;t<this._disabledInputs.length;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,"datepicker")}catch(n){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(t,n,r){var i,s,o,u,f=this._getInst(t);if(arguments.length===2&&typeof n=="string")return n==="defaults"?e.extend({},e.datepicker._defaults):f?n==="all"?e.extend({},f.settings):this._get(f,n):null;i=n||{},typeof n=="string"&&(i={},i[n]=r),f&&(this._curInst===f&&this._hideDatepicker(),s=this._getDateDatepicker(t,!0),o=this._getMinMaxDate(f,"min"),u=this._getMinMaxDate(f,"max"),a(f.settings,i),o!==null&&i.dateFormat!==undefined&&i.minDate===undefined&&(f.settings.minDate=this._formatDate(f,o)),u!==null&&i.dateFormat!==undefined&&i.maxDate===undefined&&(f.settings.maxDate=this._formatDate(f,u)),"disabled"in i&&(i.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(e(t),f),this._autoSize(f),this._setDate(f,s),this._updateAlternate(f),this._updateDatepicker(f))},_changeDatepicker:function(e,t,n){this._optionDatepicker(e,t,n)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var n=this._getInst(e);n&&(this._setDate(n,t),this._updateDatepicker(n),this._updateAlternate(n))},_getDateDatepicker:function(e,t){var n=this._getInst(e);return n&&!n.inline&&this._setDateFromField(n,t),n?this._getDate(n):null},_doKeyDown:function(t){var n,r,i,s=e.datepicker._getInst(t.target),o=!0,u=s.dpDiv.is(".ui-datepicker-rtl");s._keyEvent=!0;if(e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),o=!1;break;case 13:return i=e("td."+e.datepicker._dayOverClass+":not(."+e.datepicker._currentClass+")",s.dpDiv),i[0]&&e.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),n=e.datepicker._get(s,"onSelect"),n?(r=e.datepicker._formatDate(s),n.apply(s.input?s.input[0]:null,[r,s])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),o=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),o=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?1:-1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,"D"),o=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?-1:1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,"D"),o=t.ctrlKey||t.metaKey;break;default:o=!1}else t.keyCode===36&&t.ctrlKey?e.datepicker._showDatepicker(this):o=!1;o&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var n,r,i=e.datepicker._getInst(t.target);if(e.datepicker._get(i,"constrainInput"))return n=e.datepicker._possibleChars(e.datepicker._get(i,"dateFormat")),r=String.fromCharCode(t.charCode==null?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||r<" "||!n||n.indexOf(r)>-1},_doKeyUp:function(t){var n,r=e.datepicker._getInst(t.target);if(r.input.val()!==r.lastVal)try{n=e.datepicker.parseDate(e.datepicker._get(r,"dateFormat"),r.input?r.input.val():null,e.datepicker._getFormatConfig(r)),n&&(e.datepicker._setDateFromField(r),e.datepicker._updateAlternate(r),e.datepicker._updateDatepicker(r))}catch(i){}return!0},_showDatepicker:function(t){t=t.target||t,t.nodeName.toLowerCase()!=="input"&&(t=e("input",t.parentNode)[0]);if(e.datepicker._isDisabledDatepicker(t)||e.datepicker._lastInput===t)return;var n,r,s,o,u,f,l;n=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==n&&(e.datepicker._curInst.dpDiv.stop(!0,!0),n&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),r=e.datepicker._get(n,"beforeShow"),s=r?r.apply(t,[t,n]):{};if(s===!1)return;a(n.settings,s),n.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(n),e.datepicker._inDialog&&(t.value=""),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),o=!1,e(t).parents().each(function(){return o|=e(this).css("position")==="fixed",!o}),u={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),e.datepicker._updateDatepicker(n),u=e.datepicker._checkOffset(n,u,o),n.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?"static":o?"fixed":"absolute",display:"none",left:u.left+"px",top:u.top+"px"}),n.inline||(f=e.datepicker._get(n,"showAnim"),l=e.datepicker._get(n,"duration"),n.dpDiv.css("z-index",i(e(t))+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[f]?n.dpDiv.show(f,e.datepicker._get(n,"showOptions"),l):n.dpDiv[f||"show"](f?l:null),e.datepicker._shouldFocusInput(n)&&n.input.focus(),e.datepicker._curInst=n)},_updateDatepicker:function(t){this.maxRows=4,r=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var n,i=this._getNumberOfMonths(t),s=i[1],o=17,a=t.dpDiv.find("."+this._dayOverClass+" a");a.length>0&&u.apply(a.get(0)),t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),s>1&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",o*s+"em"),t.dpDiv[(i[0]!==1||i[1]!==1?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&e.datepicker._shouldFocusInput(t)&&t.input.focus(),t.yearshtml&&(n=t.yearshtml,setTimeout(function(){n===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml),n=t.yearshtml=null},0))},_shouldFocusInput:function(e){return e.input&&e.input.is(":visible")&&!e.input.is(":disabled")&&!e.input.is(":focus")},_checkOffset:function(t,n,r){var i=t.dpDiv.outerWidth(),s=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,u=t.input?t.input.outerHeight():0,a=document.documentElement.clientWidth+(r?0:e(document).scrollLeft()),f=document.documentElement.clientHeight+(r?0:e(document).scrollTop());return n.left-=this._get(t,"isRTL")?i-o:0,n.left-=r&&n.left===t.input.offset().left?e(document).scrollLeft():0,n.top-=r&&n.top===t.input.offset().top+u?e(document).scrollTop():0,n.left-=Math.min(n.left,n.left+i>a&&a>i?Math.abs(n.left+i-a):0),n.top-=Math.min(n.top,n.top+s>f&&f>s?Math.abs(s+u):0),n},_findPos:function(t){var n,r=this._getInst(t),i=this._get(r,"isRTL");while(t&&(t.type==="hidden"||t.nodeType!==1||e.expr.filters.hidden(t)))t=t[i?"previousSibling":"nextSibling"];return n=e(t).offset(),[n.left,n.top]},_hideDatepicker:function(t){var n,r,i,s,o=this._curInst;if(!o||t&&o!==e.data(t,"datepicker"))return;this._datepickerShowing&&(n=this._get(o,"showAnim"),r=this._get(o,"duration"),i=function(){e.datepicker._tidyDialog(o)},e.effects&&(e.effects.effect[n]||e.effects[n])?o.dpDiv.hide(n,e.datepicker._get(o,"showOptions"),r,i):o.dpDiv[n==="slideDown"?"slideUp":n==="fadeIn"?"fadeOut":"hide"](n?r:null,i),n||i(),this._datepickerShowing=!1,s=this._get(o,"onClose"),s&&s.apply(o.input?o.input[0]:null,[o.input?o.input.val():"",o]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),e.blockUI&&(e.unblockUI(),e("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(t){if(!e.datepicker._curInst)return;var n=e(t.target),r=e.datepicker._getInst(n[0]);(n[0].id!==e.datepicker._mainDivId&&n.parents("#"+e.datepicker._mainDivId).length===0&&!n.hasClass(e.datepicker.markerClassName)&&!n.closest("."+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||n.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==r)&&e.datepicker._hideDatepicker()},_adjustDate:function(t,n,r){var i=e(t),s=this._getInst(i[0]);if(this._isDisabledDatepicker(i[0]))return;this._adjustInstDate(s,n+(r==="M"?this._get(s,"showCurrentAtPos"):0),r),this._updateDatepicker(s)},_gotoToday:function(t){var n,r=e(t),i=this._getInst(r[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(n=new Date,i.selectedDay=n.getDate(),i.drawMonth=i.selectedMonth=n.getMonth(),i.drawYear=i.selectedYear=n.getFullYear()),this._notifyChange(i),this._adjustDate(r)},_selectMonthYear:function(t,n,r){var i=e(t),s=this._getInst(i[0]);s["selected"+(r==="M"?"Month":"Year")]=s["draw"+(r==="M"?"Month":"Year")]=parseInt(n.options[n.selectedIndex].value,10),this._notifyChange(s),this._adjustDate(i)},_selectDay:function(t,n,r,i){var s,o=e(t);if(e(i).hasClass(this._unselectableClass)||this._isDisabledDatepicker(o[0]))return;s=this._getInst(o[0]),s.selectedDay=s.currentDay=e("a",i).html(),s.selectedMonth=s.currentMonth=n,s.selectedYear=s.currentYear=r,this._selectDate(t,this._formatDate(s,s.currentDay,s.currentMonth,s.currentYear))},_clearDate:function(t){var n=e(t);this._selectDate(n,"")},_selectDate:function(t,n){var r,i=e(t),s=this._getInst(i[0]);n=n!=null?n:this._formatDate(s),s.input&&s.input.val(n),this._updateAlternate(s),r=this._get(s,"onSelect"),r?r.apply(s.input?s.input[0]:null,[n,s]):s.input&&s.input.trigger("change"),s.inline?this._updateDatepicker(s):(this._hideDatepicker(),this._lastInput=s.input[0],typeof s.input[0]!="object"&&s.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var n,r,i,s=this._get(t,"altField");s&&(n=this._get(t,"altFormat")||this._get(t,"dateFormat"),r=this._getDate(t),i=this.formatDate(n,r,this._getFormatConfig(t)),e(s).each(function(){e(this).val(i)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&t<6,""]},iso8601Week:function(e){var t,n=new Date(e.getTime());return n.setDate(n.getDate()+4-(n.getDay()||7)),t=n.getTime(),n.setMonth(0),n.setDate(1),Math.floor(Math.round((t-n)/864e5)/7)+1},parseDate:function(t,n,r){if(t==null||n==null)throw"Invalid arguments";n=typeof n=="object"?n.toString():n+"";if(n==="")return null;var i,s,o,u=0,a=(r?r.shortYearCutoff:null)||this._defaults.shortYearCutoff,f=typeof a!="string"?a:(new Date).getFullYear()%100+parseInt(a,10),l=(r?r.dayNamesShort:null)||this._defaults.dayNamesShort,c=(r?r.dayNames:null)||this._defaults.dayNames,h=(r?r.monthNamesShort:null)||this._defaults.monthNamesShort,p=(r?r.monthNames:null)||this._defaults.monthNames,d=-1,v=-1,m=-1,g=-1,y=!1,b,w=function(e){var n=i+1<t.length&&t.charAt(i+1)===e;return n&&i++,n},E=function(e){var t=w(e),r=e==="@"?14:e==="!"?20:e==="y"&&t?4:e==="o"?3:2,i=e==="y"?r:1,s=new RegExp("^\\d{"+i+","+r+"}"),o=n.substring(u).match(s);if(!o)throw"Missing number at position "+u;return u+=o[0].length,parseInt(o[0],10)},S=function(t,r,i){var s=-1,o=e.map(w(t)?i:r,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});e.each(o,function(e,t){var r=t[1];if(n.substr(u,r.length).toLowerCase()===r.toLowerCase())return s=t[0],u+=r.length,!1});if(s!==-1)return s+1;throw"Unknown name at position "+u},x=function(){if(n.charAt(u)!==t.charAt(i))throw"Unexpected literal at position "+u;u++};for(i=0;i<t.length;i++)if(y)t.charAt(i)==="'"&&!w("'")?y=!1:x();else switch(t.charAt(i)){case"d":m=E("d");break;case"D":S("D",l,c);break;case"o":g=E("o");break;case"m":v=E("m");break;case"M":v=S("M",h,p);break;case"y":d=E("y");break;case"@":b=new Date(E("@")),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"!":b=new Date((E("!")-this._ticksTo1970)/1e4),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"'":w("'")?x():y=!0;break;default:x()}if(u<n.length){o=n.substr(u);if(!/^\s+/.test(o))throw"Extra/unparsed characters found in date: "+o}d===-1?d=(new Date).getFullYear():d<100&&(d+=(new Date).getFullYear()-(new Date).getFullYear()%100+(d<=f?0:-100));if(g>-1){v=1,m=g;do{s=this._getDaysInMonth(d,v-1);if(m<=s)break;v++,m-=s}while(!0)}b=this._daylightSavingAdjust(new Date(d,v-1,m));if(b.getFullYear()!==d||b.getMonth()+1!==v||b.getDate()!==m)throw"Invalid date";return b},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*24*60*60*1e7,formatDate:function(e,t,n){if(!t)return"";var r,i=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,s=(n?n.dayNames:null)||this._defaults.dayNames,o=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,u=(n?n.monthNames:null)||this._defaults.monthNames,a=function(t){var n=r+1<e.length&&e.charAt(r+1)===t;return n&&r++,n},f=function(e,t,n){var r=""+t;if(a(e))while(r.length<n)r="0"+r;return r},l=function(e,t,n,r){return a(e)?r[t]:n[t]},c="",h=!1;if(t)for(r=0;r<e.length;r++)if(h)e.charAt(r)==="'"&&!a("'")?h=!1:c+=e.charAt(r);else switch(e.charAt(r)){case"d":c+=f("d",t.getDate(),2);break;case"D":c+=l("D",t.getDay(),i,s);break;case"o":c+=f("o",Math.round(((new Date(t.getFullYear(),t.getMonth(),t.getDate())).getTime()-(new Date(t.getFullYear(),0,0)).getTime())/864e5),3);break;case"m":c+=f("m",t.getMonth()+1,2);break;case"M":c+=l("M",t.getMonth(),o,u);break;case"y":c+=a("y")?t.getFullYear():(t.getYear()%100<10?"0":"")+t.getYear()%100;break;case"@":c+=t.getTime();break;case"!":c+=t.getTime()*1e4+this._ticksTo1970;break;case"'":a("'")?c+="'":h=!0;break;default:c+=e.charAt(r)}return c},_possibleChars:function(e){var t,n="",r=!1,i=function(n){var r=t+1<e.length&&e.charAt(t+1)===n;return r&&t++,r};for(t=0;t<e.length;t++)if(r)e.charAt(t)==="'"&&!i("'")?r=!1:n+=e.charAt(t);else switch(e.charAt(t)){case"d":case"m":case"y":case"@":n+="0123456789";break;case"D":case"M":return null;case"'":i("'")?n+="'":r=!0;break;default:n+=e.charAt(t)}return n},_get:function(e,t){return e.settings[t]!==undefined?e.settings[t]:this._defaults[t]},_setDateFromField:function(e,t){if(e.input.val()===e.lastVal)return;var n=this._get(e,"dateFormat"),r=e.lastVal=e.input?e.input.val():null,i=this._getDefaultDate(e),s=i,o=this._getFormatConfig(e);try{s=this.parseDate(n,r,o)||i}catch(u){r=t?"":r}e.selectedDay=s.getDate(),e.drawMonth=e.selectedMonth=s.getMonth(),e.drawYear=e.selectedYear=s.getFullYear(),e.currentDay=r?s.getDate():0,e.currentMonth=r?s.getMonth():0,e.currentYear=r?s.getFullYear():0,this._adjustInstDate(e)},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(t,n,r){var i=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},s=function(n){try{return e.datepicker.parseDate(e.datepicker._get(t,"dateFormat"),n,e.datepicker._getFormatConfig(t))}catch(r){}var i=(n.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,s=i.getFullYear(),o=i.getMonth(),u=i.getDate(),a=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,f=a.exec(n);while(f){switch(f[2]||"d"){case"d":case"D":u+=parseInt(f[1],10);break;case"w":case"W":u+=parseInt(f[1],10)*7;break;case"m":case"M":o+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o));break;case"y":case"Y":s+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o))}f=a.exec(n)}return new Date(s,o,u)},o=n==null||n===""?r:typeof n=="string"?s(n):typeof n=="number"?isNaN(n)?r:i(n):new Date(n.getTime());return o=o&&o.toString()==="Invalid Date"?r:o,o&&(o.setHours(0),o.setMinutes(0),o.setSeconds(0),o.setMilliseconds(0)),this._daylightSavingAdjust(o)},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,n){var r=!t,i=e.selectedMonth,s=e.selectedYear,o=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=o.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=o.getMonth(),e.drawYear=e.selectedYear=e.currentYear=o.getFullYear(),(i!==e.selectedMonth||s!==e.selectedYear)&&!n&&this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(r?"":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&e.input.val()===""?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var n=this._get(t,"stepMonths"),r="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){e.datepicker._adjustDate(r,-n,"M")},next:function(){e.datepicker._adjustDate(r,+n,"M")},hide:function(){e.datepicker._hideDatepicker()},today:function(){e.datepicker._gotoToday(r)},selectDay:function(){return e.datepicker._selectDay(r,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return e.datepicker._selectMonthYear(r,this,"M"),!1},selectYear:function(){return e.datepicker._selectMonthYear(r,this,"Y"),!1}};e(this).bind(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b,w,E,S,x,T,N,C,k,L,A,O,M,_,D,P,H,B,j,F,I,q=new Date,R=this._daylightSavingAdjust(new Date(q.getFullYear(),q.getMonth(),q.getDate())),U=this._get(e,"isRTL"),z=this._get(e,"showButtonPanel"),W=this._get(e,"hideIfNoPrevNext"),X=this._get(e,"navigationAsDateFormat"),V=this._getNumberOfMonths(e),$=this._get(e,"showCurrentAtPos"),J=this._get(e,"stepMonths"),K=V[0]!==1||V[1]!==1,Q=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(e,"min"),Y=this._getMinMaxDate(e,"max"),Z=e.drawMonth-$,et=e.drawYear;Z<0&&(Z+=12,et--);if(Y){t=this._daylightSavingAdjust(new Date(Y.getFullYear(),Y.getMonth()-V[0]*V[1]+1,Y.getDate())),t=G&&t<G?G:t;while(this._daylightSavingAdjust(new Date(et,Z,1))>t)Z--,Z<0&&(Z=11,et--)}e.drawMonth=Z,e.drawYear=et,n=this._get(e,"prevText"),n=X?this.formatDate(n,this._daylightSavingAdjust(new Date(et,Z-J,1)),this._getFormatConfig(e)):n,r=this._canAdjustMonth(e,-1,et,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>":W?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>",i=this._get(e,"nextText"),i=X?this.formatDate(i,this._daylightSavingAdjust(new Date(et,Z+J,1)),this._getFormatConfig(e)):i,s=this._canAdjustMonth(e,1,et,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>":W?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>",o=this._get(e,"currentText"),u=this._get(e,"gotoCurrent")&&e.currentDay?Q:R,o=X?this.formatDate(o,u,this._getFormatConfig(e)):o,a=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",f=z?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(U?a:"")+(this._isInRange(e,u)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+
o+"</button>":"")+(U?"":a)+"</div>":"",l=parseInt(this._get(e,"firstDay"),10),l=isNaN(l)?0:l,c=this._get(e,"showWeek"),h=this._get(e,"dayNames"),p=this._get(e,"dayNamesMin"),d=this._get(e,"monthNames"),v=this._get(e,"monthNamesShort"),m=this._get(e,"beforeShowDay"),g=this._get(e,"showOtherMonths"),y=this._get(e,"selectOtherMonths"),b=this._getDefaultDate(e),w="",E;for(S=0;S<V[0];S++){x="",this.maxRows=4;for(T=0;T<V[1];T++){N=this._daylightSavingAdjust(new Date(et,Z,e.selectedDay)),C=" ui-corner-all",k="";if(K){k+="<div class='ui-datepicker-group";if(V[1]>1)switch(T){case 0:k+=" ui-datepicker-group-first",C=" ui-corner-"+(U?"right":"left");break;case V[1]-1:k+=" ui-datepicker-group-last",C=" ui-corner-"+(U?"left":"right");break;default:k+=" ui-datepicker-group-middle",C=""}k+="'>"}k+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+C+"'>"+(/all|left/.test(C)&&S===0?U?s:r:"")+(/all|right/.test(C)&&S===0?U?r:s:"")+this._generateMonthYearHeader(e,Z,et,G,Y,S>0||T>0,d,v)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",L=c?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"";for(E=0;E<7;E++)A=(E+l)%7,L+="<th scope='col'"+((E+l+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+h[A]+"'>"+p[A]+"</span></th>";k+=L+"</tr></thead><tbody>",O=this._getDaysInMonth(et,Z),et===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,O)),M=(this._getFirstDayOfMonth(et,Z)-l+7)%7,_=Math.ceil((M+O)/7),D=K?this.maxRows>_?this.maxRows:_:_,this.maxRows=D,P=this._daylightSavingAdjust(new Date(et,Z,1-M));for(H=0;H<D;H++){k+="<tr>",B=c?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(P)+"</td>":"";for(E=0;E<7;E++)j=m?m.apply(e.input?e.input[0]:null,[P]):[!0,""],F=P.getMonth()!==Z,I=F&&!y||!j[0]||G&&P<G||Y&&P>Y,B+="<td class='"+((E+l+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(P.getTime()===N.getTime()&&Z===e.selectedMonth&&e._keyEvent||b.getTime()===P.getTime()&&b.getTime()===N.getTime()?" "+this._dayOverClass:"")+(I?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!g?"":" "+j[1]+(P.getTime()===Q.getTime()?" "+this._currentClass:"")+(P.getTime()===R.getTime()?" ui-datepicker-today":""))+"'"+((!F||g)&&j[2]?" title='"+j[2].replace(/'/g,"&#39;")+"'":"")+(I?"":" data-handler='selectDay' data-event='click' data-month='"+P.getMonth()+"' data-year='"+P.getFullYear()+"'")+">"+(F&&!g?"&#xa0;":I?"<span class='ui-state-default'>"+P.getDate()+"</span>":"<a class='ui-state-default"+(P.getTime()===R.getTime()?" ui-state-highlight":"")+(P.getTime()===Q.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+P.getDate()+"</a>")+"</td>",P.setDate(P.getDate()+1),P=this._daylightSavingAdjust(P);k+=B+"</tr>"}Z++,Z>11&&(Z=0,et++),k+="</tbody></table>"+(K?"</div>"+(V[0]>0&&T===V[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=k}w+=x}return w+=f,e._keyEvent=!1,w},_generateMonthYearHeader:function(e,t,n,r,i,s,o,u){var a,f,l,c,h,p,d,v,m=this._get(e,"changeMonth"),g=this._get(e,"changeYear"),y=this._get(e,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",w="";if(s||!m)w+="<span class='ui-datepicker-month'>"+o[t]+"</span>";else{a=r&&r.getFullYear()===n,f=i&&i.getFullYear()===n,w+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";for(l=0;l<12;l++)(!a||l>=r.getMonth())&&(!f||l<=i.getMonth())&&(w+="<option value='"+l+"'"+(l===t?" selected='selected'":"")+">"+u[l]+"</option>");w+="</select>"}y||(b+=w+(s||!m||!g?"&#xa0;":""));if(!e.yearshtml){e.yearshtml="";if(s||!g)b+="<span class='ui-datepicker-year'>"+n+"</span>";else{c=this._get(e,"yearRange").split(":"),h=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\-].*/)?n+parseInt(e.substring(1),10):e.match(/[+\-].*/)?h+parseInt(e,10):parseInt(e,10);return isNaN(t)?h:t},d=p(c[0]),v=Math.max(d,p(c[1]||"")),d=r?Math.max(d,r.getFullYear()):d,v=i?Math.min(v,i.getFullYear()):v,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";for(;d<=v;d++)e.yearshtml+="<option value='"+d+"'"+(d===n?" selected='selected'":"")+">"+d+"</option>";e.yearshtml+="</select>",b+=e.yearshtml,e.yearshtml=null}}return b+=this._get(e,"yearSuffix"),y&&(b+=(s||!m||!g?"&#xa0;":"")+w),b+="</div>",b},_adjustInstDate:function(e,t,n){var r=e.drawYear+(n==="Y"?t:0),i=e.drawMonth+(n==="M"?t:0),s=Math.min(e.selectedDay,this._getDaysInMonth(r,i))+(n==="D"?t:0),o=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(r,i,s)));e.selectedDay=o.getDate(),e.drawMonth=e.selectedMonth=o.getMonth(),e.drawYear=e.selectedYear=o.getFullYear(),(n==="M"||n==="Y")&&this._notifyChange(e)},_restrictMinMax:function(e,t){var n=this._getMinMaxDate(e,"min"),r=this._getMinMaxDate(e,"max"),i=n&&t<n?n:t;return r&&i>r?r:i},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,"numberOfMonths");return t==null?[1,1]:typeof t=="number"?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return(new Date(e,t,1)).getDay()},_canAdjustMonth:function(e,t,n,r){var i=this._getNumberOfMonths(e),s=this._daylightSavingAdjust(new Date(n,r+(t<0?t:i[0]*i[1]),1));return t<0&&s.setDate(this._getDaysInMonth(s.getFullYear(),s.getMonth())),this._isInRange(e,s)},_isInRange:function(e,t){var n,r,i=this._getMinMaxDate(e,"min"),s=this._getMinMaxDate(e,"max"),o=null,u=null,a=this._get(e,"yearRange");return a&&(n=a.split(":"),r=(new Date).getFullYear(),o=parseInt(n[0],10),u=parseInt(n[1],10),n[0].match(/[+\-].*/)&&(o+=r),n[1].match(/[+\-].*/)&&(u+=r)),(!i||t.getTime()>=i.getTime())&&(!s||t.getTime()<=s.getTime())&&(!o||t.getFullYear()>=o)&&(!u||t.getFullYear()<=u)},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return t=typeof t!="string"?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,n,r){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var i=t?typeof t=="object"?t:this._daylightSavingAdjust(new Date(r,n,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),i,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),e("#"+e.datepicker._mainDivId).length===0&&e("body").append(e.datepicker.dpDiv);var n=Array.prototype.slice.call(arguments,1);return typeof t!="string"||t!=="isDisabled"&&t!=="getDate"&&t!=="widget"?t==="option"&&arguments.length===2&&typeof arguments[1]=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n)):this.each(function(){typeof t=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this].concat(n)):e.datepicker._attachDatepicker(this,t)}):e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n))},e.datepicker=new s,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version="1.11.4";var f=e.datepicker}); 
/** **************************************************** **/
/** ********************** iscroll ****************************** **/
 /*!
 * iScroll v4.2.5 ~ Copyright (c) 2012 Matteo Spinelli, http://cubiq.org
 * Released under MIT license, http://cubiq.org/license
 */
(function(window, doc){
var m = Math,
	dummyStyle = doc.createElement('div').style,
	vendor = (function () {
		var vendors = 't,webkitT,MozT,msT,OT'.split(','),
			t,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			t = vendors[i] + 'ransform';
			if ( t in dummyStyle ) {
				return vendors[i].substr(0, vendors[i].length - 1);
			}
		}

		return false;
	})(),
	cssVendor = vendor ? '-' + vendor.toLowerCase() + '-' : '',

	// Style properties
	transform = prefixStyle('transform'),
	transitionProperty = prefixStyle('transitionProperty'),
	transitionDuration = prefixStyle('transitionDuration'),
	transformOrigin = prefixStyle('transformOrigin'),
	transitionTimingFunction = prefixStyle('transitionTimingFunction'),
	transitionDelay = prefixStyle('transitionDelay'),

    // Browser capabilities
	isAndroid = (/android/gi).test(navigator.appVersion),
	isIDevice = (/iphone|ipad/gi).test(navigator.appVersion),
	isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),

    has3d = prefixStyle('perspective') in dummyStyle,
    hasTouch = 'ontouchstart' in window && !isTouchPad,
    hasTransform = vendor !== false,
    hasTransitionEnd = prefixStyle('transition') in dummyStyle,

	RESIZE_EV = 'onorientationchange' in window ? 'orientationchange' : 'resize',
	START_EV = hasTouch ? 'touchstart' : 'mousedown',
	MOVE_EV = hasTouch ? 'touchmove' : 'mousemove',
	END_EV = hasTouch ? 'touchend' : 'mouseup',
	CANCEL_EV = hasTouch ? 'touchcancel' : 'mouseup',
	TRNEND_EV = (function () {
		if ( vendor === false ) return false;

		var transitionEnd = {
				''			: 'transitionend',
				'webkit'	: 'webkitTransitionEnd',
				'Moz'		: 'transitionend',
				'O'			: 'otransitionend',
				'ms'		: 'MSTransitionEnd'
			};

		return transitionEnd[vendor];
	})(),

	nextFrame = (function() {
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) { return setTimeout(callback, 1); };
	})(),
	cancelFrame = (function () {
		return window.cancelRequestAnimationFrame ||
			window.webkitCancelAnimationFrame ||
			window.webkitCancelRequestAnimationFrame ||
			window.mozCancelRequestAnimationFrame ||
			window.oCancelRequestAnimationFrame ||
			window.msCancelRequestAnimationFrame ||
			clearTimeout;
	})(),

	// Helpers
	translateZ = has3d ? ' translateZ(0)' : '',

	// Constructor
	iScroll = function (el, options) {
		var that = this,
			i;

		that.wrapper = typeof el == 'object' ? el : doc.getElementById(el);
		that.wrapper.style.overflow = 'hidden';
		that.scroller = that.wrapper.children[0];

		// Default options
		that.options = {
			hScroll: true,
			vScroll: true,
			x: 0,
			y: 0,
			bounce: true,
			bounceLock: false,
			momentum: true,
			lockDirection: true,
			useTransform: true,
			useTransition: false,
			topOffset: 0,
			checkDOMChanges: false,		// Experimental
			handleClick: true,

			// Scrollbar
			hScrollbar: true,
			vScrollbar: true,
			fixedScrollbar: isAndroid,
			hideScrollbar: isIDevice,
			fadeScrollbar: isIDevice && has3d,
			scrollbarClass: '',

			// Zoom
			zoom: false,
			zoomMin: 1,
			zoomMax: 4,
			doubleTapZoom: 2,
			wheelAction: 'scroll',

			// Snap
			snap: false,
			snapThreshold: 1,

			// Events
			onRefresh: null,
			onBeforeScrollStart: function (e) { e.preventDefault(); },
			onScrollStart: null,
			onBeforeScrollMove: null,
			onScrollMove: null,
			onBeforeScrollEnd: null,
			onScrollEnd: null,
			onTouchEnd: null,
			onDestroy: null,
			onZoomStart: null,
			onZoom: null,
			onZoomEnd: null
		};

		// User defined options
		for (i in options) that.options[i] = options[i];
		
		// Set starting position
		that.x = that.options.x;
		that.y = that.options.y;

		// Normalize options
		that.options.useTransform = hasTransform && that.options.useTransform;
		that.options.hScrollbar = that.options.hScroll && that.options.hScrollbar;
		that.options.vScrollbar = that.options.vScroll && that.options.vScrollbar;
		that.options.zoom = that.options.useTransform && that.options.zoom;
		that.options.useTransition = hasTransitionEnd && that.options.useTransition;

		// Helpers FIX ANDROID BUG!
		// translate3d and scale doesn't work together!
		// Ignoring 3d ONLY WHEN YOU SET that.options.zoom
		if ( that.options.zoom && isAndroid ){
			translateZ = '';
		}
		
		// Set some default styles
		that.scroller.style[transitionProperty] = that.options.useTransform ? cssVendor + 'transform' : 'top left';
		that.scroller.style[transitionDuration] = '0';
		that.scroller.style[transformOrigin] = '0 0';
		if (that.options.useTransition) that.scroller.style[transitionTimingFunction] = 'cubic-bezier(0.33,0.66,0.66,1)';
		
		if (that.options.useTransform) that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px)' + translateZ;
		else that.scroller.style.cssText += ';position:absolute;top:' + that.y + 'px;left:' + that.x + 'px';

		if (that.options.useTransition) that.options.fixedScrollbar = true;

		that.refresh();

		that._bind(RESIZE_EV, window);
		that._bind(START_EV);
		if (!hasTouch) {
			if (that.options.wheelAction != 'none') {
				that._bind('DOMMouseScroll');
				that._bind('mousewheel');
			}
		}

		if (that.options.checkDOMChanges) that.checkDOMTime = setInterval(function () {
			that._checkDOMChanges();
		}, 500);
	};

// Prototype
iScroll.prototype = {
	enabled: true,
	x: 0,
	y: 0,
	steps: [],
	scale: 1,
	currPageX: 0, currPageY: 0,
	pagesX: [], pagesY: [],
	aniTime: null,
	wheelZoomCount: 0,
	
	handleEvent: function (e) {
		var that = this;
		switch(e.type) {
			case START_EV:
				if (!hasTouch && e.button !== 0) return;
				that._start(e);
				break;
			case MOVE_EV: that._move(e); break;
			case END_EV:
			case CANCEL_EV: that._end(e); break;
			case RESIZE_EV: that._resize(); break;
			case 'DOMMouseScroll': case 'mousewheel': that._wheel(e); break;
			case TRNEND_EV: that._transitionEnd(e); break;
		}
	},
	
	_checkDOMChanges: function () {
		if (this.moved || this.zoomed || this.animating ||
			(this.scrollerW == this.scroller.offsetWidth * this.scale && this.scrollerH == this.scroller.offsetHeight * this.scale)) return;

		this.refresh();
	},
	
	_scrollbar: function (dir) {
		var that = this,
			bar;

		if (!that[dir + 'Scrollbar']) {
			if (that[dir + 'ScrollbarWrapper']) {
				if (hasTransform) that[dir + 'ScrollbarIndicator'].style[transform] = '';
				that[dir + 'ScrollbarWrapper'].parentNode.removeChild(that[dir + 'ScrollbarWrapper']);
				that[dir + 'ScrollbarWrapper'] = null;
				that[dir + 'ScrollbarIndicator'] = null;
			}

			return;
		}

		if (!that[dir + 'ScrollbarWrapper']) {
			// Create the scrollbar wrapper
			bar = doc.createElement('div');

			if (that.options.scrollbarClass) bar.className = that.options.scrollbarClass + dir.toUpperCase();
			else bar.style.cssText = 'position:absolute;z-index:100;' + (dir == 'h' ? 'height:7px;bottom:1px;left:2px;right:' + (that.vScrollbar ? '7' : '2') + 'px' : 'width:7px;bottom:' + (that.hScrollbar ? '7' : '2') + 'px;top:2px;right:1px');

			bar.style.cssText += ';pointer-events:none;' + cssVendor + 'transition-property:opacity;' + cssVendor + 'transition-duration:' + (that.options.fadeScrollbar ? '350ms' : '0') + ';overflow:hidden;opacity:' + (that.options.hideScrollbar ? '0' : '1');

			that.wrapper.appendChild(bar);
			that[dir + 'ScrollbarWrapper'] = bar;

			// Create the scrollbar indicator
			bar = doc.createElement('div');
			if (!that.options.scrollbarClass) {
				bar.style.cssText = 'position:absolute;z-index:100;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);' + cssVendor + 'background-clip:padding-box;' + cssVendor + 'box-sizing:border-box;' + (dir == 'h' ? 'height:100%' : 'width:100%') + ';' + cssVendor + 'border-radius:3px;border-radius:3px';
			}
			bar.style.cssText += ';pointer-events:none;' + cssVendor + 'transition-property:' + cssVendor + 'transform;' + cssVendor + 'transition-timing-function:cubic-bezier(0.33,0.66,0.66,1);' + cssVendor + 'transition-duration:0;' + cssVendor + 'transform: translate(0,0)' + translateZ;
			if (that.options.useTransition) bar.style.cssText += ';' + cssVendor + 'transition-timing-function:cubic-bezier(0.33,0.66,0.66,1)';

			that[dir + 'ScrollbarWrapper'].appendChild(bar);
			that[dir + 'ScrollbarIndicator'] = bar;
		}

		if (dir == 'h') {
			that.hScrollbarSize = that.hScrollbarWrapper.clientWidth;
			that.hScrollbarIndicatorSize = m.max(m.round(that.hScrollbarSize * that.hScrollbarSize / that.scrollerW), 8);
			that.hScrollbarIndicator.style.width = that.hScrollbarIndicatorSize + 'px';
			that.hScrollbarMaxScroll = that.hScrollbarSize - that.hScrollbarIndicatorSize;
			that.hScrollbarProp = that.hScrollbarMaxScroll / that.maxScrollX;
		} else {
			that.vScrollbarSize = that.vScrollbarWrapper.clientHeight;
			that.vScrollbarIndicatorSize = m.max(m.round(that.vScrollbarSize * that.vScrollbarSize / that.scrollerH), 8);
			that.vScrollbarIndicator.style.height = that.vScrollbarIndicatorSize + 'px';
			that.vScrollbarMaxScroll = that.vScrollbarSize - that.vScrollbarIndicatorSize;
			that.vScrollbarProp = that.vScrollbarMaxScroll / that.maxScrollY;
		}

		// Reset position
		that._scrollbarPos(dir, true);
	},
	
	_resize: function () {
		var that = this;
		setTimeout(function () { that.refresh(); }, isAndroid ? 200 : 0);
	},
	
	_pos: function (x, y) {
		if (this.zoomed) return;

		x = this.hScroll ? x : 0;
		y = this.vScroll ? y : 0;

		if (this.options.useTransform) {
			this.scroller.style[transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + this.scale + ')' + translateZ;
		} else {
			x = m.round(x);
			y = m.round(y);
			this.scroller.style.left = x + 'px';
			this.scroller.style.top = y + 'px';
		}

		this.x = x;
		this.y = y;

		this._scrollbarPos('h');
		this._scrollbarPos('v');
	},

	_scrollbarPos: function (dir, hidden) {
		var that = this,
			pos = dir == 'h' ? that.x : that.y,
			size;

		if (!that[dir + 'Scrollbar']) return;

		pos = that[dir + 'ScrollbarProp'] * pos;

		if (pos < 0) {
			if (!that.options.fixedScrollbar) {
				size = that[dir + 'ScrollbarIndicatorSize'] + m.round(pos * 3);
				if (size < 8) size = 8;
				that[dir + 'ScrollbarIndicator'].style[dir == 'h' ? 'width' : 'height'] = size + 'px';
			}
			pos = 0;
		} else if (pos > that[dir + 'ScrollbarMaxScroll']) {
			if (!that.options.fixedScrollbar) {
				size = that[dir + 'ScrollbarIndicatorSize'] - m.round((pos - that[dir + 'ScrollbarMaxScroll']) * 3);
				if (size < 8) size = 8;
				that[dir + 'ScrollbarIndicator'].style[dir == 'h' ? 'width' : 'height'] = size + 'px';
				pos = that[dir + 'ScrollbarMaxScroll'] + (that[dir + 'ScrollbarIndicatorSize'] - size);
			} else {
				pos = that[dir + 'ScrollbarMaxScroll'];
			}
		}

		that[dir + 'ScrollbarWrapper'].style[transitionDelay] = '0';
		that[dir + 'ScrollbarWrapper'].style.opacity = hidden && that.options.hideScrollbar ? '0' : '1';
		that[dir + 'ScrollbarIndicator'].style[transform] = 'translate(' + (dir == 'h' ? pos + 'px,0)' : '0,' + pos + 'px)') + translateZ;
	},
	
	_start: function (e) {
		var that = this,
			point = hasTouch ? e.touches[0] : e,
			matrix, x, y,
			c1, c2;

		if (!that.enabled) return;

		if (that.options.onBeforeScrollStart) that.options.onBeforeScrollStart.call(that, e);

		if (that.options.useTransition || that.options.zoom) that._transitionTime(0);

		that.moved = false;
		that.animating = false;
		that.zoomed = false;
		that.distX = 0;
		that.distY = 0;
		that.absDistX = 0;
		that.absDistY = 0;
		that.dirX = 0;
		that.dirY = 0;

		// Gesture start
		if (that.options.zoom && hasTouch && e.touches.length > 1) {
			c1 = m.abs(e.touches[0].pageX-e.touches[1].pageX);
			c2 = m.abs(e.touches[0].pageY-e.touches[1].pageY);
			that.touchesDistStart = m.sqrt(c1 * c1 + c2 * c2);

			that.originX = m.abs(e.touches[0].pageX + e.touches[1].pageX - that.wrapperOffsetLeft * 2) / 2 - that.x;
			that.originY = m.abs(e.touches[0].pageY + e.touches[1].pageY - that.wrapperOffsetTop * 2) / 2 - that.y;

			if (that.options.onZoomStart) that.options.onZoomStart.call(that, e);
		}

		if (that.options.momentum) {
			if (that.options.useTransform) {
				// Very lame general purpose alternative to CSSMatrix
				matrix = getComputedStyle(that.scroller, null)[transform].replace(/[^0-9\-.,]/g, '').split(',');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +getComputedStyle(that.scroller, null).left.replace(/[^0-9-]/g, '');
				y = +getComputedStyle(that.scroller, null).top.replace(/[^0-9-]/g, '');
			}
			
			if (x != that.x || y != that.y) {
				if (that.options.useTransition) that._unbind(TRNEND_EV);
				else cancelFrame(that.aniTime);
				that.steps = [];
				that._pos(x, y);
				if (that.options.onScrollEnd) that.options.onScrollEnd.call(that);
			}
		}

		that.absStartX = that.x;	// Needed by snap threshold
		that.absStartY = that.y;

		that.startX = that.x;
		that.startY = that.y;
		that.pointX = point.pageX;
		that.pointY = point.pageY;

		that.startTime = e.timeStamp || Date.now();

		if (that.options.onScrollStart) that.options.onScrollStart.call(that, e);

		that._bind(MOVE_EV, window);
		that._bind(END_EV, window);
		that._bind(CANCEL_EV, window);
	},
	
	_move: function (e) {
		var that = this,
			point = hasTouch ? e.touches[0] : e,
			deltaX = point.pageX - that.pointX,
			deltaY = point.pageY - that.pointY,
			newX = that.x + deltaX,
			newY = that.y + deltaY,
			c1, c2, scale,
			timestamp = e.timeStamp || Date.now();

		if (that.options.onBeforeScrollMove) that.options.onBeforeScrollMove.call(that, e);

		// Zoom
		if (that.options.zoom && hasTouch && e.touches.length > 1) {
			c1 = m.abs(e.touches[0].pageX - e.touches[1].pageX);
			c2 = m.abs(e.touches[0].pageY - e.touches[1].pageY);
			that.touchesDist = m.sqrt(c1*c1+c2*c2);

			that.zoomed = true;

			scale = 1 / that.touchesDistStart * that.touchesDist * this.scale;

			if (scale < that.options.zoomMin) scale = 0.5 * that.options.zoomMin * Math.pow(2.0, scale / that.options.zoomMin);
			else if (scale > that.options.zoomMax) scale = 2.0 * that.options.zoomMax * Math.pow(0.5, that.options.zoomMax / scale);

			that.lastScale = scale / this.scale;

			newX = this.originX - this.originX * that.lastScale + this.x,
			newY = this.originY - this.originY * that.lastScale + this.y;

			this.scroller.style[transform] = 'translate(' + newX + 'px,' + newY + 'px) scale(' + scale + ')' + translateZ;

			if (that.options.onZoom) that.options.onZoom.call(that, e);
			return;
		}

		that.pointX = point.pageX;
		that.pointY = point.pageY;

		// Slow down if outside of the boundaries
		if (newX > 0 || newX < that.maxScrollX) {
			newX = that.options.bounce ? that.x + (deltaX / 2) : newX >= 0 || that.maxScrollX >= 0 ? 0 : that.maxScrollX;
		}
		if (newY > that.minScrollY || newY < that.maxScrollY) {
			newY = that.options.bounce ? that.y + (deltaY / 2) : newY >= that.minScrollY || that.maxScrollY >= 0 ? that.minScrollY : that.maxScrollY;
		}

		that.distX += deltaX;
		that.distY += deltaY;
		that.absDistX = m.abs(that.distX);
		that.absDistY = m.abs(that.distY);

		if (that.absDistX < 6 && that.absDistY < 6) {
			return;
		}

		// Lock direction
		if (that.options.lockDirection) {
			if (that.absDistX > that.absDistY + 5) {
				newY = that.y;
				deltaY = 0;
			} else if (that.absDistY > that.absDistX + 5) {
				newX = that.x;
				deltaX = 0;
			}
		}

		that.moved = true;
		that._pos(newX, newY);
		that.dirX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		that.dirY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if (timestamp - that.startTime > 300) {
			that.startTime = timestamp;
			that.startX = that.x;
			that.startY = that.y;
		}
		
		if (that.options.onScrollMove) that.options.onScrollMove.call(that, e);
	},
	
	_end: function (e) {
		if (hasTouch && e.touches.length !== 0) return;

		var that = this,
			point = hasTouch ? e.changedTouches[0] : e,
			target, ev,
			momentumX = { dist:0, time:0 },
			momentumY = { dist:0, time:0 },
			duration = (e.timeStamp || Date.now()) - that.startTime,
			newPosX = that.x,
			newPosY = that.y,
			distX, distY,
			newDuration,
			snap,
			scale;

		that._unbind(MOVE_EV, window);
		that._unbind(END_EV, window);
		that._unbind(CANCEL_EV, window);

		if (that.options.onBeforeScrollEnd) that.options.onBeforeScrollEnd.call(that, e);

		if (that.zoomed) {
			scale = that.scale * that.lastScale;
			scale = Math.max(that.options.zoomMin, scale);
			scale = Math.min(that.options.zoomMax, scale);
			that.lastScale = scale / that.scale;
			that.scale = scale;

			that.x = that.originX - that.originX * that.lastScale + that.x;
			that.y = that.originY - that.originY * that.lastScale + that.y;
			
			that.scroller.style[transitionDuration] = '200ms';
			that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px) scale(' + that.scale + ')' + translateZ;
			
			that.zoomed = false;
			that.refresh();

			if (that.options.onZoomEnd) that.options.onZoomEnd.call(that, e);
			return;
		}

		if (!that.moved) {
			if (hasTouch) {
				if (that.doubleTapTimer && that.options.zoom) {
					// Double tapped
					clearTimeout(that.doubleTapTimer);
					that.doubleTapTimer = null;
					if (that.options.onZoomStart) that.options.onZoomStart.call(that, e);
					that.zoom(that.pointX, that.pointY, that.scale == 1 ? that.options.doubleTapZoom : 1);
					if (that.options.onZoomEnd) {
						setTimeout(function() {
							that.options.onZoomEnd.call(that, e);
						}, 200); // 200 is default zoom duration
					}
				} else if (this.options.handleClick) {
					that.doubleTapTimer = setTimeout(function () {
						that.doubleTapTimer = null;

						// Find the last touched element
						target = point.target;
						while (target.nodeType != 1) target = target.parentNode;

						if (target.tagName != 'SELECT' && target.tagName != 'INPUT' && target.tagName != 'TEXTAREA') {
							ev = doc.createEvent('MouseEvents');
							ev.initMouseEvent('click', true, true, e.view, 1,
								point.screenX, point.screenY, point.clientX, point.clientY,
								e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
								0, null);
							ev._fake = true;
							target.dispatchEvent(ev);
						}
					}, that.options.zoom ? 250 : 0);
				}
			}

			that._resetPos(400);

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		if (duration < 300 && that.options.momentum) {
			momentumX = newPosX ? that._momentum(newPosX - that.startX, duration, -that.x, that.scrollerW - that.wrapperW + that.x, that.options.bounce ? that.wrapperW : 0) : momentumX;
			momentumY = newPosY ? that._momentum(newPosY - that.startY, duration, -that.y, (that.maxScrollY < 0 ? that.scrollerH - that.wrapperH + that.y - that.minScrollY : 0), that.options.bounce ? that.wrapperH : 0) : momentumY;

			newPosX = that.x + momentumX.dist;
			newPosY = that.y + momentumY.dist;

			if ((that.x > 0 && newPosX > 0) || (that.x < that.maxScrollX && newPosX < that.maxScrollX)) momentumX = { dist:0, time:0 };
			if ((that.y > that.minScrollY && newPosY > that.minScrollY) || (that.y < that.maxScrollY && newPosY < that.maxScrollY)) momentumY = { dist:0, time:0 };
		}

		if (momentumX.dist || momentumY.dist) {
			newDuration = m.max(m.max(momentumX.time, momentumY.time), 10);

			// Do we need to snap?
			if (that.options.snap) {
				distX = newPosX - that.absStartX;
				distY = newPosY - that.absStartY;
				if (m.abs(distX) < that.options.snapThreshold && m.abs(distY) < that.options.snapThreshold) { that.scrollTo(that.absStartX, that.absStartY, 200); }
				else {
					snap = that._snap(newPosX, newPosY);
					newPosX = snap.x;
					newPosY = snap.y;
					newDuration = m.max(snap.time, newDuration);
				}
			}

			that.scrollTo(m.round(newPosX), m.round(newPosY), newDuration);

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		// Do we need to snap?
		if (that.options.snap) {
			distX = newPosX - that.absStartX;
			distY = newPosY - that.absStartY;
			if (m.abs(distX) < that.options.snapThreshold && m.abs(distY) < that.options.snapThreshold) that.scrollTo(that.absStartX, that.absStartY, 200);
			else {
				snap = that._snap(that.x, that.y);
				if (snap.x != that.x || snap.y != that.y) that.scrollTo(snap.x, snap.y, snap.time);
			}

			if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
			return;
		}

		that._resetPos(200);
		if (that.options.onTouchEnd) that.options.onTouchEnd.call(that, e);
	},
	
	_resetPos: function (time) {
		var that = this,
			resetX = that.x >= 0 ? 0 : that.x < that.maxScrollX ? that.maxScrollX : that.x,
			resetY = that.y >= that.minScrollY || that.maxScrollY > 0 ? that.minScrollY : that.y < that.maxScrollY ? that.maxScrollY : that.y;

		if (resetX == that.x && resetY == that.y) {
			if (that.moved) {
				that.moved = false;
				if (that.options.onScrollEnd) that.options.onScrollEnd.call(that);		// Execute custom code on scroll end
			}

			if (that.hScrollbar && that.options.hideScrollbar) {
				if (vendor == 'webkit') that.hScrollbarWrapper.style[transitionDelay] = '300ms';
				that.hScrollbarWrapper.style.opacity = '0';
			}
			if (that.vScrollbar && that.options.hideScrollbar) {
				if (vendor == 'webkit') that.vScrollbarWrapper.style[transitionDelay] = '300ms';
				that.vScrollbarWrapper.style.opacity = '0';
			}

			return;
		}

		that.scrollTo(resetX, resetY, time || 0);
	},

	_wheel: function (e) {
		var that = this,
			wheelDeltaX, wheelDeltaY,
			deltaX, deltaY,
			deltaScale;

		if ('wheelDeltaX' in e) {
			wheelDeltaX = e.wheelDeltaX / 12;
			wheelDeltaY = e.wheelDeltaY / 12;
		} else if('wheelDelta' in e) {
			wheelDeltaX = wheelDeltaY = e.wheelDelta / 12;
		} else if ('detail' in e) {
			wheelDeltaX = wheelDeltaY = -e.detail * 3;
		} else {
			return;
		}
		
		if (that.options.wheelAction == 'zoom') {
			deltaScale = that.scale * Math.pow(2, 1/3 * (wheelDeltaY ? wheelDeltaY / Math.abs(wheelDeltaY) : 0));
			if (deltaScale < that.options.zoomMin) deltaScale = that.options.zoomMin;
			if (deltaScale > that.options.zoomMax) deltaScale = that.options.zoomMax;
			
			if (deltaScale != that.scale) {
				if (!that.wheelZoomCount && that.options.onZoomStart) that.options.onZoomStart.call(that, e);
				that.wheelZoomCount++;
				
				that.zoom(e.pageX, e.pageY, deltaScale, 400);
				
				setTimeout(function() {
					that.wheelZoomCount--;
					if (!that.wheelZoomCount && that.options.onZoomEnd) that.options.onZoomEnd.call(that, e);
				}, 400);
			}
			
			return;
		}
		
		deltaX = that.x + wheelDeltaX;
		deltaY = that.y + wheelDeltaY;

		if (deltaX > 0) deltaX = 0;
		else if (deltaX < that.maxScrollX) deltaX = that.maxScrollX;

		if (deltaY > that.minScrollY) deltaY = that.minScrollY;
		else if (deltaY < that.maxScrollY) deltaY = that.maxScrollY;
    
		if (that.maxScrollY < 0) {
			that.scrollTo(deltaX, deltaY, 0);
		}
	},
	
	_transitionEnd: function (e) {
		var that = this;

		if (e.target != that.scroller) return;

		that._unbind(TRNEND_EV);
		
		that._startAni();
	},


	/**
	*
	* Utilities
	*
	*/
	_startAni: function () {
		var that = this,
			startX = that.x, startY = that.y,
			startTime = Date.now(),
			step, easeOut,
			animate;

		if (that.animating) return;
		
		if (!that.steps.length) {
			that._resetPos(400);
			return;
		}
		
		step = that.steps.shift();
		
		if (step.x == startX && step.y == startY) step.time = 0;

		that.animating = true;
		that.moved = true;
		
		if (that.options.useTransition) {
			that._transitionTime(step.time);
			that._pos(step.x, step.y);
			that.animating = false;
			if (step.time) that._bind(TRNEND_EV);
			else that._resetPos(0);
			return;
		}

		animate = function () {
			var now = Date.now(),
				newX, newY;

			if (now >= startTime + step.time) {
				that._pos(step.x, step.y);
				that.animating = false;
				if (that.options.onAnimationEnd) that.options.onAnimationEnd.call(that);			// Execute custom code on animation end
				that._startAni();
				return;
			}

			now = (now - startTime) / step.time - 1;
			easeOut = m.sqrt(1 - now * now);
			newX = (step.x - startX) * easeOut + startX;
			newY = (step.y - startY) * easeOut + startY;
			that._pos(newX, newY);
			if (that.animating) that.aniTime = nextFrame(animate);
		};

		animate();
	},

	_transitionTime: function (time) {
		time += 'ms';
		this.scroller.style[transitionDuration] = time;
		if (this.hScrollbar) this.hScrollbarIndicator.style[transitionDuration] = time;
		if (this.vScrollbar) this.vScrollbarIndicator.style[transitionDuration] = time;
	},

	_momentum: function (dist, time, maxDistUpper, maxDistLower, size) {
		var deceleration = 0.0006,
			speed = m.abs(dist) / time,
			newDist = (speed * speed) / (2 * deceleration),
			newTime = 0, outsideDist = 0;

		// Proportinally reduce speed if we are outside of the boundaries
		if (dist > 0 && newDist > maxDistUpper) {
			outsideDist = size / (6 / (newDist / speed * deceleration));
			maxDistUpper = maxDistUpper + outsideDist;
			speed = speed * maxDistUpper / newDist;
			newDist = maxDistUpper;
		} else if (dist < 0 && newDist > maxDistLower) {
			outsideDist = size / (6 / (newDist / speed * deceleration));
			maxDistLower = maxDistLower + outsideDist;
			speed = speed * maxDistLower / newDist;
			newDist = maxDistLower;
		}

		newDist = newDist * (dist < 0 ? -1 : 1);
		newTime = speed / deceleration;

		return { dist: newDist, time: m.round(newTime) };
	},

	_offset: function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;
			
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		
		if (el != this.wrapper) {
			left *= this.scale;
			top *= this.scale;
		}

		return { left: left, top: top };
	},

	_snap: function (x, y) {
		var that = this,
			i, l,
			page, time,
			sizeX, sizeY;

		// Check page X
		page = that.pagesX.length - 1;
		for (i=0, l=that.pagesX.length; i<l; i++) {
			if (x >= that.pagesX[i]) {
				page = i;
				break;
			}
		}
		if (page == that.currPageX && page > 0 && that.dirX < 0) page--;
		x = that.pagesX[page];
		sizeX = m.abs(x - that.pagesX[that.currPageX]);
		sizeX = sizeX ? m.abs(that.x - x) / sizeX * 500 : 0;
		that.currPageX = page;

		// Check page Y
		page = that.pagesY.length-1;
		for (i=0; i<page; i++) {
			if (y >= that.pagesY[i]) {
				page = i;
				break;
			}
		}
		if (page == that.currPageY && page > 0 && that.dirY < 0) page--;
		y = that.pagesY[page];
		sizeY = m.abs(y - that.pagesY[that.currPageY]);
		sizeY = sizeY ? m.abs(that.y - y) / sizeY * 500 : 0;
		that.currPageY = page;

		// Snap with constant speed (proportional duration)
		time = m.round(m.max(sizeX, sizeY)) || 200;

		return { x: x, y: y, time: time };
	},

	_bind: function (type, el, bubble) {
		(el || this.scroller).addEventListener(type, this, !!bubble);
	},

	_unbind: function (type, el, bubble) {
		(el || this.scroller).removeEventListener(type, this, !!bubble);
	},


	/**
	*
	* Public methods
	*
	*/
	destroy: function () {
		var that = this;

		that.scroller.style[transform] = '';

		// Remove the scrollbars
		that.hScrollbar = false;
		that.vScrollbar = false;
		that._scrollbar('h');
		that._scrollbar('v');

		// Remove the event listeners
		that._unbind(RESIZE_EV, window);
		that._unbind(START_EV);
		that._unbind(MOVE_EV, window);
		that._unbind(END_EV, window);
		that._unbind(CANCEL_EV, window);
		
		if (!that.options.hasTouch) {
			that._unbind('DOMMouseScroll');
			that._unbind('mousewheel');
		}
		
		if (that.options.useTransition) that._unbind(TRNEND_EV);
		
		if (that.options.checkDOMChanges) clearInterval(that.checkDOMTime);
		
		if (that.options.onDestroy) that.options.onDestroy.call(that);
	},

	refresh: function () {
		var that = this,
			offset,
			i, l,
			els,
			pos = 0,
			page = 0;

		if (that.scale < that.options.zoomMin) that.scale = that.options.zoomMin;
		that.wrapperW = that.wrapper.clientWidth || 1;
		that.wrapperH = that.wrapper.clientHeight || 1;

		that.minScrollY = -that.options.topOffset || 0;
		that.scrollerW = m.round(that.scroller.offsetWidth * that.scale);
		that.scrollerH = m.round((that.scroller.offsetHeight + that.minScrollY) * that.scale);
		that.maxScrollX = that.wrapperW - that.scrollerW;
		that.maxScrollY = that.wrapperH - that.scrollerH + that.minScrollY;
		that.dirX = 0;
		that.dirY = 0;

		if (that.options.onRefresh) that.options.onRefresh.call(that);

		that.hScroll = that.options.hScroll && that.maxScrollX < 0;
		that.vScroll = that.options.vScroll && (!that.options.bounceLock && !that.hScroll || that.scrollerH > that.wrapperH);

		that.hScrollbar = that.hScroll && that.options.hScrollbar;
		that.vScrollbar = that.vScroll && that.options.vScrollbar && that.scrollerH > that.wrapperH;

		offset = that._offset(that.wrapper);
		that.wrapperOffsetLeft = -offset.left;
		that.wrapperOffsetTop = -offset.top;

		// Prepare snap
		if (typeof that.options.snap == 'string') {
			that.pagesX = [];
			that.pagesY = [];
			els = that.scroller.querySelectorAll(that.options.snap);
			for (i=0, l=els.length; i<l; i++) {
				pos = that._offset(els[i]);
				pos.left += that.wrapperOffsetLeft;
				pos.top += that.wrapperOffsetTop;
				that.pagesX[i] = pos.left < that.maxScrollX ? that.maxScrollX : pos.left * that.scale;
				that.pagesY[i] = pos.top < that.maxScrollY ? that.maxScrollY : pos.top * that.scale;
			}
		} else if (that.options.snap) {
			that.pagesX = [];
			while (pos >= that.maxScrollX) {
				that.pagesX[page] = pos;
				pos = pos - that.wrapperW;
				page++;
			}
			if (that.maxScrollX%that.wrapperW) that.pagesX[that.pagesX.length] = that.maxScrollX - that.pagesX[that.pagesX.length-1] + that.pagesX[that.pagesX.length-1];

			pos = 0;
			page = 0;
			that.pagesY = [];
			while (pos >= that.maxScrollY) {
				that.pagesY[page] = pos;
				pos = pos - that.wrapperH;
				page++;
			}
			if (that.maxScrollY%that.wrapperH) that.pagesY[that.pagesY.length] = that.maxScrollY - that.pagesY[that.pagesY.length-1] + that.pagesY[that.pagesY.length-1];
		}

		// Prepare the scrollbars
		that._scrollbar('h');
		that._scrollbar('v');

		if (!that.zoomed) {
			that.scroller.style[transitionDuration] = '0';
			that._resetPos(400);
		}
	},

	scrollTo: function (x, y, time, relative) {
		var that = this,
			step = x,
			i, l;

		that.stop();

		if (!step.length) step = [{ x: x, y: y, time: time, relative: relative }];
		
		for (i=0, l=step.length; i<l; i++) {
			if (step[i].relative) { step[i].x = that.x - step[i].x; step[i].y = that.y - step[i].y; }
			that.steps.push({ x: step[i].x, y: step[i].y, time: step[i].time || 0 });
		}

		that._startAni();
	},

	scrollToElement: function (el, time) {
		var that = this, pos;
		el = el.nodeType ? el : that.scroller.querySelector(el);
		if (!el) return;

		pos = that._offset(el);
		pos.left += that.wrapperOffsetLeft;
		pos.top += that.wrapperOffsetTop;

		pos.left = pos.left > 0 ? 0 : pos.left < that.maxScrollX ? that.maxScrollX : pos.left;
		pos.top = pos.top > that.minScrollY ? that.minScrollY : pos.top < that.maxScrollY ? that.maxScrollY : pos.top;
		time = time === undefined ? m.max(m.abs(pos.left)*2, m.abs(pos.top)*2) : time;

		that.scrollTo(pos.left, pos.top, time);
	},

	scrollToPage: function (pageX, pageY, time) {
		var that = this, x, y;
		
		time = time === undefined ? 400 : time;

		if (that.options.onScrollStart) that.options.onScrollStart.call(that);

		if (that.options.snap) {
			pageX = pageX == 'next' ? that.currPageX+1 : pageX == 'prev' ? that.currPageX-1 : pageX;
			pageY = pageY == 'next' ? that.currPageY+1 : pageY == 'prev' ? that.currPageY-1 : pageY;

			pageX = pageX < 0 ? 0 : pageX > that.pagesX.length-1 ? that.pagesX.length-1 : pageX;
			pageY = pageY < 0 ? 0 : pageY > that.pagesY.length-1 ? that.pagesY.length-1 : pageY;

			that.currPageX = pageX;
			that.currPageY = pageY;
			x = that.pagesX[pageX];
			y = that.pagesY[pageY];
		} else {
			x = -that.wrapperW * pageX;
			y = -that.wrapperH * pageY;
			if (x < that.maxScrollX) x = that.maxScrollX;
			if (y < that.maxScrollY) y = that.maxScrollY;
		}

		that.scrollTo(x, y, time);
	},

	disable: function () {
		this.stop();
		this._resetPos(0);
		this.enabled = false;

		// If disabled after touchstart we make sure that there are no left over events
		this._unbind(MOVE_EV, window);
		this._unbind(END_EV, window);
		this._unbind(CANCEL_EV, window);
	},
	
	enable: function () {
		this.enabled = true;
	},
	
	stop: function () {
		if (this.options.useTransition) this._unbind(TRNEND_EV);
		else cancelFrame(this.aniTime);
		this.steps = [];
		this.moved = false;
		this.animating = false;
	},
	
	zoom: function (x, y, scale, time) {
		var that = this,
			relScale = scale / that.scale;

		if (!that.options.useTransform) return;

		that.zoomed = true;
		time = time === undefined ? 200 : time;
		x = x - that.wrapperOffsetLeft - that.x;
		y = y - that.wrapperOffsetTop - that.y;
		that.x = x - x * relScale + that.x;
		that.y = y - y * relScale + that.y;

		that.scale = scale;
		that.refresh();

		that.x = that.x > 0 ? 0 : that.x < that.maxScrollX ? that.maxScrollX : that.x;
		that.y = that.y > that.minScrollY ? that.minScrollY : that.y < that.maxScrollY ? that.maxScrollY : that.y;

		that.scroller.style[transitionDuration] = time + 'ms';
		that.scroller.style[transform] = 'translate(' + that.x + 'px,' + that.y + 'px) scale(' + scale + ')' + translateZ;
		that.zoomed = false;
	},
	
	isReady: function () {
		return !this.moved && !this.zoomed && !this.animating;
	}
};

function prefixStyle (style) {
	if ( vendor === '' ) return style;

	style = style.charAt(0).toUpperCase() + style.substr(1);
	return vendor + style;
}

dummyStyle = null;	// for the sake of it

if (typeof exports !== 'undefined') exports.iScroll = iScroll;
else window.iScroll = iScroll;

})(window, document);
 
/** **************************************************** **/
/** ********************** isotope-layout ****************************** **/
 /*!
 * Isotope PACKAGED v2.2.0
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * http://isotope.metafizzy.co
 * Copyright 2015 Metafizzy
 */

(function(t){function e(){}function i(t){function i(e){e.prototype.option||(e.prototype.option=function(e){t.isPlainObject(e)&&(this.options=t.extend(!0,this.options,e))})}function n(e,i){t.fn[e]=function(n){if("string"==typeof n){for(var s=o.call(arguments,1),a=0,u=this.length;u>a;a++){var p=this[a],h=t.data(p,e);if(h)if(t.isFunction(h[n])&&"_"!==n.charAt(0)){var f=h[n].apply(h,s);if(void 0!==f)return f}else r("no such method '"+n+"' for "+e+" instance");else r("cannot call methods on "+e+" prior to initialization; "+"attempted to call '"+n+"'")}return this}return this.each(function(){var o=t.data(this,e);o?(o.option(n),o._init()):(o=new i(this,n),t.data(this,e,o))})}}if(t){var r="undefined"==typeof console?e:function(t){console.error(t)};return t.bridget=function(t,e){i(e),n(t,e)},t.bridget}}var o=Array.prototype.slice;"function"==typeof define&&define.amd?define("jquery-bridget/jquery.bridget",["jquery"],i):"object"==typeof exports?i(require("jquery")):i(t.jQuery)})(window),function(t){function e(e){var i=t.event;return i.target=i.target||i.srcElement||e,i}var i=document.documentElement,o=function(){};i.addEventListener?o=function(t,e,i){t.addEventListener(e,i,!1)}:i.attachEvent&&(o=function(t,i,o){t[i+o]=o.handleEvent?function(){var i=e(t);o.handleEvent.call(o,i)}:function(){var i=e(t);o.call(t,i)},t.attachEvent("on"+i,t[i+o])});var n=function(){};i.removeEventListener?n=function(t,e,i){t.removeEventListener(e,i,!1)}:i.detachEvent&&(n=function(t,e,i){t.detachEvent("on"+e,t[e+i]);try{delete t[e+i]}catch(o){t[e+i]=void 0}});var r={bind:o,unbind:n};"function"==typeof define&&define.amd?define("eventie/eventie",r):"object"==typeof exports?module.exports=r:t.eventie=r}(window),function(){function t(){}function e(t,e){for(var i=t.length;i--;)if(t[i].listener===e)return i;return-1}function i(t){return function(){return this[t].apply(this,arguments)}}var o=t.prototype,n=this,r=n.EventEmitter;o.getListeners=function(t){var e,i,o=this._getEvents();if(t instanceof RegExp){e={};for(i in o)o.hasOwnProperty(i)&&t.test(i)&&(e[i]=o[i])}else e=o[t]||(o[t]=[]);return e},o.flattenListeners=function(t){var e,i=[];for(e=0;t.length>e;e+=1)i.push(t[e].listener);return i},o.getListenersAsObject=function(t){var e,i=this.getListeners(t);return i instanceof Array&&(e={},e[t]=i),e||i},o.addListener=function(t,i){var o,n=this.getListenersAsObject(t),r="object"==typeof i;for(o in n)n.hasOwnProperty(o)&&-1===e(n[o],i)&&n[o].push(r?i:{listener:i,once:!1});return this},o.on=i("addListener"),o.addOnceListener=function(t,e){return this.addListener(t,{listener:e,once:!0})},o.once=i("addOnceListener"),o.defineEvent=function(t){return this.getListeners(t),this},o.defineEvents=function(t){for(var e=0;t.length>e;e+=1)this.defineEvent(t[e]);return this},o.removeListener=function(t,i){var o,n,r=this.getListenersAsObject(t);for(n in r)r.hasOwnProperty(n)&&(o=e(r[n],i),-1!==o&&r[n].splice(o,1));return this},o.off=i("removeListener"),o.addListeners=function(t,e){return this.manipulateListeners(!1,t,e)},o.removeListeners=function(t,e){return this.manipulateListeners(!0,t,e)},o.manipulateListeners=function(t,e,i){var o,n,r=t?this.removeListener:this.addListener,s=t?this.removeListeners:this.addListeners;if("object"!=typeof e||e instanceof RegExp)for(o=i.length;o--;)r.call(this,e,i[o]);else for(o in e)e.hasOwnProperty(o)&&(n=e[o])&&("function"==typeof n?r.call(this,o,n):s.call(this,o,n));return this},o.removeEvent=function(t){var e,i=typeof t,o=this._getEvents();if("string"===i)delete o[t];else if(t instanceof RegExp)for(e in o)o.hasOwnProperty(e)&&t.test(e)&&delete o[e];else delete this._events;return this},o.removeAllListeners=i("removeEvent"),o.emitEvent=function(t,e){var i,o,n,r,s=this.getListenersAsObject(t);for(n in s)if(s.hasOwnProperty(n))for(o=s[n].length;o--;)i=s[n][o],i.once===!0&&this.removeListener(t,i.listener),r=i.listener.apply(this,e||[]),r===this._getOnceReturnValue()&&this.removeListener(t,i.listener);return this},o.trigger=i("emitEvent"),o.emit=function(t){var e=Array.prototype.slice.call(arguments,1);return this.emitEvent(t,e)},o.setOnceReturnValue=function(t){return this._onceReturnValue=t,this},o._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},o._getEvents=function(){return this._events||(this._events={})},t.noConflict=function(){return n.EventEmitter=r,t},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return t}):"object"==typeof module&&module.exports?module.exports=t:n.EventEmitter=t}.call(this),function(t){function e(t){if(t){if("string"==typeof o[t])return t;t=t.charAt(0).toUpperCase()+t.slice(1);for(var e,n=0,r=i.length;r>n;n++)if(e=i[n]+t,"string"==typeof o[e])return e}}var i="Webkit Moz ms Ms O".split(" "),o=document.documentElement.style;"function"==typeof define&&define.amd?define("get-style-property/get-style-property",[],function(){return e}):"object"==typeof exports?module.exports=e:t.getStyleProperty=e}(window),function(t){function e(t){var e=parseFloat(t),i=-1===t.indexOf("%")&&!isNaN(e);return i&&e}function i(){}function o(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0,i=s.length;i>e;e++){var o=s[e];t[o]=0}return t}function n(i){function n(){if(!d){d=!0;var o=t.getComputedStyle;if(p=function(){var t=o?function(t){return o(t,null)}:function(t){return t.currentStyle};return function(e){var i=t(e);return i||r("Style returned "+i+". Are you running this code in a hidden iframe on Firefox? "+"See http://bit.ly/getsizebug1"),i}}(),h=i("boxSizing")){var n=document.createElement("div");n.style.width="200px",n.style.padding="1px 2px 3px 4px",n.style.borderStyle="solid",n.style.borderWidth="1px 2px 3px 4px",n.style[h]="border-box";var s=document.body||document.documentElement;s.appendChild(n);var a=p(n);f=200===e(a.width),s.removeChild(n)}}}function a(t){if(n(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var i=p(t);if("none"===i.display)return o();var r={};r.width=t.offsetWidth,r.height=t.offsetHeight;for(var a=r.isBorderBox=!(!h||!i[h]||"border-box"!==i[h]),d=0,l=s.length;l>d;d++){var c=s[d],m=i[c];m=u(t,m);var y=parseFloat(m);r[c]=isNaN(y)?0:y}var g=r.paddingLeft+r.paddingRight,v=r.paddingTop+r.paddingBottom,_=r.marginLeft+r.marginRight,I=r.marginTop+r.marginBottom,z=r.borderLeftWidth+r.borderRightWidth,L=r.borderTopWidth+r.borderBottomWidth,x=a&&f,E=e(i.width);E!==!1&&(r.width=E+(x?0:g+z));var b=e(i.height);return b!==!1&&(r.height=b+(x?0:v+L)),r.innerWidth=r.width-(g+z),r.innerHeight=r.height-(v+L),r.outerWidth=r.width+_,r.outerHeight=r.height+I,r}}function u(e,i){if(t.getComputedStyle||-1===i.indexOf("%"))return i;var o=e.style,n=o.left,r=e.runtimeStyle,s=r&&r.left;return s&&(r.left=e.currentStyle.left),o.left=i,i=o.pixelLeft,o.left=n,s&&(r.left=s),i}var p,h,f,d=!1;return a}var r="undefined"==typeof console?i:function(t){console.error(t)},s=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];"function"==typeof define&&define.amd?define("get-size/get-size",["get-style-property/get-style-property"],n):"object"==typeof exports?module.exports=n(require("desandro-get-style-property")):t.getSize=n(t.getStyleProperty)}(window),function(t){function e(t){"function"==typeof t&&(e.isReady?t():s.push(t))}function i(t){var i="readystatechange"===t.type&&"complete"!==r.readyState;e.isReady||i||o()}function o(){e.isReady=!0;for(var t=0,i=s.length;i>t;t++){var o=s[t];o()}}function n(n){return"complete"===r.readyState?o():(n.bind(r,"DOMContentLoaded",i),n.bind(r,"readystatechange",i),n.bind(t,"load",i)),e}var r=t.document,s=[];e.isReady=!1,"function"==typeof define&&define.amd?define("doc-ready/doc-ready",["eventie/eventie"],n):"object"==typeof exports?module.exports=n(require("eventie")):t.docReady=n(t.eventie)}(window),function(t){function e(t,e){return t[s](e)}function i(t){if(!t.parentNode){var e=document.createDocumentFragment();e.appendChild(t)}}function o(t,e){i(t);for(var o=t.parentNode.querySelectorAll(e),n=0,r=o.length;r>n;n++)if(o[n]===t)return!0;return!1}function n(t,o){return i(t),e(t,o)}var r,s=function(){if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0,o=e.length;o>i;i++){var n=e[i],r=n+"MatchesSelector";if(t[r])return r}}();if(s){var a=document.createElement("div"),u=e(a,"div");r=u?e:n}else r=o;"function"==typeof define&&define.amd?define("matches-selector/matches-selector",[],function(){return r}):"object"==typeof exports?module.exports=r:window.matchesSelector=r}(Element.prototype),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["doc-ready/doc-ready","matches-selector/matches-selector"],function(i,o){return e(t,i,o)}):"object"==typeof exports?module.exports=e(t,require("doc-ready"),require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.docReady,t.matchesSelector)}(window,function(t,e,i){var o={};o.extend=function(t,e){for(var i in e)t[i]=e[i];return t},o.modulo=function(t,e){return(t%e+e)%e};var n=Object.prototype.toString;o.isArray=function(t){return"[object Array]"==n.call(t)},o.makeArray=function(t){var e=[];if(o.isArray(t))e=t;else if(t&&"number"==typeof t.length)for(var i=0,n=t.length;n>i;i++)e.push(t[i]);else e.push(t);return e},o.indexOf=Array.prototype.indexOf?function(t,e){return t.indexOf(e)}:function(t,e){for(var i=0,o=t.length;o>i;i++)if(t[i]===e)return i;return-1},o.removeFrom=function(t,e){var i=o.indexOf(t,e);-1!=i&&t.splice(i,1)},o.isElement="function"==typeof HTMLElement||"object"==typeof HTMLElement?function(t){return t instanceof HTMLElement}:function(t){return t&&"object"==typeof t&&1==t.nodeType&&"string"==typeof t.nodeName},o.setText=function(){function t(t,i){e=e||(void 0!==document.documentElement.textContent?"textContent":"innerText"),t[e]=i}var e;return t}(),o.getParent=function(t,e){for(;t!=document.body;)if(t=t.parentNode,i(t,e))return t},o.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},o.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},o.filterFindElements=function(t,e){t=o.makeArray(t);for(var n=[],r=0,s=t.length;s>r;r++){var a=t[r];if(o.isElement(a))if(e){i(a,e)&&n.push(a);for(var u=a.querySelectorAll(e),p=0,h=u.length;h>p;p++)n.push(u[p])}else n.push(a)}return n},o.debounceMethod=function(t,e,i){var o=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){var t=this[n];t&&clearTimeout(t);var e=arguments,r=this;this[n]=setTimeout(function(){o.apply(r,e),delete r[n]},i||100)}},o.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var r=t.console;return o.htmlInit=function(i,n){e(function(){for(var e=o.toDashed(n),s=document.querySelectorAll(".js-"+e),a="data-"+e+"-options",u=0,p=s.length;p>u;u++){var h,f=s[u],d=f.getAttribute(a);try{h=d&&JSON.parse(d)}catch(l){r&&r.error("Error parsing "+a+" on "+f.nodeName.toLowerCase()+(f.id?"#"+f.id:"")+": "+l);continue}var c=new i(f,h),m=t.jQuery;m&&m.data(f,n,c)}})},o}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["eventEmitter/EventEmitter","get-size/get-size","get-style-property/get-style-property","fizzy-ui-utils/utils"],function(i,o,n,r){return e(t,i,o,n,r)}):"object"==typeof exports?module.exports=e(t,require("wolfy87-eventemitter"),require("get-size"),require("desandro-get-style-property"),require("fizzy-ui-utils")):(t.Outlayer={},t.Outlayer.Item=e(t,t.EventEmitter,t.getSize,t.getStyleProperty,t.fizzyUIUtils))}(window,function(t,e,i,o,n){function r(t){for(var e in t)return!1;return e=null,!0}function s(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}var a=t.getComputedStyle,u=a?function(t){return a(t,null)}:function(t){return t.currentStyle},p=o("transition"),h=o("transform"),f=p&&h,d=!!o("perspective"),l={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"otransitionend",transition:"transitionend"}[p],c=["transform","transition","transitionDuration","transitionProperty"],m=function(){for(var t={},e=0,i=c.length;i>e;e++){var n=c[e],r=o(n);r&&r!==n&&(t[n]=r)}return t}();n.extend(s.prototype,e.prototype),s.prototype._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},s.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},s.prototype.getSize=function(){this.size=i(this.element)},s.prototype.css=function(t){var e=this.element.style;for(var i in t){var o=m[i]||i;e[o]=t[i]}},s.prototype.getPosition=function(){var t=u(this.element),e=this.layout.options,i=e.isOriginLeft,o=e.isOriginTop,n=parseInt(t[i?"left":"right"],10),r=parseInt(t[o?"top":"bottom"],10);n=isNaN(n)?0:n,r=isNaN(r)?0:r;var s=this.layout.size;n-=i?s.paddingLeft:s.paddingRight,r-=o?s.paddingTop:s.paddingBottom,this.position.x=n,this.position.y=r},s.prototype.layoutPosition=function(){var t=this.layout.size,e=this.layout.options,i={},o=e.isOriginLeft?"paddingLeft":"paddingRight",n=e.isOriginLeft?"left":"right",r=e.isOriginLeft?"right":"left",s=this.position.x+t[o];s=e.percentPosition&&!e.isHorizontal?100*(s/t.width)+"%":s+"px",i[n]=s,i[r]="";var a=e.isOriginTop?"paddingTop":"paddingBottom",u=e.isOriginTop?"top":"bottom",p=e.isOriginTop?"bottom":"top",h=this.position.y+t[a];h=e.percentPosition&&e.isHorizontal?100*(h/t.height)+"%":h+"px",i[u]=h,i[p]="",this.css(i),this.emitEvent("layout",[this])};var y=d?function(t,e){return"translate3d("+t+"px, "+e+"px, 0)"}:function(t,e){return"translate("+t+"px, "+e+"px)"};s.prototype._transitionTo=function(t,e){this.getPosition();var i=this.position.x,o=this.position.y,n=parseInt(t,10),r=parseInt(e,10),s=n===this.position.x&&r===this.position.y;if(this.setPosition(t,e),s&&!this.isTransitioning)return this.layoutPosition(),void 0;var a=t-i,u=e-o,p={},h=this.layout.options;a=h.isOriginLeft?a:-a,u=h.isOriginTop?u:-u,p.transform=y(a,u),this.transition({to:p,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},s.prototype.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},s.prototype.moveTo=f?s.prototype._transitionTo:s.prototype.goTo,s.prototype.setPosition=function(t,e){this.position.x=parseInt(t,10),this.position.y=parseInt(e,10)},s.prototype._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},s.prototype._transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return this._nonTransition(t),void 0;var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var o=this.element.offsetHeight;o=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var g=h&&n.toDashed(h)+",opacity";s.prototype.enableTransition=function(){this.isTransitioning||(this.css({transitionProperty:g,transitionDuration:this.layout.options.transitionDuration}),this.element.addEventListener(l,this,!1))},s.prototype.transition=s.prototype[p?"_transition":"_nonTransition"],s.prototype.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},s.prototype.onotransitionend=function(t){this.ontransitionend(t)};var v={"-webkit-transform":"transform","-moz-transform":"transform","-o-transform":"transform"};s.prototype.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,i=v[t.propertyName]||t.propertyName;if(delete e.ingProperties[i],r(e.ingProperties)&&this.disableTransition(),i in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[i]),i in e.onEnd){var o=e.onEnd[i];o.call(this),delete e.onEnd[i]}this.emitEvent("transitionEnd",[this])}},s.prototype.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(l,this,!1),this.isTransitioning=!1},s.prototype._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var _={transitionProperty:"",transitionDuration:""};return s.prototype.removeTransitionStyles=function(){this.css(_)},s.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},s.prototype.remove=function(){if(!p||!parseFloat(this.layout.options.transitionDuration))return this.removeElem(),void 0;var t=this;this.once("transitionEnd",function(){t.removeElem()}),this.hide()},s.prototype.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},s.prototype.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},s.prototype.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},s.prototype.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},s.prototype.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},s.prototype.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},s}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/outlayer",["eventie/eventie","eventEmitter/EventEmitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,o,n,r,s){return e(t,i,o,n,r,s)}):"object"==typeof exports?module.exports=e(t,require("eventie"),require("wolfy87-eventemitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.eventie,t.EventEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,o,n,r){function s(t,e){var i=n.getQueryElement(t);if(!i)return a&&a.error("Bad element for "+this.constructor.namespace+": "+(i||t)),void 0;this.element=i,u&&(this.$element=u(this.element)),this.options=n.extend({},this.constructor.defaults),this.option(e);var o=++h;this.element.outlayerGUID=o,f[o]=this,this._create(),this.options.isInitLayout&&this.layout()}var a=t.console,u=t.jQuery,p=function(){},h=0,f={};return s.namespace="outlayer",s.Item=r,s.defaults={containerStyle:{position:"relative"},isInitLayout:!0,isOriginLeft:!0,isOriginTop:!0,isResizeBound:!0,isResizingContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}},n.extend(s.prototype,i.prototype),s.prototype.option=function(t){n.extend(this.options,t)},s.prototype._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),n.extend(this.element.style,this.options.containerStyle),this.options.isResizeBound&&this.bindResize()},s.prototype.reloadItems=function(){this.items=this._itemize(this.element.children)},s.prototype._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,o=[],n=0,r=e.length;r>n;n++){var s=e[n],a=new i(s,this);o.push(a)}return o},s.prototype._filterFindItemElements=function(t){return n.filterFindElements(t,this.options.itemSelector)},s.prototype.getItemElements=function(){for(var t=[],e=0,i=this.items.length;i>e;e++)t.push(this.items[e].element);return t},s.prototype.layout=function(){this._resetLayout(),this._manageStamps();var t=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;this.layoutItems(this.items,t),this._isLayoutInited=!0},s.prototype._init=s.prototype.layout,s.prototype._resetLayout=function(){this.getSize()},s.prototype.getSize=function(){this.size=o(this.element)},s.prototype._getMeasurement=function(t,e){var i,r=this.options[t];r?("string"==typeof r?i=this.element.querySelector(r):n.isElement(r)&&(i=r),this[t]=i?o(i)[e]:r):this[t]=0},s.prototype.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},s.prototype._getItemsForLayout=function(t){for(var e=[],i=0,o=t.length;o>i;i++){var n=t[i];n.isIgnored||e.push(n)}return e},s.prototype._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){for(var i=[],o=0,n=t.length;n>o;o++){var r=t[o],s=this._getItemLayoutPosition(r);s.item=r,s.isInstant=e||r.isLayoutInstant,i.push(s)}this._processLayoutQueue(i)}},s.prototype._getItemLayoutPosition=function(){return{x:0,y:0}},s.prototype._processLayoutQueue=function(t){for(var e=0,i=t.length;i>e;e++){var o=t[e];this._positionItem(o.item,o.x,o.y,o.isInstant)}},s.prototype._positionItem=function(t,e,i,o){o?t.goTo(e,i):t.moveTo(e,i)},s.prototype._postLayout=function(){this.resizeContainer()},s.prototype.resizeContainer=function(){if(this.options.isResizingContainer){var t=this._getContainerSize();t&&(this._setContainerMeasure(t.width,!0),this._setContainerMeasure(t.height,!1))}},s.prototype._getContainerSize=p,s.prototype._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},s.prototype._emitCompleteOnItems=function(t,e){function i(){n.emitEvent(t+"Complete",[e])}function o(){s++,s===r&&i()}var n=this,r=e.length;if(!e||!r)return i(),void 0;for(var s=0,a=0,u=e.length;u>a;a++){var p=e[a];p.once(t,o)}},s.prototype.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},s.prototype.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},s.prototype.stamp=function(t){if(t=this._find(t)){this.stamps=this.stamps.concat(t);for(var e=0,i=t.length;i>e;e++){var o=t[e];this.ignore(o)}}},s.prototype.unstamp=function(t){if(t=this._find(t))for(var e=0,i=t.length;i>e;e++){var o=t[e];n.removeFrom(this.stamps,o),this.unignore(o)}},s.prototype._find=function(t){return t?("string"==typeof t&&(t=this.element.querySelectorAll(t)),t=n.makeArray(t)):void 0},s.prototype._manageStamps=function(){if(this.stamps&&this.stamps.length){this._getBoundingRect();for(var t=0,e=this.stamps.length;e>t;t++){var i=this.stamps[t];this._manageStamp(i)}}},s.prototype._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},s.prototype._manageStamp=p,s.prototype._getElementOffset=function(t){var e=t.getBoundingClientRect(),i=this._boundingRect,n=o(t),r={left:e.left-i.left-n.marginLeft,top:e.top-i.top-n.marginTop,right:i.right-e.right-n.marginRight,bottom:i.bottom-e.bottom-n.marginBottom};return r},s.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},s.prototype.bindResize=function(){this.isResizeBound||(e.bind(t,"resize",this),this.isResizeBound=!0)},s.prototype.unbindResize=function(){this.isResizeBound&&e.unbind(t,"resize",this),this.isResizeBound=!1},s.prototype.onresize=function(){function t(){e.resize(),delete e.resizeTimeout}this.resizeTimeout&&clearTimeout(this.resizeTimeout);var e=this;this.resizeTimeout=setTimeout(t,100)},s.prototype.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},s.prototype.needsResizeLayout=function(){var t=o(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},s.prototype.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},s.prototype.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},s.prototype.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},s.prototype.reveal=function(t){this._emitCompleteOnItems("reveal",t);for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.reveal()}},s.prototype.hide=function(t){this._emitCompleteOnItems("hide",t);for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.hide()}},s.prototype.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},s.prototype.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},s.prototype.getItem=function(t){for(var e=0,i=this.items.length;i>e;e++){var o=this.items[e];if(o.element===t)return o}},s.prototype.getItems=function(t){t=n.makeArray(t);for(var e=[],i=0,o=t.length;o>i;i++){var r=t[i],s=this.getItem(r);s&&e.push(s)}return e},s.prototype.remove=function(t){var e=this.getItems(t);if(this._emitCompleteOnItems("remove",e),e&&e.length)for(var i=0,o=e.length;o>i;i++){var r=e[i];r.remove(),n.removeFrom(this.items,r)}},s.prototype.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="";for(var e=0,i=this.items.length;i>e;e++){var o=this.items[e];o.destroy()}this.unbindResize();var n=this.element.outlayerGUID;delete f[n],delete this.element.outlayerGUID,u&&u.removeData(this.element,this.constructor.namespace)},s.data=function(t){t=n.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&f[e]},s.create=function(t,e){function i(){s.apply(this,arguments)}return Object.create?i.prototype=Object.create(s.prototype):n.extend(i.prototype,s.prototype),i.prototype.constructor=i,i.defaults=n.extend({},s.defaults),n.extend(i.defaults,e),i.prototype.settings={},i.namespace=t,i.data=s.data,i.Item=function(){r.apply(this,arguments)},i.Item.prototype=new r,n.htmlInit(i,t),u&&u.bridget&&u.bridget(t,i),i},s.Item=r,s}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/item",["outlayer/outlayer"],e):"object"==typeof exports?module.exports=e(require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.Item=e(t.Outlayer))}(window,function(t){function e(){t.Item.apply(this,arguments)}e.prototype=new t.Item,e.prototype._create=function(){this.id=this.layout.itemGUID++,t.Item.prototype._create.call(this),this.sortData={}},e.prototype.updateSortData=function(){if(!this.isIgnored){this.sortData.id=this.id,this.sortData["original-order"]=this.id,this.sortData.random=Math.random();var t=this.layout.options.getSortData,e=this.layout._sorters;for(var i in t){var o=e[i];this.sortData[i]=o(this.element,this)}}};var i=e.prototype.destroy;return e.prototype.destroy=function(){i.apply(this,arguments),this.css({display:""})},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-mode",["get-size/get-size","outlayer/outlayer"],e):"object"==typeof exports?module.exports=e(require("get-size"),require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.LayoutMode=e(t.getSize,t.Outlayer))}(window,function(t,e){function i(t){this.isotope=t,t&&(this.options=t.options[this.namespace],this.element=t.element,this.items=t.filteredItems,this.size=t.size)}return function(){function t(t){return function(){return e.prototype[t].apply(this.isotope,arguments)}}for(var o=["_resetLayout","_getItemLayoutPosition","_manageStamp","_getContainerSize","_getElementOffset","needsResizeLayout"],n=0,r=o.length;r>n;n++){var s=o[n];i.prototype[s]=t(s)}}(),i.prototype.needsVerticalResizeLayout=function(){var e=t(this.isotope.element),i=this.isotope.size&&e;return i&&e.innerHeight!=this.isotope.size.innerHeight},i.prototype._getMeasurement=function(){this.isotope._getMeasurement.apply(this,arguments)},i.prototype.getColumnWidth=function(){this.getSegmentSize("column","Width")},i.prototype.getRowHeight=function(){this.getSegmentSize("row","Height")},i.prototype.getSegmentSize=function(t,e){var i=t+e,o="outer"+e;if(this._getMeasurement(i,o),!this[i]){var n=this.getFirstItemSize();this[i]=n&&n[o]||this.isotope.size["inner"+e]}},i.prototype.getFirstItemSize=function(){var e=this.isotope.filteredItems[0];return e&&e.element&&t(e.element)},i.prototype.layout=function(){this.isotope.layout.apply(this.isotope,arguments)},i.prototype.getSize=function(){this.isotope.getSize(),this.size=this.isotope.size},i.modes={},i.create=function(t,e){function o(){i.apply(this,arguments)}return o.prototype=new i,e&&(o.options=e),o.prototype.namespace=t,i.modes[t]=o,o},i}),function(t,e){"function"==typeof define&&define.amd?define("masonry/masonry",["outlayer/outlayer","get-size/get-size","fizzy-ui-utils/utils"],e):"object"==typeof exports?module.exports=e(require("outlayer"),require("get-size"),require("fizzy-ui-utils")):t.Masonry=e(t.Outlayer,t.getSize,t.fizzyUIUtils)}(window,function(t,e,i){var o=t.create("masonry");return o.prototype._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns();var t=this.cols;for(this.colYs=[];t--;)this.colYs.push(0);this.maxY=0},o.prototype.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var o=this.columnWidth+=this.gutter,n=this.containerWidth+this.gutter,r=n/o,s=o-n%o,a=s&&1>s?"round":"floor";r=Math[a](r),this.cols=Math.max(r,1)},o.prototype.getContainerWidth=function(){var t=this.options.isFitWidth?this.element.parentNode:this.element,i=e(t);this.containerWidth=i&&i.innerWidth},o.prototype._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,o=e&&1>e?"round":"ceil",n=Math[o](t.size.outerWidth/this.columnWidth);n=Math.min(n,this.cols);for(var r=this._getColGroup(n),s=Math.min.apply(Math,r),a=i.indexOf(r,s),u={x:this.columnWidth*a,y:s},p=s+t.size.outerHeight,h=this.cols+1-r.length,f=0;h>f;f++)this.colYs[a+f]=p;return u},o.prototype._getColGroup=function(t){if(2>t)return this.colYs;for(var e=[],i=this.cols+1-t,o=0;i>o;o++){var n=this.colYs.slice(o,o+t);e[o]=Math.max.apply(Math,n)}return e},o.prototype._manageStamp=function(t){var i=e(t),o=this._getElementOffset(t),n=this.options.isOriginLeft?o.left:o.right,r=n+i.outerWidth,s=Math.floor(n/this.columnWidth);s=Math.max(0,s);var a=Math.floor(r/this.columnWidth);a-=r%this.columnWidth?0:1,a=Math.min(this.cols-1,a);for(var u=(this.options.isOriginTop?o.top:o.bottom)+i.outerHeight,p=s;a>=p;p++)this.colYs[p]=Math.max(u,this.colYs[p])},o.prototype._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this.options.isFitWidth&&(t.width=this._getContainerFitWidth()),t},o.prototype._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},o.prototype.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!==this.containerWidth},o}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/masonry",["../layout-mode","masonry/masonry"],e):"object"==typeof exports?module.exports=e(require("../layout-mode"),require("masonry-layout")):e(t.Isotope.LayoutMode,t.Masonry)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}var o=t.create("masonry"),n=o.prototype._getElementOffset,r=o.prototype.layout,s=o.prototype._getMeasurement;i(o.prototype,e.prototype),o.prototype._getElementOffset=n,o.prototype.layout=r,o.prototype._getMeasurement=s;var a=o.prototype.measureColumns;o.prototype.measureColumns=function(){this.items=this.isotope.filteredItems,a.call(this)};var u=o.prototype._manageStamp;return o.prototype._manageStamp=function(){this.options.isOriginLeft=this.isotope.options.isOriginLeft,this.options.isOriginTop=this.isotope.options.isOriginTop,u.apply(this,arguments)},o}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/fit-rows",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){var e=t.create("fitRows");return e.prototype._resetLayout=function(){this.x=0,this.y=0,this.maxY=0,this._getMeasurement("gutter","outerWidth")
},e.prototype._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth+this.gutter,i=this.isotope.size.innerWidth+this.gutter;0!==this.x&&e+this.x>i&&(this.x=0,this.y=this.maxY);var o={x:this.x,y:this.y};return this.maxY=Math.max(this.maxY,this.y+t.size.outerHeight),this.x+=e,o},e.prototype._getContainerSize=function(){return{height:this.maxY}},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope/js/layout-modes/vertical",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){var e=t.create("vertical",{horizontalAlignment:0});return e.prototype._resetLayout=function(){this.y=0},e.prototype._getItemLayoutPosition=function(t){t.getSize();var e=(this.isotope.size.innerWidth-t.size.outerWidth)*this.options.horizontalAlignment,i=this.y;return this.y+=t.size.outerHeight,{x:e,y:i}},e.prototype._getContainerSize=function(){return{height:this.y}},e}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size","matches-selector/matches-selector","fizzy-ui-utils/utils","isotope/js/item","isotope/js/layout-mode","isotope/js/layout-modes/masonry","isotope/js/layout-modes/fit-rows","isotope/js/layout-modes/vertical"],function(i,o,n,r,s,a){return e(t,i,o,n,r,s,a)}):"object"==typeof exports?module.exports=e(t,require("outlayer"),require("get-size"),require("desandro-matches-selector"),require("fizzy-ui-utils"),require("./item"),require("./layout-mode"),require("./layout-modes/masonry"),require("./layout-modes/fit-rows"),require("./layout-modes/vertical")):t.Isotope=e(t,t.Outlayer,t.getSize,t.matchesSelector,t.fizzyUIUtils,t.Isotope.Item,t.Isotope.LayoutMode)}(window,function(t,e,i,o,n,r,s){function a(t,e){return function(i,o){for(var n=0,r=t.length;r>n;n++){var s=t[n],a=i.sortData[s],u=o.sortData[s];if(a>u||u>a){var p=void 0!==e[s]?e[s]:e,h=p?1:-1;return(a>u?1:-1)*h}}return 0}}var u=t.jQuery,p=String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/g,"")},h=document.documentElement,f=h.textContent?function(t){return t.textContent}:function(t){return t.innerText},d=e.create("isotope",{layoutMode:"masonry",isJQueryFiltering:!0,sortAscending:!0});d.Item=r,d.LayoutMode=s,d.prototype._create=function(){this.itemGUID=0,this._sorters={},this._getSorters(),e.prototype._create.call(this),this.modes={},this.filteredItems=this.items,this.sortHistory=["original-order"];for(var t in s.modes)this._initLayoutMode(t)},d.prototype.reloadItems=function(){this.itemGUID=0,e.prototype.reloadItems.call(this)},d.prototype._itemize=function(){for(var t=e.prototype._itemize.apply(this,arguments),i=0,o=t.length;o>i;i++){var n=t[i];n.id=this.itemGUID++}return this._updateItemsSortData(t),t},d.prototype._initLayoutMode=function(t){var e=s.modes[t],i=this.options[t]||{};this.options[t]=e.options?n.extend(e.options,i):i,this.modes[t]=new e(this)},d.prototype.layout=function(){return!this._isLayoutInited&&this.options.isInitLayout?(this.arrange(),void 0):(this._layout(),void 0)},d.prototype._layout=function(){var t=this._getIsInstant();this._resetLayout(),this._manageStamps(),this.layoutItems(this.filteredItems,t),this._isLayoutInited=!0},d.prototype.arrange=function(t){function e(){o.reveal(i.needReveal),o.hide(i.needHide)}this.option(t),this._getIsInstant();var i=this._filter(this.items);this.filteredItems=i.matches;var o=this;this._bindArrangeComplete(),this._isInstant?this._noTransition(e):e(),this._sort(),this._layout()},d.prototype._init=d.prototype.arrange,d.prototype._getIsInstant=function(){var t=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;return this._isInstant=t,t},d.prototype._bindArrangeComplete=function(){function t(){e&&i&&o&&n.emitEvent("arrangeComplete",[n.filteredItems])}var e,i,o,n=this;this.once("layoutComplete",function(){e=!0,t()}),this.once("hideComplete",function(){i=!0,t()}),this.once("revealComplete",function(){o=!0,t()})},d.prototype._filter=function(t){var e=this.options.filter;e=e||"*";for(var i=[],o=[],n=[],r=this._getFilterTest(e),s=0,a=t.length;a>s;s++){var u=t[s];if(!u.isIgnored){var p=r(u);p&&i.push(u),p&&u.isHidden?o.push(u):p||u.isHidden||n.push(u)}}return{matches:i,needReveal:o,needHide:n}},d.prototype._getFilterTest=function(t){return u&&this.options.isJQueryFiltering?function(e){return u(e.element).is(t)}:"function"==typeof t?function(e){return t(e.element)}:function(e){return o(e.element,t)}},d.prototype.updateSortData=function(t){var e;t?(t=n.makeArray(t),e=this.getItems(t)):e=this.items,this._getSorters(),this._updateItemsSortData(e)},d.prototype._getSorters=function(){var t=this.options.getSortData;for(var e in t){var i=t[e];this._sorters[e]=l(i)}},d.prototype._updateItemsSortData=function(t){for(var e=t&&t.length,i=0;e&&e>i;i++){var o=t[i];o.updateSortData()}};var l=function(){function t(t){if("string"!=typeof t)return t;var i=p(t).split(" "),o=i[0],n=o.match(/^\[(.+)\]$/),r=n&&n[1],s=e(r,o),a=d.sortDataParsers[i[1]];return t=a?function(t){return t&&a(s(t))}:function(t){return t&&s(t)}}function e(t,e){var i;return i=t?function(e){return e.getAttribute(t)}:function(t){var i=t.querySelector(e);return i&&f(i)}}return t}();d.sortDataParsers={parseInt:function(t){return parseInt(t,10)},parseFloat:function(t){return parseFloat(t)}},d.prototype._sort=function(){var t=this.options.sortBy;if(t){var e=[].concat.apply(t,this.sortHistory),i=a(e,this.options.sortAscending);this.filteredItems.sort(i),t!=this.sortHistory[0]&&this.sortHistory.unshift(t)}},d.prototype._mode=function(){var t=this.options.layoutMode,e=this.modes[t];if(!e)throw Error("No layout mode: "+t);return e.options=this.options[t],e},d.prototype._resetLayout=function(){e.prototype._resetLayout.call(this),this._mode()._resetLayout()},d.prototype._getItemLayoutPosition=function(t){return this._mode()._getItemLayoutPosition(t)},d.prototype._manageStamp=function(t){this._mode()._manageStamp(t)},d.prototype._getContainerSize=function(){return this._mode()._getContainerSize()},d.prototype.needsResizeLayout=function(){return this._mode().needsResizeLayout()},d.prototype.appended=function(t){var e=this.addItems(t);if(e.length){var i=this._filterRevealAdded(e);this.filteredItems=this.filteredItems.concat(i)}},d.prototype.prepended=function(t){var e=this._itemize(t);if(e.length){this._resetLayout(),this._manageStamps();var i=this._filterRevealAdded(e);this.layoutItems(this.filteredItems),this.filteredItems=i.concat(this.filteredItems),this.items=e.concat(this.items)}},d.prototype._filterRevealAdded=function(t){var e=this._filter(t);return this.hide(e.needHide),this.reveal(e.matches),this.layoutItems(e.matches,!0),e.matches},d.prototype.insert=function(t){var e=this.addItems(t);if(e.length){var i,o,n=e.length;for(i=0;n>i;i++)o=e[i],this.element.appendChild(o.element);var r=this._filter(e).matches;for(i=0;n>i;i++)e[i].isLayoutInstant=!0;for(this.arrange(),i=0;n>i;i++)delete e[i].isLayoutInstant;this.reveal(r)}};var c=d.prototype.remove;return d.prototype.remove=function(t){t=n.makeArray(t);var e=this.getItems(t);c.call(this,t);var i=e&&e.length;if(i)for(var o=0;i>o;o++){var r=e[o];n.removeFrom(this.filteredItems,r)}},d.prototype.shuffle=function(){for(var t=0,e=this.items.length;e>t;t++){var i=this.items[t];i.sortData.random=Math.random()}this.options.sortBy="random",this._sort(),this._layout()},d.prototype._noTransition=function(t){var e=this.options.transitionDuration;this.options.transitionDuration=0;var i=t.call(this);return this.options.transitionDuration=e,i},d.prototype.getFilteredItemElements=function(){for(var t=[],e=0,i=this.filteredItems.length;i>e;e++)t.push(this.filteredItems[e].element);return t},d}); 
/** **************************************************** **/
/** ********************** slick-carousel ****************************** **/
 /*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}}); 
/** **************************************************** **/
/** ********************** angular ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(T,V,s){'use strict';function F(b){return function(){var a=arguments[0],c;c="["+(b?b+":":"")+a+"] http://errors.angularjs.org/1.3.16/"+(b?b+"/":"")+a;for(a=1;a<arguments.length;a++){c=c+(1==a?"?":"&")+"p"+(a-1)+"=";var d=encodeURIComponent,e;e=arguments[a];e="function"==typeof e?e.toString().replace(/ \{[\s\S]*$/,""):"undefined"==typeof e?"undefined":"string"!=typeof e?JSON.stringify(e):e;c+=d(e)}return Error(c)}}function Sa(b){if(null==b||Ta(b))return!1;var a="length"in Object(b)&&b.length;
return b.nodeType===ma&&a?!0:O(b)||w(b)||0===a||"number"===typeof a&&0<a&&a-1 in b}function q(b,a,c){var d,e;if(b)if(E(b))for(d in b)"prototype"==d||"length"==d||"name"==d||b.hasOwnProperty&&!b.hasOwnProperty(d)||a.call(c,b[d],d,b);else if(w(b)||Sa(b)){var f="object"!==typeof b;d=0;for(e=b.length;d<e;d++)(f||d in b)&&a.call(c,b[d],d,b)}else if(b.forEach&&b.forEach!==q)b.forEach(a,c,b);else for(d in b)b.hasOwnProperty(d)&&a.call(c,b[d],d,b);return b}function Jd(b,a,c){for(var d=Object.keys(b).sort(),
e=0;e<d.length;e++)a.call(c,b[d[e]],d[e]);return d}function pc(b){return function(a,c){b(c,a)}}function Kd(){return++rb}function qc(b,a){a?b.$$hashKey=a:delete b.$$hashKey}function x(b){for(var a=b.$$hashKey,c=1,d=arguments.length;c<d;c++){var e=arguments[c];if(e)for(var f=Object.keys(e),g=0,h=f.length;g<h;g++){var l=f[g];b[l]=e[l]}}qc(b,a);return b}function aa(b){return parseInt(b,10)}function Pb(b,a){return x(Object.create(b),a)}function A(){}function na(b){return b}function ca(b){return function(){return b}}
function C(b){return"undefined"===typeof b}function y(b){return"undefined"!==typeof b}function I(b){return null!==b&&"object"===typeof b}function O(b){return"string"===typeof b}function Q(b){return"number"===typeof b}function ea(b){return"[object Date]"===Aa.call(b)}function E(b){return"function"===typeof b}function Ua(b){return"[object RegExp]"===Aa.call(b)}function Ta(b){return b&&b.window===b}function Va(b){return b&&b.$evalAsync&&b.$watch}function Wa(b){return"boolean"===typeof b}function rc(b){return!(!b||
!(b.nodeName||b.prop&&b.attr&&b.find))}function Ld(b){var a={};b=b.split(",");var c;for(c=0;c<b.length;c++)a[b[c]]=!0;return a}function sa(b){return L(b.nodeName||b[0]&&b[0].nodeName)}function Xa(b,a){var c=b.indexOf(a);0<=c&&b.splice(c,1);return a}function Ba(b,a,c,d){if(Ta(b)||Va(b))throw Ja("cpws");if(a){if(b===a)throw Ja("cpi");c=c||[];d=d||[];if(I(b)){var e=c.indexOf(b);if(-1!==e)return d[e];c.push(b);d.push(a)}if(w(b))for(var f=a.length=0;f<b.length;f++)e=Ba(b[f],null,c,d),I(b[f])&&(c.push(b[f]),
d.push(e)),a.push(e);else{var g=a.$$hashKey;w(a)?a.length=0:q(a,function(b,c){delete a[c]});for(f in b)b.hasOwnProperty(f)&&(e=Ba(b[f],null,c,d),I(b[f])&&(c.push(b[f]),d.push(e)),a[f]=e);qc(a,g)}}else if(a=b)w(b)?a=Ba(b,[],c,d):ea(b)?a=new Date(b.getTime()):Ua(b)?(a=new RegExp(b.source,b.toString().match(/[^\/]*$/)[0]),a.lastIndex=b.lastIndex):I(b)&&(e=Object.create(Object.getPrototypeOf(b)),a=Ba(b,e,c,d));return a}function oa(b,a){if(w(b)){a=a||[];for(var c=0,d=b.length;c<d;c++)a[c]=b[c]}else if(I(b))for(c in a=
a||{},b)if("$"!==c.charAt(0)||"$"!==c.charAt(1))a[c]=b[c];return a||b}function fa(b,a){if(b===a)return!0;if(null===b||null===a)return!1;if(b!==b&&a!==a)return!0;var c=typeof b,d;if(c==typeof a&&"object"==c)if(w(b)){if(!w(a))return!1;if((c=b.length)==a.length){for(d=0;d<c;d++)if(!fa(b[d],a[d]))return!1;return!0}}else{if(ea(b))return ea(a)?fa(b.getTime(),a.getTime()):!1;if(Ua(b))return Ua(a)?b.toString()==a.toString():!1;if(Va(b)||Va(a)||Ta(b)||Ta(a)||w(a)||ea(a)||Ua(a))return!1;c={};for(d in b)if("$"!==
d.charAt(0)&&!E(b[d])){if(!fa(b[d],a[d]))return!1;c[d]=!0}for(d in a)if(!c.hasOwnProperty(d)&&"$"!==d.charAt(0)&&a[d]!==s&&!E(a[d]))return!1;return!0}return!1}function Ya(b,a,c){return b.concat(Za.call(a,c))}function sc(b,a){var c=2<arguments.length?Za.call(arguments,2):[];return!E(a)||a instanceof RegExp?a:c.length?function(){return arguments.length?a.apply(b,Ya(c,arguments,0)):a.apply(b,c)}:function(){return arguments.length?a.apply(b,arguments):a.call(b)}}function Md(b,a){var c=a;"string"===typeof b&&
"$"===b.charAt(0)&&"$"===b.charAt(1)?c=s:Ta(a)?c="$WINDOW":a&&V===a?c="$DOCUMENT":Va(a)&&(c="$SCOPE");return c}function $a(b,a){if("undefined"===typeof b)return s;Q(a)||(a=a?2:null);return JSON.stringify(b,Md,a)}function tc(b){return O(b)?JSON.parse(b):b}function ta(b){b=z(b).clone();try{b.empty()}catch(a){}var c=z("<div>").append(b).html();try{return b[0].nodeType===ab?L(c):c.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/,function(a,b){return"<"+L(b)})}catch(d){return L(c)}}function uc(b){try{return decodeURIComponent(b)}catch(a){}}
function vc(b){var a={},c,d;q((b||"").split("&"),function(b){b&&(c=b.replace(/\+/g,"%20").split("="),d=uc(c[0]),y(d)&&(b=y(c[1])?uc(c[1]):!0,wc.call(a,d)?w(a[d])?a[d].push(b):a[d]=[a[d],b]:a[d]=b))});return a}function Qb(b){var a=[];q(b,function(b,d){w(b)?q(b,function(b){a.push(Ca(d,!0)+(!0===b?"":"="+Ca(b,!0)))}):a.push(Ca(d,!0)+(!0===b?"":"="+Ca(b,!0)))});return a.length?a.join("&"):""}function sb(b){return Ca(b,!0).replace(/%26/gi,"&").replace(/%3D/gi,"=").replace(/%2B/gi,"+")}function Ca(b,a){return encodeURIComponent(b).replace(/%40/gi,
"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%3B/gi,";").replace(/%20/g,a?"%20":"+")}function Nd(b,a){var c,d,e=tb.length;b=z(b);for(d=0;d<e;++d)if(c=tb[d]+a,O(c=b.attr(c)))return c;return null}function Od(b,a){var c,d,e={};q(tb,function(a){a+="app";!c&&b.hasAttribute&&b.hasAttribute(a)&&(c=b,d=b.getAttribute(a))});q(tb,function(a){a+="app";var e;!c&&(e=b.querySelector("["+a.replace(":","\\:")+"]"))&&(c=e,d=e.getAttribute(a))});c&&(e.strictDi=null!==Nd(c,"strict-di"),
a(c,d?[d]:[],e))}function xc(b,a,c){I(c)||(c={});c=x({strictDi:!1},c);var d=function(){b=z(b);if(b.injector()){var d=b[0]===V?"document":ta(b);throw Ja("btstrpd",d.replace(/</,"&lt;").replace(/>/,"&gt;"));}a=a||[];a.unshift(["$provide",function(a){a.value("$rootElement",b)}]);c.debugInfoEnabled&&a.push(["$compileProvider",function(a){a.debugInfoEnabled(!0)}]);a.unshift("ng");d=bb(a,c.strictDi);d.invoke(["$rootScope","$rootElement","$compile","$injector",function(a,b,c,d){a.$apply(function(){b.data("$injector",
d);c(b)(a)})}]);return d},e=/^NG_ENABLE_DEBUG_INFO!/,f=/^NG_DEFER_BOOTSTRAP!/;T&&e.test(T.name)&&(c.debugInfoEnabled=!0,T.name=T.name.replace(e,""));if(T&&!f.test(T.name))return d();T.name=T.name.replace(f,"");ba.resumeBootstrap=function(b){q(b,function(b){a.push(b)});return d()};E(ba.resumeDeferredBootstrap)&&ba.resumeDeferredBootstrap()}function Pd(){T.name="NG_ENABLE_DEBUG_INFO!"+T.name;T.location.reload()}function Qd(b){b=ba.element(b).injector();if(!b)throw Ja("test");return b.get("$$testability")}
function yc(b,a){a=a||"_";return b.replace(Rd,function(b,d){return(d?a:"")+b.toLowerCase()})}function Sd(){var b;zc||((pa=T.jQuery)&&pa.fn.on?(z=pa,x(pa.fn,{scope:Ka.scope,isolateScope:Ka.isolateScope,controller:Ka.controller,injector:Ka.injector,inheritedData:Ka.inheritedData}),b=pa.cleanData,pa.cleanData=function(a){var c;if(Rb)Rb=!1;else for(var d=0,e;null!=(e=a[d]);d++)(c=pa._data(e,"events"))&&c.$destroy&&pa(e).triggerHandler("$destroy");b(a)}):z=R,ba.element=z,zc=!0)}function Sb(b,a,c){if(!b)throw Ja("areq",
a||"?",c||"required");return b}function La(b,a,c){c&&w(b)&&(b=b[b.length-1]);Sb(E(b),a,"not a function, got "+(b&&"object"===typeof b?b.constructor.name||"Object":typeof b));return b}function Ma(b,a){if("hasOwnProperty"===b)throw Ja("badname",a);}function Ac(b,a,c){if(!a)return b;a=a.split(".");for(var d,e=b,f=a.length,g=0;g<f;g++)d=a[g],b&&(b=(e=b)[d]);return!c&&E(b)?sc(e,b):b}function ub(b){var a=b[0];b=b[b.length-1];var c=[a];do{a=a.nextSibling;if(!a)break;c.push(a)}while(a!==b);return z(c)}function ga(){return Object.create(null)}
function Td(b){function a(a,b,c){return a[b]||(a[b]=c())}var c=F("$injector"),d=F("ng");b=a(b,"angular",Object);b.$$minErr=b.$$minErr||F;return a(b,"module",function(){var b={};return function(f,g,h){if("hasOwnProperty"===f)throw d("badname","module");g&&b.hasOwnProperty(f)&&(b[f]=null);return a(b,f,function(){function a(c,d,e,f){f||(f=b);return function(){f[e||"push"]([c,d,arguments]);return u}}if(!g)throw c("nomod",f);var b=[],d=[],e=[],n=a("$injector","invoke","push",d),u={_invokeQueue:b,_configBlocks:d,
_runBlocks:e,requires:g,name:f,provider:a("$provide","provider"),factory:a("$provide","factory"),service:a("$provide","service"),value:a("$provide","value"),constant:a("$provide","constant","unshift"),animation:a("$animateProvider","register"),filter:a("$filterProvider","register"),controller:a("$controllerProvider","register"),directive:a("$compileProvider","directive"),config:n,run:function(a){e.push(a);return this}};h&&n(h);return u})}})}function Ud(b){x(b,{bootstrap:xc,copy:Ba,extend:x,equals:fa,
element:z,forEach:q,injector:bb,noop:A,bind:sc,toJson:$a,fromJson:tc,identity:na,isUndefined:C,isDefined:y,isString:O,isFunction:E,isObject:I,isNumber:Q,isElement:rc,isArray:w,version:Vd,isDate:ea,lowercase:L,uppercase:vb,callbacks:{counter:0},getTestability:Qd,$$minErr:F,$$csp:cb,reloadWithDebugInfo:Pd});db=Td(T);try{db("ngLocale")}catch(a){db("ngLocale",[]).provider("$locale",Wd)}db("ng",["ngLocale"],["$provide",function(a){a.provider({$$sanitizeUri:Xd});a.provider("$compile",Bc).directive({a:Yd,
input:Cc,textarea:Cc,form:Zd,script:$d,select:ae,style:be,option:ce,ngBind:de,ngBindHtml:ee,ngBindTemplate:fe,ngClass:ge,ngClassEven:he,ngClassOdd:ie,ngCloak:je,ngController:ke,ngForm:le,ngHide:me,ngIf:ne,ngInclude:oe,ngInit:pe,ngNonBindable:qe,ngPluralize:re,ngRepeat:se,ngShow:te,ngStyle:ue,ngSwitch:ve,ngSwitchWhen:we,ngSwitchDefault:xe,ngOptions:ye,ngTransclude:ze,ngModel:Ae,ngList:Be,ngChange:Ce,pattern:Dc,ngPattern:Dc,required:Ec,ngRequired:Ec,minlength:Fc,ngMinlength:Fc,maxlength:Gc,ngMaxlength:Gc,
ngValue:De,ngModelOptions:Ee}).directive({ngInclude:Fe}).directive(wb).directive(Hc);a.provider({$anchorScroll:Ge,$animate:He,$browser:Ie,$cacheFactory:Je,$controller:Ke,$document:Le,$exceptionHandler:Me,$filter:Ic,$interpolate:Ne,$interval:Oe,$http:Pe,$httpBackend:Qe,$location:Re,$log:Se,$parse:Te,$rootScope:Ue,$q:Ve,$$q:We,$sce:Xe,$sceDelegate:Ye,$sniffer:Ze,$templateCache:$e,$templateRequest:af,$$testability:bf,$timeout:cf,$window:df,$$rAF:ef,$$asyncCallback:ff,$$jqLite:gf})}])}function eb(b){return b.replace(hf,
function(a,b,d,e){return e?d.toUpperCase():d}).replace(jf,"Moz$1")}function Jc(b){b=b.nodeType;return b===ma||!b||9===b}function Kc(b,a){var c,d,e=a.createDocumentFragment(),f=[];if(Tb.test(b)){c=c||e.appendChild(a.createElement("div"));d=(kf.exec(b)||["",""])[1].toLowerCase();d=ha[d]||ha._default;c.innerHTML=d[1]+b.replace(lf,"<$1></$2>")+d[2];for(d=d[0];d--;)c=c.lastChild;f=Ya(f,c.childNodes);c=e.firstChild;c.textContent=""}else f.push(a.createTextNode(b));e.textContent="";e.innerHTML="";q(f,function(a){e.appendChild(a)});
return e}function R(b){if(b instanceof R)return b;var a;O(b)&&(b=U(b),a=!0);if(!(this instanceof R)){if(a&&"<"!=b.charAt(0))throw Ub("nosel");return new R(b)}if(a){a=V;var c;b=(c=mf.exec(b))?[a.createElement(c[1])]:(c=Kc(b,a))?c.childNodes:[]}Lc(this,b)}function Vb(b){return b.cloneNode(!0)}function xb(b,a){a||yb(b);if(b.querySelectorAll)for(var c=b.querySelectorAll("*"),d=0,e=c.length;d<e;d++)yb(c[d])}function Mc(b,a,c,d){if(y(d))throw Ub("offargs");var e=(d=zb(b))&&d.events,f=d&&d.handle;if(f)if(a)q(a.split(" "),
function(a){if(y(c)){var d=e[a];Xa(d||[],c);if(d&&0<d.length)return}b.removeEventListener(a,f,!1);delete e[a]});else for(a in e)"$destroy"!==a&&b.removeEventListener(a,f,!1),delete e[a]}function yb(b,a){var c=b.ng339,d=c&&Ab[c];d&&(a?delete d.data[a]:(d.handle&&(d.events.$destroy&&d.handle({},"$destroy"),Mc(b)),delete Ab[c],b.ng339=s))}function zb(b,a){var c=b.ng339,c=c&&Ab[c];a&&!c&&(b.ng339=c=++nf,c=Ab[c]={events:{},data:{},handle:s});return c}function Wb(b,a,c){if(Jc(b)){var d=y(c),e=!d&&a&&!I(a),
f=!a;b=(b=zb(b,!e))&&b.data;if(d)b[a]=c;else{if(f)return b;if(e)return b&&b[a];x(b,a)}}}function Bb(b,a){return b.getAttribute?-1<(" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").indexOf(" "+a+" "):!1}function Cb(b,a){a&&b.setAttribute&&q(a.split(" "),function(a){b.setAttribute("class",U((" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").replace(" "+U(a)+" "," ")))})}function Db(b,a){if(a&&b.setAttribute){var c=(" "+(b.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ");
q(a.split(" "),function(a){a=U(a);-1===c.indexOf(" "+a+" ")&&(c+=a+" ")});b.setAttribute("class",U(c))}}function Lc(b,a){if(a)if(a.nodeType)b[b.length++]=a;else{var c=a.length;if("number"===typeof c&&a.window!==a){if(c)for(var d=0;d<c;d++)b[b.length++]=a[d]}else b[b.length++]=a}}function Nc(b,a){return Eb(b,"$"+(a||"ngController")+"Controller")}function Eb(b,a,c){9==b.nodeType&&(b=b.documentElement);for(a=w(a)?a:[a];b;){for(var d=0,e=a.length;d<e;d++)if((c=z.data(b,a[d]))!==s)return c;b=b.parentNode||
11===b.nodeType&&b.host}}function Oc(b){for(xb(b,!0);b.firstChild;)b.removeChild(b.firstChild)}function Pc(b,a){a||xb(b);var c=b.parentNode;c&&c.removeChild(b)}function of(b,a){a=a||T;if("complete"===a.document.readyState)a.setTimeout(b);else z(a).on("load",b)}function Qc(b,a){var c=Fb[a.toLowerCase()];return c&&Rc[sa(b)]&&c}function pf(b,a){var c=b.nodeName;return("INPUT"===c||"TEXTAREA"===c)&&Sc[a]}function qf(b,a){var c=function(c,e){c.isDefaultPrevented=function(){return c.defaultPrevented};var f=
a[e||c.type],g=f?f.length:0;if(g){if(C(c.immediatePropagationStopped)){var h=c.stopImmediatePropagation;c.stopImmediatePropagation=function(){c.immediatePropagationStopped=!0;c.stopPropagation&&c.stopPropagation();h&&h.call(c)}}c.isImmediatePropagationStopped=function(){return!0===c.immediatePropagationStopped};1<g&&(f=oa(f));for(var l=0;l<g;l++)c.isImmediatePropagationStopped()||f[l].call(b,c)}};c.elem=b;return c}function gf(){this.$get=function(){return x(R,{hasClass:function(b,a){b.attr&&(b=b[0]);
return Bb(b,a)},addClass:function(b,a){b.attr&&(b=b[0]);return Db(b,a)},removeClass:function(b,a){b.attr&&(b=b[0]);return Cb(b,a)}})}}function Na(b,a){var c=b&&b.$$hashKey;if(c)return"function"===typeof c&&(c=b.$$hashKey()),c;c=typeof b;return c="function"==c||"object"==c&&null!==b?b.$$hashKey=c+":"+(a||Kd)():c+":"+b}function fb(b,a){if(a){var c=0;this.nextUid=function(){return++c}}q(b,this.put,this)}function rf(b){return(b=b.toString().replace(Tc,"").match(Uc))?"function("+(b[1]||"").replace(/[\s\r\n]+/,
" ")+")":"fn"}function bb(b,a){function c(a){return function(b,c){if(I(b))q(b,pc(a));else return a(b,c)}}function d(a,b){Ma(a,"service");if(E(b)||w(b))b=n.instantiate(b);if(!b.$get)throw Da("pget",a);return r[a+"Provider"]=b}function e(a,b){return function(){var c=v.invoke(b,this);if(C(c))throw Da("undef",a);return c}}function f(a,b,c){return d(a,{$get:!1!==c?e(a,b):b})}function g(a){var b=[],c;q(a,function(a){function d(a){var b,c;b=0;for(c=a.length;b<c;b++){var e=a[b],f=n.get(e[0]);f[e[1]].apply(f,
e[2])}}if(!m.get(a)){m.put(a,!0);try{O(a)?(c=db(a),b=b.concat(g(c.requires)).concat(c._runBlocks),d(c._invokeQueue),d(c._configBlocks)):E(a)?b.push(n.invoke(a)):w(a)?b.push(n.invoke(a)):La(a,"module")}catch(e){throw w(a)&&(a=a[a.length-1]),e.message&&e.stack&&-1==e.stack.indexOf(e.message)&&(e=e.message+"\n"+e.stack),Da("modulerr",a,e.stack||e.message||e);}}});return b}function h(b,c){function d(a,e){if(b.hasOwnProperty(a)){if(b[a]===l)throw Da("cdep",a+" <- "+k.join(" <- "));return b[a]}try{return k.unshift(a),
b[a]=l,b[a]=c(a,e)}catch(f){throw b[a]===l&&delete b[a],f;}finally{k.shift()}}function e(b,c,f,g){"string"===typeof f&&(g=f,f=null);var k=[],l=bb.$$annotate(b,a,g),h,n,m;n=0;for(h=l.length;n<h;n++){m=l[n];if("string"!==typeof m)throw Da("itkn",m);k.push(f&&f.hasOwnProperty(m)?f[m]:d(m,g))}w(b)&&(b=b[h]);return b.apply(c,k)}return{invoke:e,instantiate:function(a,b,c){var d=Object.create((w(a)?a[a.length-1]:a).prototype||null);a=e(a,d,b,c);return I(a)||E(a)?a:d},get:d,annotate:bb.$$annotate,has:function(a){return r.hasOwnProperty(a+
"Provider")||b.hasOwnProperty(a)}}}a=!0===a;var l={},k=[],m=new fb([],!0),r={$provide:{provider:c(d),factory:c(f),service:c(function(a,b){return f(a,["$injector",function(a){return a.instantiate(b)}])}),value:c(function(a,b){return f(a,ca(b),!1)}),constant:c(function(a,b){Ma(a,"constant");r[a]=b;u[a]=b}),decorator:function(a,b){var c=n.get(a+"Provider"),d=c.$get;c.$get=function(){var a=v.invoke(d,c);return v.invoke(b,null,{$delegate:a})}}}},n=r.$injector=h(r,function(a,b){ba.isString(b)&&k.push(b);
throw Da("unpr",k.join(" <- "));}),u={},v=u.$injector=h(u,function(a,b){var c=n.get(a+"Provider",b);return v.invoke(c.$get,c,s,a)});q(g(b),function(a){v.invoke(a||A)});return v}function Ge(){var b=!0;this.disableAutoScrolling=function(){b=!1};this.$get=["$window","$location","$rootScope",function(a,c,d){function e(a){var b=null;Array.prototype.some.call(a,function(a){if("a"===sa(a))return b=a,!0});return b}function f(b){if(b){b.scrollIntoView();var c;c=g.yOffset;E(c)?c=c():rc(c)?(c=c[0],c="fixed"!==
a.getComputedStyle(c).position?0:c.getBoundingClientRect().bottom):Q(c)||(c=0);c&&(b=b.getBoundingClientRect().top,a.scrollBy(0,b-c))}else a.scrollTo(0,0)}function g(){var a=c.hash(),b;a?(b=h.getElementById(a))?f(b):(b=e(h.getElementsByName(a)))?f(b):"top"===a&&f(null):f(null)}var h=a.document;b&&d.$watch(function(){return c.hash()},function(a,b){a===b&&""===a||of(function(){d.$evalAsync(g)})});return g}]}function ff(){this.$get=["$$rAF","$timeout",function(b,a){return b.supported?function(a){return b(a)}:
function(b){return a(b,0,!1)}}]}function sf(b,a,c,d){function e(a){try{a.apply(null,Za.call(arguments,1))}finally{if(p--,0===p)for(;H.length;)try{H.pop()()}catch(b){c.error(b)}}}function f(a,b){(function Xb(){q(J,function(a){a()});B=b(Xb,a)})()}function g(){h();l()}function h(){a:{try{M=u.state;break a}catch(a){}M=void 0}M=C(M)?null:M;fa(M,S)&&(M=S);S=M}function l(){if(G!==m.url()||D!==M)G=m.url(),D=M,q($,function(a){a(m.url(),M)})}function k(a){try{return decodeURIComponent(a)}catch(b){return a}}
var m=this,r=a[0],n=b.location,u=b.history,v=b.setTimeout,P=b.clearTimeout,t={};m.isMock=!1;var p=0,H=[];m.$$completeOutstandingRequest=e;m.$$incOutstandingRequestCount=function(){p++};m.notifyWhenNoOutstandingRequests=function(a){q(J,function(a){a()});0===p?a():H.push(a)};var J=[],B;m.addPollFn=function(a){C(B)&&f(100,v);J.push(a);return a};var M,D,G=n.href,N=a.find("base"),Y=null;h();D=M;m.url=function(a,c,e){C(e)&&(e=null);n!==b.location&&(n=b.location);u!==b.history&&(u=b.history);if(a){var f=
D===e;if(G===a&&(!d.history||f))return m;var g=G&&Ea(G)===Ea(a);G=a;D=e;!d.history||g&&f?(g||(Y=a),c?n.replace(a):g?(c=n,e=a.indexOf("#"),a=-1===e?"":a.substr(e+1),c.hash=a):n.href=a):(u[c?"replaceState":"pushState"](e,"",a),h(),D=M);return m}return Y||n.href.replace(/%27/g,"'")};m.state=function(){return M};var $=[],W=!1,S=null;m.onUrlChange=function(a){if(!W){if(d.history)z(b).on("popstate",g);z(b).on("hashchange",g);W=!0}$.push(a);return a};m.$$checkUrlChange=l;m.baseHref=function(){var a=N.attr("href");
return a?a.replace(/^(https?\:)?\/\/[^\/]*/,""):""};var Fa={},y="",hb=m.baseHref();m.cookies=function(a,b){var d,e,f,g;if(a)b===s?r.cookie=encodeURIComponent(a)+"=;path="+hb+";expires=Thu, 01 Jan 1970 00:00:00 GMT":O(b)&&(d=(r.cookie=encodeURIComponent(a)+"="+encodeURIComponent(b)+";path="+hb).length+1,4096<d&&c.warn("Cookie '"+a+"' possibly not set or overflowed because it was too large ("+d+" > 4096 bytes)!"));else{if(r.cookie!==y)for(y=r.cookie,d=y.split("; "),Fa={},f=0;f<d.length;f++)e=d[f],g=
e.indexOf("="),0<g&&(a=k(e.substring(0,g)),Fa[a]===s&&(Fa[a]=k(e.substring(g+1))));return Fa}};m.defer=function(a,b){var c;p++;c=v(function(){delete t[c];e(a)},b||0);t[c]=!0;return c};m.defer.cancel=function(a){return t[a]?(delete t[a],P(a),e(A),!0):!1}}function Ie(){this.$get=["$window","$log","$sniffer","$document",function(b,a,c,d){return new sf(b,d,a,c)}]}function Je(){this.$get=function(){function b(b,d){function e(a){a!=r&&(n?n==a&&(n=a.n):n=a,f(a.n,a.p),f(a,r),r=a,r.n=null)}function f(a,b){a!=
b&&(a&&(a.p=b),b&&(b.n=a))}if(b in a)throw F("$cacheFactory")("iid",b);var g=0,h=x({},d,{id:b}),l={},k=d&&d.capacity||Number.MAX_VALUE,m={},r=null,n=null;return a[b]={put:function(a,b){if(k<Number.MAX_VALUE){var c=m[a]||(m[a]={key:a});e(c)}if(!C(b))return a in l||g++,l[a]=b,g>k&&this.remove(n.key),b},get:function(a){if(k<Number.MAX_VALUE){var b=m[a];if(!b)return;e(b)}return l[a]},remove:function(a){if(k<Number.MAX_VALUE){var b=m[a];if(!b)return;b==r&&(r=b.p);b==n&&(n=b.n);f(b.n,b.p);delete m[a]}delete l[a];
g--},removeAll:function(){l={};g=0;m={};r=n=null},destroy:function(){m=h=l=null;delete a[b]},info:function(){return x({},h,{size:g})}}}var a={};b.info=function(){var b={};q(a,function(a,e){b[e]=a.info()});return b};b.get=function(b){return a[b]};return b}}function $e(){this.$get=["$cacheFactory",function(b){return b("templates")}]}function Bc(b,a){function c(a,b){var c=/^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/,d={};q(a,function(a,e){var f=a.match(c);if(!f)throw da("iscp",b,e,a);d[e]={mode:f[1][0],collection:"*"===
f[2],optional:"?"===f[3],attrName:f[4]||e}});return d}function d(a){var b=a.charAt(0);if(!b||b!==L(b))throw da("baddir",a);return a}var e={},f=/^\s*directive\:\s*([\w\-]+)\s+(.*)$/,g=/(([\w\-]+)(?:\:([^;]+))?;?)/,h=Ld("ngSrc,ngSrcset,src,srcset"),l=/^(?:(\^\^?)?(\?)?(\^\^?)?)?/,k=/^(on[a-z]+|formaction)$/;this.directive=function n(a,f){Ma(a,"directive");O(a)?(d(a),Sb(f,"directiveFactory"),e.hasOwnProperty(a)||(e[a]=[],b.factory(a+"Directive",["$injector","$exceptionHandler",function(b,d){var f=[];
q(e[a],function(e,g){try{var h=b.invoke(e);E(h)?h={compile:ca(h)}:!h.compile&&h.link&&(h.compile=ca(h.link));h.priority=h.priority||0;h.index=g;h.name=h.name||a;h.require=h.require||h.controller&&h.name;h.restrict=h.restrict||"EA";I(h.scope)&&(h.$$isolateBindings=c(h.scope,h.name));f.push(h)}catch(l){d(l)}});return f}])),e[a].push(f)):q(a,pc(n));return this};this.aHrefSanitizationWhitelist=function(b){return y(b)?(a.aHrefSanitizationWhitelist(b),this):a.aHrefSanitizationWhitelist()};this.imgSrcSanitizationWhitelist=
function(b){return y(b)?(a.imgSrcSanitizationWhitelist(b),this):a.imgSrcSanitizationWhitelist()};var m=!0;this.debugInfoEnabled=function(a){return y(a)?(m=a,this):m};this.$get=["$injector","$interpolate","$exceptionHandler","$templateRequest","$parse","$controller","$rootScope","$document","$sce","$animate","$$sanitizeUri",function(a,b,c,d,t,p,H,J,B,M,D){function G(a,b){try{a.addClass(b)}catch(c){}}function N(a,b,c,d,e){a instanceof z||(a=z(a));q(a,function(b,c){b.nodeType==ab&&b.nodeValue.match(/\S+/)&&
(a[c]=z(b).wrap("<span></span>").parent()[0])});var f=Y(a,b,a,c,d,e);N.$$addScopeClass(a);var g=null;return function(b,c,d){Sb(b,"scope");d=d||{};var e=d.parentBoundTranscludeFn,h=d.transcludeControllers;d=d.futureParentElement;e&&e.$$boundTransclude&&(e=e.$$boundTransclude);g||(g=(d=d&&d[0])?"foreignobject"!==sa(d)&&d.toString().match(/SVG/)?"svg":"html":"html");d="html"!==g?z(T(g,z("<div>").append(a).html())):c?Ka.clone.call(a):a;if(h)for(var l in h)d.data("$"+l+"Controller",h[l].instance);N.$$addScopeInfo(d,
b);c&&c(d,b);f&&f(b,d,d,e);return d}}function Y(a,b,c,d,e,f){function g(a,c,d,e){var f,l,k,n,m,v,u;if(p)for(u=Array(c.length),n=0;n<h.length;n+=3)f=h[n],u[f]=c[f];else u=c;n=0;for(m=h.length;n<m;)l=u[h[n++]],c=h[n++],f=h[n++],c?(c.scope?(k=a.$new(),N.$$addScopeInfo(z(l),k)):k=a,v=c.transcludeOnThisElement?$(a,c.transclude,e,c.elementTranscludeOnThisElement):!c.templateOnThisElement&&e?e:!e&&b?$(a,b):null,c(f,k,l,d,v)):f&&f(a,l.childNodes,s,e)}for(var h=[],l,k,n,m,p,v=0;v<a.length;v++){l=new $b;k=
W(a[v],[],l,0===v?d:s,e);(f=k.length?y(k,a[v],l,b,c,null,[],[],f):null)&&f.scope&&N.$$addScopeClass(l.$$element);l=f&&f.terminal||!(n=a[v].childNodes)||!n.length?null:Y(n,f?(f.transcludeOnThisElement||!f.templateOnThisElement)&&f.transclude:b);if(f||l)h.push(v,f,l),m=!0,p=p||f;f=null}return m?g:null}function $(a,b,c,d){return function(d,e,f,g,h){d||(d=a.$new(!1,h),d.$$transcluded=!0);return b(d,e,{parentBoundTranscludeFn:c,transcludeControllers:f,futureParentElement:g})}}function W(a,b,c,d,e){var h=
c.$attr,l;switch(a.nodeType){case ma:C(b,va(sa(a)),"E",d,e);for(var k,n,m,p=a.attributes,v=0,u=p&&p.length;v<u;v++){var B=!1,P=!1;k=p[v];l=k.name;n=U(k.value);k=va(l);if(m=ac.test(k))l=l.replace(Wc,"").substr(8).replace(/_(.)/g,function(a,b){return b.toUpperCase()});var M=k.replace(/(Start|End)$/,"");F(M)&&k===M+"Start"&&(B=l,P=l.substr(0,l.length-5)+"end",l=l.substr(0,l.length-6));k=va(l.toLowerCase());h[k]=l;if(m||!c.hasOwnProperty(k))c[k]=n,Qc(a,k)&&(c[k]=!0);R(a,b,n,k,m);C(b,k,"A",d,e,B,P)}a=
a.className;I(a)&&(a=a.animVal);if(O(a)&&""!==a)for(;l=g.exec(a);)k=va(l[2]),C(b,k,"C",d,e)&&(c[k]=U(l[3])),a=a.substr(l.index+l[0].length);break;case ab:ia(b,a.nodeValue);break;case 8:try{if(l=f.exec(a.nodeValue))k=va(l[1]),C(b,k,"M",d,e)&&(c[k]=U(l[2]))}catch(t){}}b.sort(xa);return b}function S(a,b,c){var d=[],e=0;if(b&&a.hasAttribute&&a.hasAttribute(b)){do{if(!a)throw da("uterdir",b,c);a.nodeType==ma&&(a.hasAttribute(b)&&e++,a.hasAttribute(c)&&e--);d.push(a);a=a.nextSibling}while(0<e)}else d.push(a);
return z(d)}function Fa(a,b,c){return function(d,e,f,g,h){e=S(e[0],b,c);return a(d,e,f,g,h)}}function y(a,d,e,f,g,h,k,n,m){function B(a,b,c,d){if(a){c&&(a=Fa(a,c,d));a.require=K.require;a.directiveName=ia;if(J===K||K.$$isolateScope)a=X(a,{isolateScope:!0});k.push(a)}if(b){c&&(b=Fa(b,c,d));b.require=K.require;b.directiveName=ia;if(J===K||K.$$isolateScope)b=X(b,{isolateScope:!0});n.push(b)}}function P(a,b,c,d){var e,f="data",g=!1,h=c,k;if(O(b)){k=b.match(l);b=b.substring(k[0].length);k[3]&&(k[1]?k[3]=
null:k[1]=k[3]);"^"===k[1]?f="inheritedData":"^^"===k[1]&&(f="inheritedData",h=c.parent());"?"===k[2]&&(g=!0);e=null;d&&"data"===f&&(e=d[b])&&(e=e.instance);e=e||h[f]("$"+b+"Controller");if(!e&&!g)throw da("ctreq",b,a);return e||null}w(b)&&(e=[],q(b,function(b){e.push(P(a,b,c,d))}));return e}function M(a,c,f,g,h){function l(a,b,c){var d;Va(a)||(c=b,b=a,a=s);A&&(d=G);c||(c=A?S.parent():S);return h(a,b,d,c,Zb)}var m,v,B,D,G,ib,S,W;d===f?(W=e,S=e.$$element):(S=z(f),W=new $b(S,e));J&&(D=c.$new(!0));h&&
(ib=l,ib.$$boundTransclude=h);H&&($={},G={},q(H,function(a){var b={$scope:a===J||a.$$isolateScope?D:c,$element:S,$attrs:W,$transclude:ib};B=a.controller;"@"==B&&(B=W[a.name]);b=p(B,b,!0,a.controllerAs);G[a.name]=b;A||S.data("$"+a.name+"Controller",b.instance);$[a.name]=b}));if(J){N.$$addScopeInfo(S,D,!0,!(Y&&(Y===J||Y===J.$$originalDirective)));N.$$addScopeClass(S,!0);g=$&&$[J.name];var ua=D;g&&g.identifier&&!0===J.bindToController&&(ua=g.instance);q(D.$$isolateBindings=J.$$isolateBindings,function(a,
d){var e=a.attrName,f=a.optional,g,h,k,l;switch(a.mode){case "@":W.$observe(e,function(a){ua[d]=a});W.$$observers[e].$$scope=c;W[e]&&(ua[d]=b(W[e])(c));break;case "=":if(f&&!W[e])break;h=t(W[e]);l=h.literal?fa:function(a,b){return a===b||a!==a&&b!==b};k=h.assign||function(){g=ua[d]=h(c);throw da("nonassign",W[e],J.name);};g=ua[d]=h(c);f=function(a){l(a,ua[d])||(l(a,g)?k(c,a=ua[d]):ua[d]=a);return g=a};f.$stateful=!0;f=a.collection?c.$watchCollection(W[e],f):c.$watch(t(W[e],f),null,h.literal);D.$on("$destroy",
f);break;case "&":h=t(W[e]),ua[d]=function(a){return h(c,a)}}})}$&&(q($,function(a){a()}),$=null);g=0;for(m=k.length;g<m;g++)v=k[g],Xc(v,v.isolateScope?D:c,S,W,v.require&&P(v.directiveName,v.require,S,G),ib);var Zb=c;J&&(J.template||null===J.templateUrl)&&(Zb=D);a&&a(Zb,f.childNodes,s,h);for(g=n.length-1;0<=g;g--)v=n[g],Xc(v,v.isolateScope?D:c,S,W,v.require&&P(v.directiveName,v.require,S,G),ib)}m=m||{};for(var D=-Number.MAX_VALUE,G,H=m.controllerDirectives,$,J=m.newIsolateScopeDirective,Y=m.templateDirective,
Ga=m.nonTlbTranscludeDirective,C=!1,Yb=!1,A=m.hasElementTranscludeDirective,x=e.$$element=z(d),K,ia,F,gb=f,xa,qa=0,L=a.length;qa<L;qa++){K=a[qa];var R=K.$$start,jb=K.$$end;R&&(x=S(d,R,jb));F=s;if(D>K.priority)break;if(F=K.scope)K.templateUrl||(I(F)?(Oa("new/isolated scope",J||G,K,x),J=K):Oa("new/isolated scope",J,K,x)),G=G||K;ia=K.name;!K.templateUrl&&K.controller&&(F=K.controller,H=H||{},Oa("'"+ia+"' controller",H[ia],K,x),H[ia]=K);if(F=K.transclude)C=!0,K.$$tlb||(Oa("transclusion",Ga,K,x),Ga=K),
"element"==F?(A=!0,D=K.priority,F=x,x=e.$$element=z(V.createComment(" "+ia+": "+e[ia]+" ")),d=x[0],Q(g,Za.call(F,0),d),gb=N(F,f,D,h&&h.name,{nonTlbTranscludeDirective:Ga})):(F=z(Vb(d)).contents(),x.empty(),gb=N(F,f));if(K.template)if(Yb=!0,Oa("template",Y,K,x),Y=K,F=E(K.template)?K.template(x,e):K.template,F=Yc(F),K.replace){h=K;F=Tb.test(F)?Zc(T(K.templateNamespace,U(F))):[];d=F[0];if(1!=F.length||d.nodeType!==ma)throw da("tplrt",ia,"");Q(g,x,d);L={$attr:{}};F=W(d,[],L);var tf=a.splice(qa+1,a.length-
(qa+1));J&&hb(F);a=a.concat(F).concat(tf);Vc(e,L);L=a.length}else x.html(F);if(K.templateUrl)Yb=!0,Oa("template",Y,K,x),Y=K,K.replace&&(h=K),M=Xb(a.splice(qa,a.length-qa),x,e,g,C&&gb,k,n,{controllerDirectives:H,newIsolateScopeDirective:J,templateDirective:Y,nonTlbTranscludeDirective:Ga}),L=a.length;else if(K.compile)try{xa=K.compile(x,e,gb),E(xa)?B(null,xa,R,jb):xa&&B(xa.pre,xa.post,R,jb)}catch(ac){c(ac,ta(x))}K.terminal&&(M.terminal=!0,D=Math.max(D,K.priority))}M.scope=G&&!0===G.scope;M.transcludeOnThisElement=
C;M.elementTranscludeOnThisElement=A;M.templateOnThisElement=Yb;M.transclude=gb;m.hasElementTranscludeDirective=A;return M}function hb(a){for(var b=0,c=a.length;b<c;b++)a[b]=Pb(a[b],{$$isolateScope:!0})}function C(b,d,f,g,h,k,l){if(d===h)return null;h=null;if(e.hasOwnProperty(d)){var m;d=a.get(d+"Directive");for(var p=0,B=d.length;p<B;p++)try{m=d[p],(g===s||g>m.priority)&&-1!=m.restrict.indexOf(f)&&(k&&(m=Pb(m,{$$start:k,$$end:l})),b.push(m),h=m)}catch(u){c(u)}}return h}function F(b){if(e.hasOwnProperty(b))for(var c=
a.get(b+"Directive"),d=0,f=c.length;d<f;d++)if(b=c[d],b.multiElement)return!0;return!1}function Vc(a,b){var c=b.$attr,d=a.$attr,e=a.$$element;q(a,function(d,e){"$"!=e.charAt(0)&&(b[e]&&b[e]!==d&&(d+=("style"===e?";":" ")+b[e]),a.$set(e,d,!0,c[e]))});q(b,function(b,f){"class"==f?(G(e,b),a["class"]=(a["class"]?a["class"]+" ":"")+b):"style"==f?(e.attr("style",e.attr("style")+";"+b),a.style=(a.style?a.style+";":"")+b):"$"==f.charAt(0)||a.hasOwnProperty(f)||(a[f]=b,d[f]=c[f])})}function Xb(a,b,c,e,f,g,
h,k){var l=[],n,m,p=b[0],v=a.shift(),u=Pb(v,{templateUrl:null,transclude:null,replace:null,$$originalDirective:v}),M=E(v.templateUrl)?v.templateUrl(b,c):v.templateUrl,D=v.templateNamespace;b.empty();d(B.getTrustedResourceUrl(M)).then(function(d){var B,P;d=Yc(d);if(v.replace){d=Tb.test(d)?Zc(T(D,U(d))):[];B=d[0];if(1!=d.length||B.nodeType!==ma)throw da("tplrt",v.name,M);d={$attr:{}};Q(e,b,B);var t=W(B,[],d);I(v.scope)&&hb(t);a=t.concat(a);Vc(c,d)}else B=p,b.html(d);a.unshift(u);n=y(a,B,c,f,b,v,g,h,
k);q(e,function(a,c){a==B&&(e[c]=b[0])});for(m=Y(b[0].childNodes,f);l.length;){d=l.shift();P=l.shift();var H=l.shift(),N=l.shift(),t=b[0];if(!d.$$destroyed){if(P!==p){var J=P.className;k.hasElementTranscludeDirective&&v.replace||(t=Vb(B));Q(H,z(P),t);G(z(t),J)}P=n.transcludeOnThisElement?$(d,n.transclude,N):N;n(m,d,t,e,P)}}l=null});return function(a,b,c,d,e){a=e;b.$$destroyed||(l?l.push(b,c,d,a):(n.transcludeOnThisElement&&(a=$(b,n.transclude,e)),n(m,b,c,d,a)))}}function xa(a,b){var c=b.priority-
a.priority;return 0!==c?c:a.name!==b.name?a.name<b.name?-1:1:a.index-b.index}function Oa(a,b,c,d){if(b)throw da("multidir",b.name,c.name,a,ta(d));}function ia(a,c){var d=b(c,!0);d&&a.push({priority:0,compile:function(a){a=a.parent();var b=!!a.length;b&&N.$$addBindingClass(a);return function(a,c){var e=c.parent();b||N.$$addBindingClass(e);N.$$addBindingInfo(e,d.expressions);a.$watch(d,function(a){c[0].nodeValue=a})}}})}function T(a,b){a=L(a||"html");switch(a){case "svg":case "math":var c=V.createElement("div");
c.innerHTML="<"+a+">"+b+"</"+a+">";return c.childNodes[0].childNodes;default:return b}}function jb(a,b){if("srcdoc"==b)return B.HTML;var c=sa(a);if("xlinkHref"==b||"form"==c&&"action"==b||"img"!=c&&("src"==b||"ngSrc"==b))return B.RESOURCE_URL}function R(a,c,d,e,f){var g=jb(a,e);f=h[e]||f;var l=b(d,!0,g,f);if(l){if("multiple"===e&&"select"===sa(a))throw da("selmulti",ta(a));c.push({priority:100,compile:function(){return{pre:function(a,c,h){c=h.$$observers||(h.$$observers={});if(k.test(e))throw da("nodomevents");
var n=h[e];n!==d&&(l=n&&b(n,!0,g,f),d=n);l&&(h[e]=l(a),(c[e]||(c[e]=[])).$$inter=!0,(h.$$observers&&h.$$observers[e].$$scope||a).$watch(l,function(a,b){"class"===e&&a!=b?h.$updateClass(a,b):h.$set(e,a)}))}}}})}}function Q(a,b,c){var d=b[0],e=b.length,f=d.parentNode,g,h;if(a)for(g=0,h=a.length;g<h;g++)if(a[g]==d){a[g++]=c;h=g+e-1;for(var l=a.length;g<l;g++,h++)h<l?a[g]=a[h]:delete a[g];a.length-=e-1;a.context===d&&(a.context=c);break}f&&f.replaceChild(c,d);a=V.createDocumentFragment();a.appendChild(d);
z(c).data(z(d).data());pa?(Rb=!0,pa.cleanData([d])):delete z.cache[d[z.expando]];d=1;for(e=b.length;d<e;d++)f=b[d],z(f).remove(),a.appendChild(f),delete b[d];b[0]=c;b.length=1}function X(a,b){return x(function(){return a.apply(null,arguments)},a,b)}function Xc(a,b,d,e,f,g){try{a(b,d,e,f,g)}catch(h){c(h,ta(d))}}var $b=function(a,b){if(b){var c=Object.keys(b),d,e,f;d=0;for(e=c.length;d<e;d++)f=c[d],this[f]=b[f]}else this.$attr={};this.$$element=a};$b.prototype={$normalize:va,$addClass:function(a){a&&
0<a.length&&M.addClass(this.$$element,a)},$removeClass:function(a){a&&0<a.length&&M.removeClass(this.$$element,a)},$updateClass:function(a,b){var c=$c(a,b);c&&c.length&&M.addClass(this.$$element,c);(c=$c(b,a))&&c.length&&M.removeClass(this.$$element,c)},$set:function(a,b,d,e){var f=this.$$element[0],g=Qc(f,a),h=pf(f,a),f=a;g?(this.$$element.prop(a,b),e=g):h&&(this[h]=b,f=h);this[a]=b;e?this.$attr[a]=e:(e=this.$attr[a])||(this.$attr[a]=e=yc(a,"-"));g=sa(this.$$element);if("a"===g&&"href"===a||"img"===
g&&"src"===a)this[a]=b=D(b,"src"===a);else if("img"===g&&"srcset"===a){for(var g="",h=U(b),l=/(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/,l=/\s/.test(h)?l:/(,)/,h=h.split(l),l=Math.floor(h.length/2),k=0;k<l;k++)var n=2*k,g=g+D(U(h[n]),!0),g=g+(" "+U(h[n+1]));h=U(h[2*k]).split(/\s/);g+=D(U(h[0]),!0);2===h.length&&(g+=" "+U(h[1]));this[a]=b=g}!1!==d&&(null===b||b===s?this.$$element.removeAttr(e):this.$$element.attr(e,b));(a=this.$$observers)&&q(a[f],function(a){try{a(b)}catch(d){c(d)}})},$observe:function(a,
b){var c=this,d=c.$$observers||(c.$$observers=ga()),e=d[a]||(d[a]=[]);e.push(b);H.$evalAsync(function(){!e.$$inter&&c.hasOwnProperty(a)&&b(c[a])});return function(){Xa(e,b)}}};var Ga=b.startSymbol(),qa=b.endSymbol(),Yc="{{"==Ga||"}}"==qa?na:function(a){return a.replace(/\{\{/g,Ga).replace(/}}/g,qa)},ac=/^ngAttr[A-Z]/;N.$$addBindingInfo=m?function(a,b){var c=a.data("$binding")||[];w(b)?c=c.concat(b):c.push(b);a.data("$binding",c)}:A;N.$$addBindingClass=m?function(a){G(a,"ng-binding")}:A;N.$$addScopeInfo=
m?function(a,b,c,d){a.data(c?d?"$isolateScopeNoTemplate":"$isolateScope":"$scope",b)}:A;N.$$addScopeClass=m?function(a,b){G(a,b?"ng-isolate-scope":"ng-scope")}:A;return N}]}function va(b){return eb(b.replace(Wc,""))}function $c(b,a){var c="",d=b.split(/\s+/),e=a.split(/\s+/),f=0;a:for(;f<d.length;f++){for(var g=d[f],h=0;h<e.length;h++)if(g==e[h])continue a;c+=(0<c.length?" ":"")+g}return c}function Zc(b){b=z(b);var a=b.length;if(1>=a)return b;for(;a--;)8===b[a].nodeType&&uf.call(b,a,1);return b}function Ke(){var b=
{},a=!1,c=/^(\S+)(\s+as\s+(\w+))?$/;this.register=function(a,c){Ma(a,"controller");I(a)?x(b,a):b[a]=c};this.allowGlobals=function(){a=!0};this.$get=["$injector","$window",function(d,e){function f(a,b,c,d){if(!a||!I(a.$scope))throw F("$controller")("noscp",d,b);a.$scope[b]=c}return function(g,h,l,k){var m,r,n;l=!0===l;k&&O(k)&&(n=k);if(O(g)){k=g.match(c);if(!k)throw vf("ctrlfmt",g);r=k[1];n=n||k[3];g=b.hasOwnProperty(r)?b[r]:Ac(h.$scope,r,!0)||(a?Ac(e,r,!0):s);La(g,r,!0)}if(l)return l=(w(g)?g[g.length-
1]:g).prototype,m=Object.create(l||null),n&&f(h,n,m,r||g.name),x(function(){d.invoke(g,m,h,r);return m},{instance:m,identifier:n});m=d.instantiate(g,h,r);n&&f(h,n,m,r||g.name);return m}}]}function Le(){this.$get=["$window",function(b){return z(b.document)}]}function Me(){this.$get=["$log",function(b){return function(a,c){b.error.apply(b,arguments)}}]}function bc(b,a){if(O(b)){var c=b.replace(wf,"").trim();if(c){var d=a("Content-Type");(d=d&&0===d.indexOf(ad))||(d=(d=c.match(xf))&&yf[d[0]].test(c));
d&&(b=tc(c))}}return b}function bd(b){var a=ga(),c,d,e;if(!b)return a;q(b.split("\n"),function(b){e=b.indexOf(":");c=L(U(b.substr(0,e)));d=U(b.substr(e+1));c&&(a[c]=a[c]?a[c]+", "+d:d)});return a}function cd(b){var a=I(b)?b:s;return function(c){a||(a=bd(b));return c?(c=a[L(c)],void 0===c&&(c=null),c):a}}function dd(b,a,c,d){if(E(d))return d(b,a,c);q(d,function(d){b=d(b,a,c)});return b}function Pe(){var b=this.defaults={transformResponse:[bc],transformRequest:[function(a){return I(a)&&"[object File]"!==
Aa.call(a)&&"[object Blob]"!==Aa.call(a)&&"[object FormData]"!==Aa.call(a)?$a(a):a}],headers:{common:{Accept:"application/json, text/plain, */*"},post:oa(cc),put:oa(cc),patch:oa(cc)},xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN"},a=!1;this.useApplyAsync=function(b){return y(b)?(a=!!b,this):a};var c=this.interceptors=[];this.$get=["$httpBackend","$browser","$cacheFactory","$rootScope","$q","$injector",function(d,e,f,g,h,l){function k(a){function c(a){var b=x({},a);b.data=a.data?dd(a.data,
a.headers,a.status,e.transformResponse):a.data;a=a.status;return 200<=a&&300>a?b:h.reject(b)}function d(a){var b,c={};q(a,function(a,d){E(a)?(b=a(),null!=b&&(c[d]=b)):c[d]=a});return c}if(!ba.isObject(a))throw F("$http")("badreq",a);var e=x({method:"get",transformRequest:b.transformRequest,transformResponse:b.transformResponse},a);e.headers=function(a){var c=b.headers,e=x({},a.headers),f,g,c=x({},c.common,c[L(a.method)]);a:for(f in c){a=L(f);for(g in e)if(L(g)===a)continue a;e[f]=c[f]}return d(e)}(a);
e.method=vb(e.method);var f=[function(a){var d=a.headers,e=dd(a.data,cd(d),s,a.transformRequest);C(e)&&q(d,function(a,b){"content-type"===L(b)&&delete d[b]});C(a.withCredentials)&&!C(b.withCredentials)&&(a.withCredentials=b.withCredentials);return m(a,e).then(c,c)},s],g=h.when(e);for(q(u,function(a){(a.request||a.requestError)&&f.unshift(a.request,a.requestError);(a.response||a.responseError)&&f.push(a.response,a.responseError)});f.length;){a=f.shift();var l=f.shift(),g=g.then(a,l)}g.success=function(a){La(a,
"fn");g.then(function(b){a(b.data,b.status,b.headers,e)});return g};g.error=function(a){La(a,"fn");g.then(null,function(b){a(b.data,b.status,b.headers,e)});return g};return g}function m(c,f){function l(b,c,d,e){function f(){m(c,b,d,e)}D&&(200<=b&&300>b?D.put(q,[b,c,bd(d),e]):D.remove(q));a?g.$applyAsync(f):(f(),g.$$phase||g.$apply())}function m(a,b,d,e){b=Math.max(b,0);(200<=b&&300>b?B.resolve:B.reject)({data:a,status:b,headers:cd(d),config:c,statusText:e})}function u(a){m(a.data,a.status,oa(a.headers()),
a.statusText)}function J(){var a=k.pendingRequests.indexOf(c);-1!==a&&k.pendingRequests.splice(a,1)}var B=h.defer(),M=B.promise,D,G,N=c.headers,q=r(c.url,c.params);k.pendingRequests.push(c);M.then(J,J);!c.cache&&!b.cache||!1===c.cache||"GET"!==c.method&&"JSONP"!==c.method||(D=I(c.cache)?c.cache:I(b.cache)?b.cache:n);D&&(G=D.get(q),y(G)?G&&E(G.then)?G.then(u,u):w(G)?m(G[1],G[0],oa(G[2]),G[3]):m(G,200,{},"OK"):D.put(q,M));C(G)&&((G=ed(c.url)?e.cookies()[c.xsrfCookieName||b.xsrfCookieName]:s)&&(N[c.xsrfHeaderName||
b.xsrfHeaderName]=G),d(c.method,q,f,l,N,c.timeout,c.withCredentials,c.responseType));return M}function r(a,b){if(!b)return a;var c=[];Jd(b,function(a,b){null===a||C(a)||(w(a)||(a=[a]),q(a,function(a){I(a)&&(a=ea(a)?a.toISOString():$a(a));c.push(Ca(b)+"="+Ca(a))}))});0<c.length&&(a+=(-1==a.indexOf("?")?"?":"&")+c.join("&"));return a}var n=f("$http"),u=[];q(c,function(a){u.unshift(O(a)?l.get(a):l.invoke(a))});k.pendingRequests=[];(function(a){q(arguments,function(a){k[a]=function(b,c){return k(x(c||
{},{method:a,url:b}))}})})("get","delete","head","jsonp");(function(a){q(arguments,function(a){k[a]=function(b,c,d){return k(x(d||{},{method:a,url:b,data:c}))}})})("post","put","patch");k.defaults=b;return k}]}function zf(){return new T.XMLHttpRequest}function Qe(){this.$get=["$browser","$window","$document",function(b,a,c){return Af(b,zf,b.defer,a.angular.callbacks,c[0])}]}function Af(b,a,c,d,e){function f(a,b,c){var f=e.createElement("script"),m=null;f.type="text/javascript";f.src=a;f.async=!0;
m=function(a){f.removeEventListener("load",m,!1);f.removeEventListener("error",m,!1);e.body.removeChild(f);f=null;var g=-1,u="unknown";a&&("load"!==a.type||d[b].called||(a={type:"error"}),u=a.type,g="error"===a.type?404:200);c&&c(g,u)};f.addEventListener("load",m,!1);f.addEventListener("error",m,!1);e.body.appendChild(f);return m}return function(e,h,l,k,m,r,n,u){function v(){p&&p();H&&H.abort()}function P(a,d,e,f,g){B!==s&&c.cancel(B);p=H=null;a(d,e,f,g);b.$$completeOutstandingRequest(A)}b.$$incOutstandingRequestCount();
h=h||b.url();if("jsonp"==L(e)){var t="_"+(d.counter++).toString(36);d[t]=function(a){d[t].data=a;d[t].called=!0};var p=f(h.replace("JSON_CALLBACK","angular.callbacks."+t),t,function(a,b){P(k,a,d[t].data,"",b);d[t]=A})}else{var H=a();H.open(e,h,!0);q(m,function(a,b){y(a)&&H.setRequestHeader(b,a)});H.onload=function(){var a=H.statusText||"",b="response"in H?H.response:H.responseText,c=1223===H.status?204:H.status;0===c&&(c=b?200:"file"==ya(h).protocol?404:0);P(k,c,b,H.getAllResponseHeaders(),a)};e=
function(){P(k,-1,null,null,"")};H.onerror=e;H.onabort=e;n&&(H.withCredentials=!0);if(u)try{H.responseType=u}catch(J){if("json"!==u)throw J;}H.send(l||null)}if(0<r)var B=c(v,r);else r&&E(r.then)&&r.then(v)}}function Ne(){var b="{{",a="}}";this.startSymbol=function(a){return a?(b=a,this):b};this.endSymbol=function(b){return b?(a=b,this):a};this.$get=["$parse","$exceptionHandler","$sce",function(c,d,e){function f(a){return"\\\\\\"+a}function g(f,g,u,v){function P(c){return c.replace(k,b).replace(m,
a)}function t(a){try{var b=a;a=u?e.getTrusted(u,b):e.valueOf(b);var c;if(v&&!y(a))c=a;else if(null==a)c="";else{switch(typeof a){case "string":break;case "number":a=""+a;break;default:a=$a(a)}c=a}return c}catch(g){c=dc("interr",f,g.toString()),d(c)}}v=!!v;for(var p,H,q=0,B=[],M=[],D=f.length,G=[],N=[];q<D;)if(-1!=(p=f.indexOf(b,q))&&-1!=(H=f.indexOf(a,p+h)))q!==p&&G.push(P(f.substring(q,p))),q=f.substring(p+h,H),B.push(q),M.push(c(q,t)),q=H+l,N.push(G.length),G.push("");else{q!==D&&G.push(P(f.substring(q)));
break}if(u&&1<G.length)throw dc("noconcat",f);if(!g||B.length){var Y=function(a){for(var b=0,c=B.length;b<c;b++){if(v&&C(a[b]))return;G[N[b]]=a[b]}return G.join("")};return x(function(a){var b=0,c=B.length,e=Array(c);try{for(;b<c;b++)e[b]=M[b](a);return Y(e)}catch(g){a=dc("interr",f,g.toString()),d(a)}},{exp:f,expressions:B,$$watchDelegate:function(a,b,c){var d;return a.$watchGroup(M,function(c,e){var f=Y(c);E(b)&&b.call(this,f,c!==e?d:f,a);d=f},c)}})}}var h=b.length,l=a.length,k=new RegExp(b.replace(/./g,
f),"g"),m=new RegExp(a.replace(/./g,f),"g");g.startSymbol=function(){return b};g.endSymbol=function(){return a};return g}]}function Oe(){this.$get=["$rootScope","$window","$q","$$q",function(b,a,c,d){function e(e,h,l,k){var m=a.setInterval,r=a.clearInterval,n=0,u=y(k)&&!k,v=(u?d:c).defer(),P=v.promise;l=y(l)?l:0;P.then(null,null,e);P.$$intervalId=m(function(){v.notify(n++);0<l&&n>=l&&(v.resolve(n),r(P.$$intervalId),delete f[P.$$intervalId]);u||b.$apply()},h);f[P.$$intervalId]=v;return P}var f={};
e.cancel=function(b){return b&&b.$$intervalId in f?(f[b.$$intervalId].reject("canceled"),a.clearInterval(b.$$intervalId),delete f[b.$$intervalId],!0):!1};return e}]}function Wd(){this.$get=function(){return{id:"en-us",NUMBER_FORMATS:{DECIMAL_SEP:".",GROUP_SEP:",",PATTERNS:[{minInt:1,minFrac:0,maxFrac:3,posPre:"",posSuf:"",negPre:"-",negSuf:"",gSize:3,lgSize:3},{minInt:1,minFrac:2,maxFrac:2,posPre:"\u00a4",posSuf:"",negPre:"(\u00a4",negSuf:")",gSize:3,lgSize:3}],CURRENCY_SYM:"$"},DATETIME_FORMATS:{MONTH:"January February March April May June July August September October November December".split(" "),
SHORTMONTH:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),DAY:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),SHORTDAY:"Sun Mon Tue Wed Thu Fri Sat".split(" "),AMPMS:["AM","PM"],medium:"MMM d, y h:mm:ss a","short":"M/d/yy h:mm a",fullDate:"EEEE, MMMM d, y",longDate:"MMMM d, y",mediumDate:"MMM d, y",shortDate:"M/d/yy",mediumTime:"h:mm:ss a",shortTime:"h:mm a",ERANAMES:["Before Christ","Anno Domini"],ERAS:["BC","AD"]},pluralCat:function(b){return 1===b?"one":"other"}}}}
function ec(b){b=b.split("/");for(var a=b.length;a--;)b[a]=sb(b[a]);return b.join("/")}function fd(b,a){var c=ya(b);a.$$protocol=c.protocol;a.$$host=c.hostname;a.$$port=aa(c.port)||Bf[c.protocol]||null}function gd(b,a){var c="/"!==b.charAt(0);c&&(b="/"+b);var d=ya(b);a.$$path=decodeURIComponent(c&&"/"===d.pathname.charAt(0)?d.pathname.substring(1):d.pathname);a.$$search=vc(d.search);a.$$hash=decodeURIComponent(d.hash);a.$$path&&"/"!=a.$$path.charAt(0)&&(a.$$path="/"+a.$$path)}function wa(b,a){if(0===
a.indexOf(b))return a.substr(b.length)}function Ea(b){var a=b.indexOf("#");return-1==a?b:b.substr(0,a)}function Gb(b){return b.replace(/(#.+)|#$/,"$1")}function fc(b){return b.substr(0,Ea(b).lastIndexOf("/")+1)}function gc(b,a){this.$$html5=!0;a=a||"";var c=fc(b);fd(b,this);this.$$parse=function(a){var b=wa(c,a);if(!O(b))throw Hb("ipthprfx",a,c);gd(b,this);this.$$path||(this.$$path="/");this.$$compose()};this.$$compose=function(){var a=Qb(this.$$search),b=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=
ec(this.$$path)+(a?"?"+a:"")+b;this.$$absUrl=c+this.$$url.substr(1)};this.$$parseLinkUrl=function(d,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,g;(f=wa(b,d))!==s?(g=f,g=(f=wa(a,f))!==s?c+(wa("/",f)||f):b+g):(f=wa(c,d))!==s?g=c+f:c==d+"/"&&(g=c);g&&this.$$parse(g);return!!g}}function hc(b,a){var c=fc(b);fd(b,this);this.$$parse=function(d){d=wa(b,d)||wa(c,d);var e;"#"===d.charAt(0)?(e=wa(a,d),C(e)&&(e=d)):e=this.$$html5?d:"";gd(e,this);d=this.$$path;var f=/^\/[A-Z]:(\/.*)/;0===e.indexOf(b)&&
(e=e.replace(b,""));f.exec(e)||(d=(e=f.exec(d))?e[1]:d);this.$$path=d;this.$$compose()};this.$$compose=function(){var c=Qb(this.$$search),e=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=ec(this.$$path)+(c?"?"+c:"")+e;this.$$absUrl=b+(this.$$url?a+this.$$url:"")};this.$$parseLinkUrl=function(a,c){return Ea(b)==Ea(a)?(this.$$parse(a),!0):!1}}function hd(b,a){this.$$html5=!0;hc.apply(this,arguments);var c=fc(b);this.$$parseLinkUrl=function(d,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,
g;b==Ea(d)?f=d:(g=wa(c,d))?f=b+a+g:c===d+"/"&&(f=c);f&&this.$$parse(f);return!!f};this.$$compose=function(){var c=Qb(this.$$search),e=this.$$hash?"#"+sb(this.$$hash):"";this.$$url=ec(this.$$path)+(c?"?"+c:"")+e;this.$$absUrl=b+a+this.$$url}}function Ib(b){return function(){return this[b]}}function id(b,a){return function(c){if(C(c))return this[b];this[b]=a(c);this.$$compose();return this}}function Re(){var b="",a={enabled:!1,requireBase:!0,rewriteLinks:!0};this.hashPrefix=function(a){return y(a)?
(b=a,this):b};this.html5Mode=function(b){return Wa(b)?(a.enabled=b,this):I(b)?(Wa(b.enabled)&&(a.enabled=b.enabled),Wa(b.requireBase)&&(a.requireBase=b.requireBase),Wa(b.rewriteLinks)&&(a.rewriteLinks=b.rewriteLinks),this):a};this.$get=["$rootScope","$browser","$sniffer","$rootElement","$window",function(c,d,e,f,g){function h(a,b,c){var e=k.url(),f=k.$$state;try{d.url(a,b,c),k.$$state=d.state()}catch(g){throw k.url(e),k.$$state=f,g;}}function l(a,b){c.$broadcast("$locationChangeSuccess",k.absUrl(),
a,k.$$state,b)}var k,m;m=d.baseHref();var r=d.url(),n;if(a.enabled){if(!m&&a.requireBase)throw Hb("nobase");n=r.substring(0,r.indexOf("/",r.indexOf("//")+2))+(m||"/");m=e.history?gc:hd}else n=Ea(r),m=hc;k=new m(n,"#"+b);k.$$parseLinkUrl(r,r);k.$$state=d.state();var u=/^\s*(javascript|mailto):/i;f.on("click",function(b){if(a.rewriteLinks&&!b.ctrlKey&&!b.metaKey&&!b.shiftKey&&2!=b.which&&2!=b.button){for(var e=z(b.target);"a"!==sa(e[0]);)if(e[0]===f[0]||!(e=e.parent())[0])return;var h=e.prop("href"),
l=e.attr("href")||e.attr("xlink:href");I(h)&&"[object SVGAnimatedString]"===h.toString()&&(h=ya(h.animVal).href);u.test(h)||!h||e.attr("target")||b.isDefaultPrevented()||!k.$$parseLinkUrl(h,l)||(b.preventDefault(),k.absUrl()!=d.url()&&(c.$apply(),g.angular["ff-684208-preventDefault"]=!0))}});Gb(k.absUrl())!=Gb(r)&&d.url(k.absUrl(),!0);var v=!0;d.onUrlChange(function(a,b){c.$evalAsync(function(){var d=k.absUrl(),e=k.$$state,f;k.$$parse(a);k.$$state=b;f=c.$broadcast("$locationChangeStart",a,d,b,e).defaultPrevented;
k.absUrl()===a&&(f?(k.$$parse(d),k.$$state=e,h(d,!1,e)):(v=!1,l(d,e)))});c.$$phase||c.$digest()});c.$watch(function(){var a=Gb(d.url()),b=Gb(k.absUrl()),f=d.state(),g=k.$$replace,n=a!==b||k.$$html5&&e.history&&f!==k.$$state;if(v||n)v=!1,c.$evalAsync(function(){var b=k.absUrl(),d=c.$broadcast("$locationChangeStart",b,a,k.$$state,f).defaultPrevented;k.absUrl()===b&&(d?(k.$$parse(a),k.$$state=f):(n&&h(b,g,f===k.$$state?null:k.$$state),l(a,f)))});k.$$replace=!1});return k}]}function Se(){var b=!0,a=this;
this.debugEnabled=function(a){return y(a)?(b=a,this):b};this.$get=["$window",function(c){function d(a){a instanceof Error&&(a.stack?a=a.message&&-1===a.stack.indexOf(a.message)?"Error: "+a.message+"\n"+a.stack:a.stack:a.sourceURL&&(a=a.message+"\n"+a.sourceURL+":"+a.line));return a}function e(a){var b=c.console||{},e=b[a]||b.log||A;a=!1;try{a=!!e.apply}catch(l){}return a?function(){var a=[];q(arguments,function(b){a.push(d(b))});return e.apply(b,a)}:function(a,b){e(a,null==b?"":b)}}return{log:e("log"),
info:e("info"),warn:e("warn"),error:e("error"),debug:function(){var c=e("debug");return function(){b&&c.apply(a,arguments)}}()}}]}function ra(b,a){if("__defineGetter__"===b||"__defineSetter__"===b||"__lookupGetter__"===b||"__lookupSetter__"===b||"__proto__"===b)throw ja("isecfld",a);return b}function ka(b,a){if(b){if(b.constructor===b)throw ja("isecfn",a);if(b.window===b)throw ja("isecwindow",a);if(b.children&&(b.nodeName||b.prop&&b.attr&&b.find))throw ja("isecdom",a);if(b===Object)throw ja("isecobj",
a);}return b}function ic(b){return b.constant}function kb(b,a,c,d,e){ka(b,e);ka(a,e);c=c.split(".");for(var f,g=0;1<c.length;g++){f=ra(c.shift(),e);var h=0===g&&a&&a[f]||b[f];h||(h={},b[f]=h);b=ka(h,e)}f=ra(c.shift(),e);ka(b[f],e);return b[f]=d}function Pa(b){return"constructor"==b}function jd(b,a,c,d,e,f,g){ra(b,f);ra(a,f);ra(c,f);ra(d,f);ra(e,f);var h=function(a){return ka(a,f)},l=g||Pa(b)?h:na,k=g||Pa(a)?h:na,m=g||Pa(c)?h:na,r=g||Pa(d)?h:na,n=g||Pa(e)?h:na;return function(f,g){var h=g&&g.hasOwnProperty(b)?
g:f;if(null==h)return h;h=l(h[b]);if(!a)return h;if(null==h)return s;h=k(h[a]);if(!c)return h;if(null==h)return s;h=m(h[c]);if(!d)return h;if(null==h)return s;h=r(h[d]);return e?null==h?s:h=n(h[e]):h}}function Cf(b,a){return function(c,d){return b(c,d,ka,a)}}function Df(b,a,c){var d=a.expensiveChecks,e=d?Ef:Ff,f=e[b];if(f)return f;var g=b.split("."),h=g.length;if(a.csp)f=6>h?jd(g[0],g[1],g[2],g[3],g[4],c,d):function(a,b){var e=0,f;do f=jd(g[e++],g[e++],g[e++],g[e++],g[e++],c,d)(a,b),b=s,a=f;while(e<
h);return f};else{var l="";d&&(l+="s = eso(s, fe);\nl = eso(l, fe);\n");var k=d;q(g,function(a,b){ra(a,c);var e=(b?"s":'((l&&l.hasOwnProperty("'+a+'"))?l:s)')+"."+a;if(d||Pa(a))e="eso("+e+", fe)",k=!0;l+="if(s == null) return undefined;\ns="+e+";\n"});l+="return s;";a=new Function("s","l","eso","fe",l);a.toString=ca(l);k&&(a=Cf(a,c));f=a}f.sharedGetter=!0;f.assign=function(a,c,d){return kb(a,d,b,c,b)};return e[b]=f}function jc(b){return E(b.valueOf)?b.valueOf():Gf.call(b)}function Te(){var b=ga(),
a=ga();this.$get=["$filter","$sniffer",function(c,d){function e(a){var b=a;a.sharedGetter&&(b=function(b,c){return a(b,c)},b.literal=a.literal,b.constant=a.constant,b.assign=a.assign);return b}function f(a,b){for(var c=0,d=a.length;c<d;c++){var e=a[c];e.constant||(e.inputs?f(e.inputs,b):-1===b.indexOf(e)&&b.push(e))}return b}function g(a,b){return null==a||null==b?a===b:"object"===typeof a&&(a=jc(a),"object"===typeof a)?!1:a===b||a!==a&&b!==b}function h(a,b,c,d){var e=d.$$inputs||(d.$$inputs=f(d.inputs,
[])),h;if(1===e.length){var l=g,e=e[0];return a.$watch(function(a){var b=e(a);g(b,l)||(h=d(a),l=b&&jc(b));return h},b,c)}for(var k=[],n=0,m=e.length;n<m;n++)k[n]=g;return a.$watch(function(a){for(var b=!1,c=0,f=e.length;c<f;c++){var l=e[c](a);if(b||(b=!g(l,k[c])))k[c]=l&&jc(l)}b&&(h=d(a));return h},b,c)}function l(a,b,c,d){var e,f;return e=a.$watch(function(a){return d(a)},function(a,c,d){f=a;E(b)&&b.apply(this,arguments);y(a)&&d.$$postDigest(function(){y(f)&&e()})},c)}function k(a,b,c,d){function e(a){var b=
!0;q(a,function(a){y(a)||(b=!1)});return b}var f,g;return f=a.$watch(function(a){return d(a)},function(a,c,d){g=a;E(b)&&b.call(this,a,c,d);e(a)&&d.$$postDigest(function(){e(g)&&f()})},c)}function m(a,b,c,d){var e;return e=a.$watch(function(a){return d(a)},function(a,c,d){E(b)&&b.apply(this,arguments);e()},c)}function r(a,b){if(!b)return a;var c=a.$$watchDelegate,c=c!==k&&c!==l?function(c,d){var e=a(c,d);return b(e,c,d)}:function(c,d){var e=a(c,d),f=b(e,c,d);return y(e)?f:e};a.$$watchDelegate&&a.$$watchDelegate!==
h?c.$$watchDelegate=a.$$watchDelegate:b.$stateful||(c.$$watchDelegate=h,c.inputs=[a]);return c}var n={csp:d.csp,expensiveChecks:!1},u={csp:d.csp,expensiveChecks:!0};return function(d,f,g){var p,q,s;switch(typeof d){case "string":s=d=d.trim();var B=g?a:b;p=B[s];p||(":"===d.charAt(0)&&":"===d.charAt(1)&&(q=!0,d=d.substring(2)),g=g?u:n,p=new kc(g),p=(new lb(p,c,g)).parse(d),p.constant?p.$$watchDelegate=m:q?(p=e(p),p.$$watchDelegate=p.literal?k:l):p.inputs&&(p.$$watchDelegate=h),B[s]=p);return r(p,f);
case "function":return r(d,f);default:return r(A,f)}}}]}function Ve(){this.$get=["$rootScope","$exceptionHandler",function(b,a){return kd(function(a){b.$evalAsync(a)},a)}]}function We(){this.$get=["$browser","$exceptionHandler",function(b,a){return kd(function(a){b.defer(a)},a)}]}function kd(b,a){function c(a,b,c){function d(b){return function(c){e||(e=!0,b.call(a,c))}}var e=!1;return[d(b),d(c)]}function d(){this.$$state={status:0}}function e(a,b){return function(c){b.call(a,c)}}function f(c){!c.processScheduled&&
c.pending&&(c.processScheduled=!0,b(function(){var b,d,e;e=c.pending;c.processScheduled=!1;c.pending=s;for(var f=0,g=e.length;f<g;++f){d=e[f][0];b=e[f][c.status];try{E(b)?d.resolve(b(c.value)):1===c.status?d.resolve(c.value):d.reject(c.value)}catch(h){d.reject(h),a(h)}}}))}function g(){this.promise=new d;this.resolve=e(this,this.resolve);this.reject=e(this,this.reject);this.notify=e(this,this.notify)}var h=F("$q",TypeError);d.prototype={then:function(a,b,c){var d=new g;this.$$state.pending=this.$$state.pending||
[];this.$$state.pending.push([d,a,b,c]);0<this.$$state.status&&f(this.$$state);return d.promise},"catch":function(a){return this.then(null,a)},"finally":function(a,b){return this.then(function(b){return k(b,!0,a)},function(b){return k(b,!1,a)},b)}};g.prototype={resolve:function(a){this.promise.$$state.status||(a===this.promise?this.$$reject(h("qcycle",a)):this.$$resolve(a))},$$resolve:function(b){var d,e;e=c(this,this.$$resolve,this.$$reject);try{if(I(b)||E(b))d=b&&b.then;E(d)?(this.promise.$$state.status=
-1,d.call(b,e[0],e[1],this.notify)):(this.promise.$$state.value=b,this.promise.$$state.status=1,f(this.promise.$$state))}catch(g){e[1](g),a(g)}},reject:function(a){this.promise.$$state.status||this.$$reject(a)},$$reject:function(a){this.promise.$$state.value=a;this.promise.$$state.status=2;f(this.promise.$$state)},notify:function(c){var d=this.promise.$$state.pending;0>=this.promise.$$state.status&&d&&d.length&&b(function(){for(var b,e,f=0,g=d.length;f<g;f++){e=d[f][0];b=d[f][3];try{e.notify(E(b)?
b(c):c)}catch(h){a(h)}}})}};var l=function(a,b){var c=new g;b?c.resolve(a):c.reject(a);return c.promise},k=function(a,b,c){var d=null;try{E(c)&&(d=c())}catch(e){return l(e,!1)}return d&&E(d.then)?d.then(function(){return l(a,b)},function(a){return l(a,!1)}):l(a,b)},m=function(a,b,c,d){var e=new g;e.resolve(a);return e.promise.then(b,c,d)},r=function u(a){if(!E(a))throw h("norslvr",a);if(!(this instanceof u))return new u(a);var b=new g;a(function(a){b.resolve(a)},function(a){b.reject(a)});return b.promise};
r.defer=function(){return new g};r.reject=function(a){var b=new g;b.reject(a);return b.promise};r.when=m;r.all=function(a){var b=new g,c=0,d=w(a)?[]:{};q(a,function(a,e){c++;m(a).then(function(a){d.hasOwnProperty(e)||(d[e]=a,--c||b.resolve(d))},function(a){d.hasOwnProperty(e)||b.reject(a)})});0===c&&b.resolve(d);return b.promise};return r}function ef(){this.$get=["$window","$timeout",function(b,a){function c(){for(var a=0;a<m.length;a++){var b=m[a];b&&(m[a]=null,b())}k=m.length=0}function d(a){var b=
m.length;k++;m.push(a);0===b&&(l=h(c));return function(){0<=b&&(b=m[b]=null,0===--k&&l&&(l(),l=null,m.length=0))}}var e=b.requestAnimationFrame||b.webkitRequestAnimationFrame,f=b.cancelAnimationFrame||b.webkitCancelAnimationFrame||b.webkitCancelRequestAnimationFrame,g=!!e,h=g?function(a){var b=e(a);return function(){f(b)}}:function(b){var c=a(b,16.66,!1);return function(){a.cancel(c)}};d.supported=g;var l,k=0,m=[];return d}]}function Ue(){function b(a){function b(){this.$$watchers=this.$$nextSibling=
this.$$childHead=this.$$childTail=null;this.$$listeners={};this.$$listenerCount={};this.$id=++rb;this.$$ChildScope=null}b.prototype=a;return b}var a=10,c=F("$rootScope"),d=null,e=null;this.digestTtl=function(b){arguments.length&&(a=b);return a};this.$get=["$injector","$exceptionHandler","$parse","$browser",function(f,g,h,l){function k(a){a.currentScope.$$destroyed=!0}function m(){this.$id=++rb;this.$$phase=this.$parent=this.$$watchers=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=
null;this.$root=this;this.$$destroyed=!1;this.$$listeners={};this.$$listenerCount={};this.$$isolateBindings=null}function r(a){if(t.$$phase)throw c("inprog",t.$$phase);t.$$phase=a}function n(a,b,c){do a.$$listenerCount[c]-=b,0===a.$$listenerCount[c]&&delete a.$$listenerCount[c];while(a=a.$parent)}function u(){}function v(){for(;J.length;)try{J.shift()()}catch(a){g(a)}e=null}function s(){null===e&&(e=l.defer(function(){t.$apply(v)}))}m.prototype={constructor:m,$new:function(a,c){var d;c=c||this;a?
(d=new m,d.$root=this.$root):(this.$$ChildScope||(this.$$ChildScope=b(this)),d=new this.$$ChildScope);d.$parent=c;d.$$prevSibling=c.$$childTail;c.$$childHead?(c.$$childTail.$$nextSibling=d,c.$$childTail=d):c.$$childHead=c.$$childTail=d;(a||c!=this)&&d.$on("$destroy",k);return d},$watch:function(a,b,c){var e=h(a);if(e.$$watchDelegate)return e.$$watchDelegate(this,b,c,e);var f=this.$$watchers,g={fn:b,last:u,get:e,exp:a,eq:!!c};d=null;E(b)||(g.fn=A);f||(f=this.$$watchers=[]);f.unshift(g);return function(){Xa(f,
g);d=null}},$watchGroup:function(a,b){function c(){h=!1;l?(l=!1,b(e,e,g)):b(e,d,g)}var d=Array(a.length),e=Array(a.length),f=[],g=this,h=!1,l=!0;if(!a.length){var k=!0;g.$evalAsync(function(){k&&b(e,e,g)});return function(){k=!1}}if(1===a.length)return this.$watch(a[0],function(a,c,f){e[0]=a;d[0]=c;b(e,a===c?e:d,f)});q(a,function(a,b){var l=g.$watch(a,function(a,f){e[b]=a;d[b]=f;h||(h=!0,g.$evalAsync(c))});f.push(l)});return function(){for(;f.length;)f.shift()()}},$watchCollection:function(a,b){function c(a){e=
a;var b,d,g,h;if(!C(e)){if(I(e))if(Sa(e))for(f!==n&&(f=n,u=f.length=0,k++),a=e.length,u!==a&&(k++,f.length=u=a),b=0;b<a;b++)h=f[b],g=e[b],d=h!==h&&g!==g,d||h===g||(k++,f[b]=g);else{f!==r&&(f=r={},u=0,k++);a=0;for(b in e)e.hasOwnProperty(b)&&(a++,g=e[b],h=f[b],b in f?(d=h!==h&&g!==g,d||h===g||(k++,f[b]=g)):(u++,f[b]=g,k++));if(u>a)for(b in k++,f)e.hasOwnProperty(b)||(u--,delete f[b])}else f!==e&&(f=e,k++);return k}}c.$stateful=!0;var d=this,e,f,g,l=1<b.length,k=0,m=h(a,c),n=[],r={},p=!0,u=0;return this.$watch(m,
function(){p?(p=!1,b(e,e,d)):b(e,g,d);if(l)if(I(e))if(Sa(e)){g=Array(e.length);for(var a=0;a<e.length;a++)g[a]=e[a]}else for(a in g={},e)wc.call(e,a)&&(g[a]=e[a]);else g=e})},$digest:function(){var b,f,h,k,m,n,q=a,s,S=[],P,J;r("$digest");l.$$checkUrlChange();this===t&&null!==e&&(l.defer.cancel(e),v());d=null;do{n=!1;for(s=this;p.length;){try{J=p.shift(),J.scope.$eval(J.expression,J.locals)}catch(y){g(y)}d=null}a:do{if(k=s.$$watchers)for(m=k.length;m--;)try{if(b=k[m])if((f=b.get(s))!==(h=b.last)&&
!(b.eq?fa(f,h):"number"===typeof f&&"number"===typeof h&&isNaN(f)&&isNaN(h)))n=!0,d=b,b.last=b.eq?Ba(f,null):f,b.fn(f,h===u?f:h,s),5>q&&(P=4-q,S[P]||(S[P]=[]),S[P].push({msg:E(b.exp)?"fn: "+(b.exp.name||b.exp.toString()):b.exp,newVal:f,oldVal:h}));else if(b===d){n=!1;break a}}catch(F){g(F)}if(!(k=s.$$childHead||s!==this&&s.$$nextSibling))for(;s!==this&&!(k=s.$$nextSibling);)s=s.$parent}while(s=k);if((n||p.length)&&!q--)throw t.$$phase=null,c("infdig",a,S);}while(n||p.length);for(t.$$phase=null;H.length;)try{H.shift()()}catch(x){g(x)}},
$destroy:function(){if(!this.$$destroyed){var a=this.$parent;this.$broadcast("$destroy");this.$$destroyed=!0;if(this!==t){for(var b in this.$$listenerCount)n(this,this.$$listenerCount[b],b);a.$$childHead==this&&(a.$$childHead=this.$$nextSibling);a.$$childTail==this&&(a.$$childTail=this.$$prevSibling);this.$$prevSibling&&(this.$$prevSibling.$$nextSibling=this.$$nextSibling);this.$$nextSibling&&(this.$$nextSibling.$$prevSibling=this.$$prevSibling);this.$destroy=this.$digest=this.$apply=this.$evalAsync=
this.$applyAsync=A;this.$on=this.$watch=this.$watchGroup=function(){return A};this.$$listeners={};this.$parent=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=this.$root=this.$$watchers=null}}},$eval:function(a,b){return h(a)(this,b)},$evalAsync:function(a,b){t.$$phase||p.length||l.defer(function(){p.length&&t.$digest()});p.push({scope:this,expression:a,locals:b})},$$postDigest:function(a){H.push(a)},$apply:function(a){try{return r("$apply"),this.$eval(a)}catch(b){g(b)}finally{t.$$phase=
null;try{t.$digest()}catch(c){throw g(c),c;}}},$applyAsync:function(a){function b(){c.$eval(a)}var c=this;a&&J.push(b);s()},$on:function(a,b){var c=this.$$listeners[a];c||(this.$$listeners[a]=c=[]);c.push(b);var d=this;do d.$$listenerCount[a]||(d.$$listenerCount[a]=0),d.$$listenerCount[a]++;while(d=d.$parent);var e=this;return function(){var d=c.indexOf(b);-1!==d&&(c[d]=null,n(e,1,a))}},$emit:function(a,b){var c=[],d,e=this,f=!1,h={name:a,targetScope:e,stopPropagation:function(){f=!0},preventDefault:function(){h.defaultPrevented=
!0},defaultPrevented:!1},l=Ya([h],arguments,1),k,m;do{d=e.$$listeners[a]||c;h.currentScope=e;k=0;for(m=d.length;k<m;k++)if(d[k])try{d[k].apply(null,l)}catch(n){g(n)}else d.splice(k,1),k--,m--;if(f)return h.currentScope=null,h;e=e.$parent}while(e);h.currentScope=null;return h},$broadcast:function(a,b){var c=this,d=this,e={name:a,targetScope:this,preventDefault:function(){e.defaultPrevented=!0},defaultPrevented:!1};if(!this.$$listenerCount[a])return e;for(var f=Ya([e],arguments,1),h,l;c=d;){e.currentScope=
c;d=c.$$listeners[a]||[];h=0;for(l=d.length;h<l;h++)if(d[h])try{d[h].apply(null,f)}catch(k){g(k)}else d.splice(h,1),h--,l--;if(!(d=c.$$listenerCount[a]&&c.$$childHead||c!==this&&c.$$nextSibling))for(;c!==this&&!(d=c.$$nextSibling);)c=c.$parent}e.currentScope=null;return e}};var t=new m,p=t.$$asyncQueue=[],H=t.$$postDigestQueue=[],J=t.$$applyAsyncQueue=[];return t}]}function Xd(){var b=/^\s*(https?|ftp|mailto|tel|file):/,a=/^\s*((https?|ftp|file|blob):|data:image\/)/;this.aHrefSanitizationWhitelist=
function(a){return y(a)?(b=a,this):b};this.imgSrcSanitizationWhitelist=function(b){return y(b)?(a=b,this):a};this.$get=function(){return function(c,d){var e=d?a:b,f;f=ya(c).href;return""===f||f.match(e)?c:"unsafe:"+f}}}function Hf(b){if("self"===b)return b;if(O(b)){if(-1<b.indexOf("***"))throw za("iwcard",b);b=ld(b).replace("\\*\\*",".*").replace("\\*","[^:/.?&;]*");return new RegExp("^"+b+"$")}if(Ua(b))return new RegExp("^"+b.source+"$");throw za("imatcher");}function md(b){var a=[];y(b)&&q(b,function(b){a.push(Hf(b))});
return a}function Ye(){this.SCE_CONTEXTS=la;var b=["self"],a=[];this.resourceUrlWhitelist=function(a){arguments.length&&(b=md(a));return b};this.resourceUrlBlacklist=function(b){arguments.length&&(a=md(b));return a};this.$get=["$injector",function(c){function d(a,b){return"self"===a?ed(b):!!a.exec(b.href)}function e(a){var b=function(a){this.$$unwrapTrustedValue=function(){return a}};a&&(b.prototype=new a);b.prototype.valueOf=function(){return this.$$unwrapTrustedValue()};b.prototype.toString=function(){return this.$$unwrapTrustedValue().toString()};
return b}var f=function(a){throw za("unsafe");};c.has("$sanitize")&&(f=c.get("$sanitize"));var g=e(),h={};h[la.HTML]=e(g);h[la.CSS]=e(g);h[la.URL]=e(g);h[la.JS]=e(g);h[la.RESOURCE_URL]=e(h[la.URL]);return{trustAs:function(a,b){var c=h.hasOwnProperty(a)?h[a]:null;if(!c)throw za("icontext",a,b);if(null===b||b===s||""===b)return b;if("string"!==typeof b)throw za("itype",a);return new c(b)},getTrusted:function(c,e){if(null===e||e===s||""===e)return e;var g=h.hasOwnProperty(c)?h[c]:null;if(g&&e instanceof
g)return e.$$unwrapTrustedValue();if(c===la.RESOURCE_URL){var g=ya(e.toString()),r,n,u=!1;r=0;for(n=b.length;r<n;r++)if(d(b[r],g)){u=!0;break}if(u)for(r=0,n=a.length;r<n;r++)if(d(a[r],g)){u=!1;break}if(u)return e;throw za("insecurl",e.toString());}if(c===la.HTML)return f(e);throw za("unsafe");},valueOf:function(a){return a instanceof g?a.$$unwrapTrustedValue():a}}}]}function Xe(){var b=!0;this.enabled=function(a){arguments.length&&(b=!!a);return b};this.$get=["$parse","$sceDelegate",function(a,c){if(b&&
8>Qa)throw za("iequirks");var d=oa(la);d.isEnabled=function(){return b};d.trustAs=c.trustAs;d.getTrusted=c.getTrusted;d.valueOf=c.valueOf;b||(d.trustAs=d.getTrusted=function(a,b){return b},d.valueOf=na);d.parseAs=function(b,c){var e=a(c);return e.literal&&e.constant?e:a(c,function(a){return d.getTrusted(b,a)})};var e=d.parseAs,f=d.getTrusted,g=d.trustAs;q(la,function(a,b){var c=L(b);d[eb("parse_as_"+c)]=function(b){return e(a,b)};d[eb("get_trusted_"+c)]=function(b){return f(a,b)};d[eb("trust_as_"+
c)]=function(b){return g(a,b)}});return d}]}function Ze(){this.$get=["$window","$document",function(b,a){var c={},d=aa((/android (\d+)/.exec(L((b.navigator||{}).userAgent))||[])[1]),e=/Boxee/i.test((b.navigator||{}).userAgent),f=a[0]||{},g,h=/^(Moz|webkit|ms)(?=[A-Z])/,l=f.body&&f.body.style,k=!1,m=!1;if(l){for(var r in l)if(k=h.exec(r)){g=k[0];g=g.substr(0,1).toUpperCase()+g.substr(1);break}g||(g="WebkitOpacity"in l&&"webkit");k=!!("transition"in l||g+"Transition"in l);m=!!("animation"in l||g+"Animation"in
l);!d||k&&m||(k=O(f.body.style.webkitTransition),m=O(f.body.style.webkitAnimation))}return{history:!(!b.history||!b.history.pushState||4>d||e),hasEvent:function(a){if("input"===a&&11>=Qa)return!1;if(C(c[a])){var b=f.createElement("div");c[a]="on"+a in b}return c[a]},csp:cb(),vendorPrefix:g,transitions:k,animations:m,android:d}}]}function af(){this.$get=["$templateCache","$http","$q",function(b,a,c){function d(e,f){d.totalPendingRequests++;var g=a.defaults&&a.defaults.transformResponse;w(g)?g=g.filter(function(a){return a!==
bc}):g===bc&&(g=null);return a.get(e,{cache:b,transformResponse:g})["finally"](function(){d.totalPendingRequests--}).then(function(a){return a.data},function(a){if(!f)throw da("tpload",e);return c.reject(a)})}d.totalPendingRequests=0;return d}]}function bf(){this.$get=["$rootScope","$browser","$location",function(b,a,c){return{findBindings:function(a,b,c){a=a.getElementsByClassName("ng-binding");var g=[];q(a,function(a){var d=ba.element(a).data("$binding");d&&q(d,function(d){c?(new RegExp("(^|\\s)"+
ld(b)+"(\\s|\\||$)")).test(d)&&g.push(a):-1!=d.indexOf(b)&&g.push(a)})});return g},findModels:function(a,b,c){for(var g=["ng-","data-ng-","ng\\:"],h=0;h<g.length;++h){var l=a.querySelectorAll("["+g[h]+"model"+(c?"=":"*=")+'"'+b+'"]');if(l.length)return l}},getLocation:function(){return c.url()},setLocation:function(a){a!==c.url()&&(c.url(a),b.$digest())},whenStable:function(b){a.notifyWhenNoOutstandingRequests(b)}}}]}function cf(){this.$get=["$rootScope","$browser","$q","$$q","$exceptionHandler",
function(b,a,c,d,e){function f(f,l,k){var m=y(k)&&!k,r=(m?d:c).defer(),n=r.promise;l=a.defer(function(){try{r.resolve(f())}catch(a){r.reject(a),e(a)}finally{delete g[n.$$timeoutId]}m||b.$apply()},l);n.$$timeoutId=l;g[l]=r;return n}var g={};f.cancel=function(b){return b&&b.$$timeoutId in g?(g[b.$$timeoutId].reject("canceled"),delete g[b.$$timeoutId],a.defer.cancel(b.$$timeoutId)):!1};return f}]}function ya(b){Qa&&(X.setAttribute("href",b),b=X.href);X.setAttribute("href",b);return{href:X.href,protocol:X.protocol?
X.protocol.replace(/:$/,""):"",host:X.host,search:X.search?X.search.replace(/^\?/,""):"",hash:X.hash?X.hash.replace(/^#/,""):"",hostname:X.hostname,port:X.port,pathname:"/"===X.pathname.charAt(0)?X.pathname:"/"+X.pathname}}function ed(b){b=O(b)?ya(b):b;return b.protocol===nd.protocol&&b.host===nd.host}function df(){this.$get=ca(T)}function Ic(b){function a(c,d){if(I(c)){var e={};q(c,function(b,c){e[c]=a(c,b)});return e}return b.factory(c+"Filter",d)}this.register=a;this.$get=["$injector",function(a){return function(b){return a.get(b+
"Filter")}}];a("currency",od);a("date",pd);a("filter",If);a("json",Jf);a("limitTo",Kf);a("lowercase",Lf);a("number",qd);a("orderBy",rd);a("uppercase",Mf)}function If(){return function(b,a,c){if(!w(b))return b;var d;switch(null!==a?typeof a:"null"){case "function":break;case "boolean":case "null":case "number":case "string":d=!0;case "object":a=Nf(a,c,d);break;default:return b}return b.filter(a)}}function Nf(b,a,c){var d=I(b)&&"$"in b;!0===a?a=fa:E(a)||(a=function(a,b){if(C(a))return!1;if(null===a||
null===b)return a===b;if(I(a)||I(b))return!1;a=L(""+a);b=L(""+b);return-1!==a.indexOf(b)});return function(e){return d&&!I(e)?Ha(e,b.$,a,!1):Ha(e,b,a,c)}}function Ha(b,a,c,d,e){var f=null!==b?typeof b:"null",g=null!==a?typeof a:"null";if("string"===g&&"!"===a.charAt(0))return!Ha(b,a.substring(1),c,d);if(w(b))return b.some(function(b){return Ha(b,a,c,d)});switch(f){case "object":var h;if(d){for(h in b)if("$"!==h.charAt(0)&&Ha(b[h],a,c,!0))return!0;return e?!1:Ha(b,a,c,!1)}if("object"===g){for(h in a)if(e=
a[h],!E(e)&&!C(e)&&(f="$"===h,!Ha(f?b:b[h],e,c,f,f)))return!1;return!0}return c(b,a);case "function":return!1;default:return c(b,a)}}function od(b){var a=b.NUMBER_FORMATS;return function(b,d,e){C(d)&&(d=a.CURRENCY_SYM);C(e)&&(e=a.PATTERNS[1].maxFrac);return null==b?b:sd(b,a.PATTERNS[1],a.GROUP_SEP,a.DECIMAL_SEP,e).replace(/\u00A4/g,d)}}function qd(b){var a=b.NUMBER_FORMATS;return function(b,d){return null==b?b:sd(b,a.PATTERNS[0],a.GROUP_SEP,a.DECIMAL_SEP,d)}}function sd(b,a,c,d,e){if(!isFinite(b)||
I(b))return"";var f=0>b;b=Math.abs(b);var g=b+"",h="",l=[],k=!1;if(-1!==g.indexOf("e")){var m=g.match(/([\d\.]+)e(-?)(\d+)/);m&&"-"==m[2]&&m[3]>e+1?b=0:(h=g,k=!0)}if(k)0<e&&1>b&&(h=b.toFixed(e),b=parseFloat(h));else{g=(g.split(td)[1]||"").length;C(e)&&(e=Math.min(Math.max(a.minFrac,g),a.maxFrac));b=+(Math.round(+(b.toString()+"e"+e)).toString()+"e"+-e);var g=(""+b).split(td),k=g[0],g=g[1]||"",r=0,n=a.lgSize,u=a.gSize;if(k.length>=n+u)for(r=k.length-n,m=0;m<r;m++)0===(r-m)%u&&0!==m&&(h+=c),h+=k.charAt(m);
for(m=r;m<k.length;m++)0===(k.length-m)%n&&0!==m&&(h+=c),h+=k.charAt(m);for(;g.length<e;)g+="0";e&&"0"!==e&&(h+=d+g.substr(0,e))}0===b&&(f=!1);l.push(f?a.negPre:a.posPre,h,f?a.negSuf:a.posSuf);return l.join("")}function Jb(b,a,c){var d="";0>b&&(d="-",b=-b);for(b=""+b;b.length<a;)b="0"+b;c&&(b=b.substr(b.length-a));return d+b}function Z(b,a,c,d){c=c||0;return function(e){e=e["get"+b]();if(0<c||e>-c)e+=c;0===e&&-12==c&&(e=12);return Jb(e,a,d)}}function Kb(b,a){return function(c,d){var e=c["get"+b](),
f=vb(a?"SHORT"+b:b);return d[f][e]}}function ud(b){var a=(new Date(b,0,1)).getDay();return new Date(b,0,(4>=a?5:12)-a)}function vd(b){return function(a){var c=ud(a.getFullYear());a=+new Date(a.getFullYear(),a.getMonth(),a.getDate()+(4-a.getDay()))-+c;a=1+Math.round(a/6048E5);return Jb(a,b)}}function lc(b,a){return 0>=b.getFullYear()?a.ERAS[0]:a.ERAS[1]}function pd(b){function a(a){var b;if(b=a.match(c)){a=new Date(0);var f=0,g=0,h=b[8]?a.setUTCFullYear:a.setFullYear,l=b[8]?a.setUTCHours:a.setHours;
b[9]&&(f=aa(b[9]+b[10]),g=aa(b[9]+b[11]));h.call(a,aa(b[1]),aa(b[2])-1,aa(b[3]));f=aa(b[4]||0)-f;g=aa(b[5]||0)-g;h=aa(b[6]||0);b=Math.round(1E3*parseFloat("0."+(b[7]||0)));l.call(a,f,g,h,b)}return a}var c=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;return function(c,e,f){var g="",h=[],l,k;e=e||"mediumDate";e=b.DATETIME_FORMATS[e]||e;O(c)&&(c=Of.test(c)?aa(c):a(c));Q(c)&&(c=new Date(c));if(!ea(c))return c;for(;e;)(k=Pf.exec(e))?(h=Ya(h,k,1),
e=h.pop()):(h.push(e),e=null);f&&"UTC"===f&&(c=new Date(c.getTime()),c.setMinutes(c.getMinutes()+c.getTimezoneOffset()));q(h,function(a){l=Qf[a];g+=l?l(c,b.DATETIME_FORMATS):a.replace(/(^'|'$)/g,"").replace(/''/g,"'")});return g}}function Jf(){return function(b,a){C(a)&&(a=2);return $a(b,a)}}function Kf(){return function(b,a){Q(b)&&(b=b.toString());return w(b)||O(b)?(a=Infinity===Math.abs(Number(a))?Number(a):aa(a))?0<a?b.slice(0,a):b.slice(a):O(b)?"":[]:b}}function rd(b){return function(a,c,d){function e(a,
b){return b?function(b,c){return a(c,b)}:a}function f(a){switch(typeof a){case "number":case "boolean":case "string":return!0;default:return!1}}function g(a){return null===a?"null":"function"===typeof a.valueOf&&(a=a.valueOf(),f(a))||"function"===typeof a.toString&&(a=a.toString(),f(a))?a:""}function h(a,b){var c=typeof a,d=typeof b;c===d&&"object"===c&&(a=g(a),b=g(b));return c===d?("string"===c&&(a=a.toLowerCase(),b=b.toLowerCase()),a===b?0:a<b?-1:1):c<d?-1:1}if(!Sa(a))return a;c=w(c)?c:[c];0===
c.length&&(c=["+"]);c=c.map(function(a){var c=!1,d=a||na;if(O(a)){if("+"==a.charAt(0)||"-"==a.charAt(0))c="-"==a.charAt(0),a=a.substring(1);if(""===a)return e(h,c);d=b(a);if(d.constant){var f=d();return e(function(a,b){return h(a[f],b[f])},c)}}return e(function(a,b){return h(d(a),d(b))},c)});return Za.call(a).sort(e(function(a,b){for(var d=0;d<c.length;d++){var e=c[d](a,b);if(0!==e)return e}return 0},d))}}function Ia(b){E(b)&&(b={link:b});b.restrict=b.restrict||"AC";return ca(b)}function wd(b,a,c,
d,e){var f=this,g=[],h=f.$$parentForm=b.parent().controller("form")||Lb;f.$error={};f.$$success={};f.$pending=s;f.$name=e(a.name||a.ngForm||"")(c);f.$dirty=!1;f.$pristine=!0;f.$valid=!0;f.$invalid=!1;f.$submitted=!1;h.$addControl(f);f.$rollbackViewValue=function(){q(g,function(a){a.$rollbackViewValue()})};f.$commitViewValue=function(){q(g,function(a){a.$commitViewValue()})};f.$addControl=function(a){Ma(a.$name,"input");g.push(a);a.$name&&(f[a.$name]=a)};f.$$renameControl=function(a,b){var c=a.$name;
f[c]===a&&delete f[c];f[b]=a;a.$name=b};f.$removeControl=function(a){a.$name&&f[a.$name]===a&&delete f[a.$name];q(f.$pending,function(b,c){f.$setValidity(c,null,a)});q(f.$error,function(b,c){f.$setValidity(c,null,a)});q(f.$$success,function(b,c){f.$setValidity(c,null,a)});Xa(g,a)};xd({ctrl:this,$element:b,set:function(a,b,c){var d=a[b];d?-1===d.indexOf(c)&&d.push(c):a[b]=[c]},unset:function(a,b,c){var d=a[b];d&&(Xa(d,c),0===d.length&&delete a[b])},parentForm:h,$animate:d});f.$setDirty=function(){d.removeClass(b,
Ra);d.addClass(b,Mb);f.$dirty=!0;f.$pristine=!1;h.$setDirty()};f.$setPristine=function(){d.setClass(b,Ra,Mb+" ng-submitted");f.$dirty=!1;f.$pristine=!0;f.$submitted=!1;q(g,function(a){a.$setPristine()})};f.$setUntouched=function(){q(g,function(a){a.$setUntouched()})};f.$setSubmitted=function(){d.addClass(b,"ng-submitted");f.$submitted=!0;h.$setSubmitted()}}function mc(b){b.$formatters.push(function(a){return b.$isEmpty(a)?a:a.toString()})}function mb(b,a,c,d,e,f){var g=L(a[0].type);if(!e.android){var h=
!1;a.on("compositionstart",function(a){h=!0});a.on("compositionend",function(){h=!1;l()})}var l=function(b){k&&(f.defer.cancel(k),k=null);if(!h){var e=a.val();b=b&&b.type;"password"===g||c.ngTrim&&"false"===c.ngTrim||(e=U(e));(d.$viewValue!==e||""===e&&d.$$hasNativeValidators)&&d.$setViewValue(e,b)}};if(e.hasEvent("input"))a.on("input",l);else{var k,m=function(a,b,c){k||(k=f.defer(function(){k=null;b&&b.value===c||l(a)}))};a.on("keydown",function(a){var b=a.keyCode;91===b||15<b&&19>b||37<=b&&40>=
b||m(a,this,this.value)});if(e.hasEvent("paste"))a.on("paste cut",m)}a.on("change",l);d.$render=function(){a.val(d.$isEmpty(d.$viewValue)?"":d.$viewValue)}}function Nb(b,a){return function(c,d){var e,f;if(ea(c))return c;if(O(c)){'"'==c.charAt(0)&&'"'==c.charAt(c.length-1)&&(c=c.substring(1,c.length-1));if(Rf.test(c))return new Date(c);b.lastIndex=0;if(e=b.exec(c))return e.shift(),f=d?{yyyy:d.getFullYear(),MM:d.getMonth()+1,dd:d.getDate(),HH:d.getHours(),mm:d.getMinutes(),ss:d.getSeconds(),sss:d.getMilliseconds()/
1E3}:{yyyy:1970,MM:1,dd:1,HH:0,mm:0,ss:0,sss:0},q(e,function(b,c){c<a.length&&(f[a[c]]=+b)}),new Date(f.yyyy,f.MM-1,f.dd,f.HH,f.mm,f.ss||0,1E3*f.sss||0)}return NaN}}function nb(b,a,c,d){return function(e,f,g,h,l,k,m){function r(a){return a&&!(a.getTime&&a.getTime()!==a.getTime())}function n(a){return y(a)?ea(a)?a:c(a):s}yd(e,f,g,h);mb(e,f,g,h,l,k);var u=h&&h.$options&&h.$options.timezone,v;h.$$parserName=b;h.$parsers.push(function(b){return h.$isEmpty(b)?null:a.test(b)?(b=c(b,v),"UTC"===u&&b.setMinutes(b.getMinutes()-
b.getTimezoneOffset()),b):s});h.$formatters.push(function(a){if(a&&!ea(a))throw Ob("datefmt",a);if(r(a)){if((v=a)&&"UTC"===u){var b=6E4*v.getTimezoneOffset();v=new Date(v.getTime()+b)}return m("date")(a,d,u)}v=null;return""});if(y(g.min)||g.ngMin){var q;h.$validators.min=function(a){return!r(a)||C(q)||c(a)>=q};g.$observe("min",function(a){q=n(a);h.$validate()})}if(y(g.max)||g.ngMax){var t;h.$validators.max=function(a){return!r(a)||C(t)||c(a)<=t};g.$observe("max",function(a){t=n(a);h.$validate()})}}}
function yd(b,a,c,d){(d.$$hasNativeValidators=I(a[0].validity))&&d.$parsers.push(function(b){var c=a.prop("validity")||{};return c.badInput&&!c.typeMismatch?s:b})}function zd(b,a,c,d,e){if(y(d)){b=b(d);if(!b.constant)throw F("ngModel")("constexpr",c,d);return b(a)}return e}function nc(b,a){b="ngClass"+b;return["$animate",function(c){function d(a,b){var c=[],d=0;a:for(;d<a.length;d++){for(var e=a[d],m=0;m<b.length;m++)if(e==b[m])continue a;c.push(e)}return c}function e(a){if(!w(a)){if(O(a))return a.split(" ");
if(I(a)){var b=[];q(a,function(a,c){a&&(b=b.concat(c.split(" ")))});return b}}return a}return{restrict:"AC",link:function(f,g,h){function l(a,b){var c=g.data("$classCounts")||{},d=[];q(a,function(a){if(0<b||c[a])c[a]=(c[a]||0)+b,c[a]===+(0<b)&&d.push(a)});g.data("$classCounts",c);return d.join(" ")}function k(b){if(!0===a||f.$index%2===a){var k=e(b||[]);if(!m){var u=l(k,1);h.$addClass(u)}else if(!fa(b,m)){var q=e(m),u=d(k,q),k=d(q,k),u=l(u,1),k=l(k,-1);u&&u.length&&c.addClass(g,u);k&&k.length&&c.removeClass(g,
k)}}m=oa(b)}var m;f.$watch(h[b],k,!0);h.$observe("class",function(a){k(f.$eval(h[b]))});"ngClass"!==b&&f.$watch("$index",function(c,d){var g=c&1;if(g!==(d&1)){var k=e(f.$eval(h[b]));g===a?(g=l(k,1),h.$addClass(g)):(g=l(k,-1),h.$removeClass(g))}})}}}]}function xd(b){function a(a,b){b&&!f[a]?(k.addClass(e,a),f[a]=!0):!b&&f[a]&&(k.removeClass(e,a),f[a]=!1)}function c(b,c){b=b?"-"+yc(b,"-"):"";a(ob+b,!0===c);a(Ad+b,!1===c)}var d=b.ctrl,e=b.$element,f={},g=b.set,h=b.unset,l=b.parentForm,k=b.$animate;f[Ad]=
!(f[ob]=e.hasClass(ob));d.$setValidity=function(b,e,f){e===s?(d.$pending||(d.$pending={}),g(d.$pending,b,f)):(d.$pending&&h(d.$pending,b,f),Bd(d.$pending)&&(d.$pending=s));Wa(e)?e?(h(d.$error,b,f),g(d.$$success,b,f)):(g(d.$error,b,f),h(d.$$success,b,f)):(h(d.$error,b,f),h(d.$$success,b,f));d.$pending?(a(Cd,!0),d.$valid=d.$invalid=s,c("",null)):(a(Cd,!1),d.$valid=Bd(d.$error),d.$invalid=!d.$valid,c("",d.$valid));e=d.$pending&&d.$pending[b]?s:d.$error[b]?!1:d.$$success[b]?!0:null;c(b,e);l.$setValidity(b,
e,d)}}function Bd(b){if(b)for(var a in b)return!1;return!0}var Sf=/^\/(.+)\/([a-z]*)$/,L=function(b){return O(b)?b.toLowerCase():b},wc=Object.prototype.hasOwnProperty,vb=function(b){return O(b)?b.toUpperCase():b},Qa,z,pa,Za=[].slice,uf=[].splice,Tf=[].push,Aa=Object.prototype.toString,Ja=F("ng"),ba=T.angular||(T.angular={}),db,rb=0;Qa=V.documentMode;A.$inject=[];na.$inject=[];var w=Array.isArray,U=function(b){return O(b)?b.trim():b},ld=function(b){return b.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,
"\\$1").replace(/\x08/g,"\\x08")},cb=function(){if(y(cb.isActive_))return cb.isActive_;var b=!(!V.querySelector("[ng-csp]")&&!V.querySelector("[data-ng-csp]"));if(!b)try{new Function("")}catch(a){b=!0}return cb.isActive_=b},tb=["ng-","data-ng-","ng:","x-ng-"],Rd=/[A-Z]/g,zc=!1,Rb,ma=1,ab=3,Vd={full:"1.3.16",major:1,minor:3,dot:16,codeName:"cookie-oatmealification"};R.expando="ng339";var Ab=R.cache={},nf=1;R._data=function(b){return this.cache[b[this.expando]]||{}};var hf=/([\:\-\_]+(.))/g,jf=/^moz([A-Z])/,
Uf={mouseleave:"mouseout",mouseenter:"mouseover"},Ub=F("jqLite"),mf=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,Tb=/<|&#?\w+;/,kf=/<([\w:]+)/,lf=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ha={option:[1,'<select multiple="multiple">',"</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ha.optgroup=ha.option;ha.tbody=ha.tfoot=ha.colgroup=
ha.caption=ha.thead;ha.th=ha.td;var Ka=R.prototype={ready:function(b){function a(){c||(c=!0,b())}var c=!1;"complete"===V.readyState?setTimeout(a):(this.on("DOMContentLoaded",a),R(T).on("load",a))},toString:function(){var b=[];q(this,function(a){b.push(""+a)});return"["+b.join(", ")+"]"},eq:function(b){return 0<=b?z(this[b]):z(this[this.length+b])},length:0,push:Tf,sort:[].sort,splice:[].splice},Fb={};q("multiple selected checked disabled readOnly required open".split(" "),function(b){Fb[L(b)]=b});
var Rc={};q("input select option textarea button form details".split(" "),function(b){Rc[b]=!0});var Sc={ngMinlength:"minlength",ngMaxlength:"maxlength",ngMin:"min",ngMax:"max",ngPattern:"pattern"};q({data:Wb,removeData:yb},function(b,a){R[a]=b});q({data:Wb,inheritedData:Eb,scope:function(b){return z.data(b,"$scope")||Eb(b.parentNode||b,["$isolateScope","$scope"])},isolateScope:function(b){return z.data(b,"$isolateScope")||z.data(b,"$isolateScopeNoTemplate")},controller:Nc,injector:function(b){return Eb(b,
"$injector")},removeAttr:function(b,a){b.removeAttribute(a)},hasClass:Bb,css:function(b,a,c){a=eb(a);if(y(c))b.style[a]=c;else return b.style[a]},attr:function(b,a,c){var d=b.nodeType;if(d!==ab&&2!==d&&8!==d)if(d=L(a),Fb[d])if(y(c))c?(b[a]=!0,b.setAttribute(a,d)):(b[a]=!1,b.removeAttribute(d));else return b[a]||(b.attributes.getNamedItem(a)||A).specified?d:s;else if(y(c))b.setAttribute(a,c);else if(b.getAttribute)return b=b.getAttribute(a,2),null===b?s:b},prop:function(b,a,c){if(y(c))b[a]=c;else return b[a]},
text:function(){function b(a,b){if(C(b)){var d=a.nodeType;return d===ma||d===ab?a.textContent:""}a.textContent=b}b.$dv="";return b}(),val:function(b,a){if(C(a)){if(b.multiple&&"select"===sa(b)){var c=[];q(b.options,function(a){a.selected&&c.push(a.value||a.text)});return 0===c.length?null:c}return b.value}b.value=a},html:function(b,a){if(C(a))return b.innerHTML;xb(b,!0);b.innerHTML=a},empty:Oc},function(b,a){R.prototype[a]=function(a,d){var e,f,g=this.length;if(b!==Oc&&(2==b.length&&b!==Bb&&b!==Nc?
a:d)===s){if(I(a)){for(e=0;e<g;e++)if(b===Wb)b(this[e],a);else for(f in a)b(this[e],f,a[f]);return this}e=b.$dv;g=e===s?Math.min(g,1):g;for(f=0;f<g;f++){var h=b(this[f],a,d);e=e?e+h:h}return e}for(e=0;e<g;e++)b(this[e],a,d);return this}});q({removeData:yb,on:function a(c,d,e,f){if(y(f))throw Ub("onargs");if(Jc(c)){var g=zb(c,!0);f=g.events;var h=g.handle;h||(h=g.handle=qf(c,f));for(var g=0<=d.indexOf(" ")?d.split(" "):[d],l=g.length;l--;){d=g[l];var k=f[d];k||(f[d]=[],"mouseenter"===d||"mouseleave"===
d?a(c,Uf[d],function(a){var c=a.relatedTarget;c&&(c===this||this.contains(c))||h(a,d)}):"$destroy"!==d&&c.addEventListener(d,h,!1),k=f[d]);k.push(e)}}},off:Mc,one:function(a,c,d){a=z(a);a.on(c,function f(){a.off(c,d);a.off(c,f)});a.on(c,d)},replaceWith:function(a,c){var d,e=a.parentNode;xb(a);q(new R(c),function(c){d?e.insertBefore(c,d.nextSibling):e.replaceChild(c,a);d=c})},children:function(a){var c=[];q(a.childNodes,function(a){a.nodeType===ma&&c.push(a)});return c},contents:function(a){return a.contentDocument||
a.childNodes||[]},append:function(a,c){var d=a.nodeType;if(d===ma||11===d){c=new R(c);for(var d=0,e=c.length;d<e;d++)a.appendChild(c[d])}},prepend:function(a,c){if(a.nodeType===ma){var d=a.firstChild;q(new R(c),function(c){a.insertBefore(c,d)})}},wrap:function(a,c){c=z(c).eq(0).clone()[0];var d=a.parentNode;d&&d.replaceChild(c,a);c.appendChild(a)},remove:Pc,detach:function(a){Pc(a,!0)},after:function(a,c){var d=a,e=a.parentNode;c=new R(c);for(var f=0,g=c.length;f<g;f++){var h=c[f];e.insertBefore(h,
d.nextSibling);d=h}},addClass:Db,removeClass:Cb,toggleClass:function(a,c,d){c&&q(c.split(" "),function(c){var f=d;C(f)&&(f=!Bb(a,c));(f?Db:Cb)(a,c)})},parent:function(a){return(a=a.parentNode)&&11!==a.nodeType?a:null},next:function(a){return a.nextElementSibling},find:function(a,c){return a.getElementsByTagName?a.getElementsByTagName(c):[]},clone:Vb,triggerHandler:function(a,c,d){var e,f,g=c.type||c,h=zb(a);if(h=(h=h&&h.events)&&h[g])e={preventDefault:function(){this.defaultPrevented=!0},isDefaultPrevented:function(){return!0===
this.defaultPrevented},stopImmediatePropagation:function(){this.immediatePropagationStopped=!0},isImmediatePropagationStopped:function(){return!0===this.immediatePropagationStopped},stopPropagation:A,type:g,target:a},c.type&&(e=x(e,c)),c=oa(h),f=d?[e].concat(d):[e],q(c,function(c){e.isImmediatePropagationStopped()||c.apply(a,f)})}},function(a,c){R.prototype[c]=function(c,e,f){for(var g,h=0,l=this.length;h<l;h++)C(g)?(g=a(this[h],c,e,f),y(g)&&(g=z(g))):Lc(g,a(this[h],c,e,f));return y(g)?g:this};R.prototype.bind=
R.prototype.on;R.prototype.unbind=R.prototype.off});fb.prototype={put:function(a,c){this[Na(a,this.nextUid)]=c},get:function(a){return this[Na(a,this.nextUid)]},remove:function(a){var c=this[a=Na(a,this.nextUid)];delete this[a];return c}};var Uc=/^function\s*[^\(]*\(\s*([^\)]*)\)/m,Vf=/,/,Wf=/^\s*(_?)(\S+?)\1\s*$/,Tc=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg,Da=F("$injector");bb.$$annotate=function(a,c,d){var e;if("function"===typeof a){if(!(e=a.$inject)){e=[];if(a.length){if(c)throw O(d)&&d||(d=a.name||
rf(a)),Da("strictdi",d);c=a.toString().replace(Tc,"");c=c.match(Uc);q(c[1].split(Vf),function(a){a.replace(Wf,function(a,c,d){e.push(d)})})}a.$inject=e}}else w(a)?(c=a.length-1,La(a[c],"fn"),e=a.slice(0,c)):La(a,"fn",!0);return e};var Xf=F("$animate"),He=["$provide",function(a){this.$$selectors={};this.register=function(c,d){var e=c+"-animation";if(c&&"."!=c.charAt(0))throw Xf("notcsel",c);this.$$selectors[c.substr(1)]=e;a.factory(e,d)};this.classNameFilter=function(a){1===arguments.length&&(this.$$classNameFilter=
a instanceof RegExp?a:null);return this.$$classNameFilter};this.$get=["$$q","$$asyncCallback","$rootScope",function(a,d,e){function f(d){var f,g=a.defer();g.promise.$$cancelFn=function(){f&&f()};e.$$postDigest(function(){f=d(function(){g.resolve()})});return g.promise}function g(a,c){var d=[],e=[],f=ga();q((a.attr("class")||"").split(/\s+/),function(a){f[a]=!0});q(c,function(a,c){var g=f[c];!1===a&&g?e.push(c):!0!==a||g||d.push(c)});return 0<d.length+e.length&&[d.length?d:null,e.length?e:null]}function h(a,
c,d){for(var e=0,f=c.length;e<f;++e)a[c[e]]=d}function l(){m||(m=a.defer(),d(function(){m.resolve();m=null}));return m.promise}function k(a,c){if(ba.isObject(c)){var d=x(c.from||{},c.to||{});a.css(d)}}var m;return{animate:function(a,c,d){k(a,{from:c,to:d});return l()},enter:function(a,c,d,e){k(a,e);d?d.after(a):c.prepend(a);return l()},leave:function(a,c){k(a,c);a.remove();return l()},move:function(a,c,d,e){return this.enter(a,c,d,e)},addClass:function(a,c,d){return this.setClass(a,c,[],d)},$$addClassImmediately:function(a,
c,d){a=z(a);c=O(c)?c:w(c)?c.join(" "):"";q(a,function(a){Db(a,c)});k(a,d);return l()},removeClass:function(a,c,d){return this.setClass(a,[],c,d)},$$removeClassImmediately:function(a,c,d){a=z(a);c=O(c)?c:w(c)?c.join(" "):"";q(a,function(a){Cb(a,c)});k(a,d);return l()},setClass:function(a,c,d,e){var k=this,l=!1;a=z(a);var m=a.data("$$animateClasses");m?e&&m.options&&(m.options=ba.extend(m.options||{},e)):(m={classes:{},options:e},l=!0);e=m.classes;c=w(c)?c:c.split(" ");d=w(d)?d:d.split(" ");h(e,c,!0);
h(e,d,!1);l&&(m.promise=f(function(c){var d=a.data("$$animateClasses");a.removeData("$$animateClasses");if(d){var e=g(a,d.classes);e&&k.$$setClassImmediately(a,e[0],e[1],d.options)}c()}),a.data("$$animateClasses",m));return m.promise},$$setClassImmediately:function(a,c,d,e){c&&this.$$addClassImmediately(a,c);d&&this.$$removeClassImmediately(a,d);k(a,e);return l()},enabled:A,cancel:A}}]}],da=F("$compile");Bc.$inject=["$provide","$$sanitizeUriProvider"];var Wc=/^((?:x|data)[\:\-_])/i,vf=F("$controller"),
ad="application/json",cc={"Content-Type":ad+";charset=utf-8"},xf=/^\[|^\{(?!\{)/,yf={"[":/]$/,"{":/}$/},wf=/^\)\]\}',?\n/,dc=F("$interpolate"),Yf=/^([^\?#]*)(\?([^#]*))?(#(.*))?$/,Bf={http:80,https:443,ftp:21},Hb=F("$location"),Zf={$$html5:!1,$$replace:!1,absUrl:Ib("$$absUrl"),url:function(a){if(C(a))return this.$$url;var c=Yf.exec(a);(c[1]||""===a)&&this.path(decodeURIComponent(c[1]));(c[2]||c[1]||""===a)&&this.search(c[3]||"");this.hash(c[5]||"");return this},protocol:Ib("$$protocol"),host:Ib("$$host"),
port:Ib("$$port"),path:id("$$path",function(a){a=null!==a?a.toString():"";return"/"==a.charAt(0)?a:"/"+a}),search:function(a,c){switch(arguments.length){case 0:return this.$$search;case 1:if(O(a)||Q(a))a=a.toString(),this.$$search=vc(a);else if(I(a))a=Ba(a,{}),q(a,function(c,e){null==c&&delete a[e]}),this.$$search=a;else throw Hb("isrcharg");break;default:C(c)||null===c?delete this.$$search[a]:this.$$search[a]=c}this.$$compose();return this},hash:id("$$hash",function(a){return null!==a?a.toString():
""}),replace:function(){this.$$replace=!0;return this}};q([hd,hc,gc],function(a){a.prototype=Object.create(Zf);a.prototype.state=function(c){if(!arguments.length)return this.$$state;if(a!==gc||!this.$$html5)throw Hb("nostate");this.$$state=C(c)?null:c;return this}});var ja=F("$parse"),$f=Function.prototype.call,ag=Function.prototype.apply,bg=Function.prototype.bind,pb=ga();q({"null":function(){return null},"true":function(){return!0},"false":function(){return!1},undefined:function(){}},function(a,
c){a.constant=a.literal=a.sharedGetter=!0;pb[c]=a});pb["this"]=function(a){return a};pb["this"].sharedGetter=!0;var qb=x(ga(),{"+":function(a,c,d,e){d=d(a,c);e=e(a,c);return y(d)?y(e)?d+e:d:y(e)?e:s},"-":function(a,c,d,e){d=d(a,c);e=e(a,c);return(y(d)?d:0)-(y(e)?e:0)},"*":function(a,c,d,e){return d(a,c)*e(a,c)},"/":function(a,c,d,e){return d(a,c)/e(a,c)},"%":function(a,c,d,e){return d(a,c)%e(a,c)},"===":function(a,c,d,e){return d(a,c)===e(a,c)},"!==":function(a,c,d,e){return d(a,c)!==e(a,c)},"==":function(a,
c,d,e){return d(a,c)==e(a,c)},"!=":function(a,c,d,e){return d(a,c)!=e(a,c)},"<":function(a,c,d,e){return d(a,c)<e(a,c)},">":function(a,c,d,e){return d(a,c)>e(a,c)},"<=":function(a,c,d,e){return d(a,c)<=e(a,c)},">=":function(a,c,d,e){return d(a,c)>=e(a,c)},"&&":function(a,c,d,e){return d(a,c)&&e(a,c)},"||":function(a,c,d,e){return d(a,c)||e(a,c)},"!":function(a,c,d){return!d(a,c)},"=":!0,"|":!0}),cg={n:"\n",f:"\f",r:"\r",t:"\t",v:"\v","'":"'",'"':'"'},kc=function(a){this.options=a};kc.prototype={constructor:kc,
lex:function(a){this.text=a;this.index=0;for(this.tokens=[];this.index<this.text.length;)if(a=this.text.charAt(this.index),'"'===a||"'"===a)this.readString(a);else if(this.isNumber(a)||"."===a&&this.isNumber(this.peek()))this.readNumber();else if(this.isIdent(a))this.readIdent();else if(this.is(a,"(){}[].,;:?"))this.tokens.push({index:this.index,text:a}),this.index++;else if(this.isWhitespace(a))this.index++;else{var c=a+this.peek(),d=c+this.peek(2),e=qb[c],f=qb[d];qb[a]||e||f?(a=f?d:e?c:a,this.tokens.push({index:this.index,
text:a,operator:!0}),this.index+=a.length):this.throwError("Unexpected next character ",this.index,this.index+1)}return this.tokens},is:function(a,c){return-1!==c.indexOf(a)},peek:function(a){a=a||1;return this.index+a<this.text.length?this.text.charAt(this.index+a):!1},isNumber:function(a){return"0"<=a&&"9">=a&&"string"===typeof a},isWhitespace:function(a){return" "===a||"\r"===a||"\t"===a||"\n"===a||"\v"===a||"\u00a0"===a},isIdent:function(a){return"a"<=a&&"z">=a||"A"<=a&&"Z">=a||"_"===a||"$"===
a},isExpOperator:function(a){return"-"===a||"+"===a||this.isNumber(a)},throwError:function(a,c,d){d=d||this.index;c=y(c)?"s "+c+"-"+this.index+" ["+this.text.substring(c,d)+"]":" "+d;throw ja("lexerr",a,c,this.text);},readNumber:function(){for(var a="",c=this.index;this.index<this.text.length;){var d=L(this.text.charAt(this.index));if("."==d||this.isNumber(d))a+=d;else{var e=this.peek();if("e"==d&&this.isExpOperator(e))a+=d;else if(this.isExpOperator(d)&&e&&this.isNumber(e)&&"e"==a.charAt(a.length-
1))a+=d;else if(!this.isExpOperator(d)||e&&this.isNumber(e)||"e"!=a.charAt(a.length-1))break;else this.throwError("Invalid exponent")}this.index++}this.tokens.push({index:c,text:a,constant:!0,value:Number(a)})},readIdent:function(){for(var a=this.index;this.index<this.text.length;){var c=this.text.charAt(this.index);if(!this.isIdent(c)&&!this.isNumber(c))break;this.index++}this.tokens.push({index:a,text:this.text.slice(a,this.index),identifier:!0})},readString:function(a){var c=this.index;this.index++;
for(var d="",e=a,f=!1;this.index<this.text.length;){var g=this.text.charAt(this.index),e=e+g;if(f)"u"===g?(f=this.text.substring(this.index+1,this.index+5),f.match(/[\da-f]{4}/i)||this.throwError("Invalid unicode escape [\\u"+f+"]"),this.index+=4,d+=String.fromCharCode(parseInt(f,16))):d+=cg[g]||g,f=!1;else if("\\"===g)f=!0;else{if(g===a){this.index++;this.tokens.push({index:c,text:e,constant:!0,value:d});return}d+=g}this.index++}this.throwError("Unterminated quote",c)}};var lb=function(a,c,d){this.lexer=
a;this.$filter=c;this.options=d};lb.ZERO=x(function(){return 0},{sharedGetter:!0,constant:!0});lb.prototype={constructor:lb,parse:function(a){this.text=a;this.tokens=this.lexer.lex(a);a=this.statements();0!==this.tokens.length&&this.throwError("is an unexpected token",this.tokens[0]);a.literal=!!a.literal;a.constant=!!a.constant;return a},primary:function(){var a;this.expect("(")?(a=this.filterChain(),this.consume(")")):this.expect("[")?a=this.arrayDeclaration():this.expect("{")?a=this.object():this.peek().identifier&&
this.peek().text in pb?a=pb[this.consume().text]:this.peek().identifier?a=this.identifier():this.peek().constant?a=this.constant():this.throwError("not a primary expression",this.peek());for(var c,d;c=this.expect("(","[",".");)"("===c.text?(a=this.functionCall(a,d),d=null):"["===c.text?(d=a,a=this.objectIndex(a)):"."===c.text?(d=a,a=this.fieldAccess(a)):this.throwError("IMPOSSIBLE");return a},throwError:function(a,c){throw ja("syntax",c.text,a,c.index+1,this.text,this.text.substring(c.index));},peekToken:function(){if(0===
this.tokens.length)throw ja("ueoe",this.text);return this.tokens[0]},peek:function(a,c,d,e){return this.peekAhead(0,a,c,d,e)},peekAhead:function(a,c,d,e,f){if(this.tokens.length>a){a=this.tokens[a];var g=a.text;if(g===c||g===d||g===e||g===f||!(c||d||e||f))return a}return!1},expect:function(a,c,d,e){return(a=this.peek(a,c,d,e))?(this.tokens.shift(),a):!1},consume:function(a){if(0===this.tokens.length)throw ja("ueoe",this.text);var c=this.expect(a);c||this.throwError("is unexpected, expecting ["+a+
"]",this.peek());return c},unaryFn:function(a,c){var d=qb[a];return x(function(a,f){return d(a,f,c)},{constant:c.constant,inputs:[c]})},binaryFn:function(a,c,d,e){var f=qb[c];return x(function(c,e){return f(c,e,a,d)},{constant:a.constant&&d.constant,inputs:!e&&[a,d]})},identifier:function(){for(var a=this.consume().text;this.peek(".")&&this.peekAhead(1).identifier&&!this.peekAhead(2,"(");)a+=this.consume().text+this.consume().text;return Df(a,this.options,this.text)},constant:function(){var a=this.consume().value;
return x(function(){return a},{constant:!0,literal:!0})},statements:function(){for(var a=[];;)if(0<this.tokens.length&&!this.peek("}",")",";","]")&&a.push(this.filterChain()),!this.expect(";"))return 1===a.length?a[0]:function(c,d){for(var e,f=0,g=a.length;f<g;f++)e=a[f](c,d);return e}},filterChain:function(){for(var a=this.expression();this.expect("|");)a=this.filter(a);return a},filter:function(a){var c=this.$filter(this.consume().text),d,e;if(this.peek(":"))for(d=[],e=[];this.expect(":");)d.push(this.expression());
var f=[a].concat(d||[]);return x(function(f,h){var l=a(f,h);if(e){e[0]=l;for(l=d.length;l--;)e[l+1]=d[l](f,h);return c.apply(s,e)}return c(l)},{constant:!c.$stateful&&f.every(ic),inputs:!c.$stateful&&f})},expression:function(){return this.assignment()},assignment:function(){var a=this.ternary(),c,d;return(d=this.expect("="))?(a.assign||this.throwError("implies assignment but ["+this.text.substring(0,d.index)+"] can not be assigned to",d),c=this.ternary(),x(function(d,f){return a.assign(d,c(d,f),f)},
{inputs:[a,c]})):a},ternary:function(){var a=this.logicalOR(),c;if(this.expect("?")&&(c=this.assignment(),this.consume(":"))){var d=this.assignment();return x(function(e,f){return a(e,f)?c(e,f):d(e,f)},{constant:a.constant&&c.constant&&d.constant})}return a},logicalOR:function(){for(var a=this.logicalAND(),c;c=this.expect("||");)a=this.binaryFn(a,c.text,this.logicalAND(),!0);return a},logicalAND:function(){for(var a=this.equality(),c;c=this.expect("&&");)a=this.binaryFn(a,c.text,this.equality(),!0);
return a},equality:function(){for(var a=this.relational(),c;c=this.expect("==","!=","===","!==");)a=this.binaryFn(a,c.text,this.relational());return a},relational:function(){for(var a=this.additive(),c;c=this.expect("<",">","<=",">=");)a=this.binaryFn(a,c.text,this.additive());return a},additive:function(){for(var a=this.multiplicative(),c;c=this.expect("+","-");)a=this.binaryFn(a,c.text,this.multiplicative());return a},multiplicative:function(){for(var a=this.unary(),c;c=this.expect("*","/","%");)a=
this.binaryFn(a,c.text,this.unary());return a},unary:function(){var a;return this.expect("+")?this.primary():(a=this.expect("-"))?this.binaryFn(lb.ZERO,a.text,this.unary()):(a=this.expect("!"))?this.unaryFn(a.text,this.unary()):this.primary()},fieldAccess:function(a){var c=this.identifier();return x(function(d,e,f){d=f||a(d,e);return null==d?s:c(d)},{assign:function(d,e,f){var g=a(d,f);g||a.assign(d,g={},f);return c.assign(g,e)}})},objectIndex:function(a){var c=this.text,d=this.expression();this.consume("]");
return x(function(e,f){var g=a(e,f),h=d(e,f);ra(h,c);return g?ka(g[h],c):s},{assign:function(e,f,g){var h=ra(d(e,g),c),l=ka(a(e,g),c);l||a.assign(e,l={},g);return l[h]=f}})},functionCall:function(a,c){var d=[];if(")"!==this.peekToken().text){do d.push(this.expression());while(this.expect(","))}this.consume(")");var e=this.text,f=d.length?[]:null;return function(g,h){var l=c?c(g,h):y(c)?s:g,k=a(g,h,l)||A;if(f)for(var m=d.length;m--;)f[m]=ka(d[m](g,h),e);ka(l,e);if(k){if(k.constructor===k)throw ja("isecfn",
e);if(k===$f||k===ag||k===bg)throw ja("isecff",e);}l=k.apply?k.apply(l,f):k(f[0],f[1],f[2],f[3],f[4]);f&&(f.length=0);return ka(l,e)}},arrayDeclaration:function(){var a=[];if("]"!==this.peekToken().text){do{if(this.peek("]"))break;a.push(this.expression())}while(this.expect(","))}this.consume("]");return x(function(c,d){for(var e=[],f=0,g=a.length;f<g;f++)e.push(a[f](c,d));return e},{literal:!0,constant:a.every(ic),inputs:a})},object:function(){var a=[],c=[];if("}"!==this.peekToken().text){do{if(this.peek("}"))break;
var d=this.consume();d.constant?a.push(d.value):d.identifier?a.push(d.text):this.throwError("invalid key",d);this.consume(":");c.push(this.expression())}while(this.expect(","))}this.consume("}");return x(function(d,f){for(var g={},h=0,l=c.length;h<l;h++)g[a[h]]=c[h](d,f);return g},{literal:!0,constant:c.every(ic),inputs:c})}};var Ff=ga(),Ef=ga(),Gf=Object.prototype.valueOf,za=F("$sce"),la={HTML:"html",CSS:"css",URL:"url",RESOURCE_URL:"resourceUrl",JS:"js"},da=F("$compile"),X=V.createElement("a"),
nd=ya(T.location.href);Ic.$inject=["$provide"];od.$inject=["$locale"];qd.$inject=["$locale"];var td=".",Qf={yyyy:Z("FullYear",4),yy:Z("FullYear",2,0,!0),y:Z("FullYear",1),MMMM:Kb("Month"),MMM:Kb("Month",!0),MM:Z("Month",2,1),M:Z("Month",1,1),dd:Z("Date",2),d:Z("Date",1),HH:Z("Hours",2),H:Z("Hours",1),hh:Z("Hours",2,-12),h:Z("Hours",1,-12),mm:Z("Minutes",2),m:Z("Minutes",1),ss:Z("Seconds",2),s:Z("Seconds",1),sss:Z("Milliseconds",3),EEEE:Kb("Day"),EEE:Kb("Day",!0),a:function(a,c){return 12>a.getHours()?
c.AMPMS[0]:c.AMPMS[1]},Z:function(a){a=-1*a.getTimezoneOffset();return a=(0<=a?"+":"")+(Jb(Math[0<a?"floor":"ceil"](a/60),2)+Jb(Math.abs(a%60),2))},ww:vd(2),w:vd(1),G:lc,GG:lc,GGG:lc,GGGG:function(a,c){return 0>=a.getFullYear()?c.ERANAMES[0]:c.ERANAMES[1]}},Pf=/((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,Of=/^\-?\d+$/;pd.$inject=["$locale"];var Lf=ca(L),Mf=ca(vb);rd.$inject=["$parse"];var Yd=ca({restrict:"E",compile:function(a,c){if(!c.href&&!c.xlinkHref&&
!c.name)return function(a,c){if("a"===c[0].nodeName.toLowerCase()){var f="[object SVGAnimatedString]"===Aa.call(c.prop("href"))?"xlink:href":"href";c.on("click",function(a){c.attr(f)||a.preventDefault()})}}}}),wb={};q(Fb,function(a,c){if("multiple"!=a){var d=va("ng-"+c);wb[d]=function(){return{restrict:"A",priority:100,link:function(a,f,g){a.$watch(g[d],function(a){g.$set(c,!!a)})}}}}});q(Sc,function(a,c){wb[c]=function(){return{priority:100,link:function(a,e,f){if("ngPattern"===c&&"/"==f.ngPattern.charAt(0)&&
(e=f.ngPattern.match(Sf))){f.$set("ngPattern",new RegExp(e[1],e[2]));return}a.$watch(f[c],function(a){f.$set(c,a)})}}}});q(["src","srcset","href"],function(a){var c=va("ng-"+a);wb[c]=function(){return{priority:99,link:function(d,e,f){var g=a,h=a;"href"===a&&"[object SVGAnimatedString]"===Aa.call(e.prop("href"))&&(h="xlinkHref",f.$attr[h]="xlink:href",g=null);f.$observe(c,function(c){c?(f.$set(h,c),Qa&&g&&e.prop(g,f[h])):"href"===a&&f.$set(h,null)})}}}});var Lb={$addControl:A,$$renameControl:function(a,
c){a.$name=c},$removeControl:A,$setValidity:A,$setDirty:A,$setPristine:A,$setSubmitted:A};wd.$inject=["$element","$attrs","$scope","$animate","$interpolate"];var Dd=function(a){return["$timeout",function(c){return{name:"form",restrict:a?"EAC":"E",controller:wd,compile:function(d,e){d.addClass(Ra).addClass(ob);var f=e.name?"name":a&&e.ngForm?"ngForm":!1;return{pre:function(a,d,e,k){if(!("action"in e)){var m=function(c){a.$apply(function(){k.$commitViewValue();k.$setSubmitted()});c.preventDefault()};
d[0].addEventListener("submit",m,!1);d.on("$destroy",function(){c(function(){d[0].removeEventListener("submit",m,!1)},0,!1)})}var r=k.$$parentForm;f&&(kb(a,null,k.$name,k,k.$name),e.$observe(f,function(c){k.$name!==c&&(kb(a,null,k.$name,s,k.$name),r.$$renameControl(k,c),kb(a,null,k.$name,k,k.$name))}));d.on("$destroy",function(){r.$removeControl(k);f&&kb(a,null,e[f],s,k.$name);x(k,Lb)})}}}}}]},Zd=Dd(),le=Dd(!0),Rf=/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/,dg=/^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/,
eg=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,fg=/^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/,Ed=/^(\d{4})-(\d{2})-(\d{2})$/,Fd=/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,oc=/^(\d{4})-W(\d\d)$/,Gd=/^(\d{4})-(\d\d)$/,Hd=/^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,Id={text:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e)},date:nb("date",Ed,Nb(Ed,["yyyy","MM","dd"]),"yyyy-MM-dd"),"datetime-local":nb("datetimelocal",Fd,Nb(Fd,"yyyy MM dd HH mm ss sss".split(" ")),
"yyyy-MM-ddTHH:mm:ss.sss"),time:nb("time",Hd,Nb(Hd,["HH","mm","ss","sss"]),"HH:mm:ss.sss"),week:nb("week",oc,function(a,c){if(ea(a))return a;if(O(a)){oc.lastIndex=0;var d=oc.exec(a);if(d){var e=+d[1],f=+d[2],g=d=0,h=0,l=0,k=ud(e),f=7*(f-1);c&&(d=c.getHours(),g=c.getMinutes(),h=c.getSeconds(),l=c.getMilliseconds());return new Date(e,0,k.getDate()+f,d,g,h,l)}}return NaN},"yyyy-Www"),month:nb("month",Gd,Nb(Gd,["yyyy","MM"]),"yyyy-MM"),number:function(a,c,d,e,f,g){yd(a,c,d,e);mb(a,c,d,e,f,g);e.$$parserName=
"number";e.$parsers.push(function(a){return e.$isEmpty(a)?null:fg.test(a)?parseFloat(a):s});e.$formatters.push(function(a){if(!e.$isEmpty(a)){if(!Q(a))throw Ob("numfmt",a);a=a.toString()}return a});if(y(d.min)||d.ngMin){var h;e.$validators.min=function(a){return e.$isEmpty(a)||C(h)||a>=h};d.$observe("min",function(a){y(a)&&!Q(a)&&(a=parseFloat(a,10));h=Q(a)&&!isNaN(a)?a:s;e.$validate()})}if(y(d.max)||d.ngMax){var l;e.$validators.max=function(a){return e.$isEmpty(a)||C(l)||a<=l};d.$observe("max",function(a){y(a)&&
!Q(a)&&(a=parseFloat(a,10));l=Q(a)&&!isNaN(a)?a:s;e.$validate()})}},url:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e);e.$$parserName="url";e.$validators.url=function(a,c){var d=a||c;return e.$isEmpty(d)||dg.test(d)}},email:function(a,c,d,e,f,g){mb(a,c,d,e,f,g);mc(e);e.$$parserName="email";e.$validators.email=function(a,c){var d=a||c;return e.$isEmpty(d)||eg.test(d)}},radio:function(a,c,d,e){C(d.name)&&c.attr("name",++rb);c.on("click",function(a){c[0].checked&&e.$setViewValue(d.value,a&&a.type)});e.$render=
function(){c[0].checked=d.value==e.$viewValue};d.$observe("value",e.$render)},checkbox:function(a,c,d,e,f,g,h,l){var k=zd(l,a,"ngTrueValue",d.ngTrueValue,!0),m=zd(l,a,"ngFalseValue",d.ngFalseValue,!1);c.on("click",function(a){e.$setViewValue(c[0].checked,a&&a.type)});e.$render=function(){c[0].checked=e.$viewValue};e.$isEmpty=function(a){return!1===a};e.$formatters.push(function(a){return fa(a,k)});e.$parsers.push(function(a){return a?k:m})},hidden:A,button:A,submit:A,reset:A,file:A},Cc=["$browser",
"$sniffer","$filter","$parse",function(a,c,d,e){return{restrict:"E",require:["?ngModel"],link:{pre:function(f,g,h,l){l[0]&&(Id[L(h.type)]||Id.text)(f,g,h,l[0],c,a,d,e)}}}}],gg=/^(true|false|\d+)$/,De=function(){return{restrict:"A",priority:100,compile:function(a,c){return gg.test(c.ngValue)?function(a,c,f){f.$set("value",a.$eval(f.ngValue))}:function(a,c,f){a.$watch(f.ngValue,function(a){f.$set("value",a)})}}}},de=["$compile",function(a){return{restrict:"AC",compile:function(c){a.$$addBindingClass(c);
return function(c,e,f){a.$$addBindingInfo(e,f.ngBind);e=e[0];c.$watch(f.ngBind,function(a){e.textContent=a===s?"":a})}}}}],fe=["$interpolate","$compile",function(a,c){return{compile:function(d){c.$$addBindingClass(d);return function(d,f,g){d=a(f.attr(g.$attr.ngBindTemplate));c.$$addBindingInfo(f,d.expressions);f=f[0];g.$observe("ngBindTemplate",function(a){f.textContent=a===s?"":a})}}}}],ee=["$sce","$parse","$compile",function(a,c,d){return{restrict:"A",compile:function(e,f){var g=c(f.ngBindHtml),
h=c(f.ngBindHtml,function(a){return(a||"").toString()});d.$$addBindingClass(e);return function(c,e,f){d.$$addBindingInfo(e,f.ngBindHtml);c.$watch(h,function(){e.html(a.getTrustedHtml(g(c))||"")})}}}}],Ce=ca({restrict:"A",require:"ngModel",link:function(a,c,d,e){e.$viewChangeListeners.push(function(){a.$eval(d.ngChange)})}}),ge=nc("",!0),ie=nc("Odd",0),he=nc("Even",1),je=Ia({compile:function(a,c){c.$set("ngCloak",s);a.removeClass("ng-cloak")}}),ke=[function(){return{restrict:"A",scope:!0,controller:"@",
priority:500}}],Hc={},hg={blur:!0,focus:!0};q("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),function(a){var c=va("ng-"+a);Hc[c]=["$parse","$rootScope",function(d,e){return{restrict:"A",compile:function(f,g){var h=d(g[c],null,!0);return function(c,d){d.on(a,function(d){var f=function(){h(c,{$event:d})};hg[a]&&e.$$phase?c.$evalAsync(f):c.$apply(f)})}}}}]});var ne=["$animate",function(a){return{multiElement:!0,
transclude:"element",priority:600,terminal:!0,restrict:"A",$$tlb:!0,link:function(c,d,e,f,g){var h,l,k;c.$watch(e.ngIf,function(c){c?l||g(function(c,f){l=f;c[c.length++]=V.createComment(" end ngIf: "+e.ngIf+" ");h={clone:c};a.enter(c,d.parent(),d)}):(k&&(k.remove(),k=null),l&&(l.$destroy(),l=null),h&&(k=ub(h.clone),a.leave(k).then(function(){k=null}),h=null))})}}}],oe=["$templateRequest","$anchorScroll","$animate","$sce",function(a,c,d,e){return{restrict:"ECA",priority:400,terminal:!0,transclude:"element",
controller:ba.noop,compile:function(f,g){var h=g.ngInclude||g.src,l=g.onload||"",k=g.autoscroll;return function(f,g,n,q,v){var s=0,t,p,H,J=function(){p&&(p.remove(),p=null);t&&(t.$destroy(),t=null);H&&(d.leave(H).then(function(){p=null}),p=H,H=null)};f.$watch(e.parseAsResourceUrl(h),function(e){var h=function(){!y(k)||k&&!f.$eval(k)||c()},n=++s;e?(a(e,!0).then(function(a){if(n===s){var c=f.$new();q.template=a;a=v(c,function(a){J();d.enter(a,null,g).then(h)});t=c;H=a;t.$emit("$includeContentLoaded",
e);f.$eval(l)}},function(){n===s&&(J(),f.$emit("$includeContentError",e))}),f.$emit("$includeContentRequested",e)):(J(),q.template=null)})}}}}],Fe=["$compile",function(a){return{restrict:"ECA",priority:-400,require:"ngInclude",link:function(c,d,e,f){/SVG/.test(d[0].toString())?(d.empty(),a(Kc(f.template,V).childNodes)(c,function(a){d.append(a)},{futureParentElement:d})):(d.html(f.template),a(d.contents())(c))}}}],pe=Ia({priority:450,compile:function(){return{pre:function(a,c,d){a.$eval(d.ngInit)}}}}),
Be=function(){return{restrict:"A",priority:100,require:"ngModel",link:function(a,c,d,e){var f=c.attr(d.$attr.ngList)||", ",g="false"!==d.ngTrim,h=g?U(f):f;e.$parsers.push(function(a){if(!C(a)){var c=[];a&&q(a.split(h),function(a){a&&c.push(g?U(a):a)});return c}});e.$formatters.push(function(a){return w(a)?a.join(f):s});e.$isEmpty=function(a){return!a||!a.length}}}},ob="ng-valid",Ad="ng-invalid",Ra="ng-pristine",Mb="ng-dirty",Cd="ng-pending",Ob=new F("ngModel"),ig=["$scope","$exceptionHandler","$attrs",
"$element","$parse","$animate","$timeout","$rootScope","$q","$interpolate",function(a,c,d,e,f,g,h,l,k,m){this.$modelValue=this.$viewValue=Number.NaN;this.$$rawModelValue=s;this.$validators={};this.$asyncValidators={};this.$parsers=[];this.$formatters=[];this.$viewChangeListeners=[];this.$untouched=!0;this.$touched=!1;this.$pristine=!0;this.$dirty=!1;this.$valid=!0;this.$invalid=!1;this.$error={};this.$$success={};this.$pending=s;this.$name=m(d.name||"",!1)(a);var r=f(d.ngModel),n=r.assign,u=r,v=n,
P=null,t,p=this;this.$$setOptions=function(a){if((p.$options=a)&&a.getterSetter){var c=f(d.ngModel+"()"),g=f(d.ngModel+"($$$p)");u=function(a){var d=r(a);E(d)&&(d=c(a));return d};v=function(a,c){E(r(a))?g(a,{$$$p:p.$modelValue}):n(a,p.$modelValue)}}else if(!r.assign)throw Ob("nonassign",d.ngModel,ta(e));};this.$render=A;this.$isEmpty=function(a){return C(a)||""===a||null===a||a!==a};var H=e.inheritedData("$formController")||Lb,J=0;xd({ctrl:this,$element:e,set:function(a,c){a[c]=!0},unset:function(a,
c){delete a[c]},parentForm:H,$animate:g});this.$setPristine=function(){p.$dirty=!1;p.$pristine=!0;g.removeClass(e,Mb);g.addClass(e,Ra)};this.$setDirty=function(){p.$dirty=!0;p.$pristine=!1;g.removeClass(e,Ra);g.addClass(e,Mb);H.$setDirty()};this.$setUntouched=function(){p.$touched=!1;p.$untouched=!0;g.setClass(e,"ng-untouched","ng-touched")};this.$setTouched=function(){p.$touched=!0;p.$untouched=!1;g.setClass(e,"ng-touched","ng-untouched")};this.$rollbackViewValue=function(){h.cancel(P);p.$viewValue=
p.$$lastCommittedViewValue;p.$render()};this.$validate=function(){if(!Q(p.$modelValue)||!isNaN(p.$modelValue)){var a=p.$$rawModelValue,c=p.$valid,d=p.$modelValue,e=p.$options&&p.$options.allowInvalid;p.$$runValidators(a,p.$$lastCommittedViewValue,function(f){e||c===f||(p.$modelValue=f?a:s,p.$modelValue!==d&&p.$$writeModelToScope())})}};this.$$runValidators=function(a,c,d){function e(){var d=!0;q(p.$validators,function(e,f){var h=e(a,c);d=d&&h;g(f,h)});return d?!0:(q(p.$asyncValidators,function(a,
c){g(c,null)}),!1)}function f(){var d=[],e=!0;q(p.$asyncValidators,function(f,h){var k=f(a,c);if(!k||!E(k.then))throw Ob("$asyncValidators",k);g(h,s);d.push(k.then(function(){g(h,!0)},function(a){e=!1;g(h,!1)}))});d.length?k.all(d).then(function(){h(e)},A):h(!0)}function g(a,c){l===J&&p.$setValidity(a,c)}function h(a){l===J&&d(a)}J++;var l=J;(function(){var a=p.$$parserName||"parse";if(t===s)g(a,null);else return t||(q(p.$validators,function(a,c){g(c,null)}),q(p.$asyncValidators,function(a,c){g(c,
null)})),g(a,t),t;return!0})()?e()?f():h(!1):h(!1)};this.$commitViewValue=function(){var a=p.$viewValue;h.cancel(P);if(p.$$lastCommittedViewValue!==a||""===a&&p.$$hasNativeValidators)p.$$lastCommittedViewValue=a,p.$pristine&&this.$setDirty(),this.$$parseAndValidate()};this.$$parseAndValidate=function(){var c=p.$$lastCommittedViewValue;if(t=C(c)?s:!0)for(var d=0;d<p.$parsers.length;d++)if(c=p.$parsers[d](c),C(c)){t=!1;break}Q(p.$modelValue)&&isNaN(p.$modelValue)&&(p.$modelValue=u(a));var e=p.$modelValue,
f=p.$options&&p.$options.allowInvalid;p.$$rawModelValue=c;f&&(p.$modelValue=c,p.$modelValue!==e&&p.$$writeModelToScope());p.$$runValidators(c,p.$$lastCommittedViewValue,function(a){f||(p.$modelValue=a?c:s,p.$modelValue!==e&&p.$$writeModelToScope())})};this.$$writeModelToScope=function(){v(a,p.$modelValue);q(p.$viewChangeListeners,function(a){try{a()}catch(d){c(d)}})};this.$setViewValue=function(a,c){p.$viewValue=a;p.$options&&!p.$options.updateOnDefault||p.$$debounceViewValueCommit(c)};this.$$debounceViewValueCommit=
function(c){var d=0,e=p.$options;e&&y(e.debounce)&&(e=e.debounce,Q(e)?d=e:Q(e[c])?d=e[c]:Q(e["default"])&&(d=e["default"]));h.cancel(P);d?P=h(function(){p.$commitViewValue()},d):l.$$phase?p.$commitViewValue():a.$apply(function(){p.$commitViewValue()})};a.$watch(function(){var c=u(a);if(c!==p.$modelValue&&(p.$modelValue===p.$modelValue||c===c)){p.$modelValue=p.$$rawModelValue=c;t=s;for(var d=p.$formatters,e=d.length,f=c;e--;)f=d[e](f);p.$viewValue!==f&&(p.$viewValue=p.$$lastCommittedViewValue=f,p.$render(),
p.$$runValidators(c,f,A))}return c})}],Ae=["$rootScope",function(a){return{restrict:"A",require:["ngModel","^?form","^?ngModelOptions"],controller:ig,priority:1,compile:function(c){c.addClass(Ra).addClass("ng-untouched").addClass(ob);return{pre:function(a,c,f,g){var h=g[0],l=g[1]||Lb;h.$$setOptions(g[2]&&g[2].$options);l.$addControl(h);f.$observe("name",function(a){h.$name!==a&&l.$$renameControl(h,a)});a.$on("$destroy",function(){l.$removeControl(h)})},post:function(c,e,f,g){var h=g[0];if(h.$options&&
h.$options.updateOn)e.on(h.$options.updateOn,function(a){h.$$debounceViewValueCommit(a&&a.type)});e.on("blur",function(e){h.$touched||(a.$$phase?c.$evalAsync(h.$setTouched):c.$apply(h.$setTouched))})}}}}}],jg=/(\s+|^)default(\s+|$)/,Ee=function(){return{restrict:"A",controller:["$scope","$attrs",function(a,c){var d=this;this.$options=a.$eval(c.ngModelOptions);this.$options.updateOn!==s?(this.$options.updateOnDefault=!1,this.$options.updateOn=U(this.$options.updateOn.replace(jg,function(){d.$options.updateOnDefault=
!0;return" "}))):this.$options.updateOnDefault=!0}]}},qe=Ia({terminal:!0,priority:1E3}),re=["$locale","$interpolate",function(a,c){var d=/{}/g,e=/^when(Minus)?(.+)$/;return{restrict:"EA",link:function(f,g,h){function l(a){g.text(a||"")}var k=h.count,m=h.$attr.when&&g.attr(h.$attr.when),r=h.offset||0,n=f.$eval(m)||{},u={},m=c.startSymbol(),s=c.endSymbol(),y=m+k+"-"+r+s,t=ba.noop,p;q(h,function(a,c){var d=e.exec(c);d&&(d=(d[1]?"-":"")+L(d[2]),n[d]=g.attr(h.$attr[c]))});q(n,function(a,e){u[e]=c(a.replace(d,
y))});f.$watch(k,function(c){c=parseFloat(c);var d=isNaN(c);d||c in n||(c=a.pluralCat(c-r));c===p||d&&isNaN(p)||(t(),t=f.$watch(u[c],l),p=c)})}}}],se=["$parse","$animate",function(a,c){var d=F("ngRepeat"),e=function(a,c,d,e,k,m,q){a[d]=e;k&&(a[k]=m);a.$index=c;a.$first=0===c;a.$last=c===q-1;a.$middle=!(a.$first||a.$last);a.$odd=!(a.$even=0===(c&1))};return{restrict:"A",multiElement:!0,transclude:"element",priority:1E3,terminal:!0,$$tlb:!0,compile:function(f,g){var h=g.ngRepeat,l=V.createComment(" end ngRepeat: "+
h+" "),k=h.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);if(!k)throw d("iexp",h);var m=k[1],r=k[2],n=k[3],u=k[4],k=m.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);if(!k)throw d("iidexp",m);var v=k[3]||k[1],y=k[2];if(n&&(!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(n)||/^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(n)))throw d("badident",n);var t,p,H,F,B={$id:Na};u?t=a(u):(H=function(a,c){return Na(c)},
F=function(a){return a});return function(a,f,g,k,m){t&&(p=function(c,d,e){y&&(B[y]=c);B[v]=d;B.$index=e;return t(a,B)});var u=ga();a.$watchCollection(r,function(g){var k,r,t=f[0],G,B=ga(),x,C,A,N,E,w,I;n&&(a[n]=g);if(Sa(g))E=g,r=p||H;else{r=p||F;E=[];for(I in g)g.hasOwnProperty(I)&&"$"!=I.charAt(0)&&E.push(I);E.sort()}x=E.length;I=Array(x);for(k=0;k<x;k++)if(C=g===E?k:E[k],A=g[C],N=r(C,A,k),u[N])w=u[N],delete u[N],B[N]=w,I[k]=w;else{if(B[N])throw q(I,function(a){a&&a.scope&&(u[a.id]=a)}),d("dupes",
h,N,A);I[k]={id:N,scope:s,clone:s};B[N]=!0}for(G in u){w=u[G];N=ub(w.clone);c.leave(N);if(N[0].parentNode)for(k=0,r=N.length;k<r;k++)N[k].$$NG_REMOVED=!0;w.scope.$destroy()}for(k=0;k<x;k++)if(C=g===E?k:E[k],A=g[C],w=I[k],w.scope){G=t;do G=G.nextSibling;while(G&&G.$$NG_REMOVED);w.clone[0]!=G&&c.move(ub(w.clone),null,z(t));t=w.clone[w.clone.length-1];e(w.scope,k,v,A,y,C,x)}else m(function(a,d){w.scope=d;var f=l.cloneNode(!1);a[a.length++]=f;c.enter(a,null,z(t));t=f;w.clone=a;B[w.id]=w;e(w.scope,k,v,
A,y,C,x)});u=B})}}}}],te=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(c,d,e){c.$watch(e.ngShow,function(c){a[c?"removeClass":"addClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],me=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(c,d,e){c.$watch(e.ngHide,function(c){a[c?"addClass":"removeClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],ue=Ia(function(a,c,d){a.$watch(d.ngStyle,function(a,d){d&&a!==d&&q(d,function(a,d){c.css(d,
"")});a&&c.css(a)},!0)}),ve=["$animate",function(a){return{restrict:"EA",require:"ngSwitch",controller:["$scope",function(){this.cases={}}],link:function(c,d,e,f){var g=[],h=[],l=[],k=[],m=function(a,c){return function(){a.splice(c,1)}};c.$watch(e.ngSwitch||e.on,function(c){var d,e;d=0;for(e=l.length;d<e;++d)a.cancel(l[d]);d=l.length=0;for(e=k.length;d<e;++d){var s=ub(h[d].clone);k[d].$destroy();(l[d]=a.leave(s)).then(m(l,d))}h.length=0;k.length=0;(g=f.cases["!"+c]||f.cases["?"])&&q(g,function(c){c.transclude(function(d,
e){k.push(e);var f=c.element;d[d.length++]=V.createComment(" end ngSwitchWhen: ");h.push({clone:d});a.enter(d,f.parent(),f)})})})}}}],we=Ia({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,c,d,e,f){e.cases["!"+d.ngSwitchWhen]=e.cases["!"+d.ngSwitchWhen]||[];e.cases["!"+d.ngSwitchWhen].push({transclude:f,element:c})}}),xe=Ia({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,c,d,e,f){e.cases["?"]=e.cases["?"]||[];e.cases["?"].push({transclude:f,
element:c})}}),ze=Ia({restrict:"EAC",link:function(a,c,d,e,f){if(!f)throw F("ngTransclude")("orphan",ta(c));f(function(a){c.empty();c.append(a)})}}),$d=["$templateCache",function(a){return{restrict:"E",terminal:!0,compile:function(c,d){"text/ng-template"==d.type&&a.put(d.id,c[0].text)}}}],kg=F("ngOptions"),ye=ca({restrict:"A",terminal:!0}),ae=["$compile","$parse",function(a,c){var d=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/,
e={$setViewValue:A};return{restrict:"E",require:["select","?ngModel"],controller:["$element","$scope","$attrs",function(a,c,d){var l=this,k={},m=e,q;l.databound=d.ngModel;l.init=function(a,c,d){m=a;q=d};l.addOption=function(c,d){Ma(c,'"option value"');k[c]=!0;m.$viewValue==c&&(a.val(c),q.parent()&&q.remove());d&&d[0].hasAttribute("selected")&&(d[0].selected=!0)};l.removeOption=function(a){this.hasOption(a)&&(delete k[a],m.$viewValue===a&&this.renderUnknownOption(a))};l.renderUnknownOption=function(c){c=
"? "+Na(c)+" ?";q.val(c);a.prepend(q);a.val(c);q.prop("selected",!0)};l.hasOption=function(a){return k.hasOwnProperty(a)};c.$on("$destroy",function(){l.renderUnknownOption=A})}],link:function(e,g,h,l){function k(a,c,d,e){d.$render=function(){var a=d.$viewValue;e.hasOption(a)?(B.parent()&&B.remove(),c.val(a),""===a&&t.prop("selected",!0)):null==a&&t?c.val(""):e.renderUnknownOption(a)};c.on("change",function(){a.$apply(function(){B.parent()&&B.remove();d.$setViewValue(c.val())})})}function m(a,c,d){var e;
d.$render=function(){var a=new fb(d.$viewValue);q(c.find("option"),function(c){c.selected=y(a.get(c.value))})};a.$watch(function(){fa(e,d.$viewValue)||(e=oa(d.$viewValue),d.$render())});c.on("change",function(){a.$apply(function(){var a=[];q(c.find("option"),function(c){c.selected&&a.push(c.value)});d.$setViewValue(a)})})}function r(e,f,g){function h(a,c,d){U[A]=d;I&&(U[I]=c);return a(e,U)}function k(a){var c;if(u)if(L&&w(a)){c=new fb([]);for(var d=0;d<a.length;d++)c.put(h(L,null,a[d]),!0)}else c=
new fb(a);else L&&(a=h(L,null,a));return function(d,e){var f;f=L?L:z?z:D;return u?y(c.remove(h(f,d,e))):a===h(f,d,e)}}function l(){p||(e.$$postDigest(r),p=!0)}function m(a,c,d){a[c]=a[c]||0;a[c]+=d?1:-1}function r(){p=!1;var a={"":[]},c=[""],d,l,s,t,v;s=g.$viewValue;t=O(e)||[];var A=I?Object.keys(t).sort():t,w,z,E,D,S={};v=k(s);var Q=!1,V,X;R={};for(D=0;E=A.length,D<E;D++){w=D;if(I&&(w=A[D],"$"===w.charAt(0)))continue;z=t[w];d=h(M,w,z)||"";(l=a[d])||(l=a[d]=[],c.push(d));d=v(w,z);Q=Q||d;z=h(B,w,z);
z=y(z)?z:"";X=L?L(e,U):I?A[D]:D;L&&(R[X]=w);l.push({id:X,label:z,selected:d})}u||(x||null===s?a[""].unshift({id:"",label:"",selected:!Q}):Q||a[""].unshift({id:"?",label:"",selected:!0}));w=0;for(A=c.length;w<A;w++){d=c[w];l=a[d];T.length<=w?(s={element:F.clone().attr("label",d),label:l.label},t=[s],T.push(t),f.append(s.element)):(t=T[w],s=t[0],s.label!=d&&s.element.attr("label",s.label=d));Q=null;D=0;for(E=l.length;D<E;D++)d=l[D],(v=t[D+1])?(Q=v.element,v.label!==d.label&&(m(S,v.label,!1),m(S,d.label,
!0),Q.text(v.label=d.label),Q.prop("label",v.label)),v.id!==d.id&&Q.val(v.id=d.id),Q[0].selected!==d.selected&&(Q.prop("selected",v.selected=d.selected),Qa&&Q.prop("selected",v.selected))):(""===d.id&&x?V=x:(V=C.clone()).val(d.id).prop("selected",d.selected).attr("selected",d.selected).prop("label",d.label).text(d.label),t.push(v={element:V,label:d.label,id:d.id,selected:d.selected}),m(S,d.label,!0),Q?Q.after(V):s.element.append(V),Q=V);for(D++;t.length>D;)d=t.pop(),m(S,d.label,!1),d.element.remove()}for(;T.length>
w;){l=T.pop();for(D=1;D<l.length;++D)m(S,l[D].label,!1);l[0].element.remove()}q(S,function(a,c){0<a?n.addOption(c):0>a&&n.removeOption(c)})}var t;if(!(t=v.match(d)))throw kg("iexp",v,ta(f));var B=c(t[2]||t[1]),A=t[4]||t[6],E=/ as /.test(t[0])&&t[1],z=E?c(E):null,I=t[5],M=c(t[3]||""),D=c(t[2]?t[1]:A),O=c(t[7]),L=t[8]?c(t[8]):null,R={},T=[[{element:f,label:""}]],U={};x&&(a(x)(e),x.removeClass("ng-scope"),x.remove());f.empty();f.on("change",function(){e.$apply(function(){var a=O(e)||[],c;if(u)c=[],q(f.val(),
function(d){d=L?R[d]:d;c.push("?"===d?s:""===d?null:h(z?z:D,d,a[d]))});else{var d=L?R[f.val()]:f.val();c="?"===d?s:""===d?null:h(z?z:D,d,a[d])}g.$setViewValue(c);r()})});g.$render=r;e.$watchCollection(O,l);e.$watchCollection(function(){var a=O(e),c;if(a&&w(a)){c=Array(a.length);for(var d=0,f=a.length;d<f;d++)c[d]=h(B,d,a[d])}else if(a)for(d in c={},a)a.hasOwnProperty(d)&&(c[d]=h(B,d,a[d]));return c},l);u&&e.$watchCollection(function(){return g.$modelValue},l)}if(l[1]){var n=l[0];l=l[1];var u=h.multiple,
v=h.ngOptions,x=!1,t,p=!1,C=z(V.createElement("option")),F=z(V.createElement("optgroup")),B=C.clone();h=0;for(var A=g.children(),E=A.length;h<E;h++)if(""===A[h].value){t=x=A.eq(h);break}n.init(l,x,B);u&&(l.$isEmpty=function(a){return!a||0===a.length});v?r(e,g,l):u?m(e,g,l):k(e,g,l,n)}}}}],ce=["$interpolate",function(a){var c={addOption:A,removeOption:A};return{restrict:"E",priority:100,compile:function(d,e){if(C(e.value)){var f=a(d.text(),!0);f||e.$set("value",d.text())}return function(a,d,e){var k=
d.parent(),m=k.data("$selectController")||k.parent().data("$selectController");m&&m.databound||(m=c);f?a.$watch(f,function(a,c){e.$set("value",a);c!==a&&m.removeOption(c);m.addOption(a,d)}):m.addOption(e.value,d);d.on("$destroy",function(){m.removeOption(e.value)})}}}}],be=ca({restrict:"E",terminal:!1}),Ec=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){e&&(d.required=!0,e.$validators.required=function(a,c){return!d.required||!e.$isEmpty(c)},d.$observe("required",function(){e.$validate()}))}}},
Dc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f,g=d.ngPattern||d.pattern;d.$observe("pattern",function(a){O(a)&&0<a.length&&(a=new RegExp("^"+a+"$"));if(a&&!a.test)throw F("ngPattern")("noregexp",g,a,ta(c));f=a||s;e.$validate()});e.$validators.pattern=function(a){return e.$isEmpty(a)||C(f)||f.test(a)}}}}},Gc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f=-1;d.$observe("maxlength",function(a){a=aa(a);f=isNaN(a)?-1:a;e.$validate()});
e.$validators.maxlength=function(a,c){return 0>f||e.$isEmpty(c)||c.length<=f}}}}},Fc=function(){return{restrict:"A",require:"?ngModel",link:function(a,c,d,e){if(e){var f=0;d.$observe("minlength",function(a){f=aa(a)||0;e.$validate()});e.$validators.minlength=function(a,c){return e.$isEmpty(c)||c.length>=f}}}}};T.angular.bootstrap?console.log("WARNING: Tried to load angular more than once."):(Sd(),Ud(ba),z(V).ready(function(){Od(V,xc)}))})(window,document);!window.angular.$$csp()&&window.angular.element(document).find("head").prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}</style>');
//# sourceMappingURL=angular.min.js.map
 
/** **************************************************** **/
/** ********************** angular-cookies ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(p,g,n){'use strict';g.module("ngCookies",["ng"]).factory("$cookies",["$rootScope","$browser",function(e,b){var c={},f={},h,k=!1,l=g.copy,m=g.isUndefined;b.addPollFn(function(){var a=b.cookies();h!=a&&(h=a,l(a,f),l(a,c),k&&e.$apply())})();k=!0;e.$watch(function(){var a,d,e;for(a in f)m(c[a])&&(b.cookies(a,n),delete f[a]);for(a in c)d=c[a],g.isString(d)||(d=""+d,c[a]=d),d!==f[a]&&(b.cookies(a,d),f[a]=d,e=!0);if(e)for(a in d=b.cookies(),c)c[a]!==d[a]&&(m(d[a])?(delete c[a],delete f[a]):c[a]=
f[a]=d[a])});return c}]).factory("$cookieStore",["$cookies",function(e){return{get:function(b){return(b=e[b])?g.fromJson(b):b},put:function(b,c){e[b]=g.toJson(c)},remove:function(b){delete e[b]}}}])})(window,window.angular);
//# sourceMappingURL=angular-cookies.min.js.map
 
/** **************************************************** **/
/** ********************** angular-route ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(q,d,C){'use strict';function v(r,k,h){return{restrict:"ECA",terminal:!0,priority:400,transclude:"element",link:function(a,f,b,c,y){function z(){l&&(h.cancel(l),l=null);m&&(m.$destroy(),m=null);n&&(l=h.leave(n),l.then(function(){l=null}),n=null)}function x(){var b=r.current&&r.current.locals;if(d.isDefined(b&&b.$template)){var b=a.$new(),c=r.current;n=y(b,function(b){h.enter(b,null,n||f).then(function(){!d.isDefined(t)||t&&!a.$eval(t)||k()});z()});m=c.scope=b;m.$emit("$viewContentLoaded");
m.$eval(w)}else z()}var m,n,l,t=b.autoscroll,w=b.onload||"";a.$on("$routeChangeSuccess",x);x()}}}function A(d,k,h){return{restrict:"ECA",priority:-400,link:function(a,f){var b=h.current,c=b.locals;f.html(c.$template);var y=d(f.contents());b.controller&&(c.$scope=a,c=k(b.controller,c),b.controllerAs&&(a[b.controllerAs]=c),f.data("$ngControllerController",c),f.children().data("$ngControllerController",c));y(a)}}}q=d.module("ngRoute",["ng"]).provider("$route",function(){function r(a,f){return d.extend(Object.create(a),
f)}function k(a,d){var b=d.caseInsensitiveMatch,c={originalPath:a,regexp:a},h=c.keys=[];a=a.replace(/([().])/g,"\\$1").replace(/(\/)?:(\w+)([\?\*])?/g,function(a,d,b,c){a="?"===c?c:null;c="*"===c?c:null;h.push({name:b,optional:!!a});d=d||"";return""+(a?"":d)+"(?:"+(a?d:"")+(c&&"(.+?)"||"([^/]+)")+(a||"")+")"+(a||"")}).replace(/([\/$\*])/g,"\\$1");c.regexp=new RegExp("^"+a+"$",b?"i":"");return c}var h={};this.when=function(a,f){var b=d.copy(f);d.isUndefined(b.reloadOnSearch)&&(b.reloadOnSearch=!0);
d.isUndefined(b.caseInsensitiveMatch)&&(b.caseInsensitiveMatch=this.caseInsensitiveMatch);h[a]=d.extend(b,a&&k(a,b));if(a){var c="/"==a[a.length-1]?a.substr(0,a.length-1):a+"/";h[c]=d.extend({redirectTo:a},k(c,b))}return this};this.caseInsensitiveMatch=!1;this.otherwise=function(a){"string"===typeof a&&(a={redirectTo:a});this.when(null,a);return this};this.$get=["$rootScope","$location","$routeParams","$q","$injector","$templateRequest","$sce",function(a,f,b,c,k,q,x){function m(b){var e=s.current;
(v=(p=l())&&e&&p.$$route===e.$$route&&d.equals(p.pathParams,e.pathParams)&&!p.reloadOnSearch&&!w)||!e&&!p||a.$broadcast("$routeChangeStart",p,e).defaultPrevented&&b&&b.preventDefault()}function n(){var u=s.current,e=p;if(v)u.params=e.params,d.copy(u.params,b),a.$broadcast("$routeUpdate",u);else if(e||u)w=!1,(s.current=e)&&e.redirectTo&&(d.isString(e.redirectTo)?f.path(t(e.redirectTo,e.params)).search(e.params).replace():f.url(e.redirectTo(e.pathParams,f.path(),f.search())).replace()),c.when(e).then(function(){if(e){var a=
d.extend({},e.resolve),b,g;d.forEach(a,function(b,e){a[e]=d.isString(b)?k.get(b):k.invoke(b,null,null,e)});d.isDefined(b=e.template)?d.isFunction(b)&&(b=b(e.params)):d.isDefined(g=e.templateUrl)&&(d.isFunction(g)&&(g=g(e.params)),g=x.getTrustedResourceUrl(g),d.isDefined(g)&&(e.loadedTemplateUrl=g,b=q(g)));d.isDefined(b)&&(a.$template=b);return c.all(a)}}).then(function(c){e==s.current&&(e&&(e.locals=c,d.copy(e.params,b)),a.$broadcast("$routeChangeSuccess",e,u))},function(b){e==s.current&&a.$broadcast("$routeChangeError",
e,u,b)})}function l(){var a,b;d.forEach(h,function(c,h){var g;if(g=!b){var k=f.path();g=c.keys;var m={};if(c.regexp)if(k=c.regexp.exec(k)){for(var l=1,n=k.length;l<n;++l){var p=g[l-1],q=k[l];p&&q&&(m[p.name]=q)}g=m}else g=null;else g=null;g=a=g}g&&(b=r(c,{params:d.extend({},f.search(),a),pathParams:a}),b.$$route=c)});return b||h[null]&&r(h[null],{params:{},pathParams:{}})}function t(a,b){var c=[];d.forEach((a||"").split(":"),function(a,d){if(0===d)c.push(a);else{var f=a.match(/(\w+)(?:[?*])?(.*)/),
h=f[1];c.push(b[h]);c.push(f[2]||"");delete b[h]}});return c.join("")}var w=!1,p,v,s={routes:h,reload:function(){w=!0;a.$evalAsync(function(){m();n()})},updateParams:function(a){if(this.current&&this.current.$$route)a=d.extend({},this.current.params,a),f.path(t(this.current.$$route.originalPath,a)),f.search(a);else throw B("norout");}};a.$on("$locationChangeStart",m);a.$on("$locationChangeSuccess",n);return s}]});var B=d.$$minErr("ngRoute");q.provider("$routeParams",function(){this.$get=function(){return{}}});
q.directive("ngView",v);q.directive("ngView",A);v.$inject=["$route","$anchorScroll","$animate"];A.$inject=["$compile","$controller","$route"]})(window,window.angular);
//# sourceMappingURL=angular-route.min.js.map
 
/** **************************************************** **/
/** ********************** angular-resource ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(I,d,B){'use strict';function D(f,q){q=q||{};d.forEach(q,function(d,h){delete q[h]});for(var h in f)!f.hasOwnProperty(h)||"$"===h.charAt(0)&&"$"===h.charAt(1)||(q[h]=f[h]);return q}var w=d.$$minErr("$resource"),C=/^(\.[a-zA-Z_$][0-9a-zA-Z_$]*)+$/;d.module("ngResource",["ng"]).provider("$resource",function(){var f=this;this.defaults={stripTrailingSlashes:!0,actions:{get:{method:"GET"},save:{method:"POST"},query:{method:"GET",isArray:!0},remove:{method:"DELETE"},"delete":{method:"DELETE"}}};
this.$get=["$http","$q",function(q,h){function t(d,g){this.template=d;this.defaults=s({},f.defaults,g);this.urlParams={}}function v(x,g,l,m){function c(b,k){var c={};k=s({},g,k);r(k,function(a,k){u(a)&&(a=a());var d;if(a&&a.charAt&&"@"==a.charAt(0)){d=b;var e=a.substr(1);if(null==e||""===e||"hasOwnProperty"===e||!C.test("."+e))throw w("badmember",e);for(var e=e.split("."),n=0,g=e.length;n<g&&d!==B;n++){var h=e[n];d=null!==d?d[h]:B}}else d=a;c[k]=d});return c}function F(b){return b.resource}function e(b){D(b||
{},this)}var G=new t(x,m);l=s({},f.defaults.actions,l);e.prototype.toJSON=function(){var b=s({},this);delete b.$promise;delete b.$resolved;return b};r(l,function(b,k){var g=/^(POST|PUT|PATCH)$/i.test(b.method);e[k]=function(a,y,m,x){var n={},f,l,z;switch(arguments.length){case 4:z=x,l=m;case 3:case 2:if(u(y)){if(u(a)){l=a;z=y;break}l=y;z=m}else{n=a;f=y;l=m;break}case 1:u(a)?l=a:g?f=a:n=a;break;case 0:break;default:throw w("badargs",arguments.length);}var t=this instanceof e,p=t?f:b.isArray?[]:new e(f),
A={},v=b.interceptor&&b.interceptor.response||F,C=b.interceptor&&b.interceptor.responseError||B;r(b,function(b,a){"params"!=a&&"isArray"!=a&&"interceptor"!=a&&(A[a]=H(b))});g&&(A.data=f);G.setUrlParams(A,s({},c(f,b.params||{}),n),b.url);n=q(A).then(function(a){var c=a.data,g=p.$promise;if(c){if(d.isArray(c)!==!!b.isArray)throw w("badcfg",k,b.isArray?"array":"object",d.isArray(c)?"array":"object");b.isArray?(p.length=0,r(c,function(a){"object"===typeof a?p.push(new e(a)):p.push(a)})):(D(c,p),p.$promise=
g)}p.$resolved=!0;a.resource=p;return a},function(a){p.$resolved=!0;(z||E)(a);return h.reject(a)});n=n.then(function(a){var b=v(a);(l||E)(b,a.headers);return b},C);return t?n:(p.$promise=n,p.$resolved=!1,p)};e.prototype["$"+k]=function(a,b,c){u(a)&&(c=b,b=a,a={});a=e[k].call(this,a,this,b,c);return a.$promise||a}});e.bind=function(b){return v(x,s({},g,b),l)};return e}var E=d.noop,r=d.forEach,s=d.extend,H=d.copy,u=d.isFunction;t.prototype={setUrlParams:function(f,g,l){var m=this,c=l||m.template,h,
e,q=m.urlParams={};r(c.split(/\W/),function(b){if("hasOwnProperty"===b)throw w("badname");!/^\d+$/.test(b)&&b&&(new RegExp("(^|[^\\\\]):"+b+"(\\W|$)")).test(c)&&(q[b]=!0)});c=c.replace(/\\:/g,":");g=g||{};r(m.urlParams,function(b,k){h=g.hasOwnProperty(k)?g[k]:m.defaults[k];d.isDefined(h)&&null!==h?(e=encodeURIComponent(h).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"%20").replace(/%26/gi,"&").replace(/%3D/gi,"=").replace(/%2B/gi,"+"),c=c.replace(new RegExp(":"+
k+"(\\W|$)","g"),function(b,a){return e+a})):c=c.replace(new RegExp("(/?):"+k+"(\\W|$)","g"),function(b,a,c){return"/"==c.charAt(0)?c:a+c})});m.defaults.stripTrailingSlashes&&(c=c.replace(/\/+$/,"")||"/");c=c.replace(/\/\.(?=\w+($|\?))/,".");f.url=c.replace(/\/\\\./,"/.");r(g,function(b,c){m.urlParams[c]||(f.params=f.params||{},f.params[c]=b)})}};return v}]})})(window,window.angular);
//# sourceMappingURL=angular-resource.min.js.map
 
/** **************************************************** **/
/** ********************** angular-animate ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(N,f,W){'use strict';f.module("ngAnimate",["ng"]).directive("ngAnimateChildren",function(){return function(X,r,g){g=g.ngAnimateChildren;f.isString(g)&&0===g.length?r.data("$$ngAnimateChildren",!0):X.$watch(g,function(f){r.data("$$ngAnimateChildren",!!f)})}}).factory("$$animateReflow",["$$rAF","$document",function(f,r){var g=r[0].body;return function(r){return f(function(){r(g.offsetWidth)})}}]).config(["$provide","$animateProvider",function(X,r){function g(f){for(var n=0;n<f.length;n++){var g=
f[n];if(1==g.nodeType)return g}}function ba(f,n){return g(f)==g(n)}var t=f.noop,n=f.forEach,da=r.$$selectors,aa=f.isArray,ea=f.isString,ga=f.isObject,w={running:!0},u;X.decorator("$animate",["$delegate","$$q","$injector","$sniffer","$rootElement","$$asyncCallback","$rootScope","$document","$templateRequest","$$jqLite",function(O,N,M,Y,y,H,P,W,Z,Q){function R(a,c){var b=a.data("$$ngAnimateState")||{};c&&(b.running=!0,b.structural=!0,a.data("$$ngAnimateState",b));return b.disabled||b.running&&b.structural}
function D(a){var c,b=N.defer();b.promise.$$cancelFn=function(){c&&c()};P.$$postDigest(function(){c=a(function(){b.resolve()})});return b.promise}function I(a){if(ga(a))return a.tempClasses&&ea(a.tempClasses)&&(a.tempClasses=a.tempClasses.split(/\s+/)),a}function S(a,c,b){b=b||{};var d={};n(b,function(e,a){n(a.split(" "),function(a){d[a]=e})});var h=Object.create(null);n((a.attr("class")||"").split(/\s+/),function(e){h[e]=!0});var f=[],l=[];n(c&&c.classes||[],function(e,a){var b=h[a],c=d[a]||{};!1===
e?(b||"addClass"==c.event)&&l.push(a):!0===e&&(b&&"removeClass"!=c.event||f.push(a))});return 0<f.length+l.length&&[f.join(" "),l.join(" ")]}function T(a){if(a){var c=[],b={};a=a.substr(1).split(".");(Y.transitions||Y.animations)&&c.push(M.get(da[""]));for(var d=0;d<a.length;d++){var f=a[d],k=da[f];k&&!b[f]&&(c.push(M.get(k)),b[f]=!0)}return c}}function U(a,c,b,d){function h(e,a){var b=e[a],c=e["before"+a.charAt(0).toUpperCase()+a.substr(1)];if(b||c)return"leave"==a&&(c=b,b=null),u.push({event:a,
fn:b}),J.push({event:a,fn:c}),!0}function k(c,l,x){var E=[];n(c,function(a){a.fn&&E.push(a)});var m=0;n(E,function(c,f){var p=function(){a:{if(l){(l[f]||t)();if(++m<E.length)break a;l=null}x()}};switch(c.event){case "setClass":l.push(c.fn(a,e,A,p,d));break;case "animate":l.push(c.fn(a,b,d.from,d.to,p));break;case "addClass":l.push(c.fn(a,e||b,p,d));break;case "removeClass":l.push(c.fn(a,A||b,p,d));break;default:l.push(c.fn(a,p,d))}});l&&0===l.length&&x()}var l=a[0];if(l){d&&(d.to=d.to||{},d.from=
d.from||{});var e,A;aa(b)&&(e=b[0],A=b[1],e?A?b=e+" "+A:(b=e,c="addClass"):(b=A,c="removeClass"));var x="setClass"==c,E=x||"addClass"==c||"removeClass"==c||"animate"==c,p=a.attr("class")+" "+b;if(B(p)){var ca=t,m=[],J=[],g=t,s=[],u=[],p=(" "+p).replace(/\s+/g,".");n(T(p),function(a){!h(a,c)&&x&&(h(a,"addClass"),h(a,"removeClass"))});return{node:l,event:c,className:b,isClassBased:E,isSetClassOperation:x,applyStyles:function(){d&&a.css(f.extend(d.from||{},d.to||{}))},before:function(a){ca=a;k(J,m,function(){ca=
t;a()})},after:function(a){g=a;k(u,s,function(){g=t;a()})},cancel:function(){m&&(n(m,function(a){(a||t)(!0)}),ca(!0));s&&(n(s,function(a){(a||t)(!0)}),g(!0))}}}}}function G(a,c,b,d,h,k,l,e){function A(e){var l="$animate:"+e;J&&J[l]&&0<J[l].length&&H(function(){b.triggerHandler(l,{event:a,className:c})})}function x(){A("before")}function E(){A("after")}function p(){p.hasBeenRun||(p.hasBeenRun=!0,k())}function g(){if(!g.hasBeenRun){m&&m.applyStyles();g.hasBeenRun=!0;l&&l.tempClasses&&n(l.tempClasses,
function(a){u.removeClass(b,a)});var x=b.data("$$ngAnimateState");x&&(m&&m.isClassBased?C(b,c):(H(function(){var e=b.data("$$ngAnimateState")||{};fa==e.index&&C(b,c,a)}),b.data("$$ngAnimateState",x)));A("close");e()}}var m=U(b,a,c,l);if(!m)return p(),x(),E(),g(),t;a=m.event;c=m.className;var J=f.element._data(m.node),J=J&&J.events;d||(d=h?h.parent():b.parent());if(z(b,d))return p(),x(),E(),g(),t;d=b.data("$$ngAnimateState")||{};var L=d.active||{},s=d.totalActive||0,q=d.last;h=!1;if(0<s){s=[];if(m.isClassBased)"setClass"==
q.event?(s.push(q),C(b,c)):L[c]&&(v=L[c],v.event==a?h=!0:(s.push(v),C(b,c)));else if("leave"==a&&L["ng-leave"])h=!0;else{for(var v in L)s.push(L[v]);d={};C(b,!0)}0<s.length&&n(s,function(a){a.cancel()})}!m.isClassBased||m.isSetClassOperation||"animate"==a||h||(h="addClass"==a==b.hasClass(c));if(h)return p(),x(),E(),A("close"),e(),t;L=d.active||{};s=d.totalActive||0;if("leave"==a)b.one("$destroy",function(a){a=f.element(this);var e=a.data("$$ngAnimateState");e&&(e=e.active["ng-leave"])&&(e.cancel(),
C(a,"ng-leave"))});u.addClass(b,"ng-animate");l&&l.tempClasses&&n(l.tempClasses,function(a){u.addClass(b,a)});var fa=K++;s++;L[c]=m;b.data("$$ngAnimateState",{last:m,active:L,index:fa,totalActive:s});x();m.before(function(e){var l=b.data("$$ngAnimateState");e=e||!l||!l.active[c]||m.isClassBased&&l.active[c].event!=a;p();!0===e?g():(E(),m.after(g))});return m.cancel}function q(a){if(a=g(a))a=f.isFunction(a.getElementsByClassName)?a.getElementsByClassName("ng-animate"):a.querySelectorAll(".ng-animate"),
n(a,function(a){a=f.element(a);(a=a.data("$$ngAnimateState"))&&a.active&&n(a.active,function(a){a.cancel()})})}function C(a,c){if(ba(a,y))w.disabled||(w.running=!1,w.structural=!1);else if(c){var b=a.data("$$ngAnimateState")||{},d=!0===c;!d&&b.active&&b.active[c]&&(b.totalActive--,delete b.active[c]);if(d||!b.totalActive)u.removeClass(a,"ng-animate"),a.removeData("$$ngAnimateState")}}function z(a,c){if(w.disabled)return!0;if(ba(a,y))return w.running;var b,d,g;do{if(0===c.length)break;var k=ba(c,y),
l=k?w:c.data("$$ngAnimateState")||{};if(l.disabled)return!0;k&&(g=!0);!1!==b&&(k=c.data("$$ngAnimateChildren"),f.isDefined(k)&&(b=k));d=d||l.running||l.last&&!l.last.isClassBased}while(c=c.parent());return!g||!b&&d}u=Q;y.data("$$ngAnimateState",w);var $=P.$watch(function(){return Z.totalPendingRequests},function(a,c){0===a&&($(),P.$$postDigest(function(){P.$$postDigest(function(){w.running=!1})}))}),K=0,V=r.classNameFilter(),B=V?function(a){return V.test(a)}:function(){return!0};return{animate:function(a,
c,b,d,h){d=d||"ng-inline-animate";h=I(h)||{};h.from=b?c:null;h.to=b?b:c;return D(function(b){return G("animate",d,f.element(g(a)),null,null,t,h,b)})},enter:function(a,c,b,d){d=I(d);a=f.element(a);c=c&&f.element(c);b=b&&f.element(b);R(a,!0);O.enter(a,c,b);return D(function(h){return G("enter","ng-enter",f.element(g(a)),c,b,t,d,h)})},leave:function(a,c){c=I(c);a=f.element(a);q(a);R(a,!0);return D(function(b){return G("leave","ng-leave",f.element(g(a)),null,null,function(){O.leave(a)},c,b)})},move:function(a,
c,b,d){d=I(d);a=f.element(a);c=c&&f.element(c);b=b&&f.element(b);q(a);R(a,!0);O.move(a,c,b);return D(function(h){return G("move","ng-move",f.element(g(a)),c,b,t,d,h)})},addClass:function(a,c,b){return this.setClass(a,c,[],b)},removeClass:function(a,c,b){return this.setClass(a,[],c,b)},setClass:function(a,c,b,d){d=I(d);a=f.element(a);a=f.element(g(a));if(R(a))return O.$$setClassImmediately(a,c,b,d);var h,k=a.data("$$animateClasses"),l=!!k;k||(k={classes:{}});h=k.classes;c=aa(c)?c:c.split(" ");n(c,
function(a){a&&a.length&&(h[a]=!0)});b=aa(b)?b:b.split(" ");n(b,function(a){a&&a.length&&(h[a]=!1)});if(l)return d&&k.options&&(k.options=f.extend(k.options||{},d)),k.promise;a.data("$$animateClasses",k={classes:h,options:d});return k.promise=D(function(e){var l=a.parent(),b=g(a),c=b.parentNode;if(!c||c.$$NG_REMOVED||b.$$NG_REMOVED)e();else{b=a.data("$$animateClasses");a.removeData("$$animateClasses");var c=a.data("$$ngAnimateState")||{},d=S(a,b,c.active);return d?G("setClass",d,a,l,null,function(){d[0]&&
O.$$addClassImmediately(a,d[0]);d[1]&&O.$$removeClassImmediately(a,d[1])},b.options,e):e()}})},cancel:function(a){a.$$cancelFn()},enabled:function(a,c){switch(arguments.length){case 2:if(a)C(c);else{var b=c.data("$$ngAnimateState")||{};b.disabled=!0;c.data("$$ngAnimateState",b)}break;case 1:w.disabled=!a;break;default:a=!w.disabled}return!!a}}}]);r.register("",["$window","$sniffer","$timeout","$$animateReflow",function(r,w,M,Y){function y(){b||(b=Y(function(){c=[];b=null;B={}}))}function H(a,e){b&&
b();c.push(e);b=Y(function(){n(c,function(a){a()});c=[];b=null;B={}})}function P(a,e){var b=g(a);a=f.element(b);k.push(a);b=Date.now()+e;b<=h||(M.cancel(d),h=b,d=M(function(){X(k);k=[]},e,!1))}function X(a){n(a,function(a){(a=a.data("$$ngAnimateCSS3Data"))&&n(a.closeAnimationFns,function(a){a()})})}function Z(a,e){var b=e?B[e]:null;if(!b){var c=0,d=0,f=0,g=0;n(a,function(a){if(1==a.nodeType){a=r.getComputedStyle(a)||{};c=Math.max(Q(a[z+"Duration"]),c);d=Math.max(Q(a[z+"Delay"]),d);g=Math.max(Q(a[K+
"Delay"]),g);var e=Q(a[K+"Duration"]);0<e&&(e*=parseInt(a[K+"IterationCount"],10)||1);f=Math.max(e,f)}});b={total:0,transitionDelay:d,transitionDuration:c,animationDelay:g,animationDuration:f};e&&(B[e]=b)}return b}function Q(a){var e=0;a=ea(a)?a.split(/\s*,\s*/):[];n(a,function(a){e=Math.max(parseFloat(a)||0,e)});return e}function R(b,e,c,d){b=0<=["ng-enter","ng-leave","ng-move"].indexOf(c);var f,p=e.parent(),h=p.data("$$ngAnimateKey");h||(p.data("$$ngAnimateKey",++a),h=a);f=h+"-"+g(e).getAttribute("class");
var p=f+" "+c,h=B[p]?++B[p].total:0,m={};if(0<h){var n=c+"-stagger",m=f+" "+n;(f=!B[m])&&u.addClass(e,n);m=Z(e,m);f&&u.removeClass(e,n)}u.addClass(e,c);var n=e.data("$$ngAnimateCSS3Data")||{},k=Z(e,p);f=k.transitionDuration;k=k.animationDuration;if(b&&0===f&&0===k)return u.removeClass(e,c),!1;c=d||b&&0<f;b=0<k&&0<m.animationDelay&&0===m.animationDuration;e.data("$$ngAnimateCSS3Data",{stagger:m,cacheKey:p,running:n.running||0,itemIndex:h,blockTransition:c,closeAnimationFns:n.closeAnimationFns||[]});
p=g(e);c&&(I(p,!0),d&&e.css(d));b&&(p.style[K+"PlayState"]="paused");return!0}function D(a,e,b,c,d){function f(){e.off(D,h);u.removeClass(e,k);u.removeClass(e,t);z&&M.cancel(z);G(e,b);var a=g(e),c;for(c in s)a.style.removeProperty(s[c])}function h(a){a.stopPropagation();var b=a.originalEvent||a;a=b.$manualTimeStamp||b.timeStamp||Date.now();b=parseFloat(b.elapsedTime.toFixed(3));Math.max(a-H,0)>=B&&b>=y&&c()}var m=g(e);a=e.data("$$ngAnimateCSS3Data");if(-1!=m.getAttribute("class").indexOf(b)&&a){var k=
"",t="";n(b.split(" "),function(a,b){var e=(0<b?" ":"")+a;k+=e+"-active";t+=e+"-pending"});var s=[],q=a.itemIndex,v=a.stagger,r=0;if(0<q){r=0;0<v.transitionDelay&&0===v.transitionDuration&&(r=v.transitionDelay*q);var w=0;0<v.animationDelay&&0===v.animationDuration&&(w=v.animationDelay*q,s.push(C+"animation-play-state"));r=Math.round(100*Math.max(r,w))/100}r||(u.addClass(e,k),a.blockTransition&&I(m,!1));var F=Z(e,a.cacheKey+" "+k),y=Math.max(F.transitionDuration,F.animationDuration);if(0===y)u.removeClass(e,
k),G(e,b),c();else{!r&&d&&0<Object.keys(d).length&&(F.transitionDuration||(e.css("transition",F.animationDuration+"s linear all"),s.push("transition")),e.css(d));var q=Math.max(F.transitionDelay,F.animationDelay),B=1E3*q;0<s.length&&(v=m.getAttribute("style")||"",";"!==v.charAt(v.length-1)&&(v+=";"),m.setAttribute("style",v+" "));var H=Date.now(),D=V+" "+$,q=1E3*(r+1.5*(q+y)),z;0<r&&(u.addClass(e,t),z=M(function(){z=null;0<F.transitionDuration&&I(m,!1);0<F.animationDuration&&(m.style[K+"PlayState"]=
"");u.addClass(e,k);u.removeClass(e,t);d&&(0===F.transitionDuration&&e.css("transition",F.animationDuration+"s linear all"),e.css(d),s.push("transition"))},1E3*r,!1));e.on(D,h);a.closeAnimationFns.push(function(){f();c()});a.running++;P(e,q);return f}}else c()}function I(a,b){a.style[z+"Property"]=b?"none":""}function S(a,b,c,d){if(R(a,b,c,d))return function(a){a&&G(b,c)}}function T(a,b,c,d,f){if(b.data("$$ngAnimateCSS3Data"))return D(a,b,c,d,f);G(b,c);d()}function U(a,b,c,d,f){var g=S(a,b,c,f.from);
if(g){var h=g;H(b,function(){h=T(a,b,c,d,f.to)});return function(a){(h||t)(a)}}y();d()}function G(a,b){u.removeClass(a,b);var c=a.data("$$ngAnimateCSS3Data");c&&(c.running&&c.running--,c.running&&0!==c.running||a.removeData("$$ngAnimateCSS3Data"))}function q(a,b){var c="";a=aa(a)?a:a.split(/\s+/);n(a,function(a,d){a&&0<a.length&&(c+=(0<d?" ":"")+a+b)});return c}var C="",z,$,K,V;N.ontransitionend===W&&N.onwebkittransitionend!==W?(C="-webkit-",z="WebkitTransition",$="webkitTransitionEnd transitionend"):
(z="transition",$="transitionend");N.onanimationend===W&&N.onwebkitanimationend!==W?(C="-webkit-",K="WebkitAnimation",V="webkitAnimationEnd animationend"):(K="animation",V="animationend");var B={},a=0,c=[],b,d=null,h=0,k=[];return{animate:function(a,b,c,d,f,g){g=g||{};g.from=c;g.to=d;return U("animate",a,b,f,g)},enter:function(a,b,c){c=c||{};return U("enter",a,"ng-enter",b,c)},leave:function(a,b,c){c=c||{};return U("leave",a,"ng-leave",b,c)},move:function(a,b,c){c=c||{};return U("move",a,"ng-move",
b,c)},beforeSetClass:function(a,b,c,d,f){f=f||{};b=q(c,"-remove")+" "+q(b,"-add");if(f=S("setClass",a,b,f.from))return H(a,d),f;y();d()},beforeAddClass:function(a,b,c,d){d=d||{};if(b=S("addClass",a,q(b,"-add"),d.from))return H(a,c),b;y();c()},beforeRemoveClass:function(a,b,c,d){d=d||{};if(b=S("removeClass",a,q(b,"-remove"),d.from))return H(a,c),b;y();c()},setClass:function(a,b,c,d,f){f=f||{};c=q(c,"-remove");b=q(b,"-add");return T("setClass",a,c+" "+b,d,f.to)},addClass:function(a,b,c,d){d=d||{};return T("addClass",
a,q(b,"-add"),c,d.to)},removeClass:function(a,b,c,d){d=d||{};return T("removeClass",a,q(b,"-remove"),c,d.to)}}}])}])})(window,window.angular);
//# sourceMappingURL=angular-animate.min.js.map
 
/** **************************************************** **/
/** ********************** angular-touch ****************************** **/
 /*
 AngularJS v1.3.16
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(y,s,z){'use strict';function t(f,k,p){n.directive(f,["$parse","$swipe",function(d,e){return function(l,m,g){function h(a){if(!b)return!1;var c=Math.abs(a.y-b.y);a=(a.x-b.x)*k;return q&&75>c&&0<a&&30<a&&.3>c/a}var c=d(g[f]),b,q,a=["touch"];s.isDefined(g.ngSwipeDisableMouse)||a.push("mouse");e.bind(m,{start:function(a,c){b=a;q=!0},cancel:function(a){q=!1},end:function(a,b){h(a)&&l.$apply(function(){m.triggerHandler(p);c(l,{$event:b})})}},a)}}])}var n=s.module("ngTouch",[]);n.factory("$swipe",
[function(){function f(d){d=d.originalEvent||d;var e=d.touches&&d.touches.length?d.touches:[d];d=d.changedTouches&&d.changedTouches[0]||e[0];return{x:d.clientX,y:d.clientY}}function k(d,e){var l=[];s.forEach(d,function(d){(d=p[d][e])&&l.push(d)});return l.join(" ")}var p={mouse:{start:"mousedown",move:"mousemove",end:"mouseup"},touch:{start:"touchstart",move:"touchmove",end:"touchend",cancel:"touchcancel"}};return{bind:function(d,e,l){var m,g,h,c,b=!1;l=l||["mouse","touch"];d.on(k(l,"start"),function(a){h=
f(a);b=!0;g=m=0;c=h;e.start&&e.start(h,a)});var q=k(l,"cancel");if(q)d.on(q,function(a){b=!1;e.cancel&&e.cancel(a)});d.on(k(l,"move"),function(a){if(b&&h){var d=f(a);m+=Math.abs(d.x-c.x);g+=Math.abs(d.y-c.y);c=d;10>m&&10>g||(g>m?(b=!1,e.cancel&&e.cancel(a)):(a.preventDefault(),e.move&&e.move(d,a)))}});d.on(k(l,"end"),function(a){b&&(b=!1,e.end&&e.end(f(a),a))})}}}]);n.config(["$provide",function(f){f.decorator("ngClickDirective",["$delegate",function(k){k.shift();return k}])}]);n.directive("ngClick",
["$parse","$timeout","$rootElement",function(f,k,p){function d(c,b,d){for(var a=0;a<c.length;a+=2){var e=c[a+1],g=d;if(25>Math.abs(c[a]-b)&&25>Math.abs(e-g))return c.splice(a,a+2),!0}return!1}function e(c){if(!(2500<Date.now()-m)){var b=c.touches&&c.touches.length?c.touches:[c],e=b[0].clientX,b=b[0].clientY;if(!(1>e&&1>b||h&&h[0]===e&&h[1]===b)){h&&(h=null);var a=c.target;"label"===s.lowercase(a.nodeName||a[0]&&a[0].nodeName)&&(h=[e,b]);d(g,e,b)||(c.stopPropagation(),c.preventDefault(),c.target&&
c.target.blur&&c.target.blur())}}}function l(c){c=c.touches&&c.touches.length?c.touches:[c];var b=c[0].clientX,d=c[0].clientY;g.push(b,d);k(function(){for(var a=0;a<g.length;a+=2)if(g[a]==b&&g[a+1]==d){g.splice(a,a+2);break}},2500,!1)}var m,g,h;return function(c,b,h){function a(){n=!1;b.removeClass("ng-click-active")}var k=f(h.ngClick),n=!1,r,t,v,w;b.on("touchstart",function(a){n=!0;r=a.target?a.target:a.srcElement;3==r.nodeType&&(r=r.parentNode);b.addClass("ng-click-active");t=Date.now();a=a.originalEvent||
a;a=(a.touches&&a.touches.length?a.touches:[a])[0];v=a.clientX;w=a.clientY});b.on("touchmove",function(b){a()});b.on("touchcancel",function(b){a()});b.on("touchend",function(c){var k=Date.now()-t,f=c.originalEvent||c,u=(f.changedTouches&&f.changedTouches.length?f.changedTouches:f.touches&&f.touches.length?f.touches:[f])[0],f=u.clientX,u=u.clientY,x=Math.sqrt(Math.pow(f-v,2)+Math.pow(u-w,2));n&&750>k&&12>x&&(g||(p[0].addEventListener("click",e,!0),p[0].addEventListener("touchstart",l,!0),g=[]),m=Date.now(),
d(g,f,u),r&&r.blur(),s.isDefined(h.disabled)&&!1!==h.disabled||b.triggerHandler("click",[c]));a()});b.onclick=function(a){};b.on("click",function(a,b){c.$apply(function(){k(c,{$event:b||a})})});b.on("mousedown",function(a){b.addClass("ng-click-active")});b.on("mousemove mouseup",function(a){b.removeClass("ng-click-active")})}}]);t("ngSwipeLeft",-1,"swipeleft");t("ngSwipeRight",1,"swiperight")})(window,window.angular);
//# sourceMappingURL=angular-touch.min.js.map
 
/** **************************************************** **/
/** ********************** angular-sanitize ****************************** **/
 /*
 AngularJS v1.6.2
 (c) 2010-2017 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(s,g){'use strict';function H(g){var l=[];t(l,A).chars(g);return l.join("")}var B=g.$$minErr("$sanitize"),C,l,D,E,q,A,F,t;g.module("ngSanitize",[]).provider("$sanitize",function(){function k(a,e){var b={},c=a.split(","),h;for(h=0;h<c.length;h++)b[e?q(c[h]):c[h]]=!0;return b}function I(a){for(var e={},b=0,c=a.length;b<c;b++){var h=a[b];e[h.name]=h.value}return e}function G(a){return a.replace(/&/g,"&amp;").replace(J,function(a){var b=a.charCodeAt(0);a=a.charCodeAt(1);return"&#"+(1024*(b-55296)+
(a-56320)+65536)+";"}).replace(K,function(a){return"&#"+a.charCodeAt(0)+";"}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}function x(a){for(;a;){if(a.nodeType===s.Node.ELEMENT_NODE)for(var e=a.attributes,b=0,c=e.length;b<c;b++){var h=e[b],d=h.name.toLowerCase();if("xmlns:ns1"===d||0===d.lastIndexOf("ns1:",0))a.removeAttributeNode(h),b--,c--}(e=a.firstChild)&&x(e);a=a.nextSibling}}var u=!1;this.$get=["$$sanitizeUri",function(a){u&&l(v,w);return function(e){var b=[];F(e,t(b,function(b,h){return!/^unsafe:/.test(a(b,
h))}));return b.join("")}}];this.enableSvg=function(a){return E(a)?(u=a,this):u};C=g.bind;l=g.extend;D=g.forEach;E=g.isDefined;q=g.lowercase;A=g.noop;F=function(a,e){null===a||void 0===a?a="":"string"!==typeof a&&(a=""+a);f.innerHTML=a;var b=5;do{if(0===b)throw B("uinput");b--;s.document.documentMode&&x(f);a=f.innerHTML;f.innerHTML=a}while(a!==f.innerHTML);for(b=f.firstChild;b;){switch(b.nodeType){case 1:e.start(b.nodeName.toLowerCase(),I(b.attributes));break;case 3:e.chars(b.textContent)}var c;if(!(c=
b.firstChild)&&(1===b.nodeType&&e.end(b.nodeName.toLowerCase()),c=b.nextSibling,!c))for(;null==c;){b=b.parentNode;if(b===f)break;c=b.nextSibling;1===b.nodeType&&e.end(b.nodeName.toLowerCase())}b=c}for(;b=f.firstChild;)f.removeChild(b)};t=function(a,e){var b=!1,c=C(a,a.push);return{start:function(a,d){a=q(a);!b&&z[a]&&(b=a);b||!0!==v[a]||(c("<"),c(a),D(d,function(b,d){var f=q(d),g="img"===a&&"src"===f||"background"===f;!0!==m[f]||!0===n[f]&&!e(b,g)||(c(" "),c(d),c('="'),c(G(b)),c('"'))}),c(">"))},
end:function(a){a=q(a);b||!0!==v[a]||!0===y[a]||(c("</"),c(a),c(">"));a==b&&(b=!1)},chars:function(a){b||c(G(a))}}};var J=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,K=/([^#-~ |!])/g,y=k("area,br,col,hr,img,wbr"),d=k("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),r=k("rp,rt"),p=l({},r,d),d=l({},d,k("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul")),r=l({},r,k("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var")),
w=k("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,stop,svg,switch,text,title,tspan"),z=k("script,style"),v=l({},y,d,r,p),n=k("background,cite,href,longdesc,src,xlink:href"),p=k("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,valign,value,vspace,width"),
r=k("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan",
!0),m=l({},n,r,p),f;(function(a){if(a.document&&a.document.implementation)a=a.document.implementation.createHTMLDocument("inert");else throw B("noinert");var e=(a.documentElement||a.getDocumentElement()).getElementsByTagName("body");1===e.length?f=e[0]:(e=a.createElement("html"),f=a.createElement("body"),e.appendChild(f),a.appendChild(e))})(s)});g.module("ngSanitize").filter("linky",["$sanitize",function(k){var l=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
q=/^mailto:/i,x=g.$$minErr("linky"),u=g.isDefined,s=g.isFunction,t=g.isObject,y=g.isString;return function(d,g,p){function w(a){a&&m.push(H(a))}function z(a,b){var c,d=v(a);m.push("<a ");for(c in d)m.push(c+'="'+d[c]+'" ');!u(g)||"target"in d||m.push('target="',g,'" ');m.push('href="',a.replace(/"/g,"&quot;"),'">');w(b);m.push("</a>")}if(null==d||""===d)return d;if(!y(d))throw x("notstring",d);for(var v=s(p)?p:t(p)?function(){return p}:function(){return{}},n=d,m=[],f,a;d=n.match(l);)f=d[0],d[2]||
d[4]||(f=(d[3]?"http://":"mailto:")+f),a=d.index,w(n.substr(0,a)),z(f,d[0].replace(q,"")),n=n.substring(a+d[0].length);w(n);return k(m.join(""))}}])})(window,window.angular);
//# sourceMappingURL=angular-sanitize.min.js.map
 
/** **************************************************** **/
/** ********************** angular-file-upload ****************************** **/
 /*
 angular-file-upload v1.1.6
 https://github.com/nervgh/angular-file-upload
*/

!function(a,b){return"function"==typeof define&&define.amd?void define("angular-file-upload",["angular"],function(a){return b(a)}):b(a)}("undefined"==typeof angular?null:angular,function(a){var b=a.module("angularFileUpload",[]);return b.value("fileUploaderOptions",{url:"/",alias:"file",headers:{},queue:[],progress:0,autoUpload:!1,removeAfterUpload:!1,method:"POST",filters:[],formData:[],queueLimit:Number.MAX_VALUE,withCredentials:!1}).factory("FileUploader",["fileUploaderOptions","$rootScope","$http","$window","$compile",function(b,c,d,e,f){function g(c){var d=a.copy(b);a.extend(this,d,c,{isUploading:!1,_nextIndex:0,_failFilterIndex:-1,_directives:{select:[],drop:[],over:[]}}),this.filters.unshift({name:"queueLimit",fn:this._queueLimitFilter}),this.filters.unshift({name:"folder",fn:this._folderFilter})}function h(b){var c=a.isElement(b),d=c?b.value:b,e=a.isString(d)?"FakePath":"Object",f="_createFrom"+e;this[f](d)}function i(b,c,d){var e=a.isElement(c),f=e?a.element(c):null,h=e?null:c;a.extend(this,{url:b.url,alias:b.alias,headers:a.copy(b.headers),formData:a.copy(b.formData),removeAfterUpload:b.removeAfterUpload,withCredentials:b.withCredentials,method:b.method},d,{uploader:b,file:new g.FileLikeObject(c),isReady:!1,isUploading:!1,isUploaded:!1,isSuccess:!1,isCancel:!1,isError:!1,progress:0,index:null,_file:h,_input:f}),f&&this._replaceNode(f)}function j(b){a.extend(this,b),this.uploader._directives[this.prop].push(this),this._saveLinks(),this.bind()}function k(a){k.super_.apply(this,arguments),this.uploader.isHTML5||this.element.removeAttr("multiple"),this.element.prop("value",null)}function l(a){l.super_.apply(this,arguments)}function m(a){m.super_.apply(this,arguments)}return g.prototype.isHTML5=!(!e.File||!e.FormData),g.prototype.addToQueue=function(b,c,d){var e=this.isArrayLikeObject(b)?b:[b],f=this._getFilters(d),h=this.queue.length,i=[];a.forEach(e,function(a){var b=new g.FileLikeObject(a);if(this._isValidFile(b,f,c)){var d=new g.FileItem(this,a,c);i.push(d),this.queue.push(d),this._onAfterAddingFile(d)}else{var e=f[this._failFilterIndex];this._onWhenAddingFileFailed(b,e,c)}},this),this.queue.length!==h&&(this._onAfterAddingAll(i),this.progress=this._getTotalProgress()),this._render(),this.autoUpload&&this.uploadAll()},g.prototype.removeFromQueue=function(a){var b=this.getIndexOfItem(a),c=this.queue[b];c.isUploading&&c.cancel(),this.queue.splice(b,1),c._destroy(),this.progress=this._getTotalProgress()},g.prototype.clearQueue=function(){for(;this.queue.length;)this.queue[0].remove();this.progress=0},g.prototype.uploadItem=function(a){var b=this.getIndexOfItem(a),c=this.queue[b],d=this.isHTML5?"_xhrTransport":"_iframeTransport";c._prepareToUploading(),this.isUploading||(this.isUploading=!0,this[d](c))},g.prototype.cancelItem=function(a){var b=this.getIndexOfItem(a),c=this.queue[b],d=this.isHTML5?"_xhr":"_form";c&&c.isUploading&&c[d].abort()},g.prototype.uploadAll=function(){var b=this.getNotUploadedItems().filter(function(a){return!a.isUploading});b.length&&(a.forEach(b,function(a){a._prepareToUploading()}),b[0].upload())},g.prototype.cancelAll=function(){var b=this.getNotUploadedItems();a.forEach(b,function(a){a.cancel()})},g.prototype.isFile=function(a){var b=e.File;return b&&a instanceof b},g.prototype.isFileLikeObject=function(a){return a instanceof g.FileLikeObject},g.prototype.isArrayLikeObject=function(b){return a.isObject(b)&&"length"in b},g.prototype.getIndexOfItem=function(b){return a.isNumber(b)?b:this.queue.indexOf(b)},g.prototype.getNotUploadedItems=function(){return this.queue.filter(function(a){return!a.isUploaded})},g.prototype.getReadyItems=function(){return this.queue.filter(function(a){return a.isReady&&!a.isUploading}).sort(function(a,b){return a.index-b.index})},g.prototype.destroy=function(){a.forEach(this._directives,function(b){a.forEach(this._directives[b],function(a){a.destroy()},this)},this)},g.prototype.onAfterAddingAll=function(a){},g.prototype.onAfterAddingFile=function(a){},g.prototype.onWhenAddingFileFailed=function(a,b,c){},g.prototype.onBeforeUploadItem=function(a){},g.prototype.onProgressItem=function(a,b){},g.prototype.onProgressAll=function(a){},g.prototype.onSuccessItem=function(a,b,c,d){},g.prototype.onErrorItem=function(a,b,c,d){},g.prototype.onCancelItem=function(a,b,c,d){},g.prototype.onCompleteItem=function(a,b,c,d){},g.prototype.onCompleteAll=function(){},g.prototype._getTotalProgress=function(a){if(this.removeAfterUpload)return a||0;var b=this.getNotUploadedItems().length,c=b?this.queue.length-b:this.queue.length,d=100/this.queue.length,e=(a||0)*d/100;return Math.round(c*d+e)},g.prototype._getFilters=function(b){if(a.isUndefined(b))return this.filters;if(a.isArray(b))return b;var c=b.match(/[^\s,]+/g);return this.filters.filter(function(a){return-1!==c.indexOf(a.name)},this)},g.prototype._render=function(){c.$$phase||c.$apply()},g.prototype._folderFilter=function(a){return!(!a.size&&!a.type)},g.prototype._queueLimitFilter=function(){return this.queue.length<this.queueLimit},g.prototype._isValidFile=function(a,b,c){return this._failFilterIndex=-1,b.length?b.every(function(b){return this._failFilterIndex++,b.fn.call(this,a,c)},this):!0},g.prototype._isSuccessCode=function(a){return a>=200&&300>a||304===a},g.prototype._transformResponse=function(b,c){var e=this._headersGetter(c);return a.forEach(d.defaults.transformResponse,function(a){b=a(b,e)}),b},g.prototype._parseHeaders=function(b){var c,d,e,f={};return b?(a.forEach(b.split("\n"),function(a){e=a.indexOf(":"),c=a.slice(0,e).trim().toLowerCase(),d=a.slice(e+1).trim(),c&&(f[c]=f[c]?f[c]+", "+d:d)}),f):f},g.prototype._headersGetter=function(a){return function(b){return b?a[b.toLowerCase()]||null:a}},g.prototype._xhrTransport=function(b){var c=b._xhr=new XMLHttpRequest,d=new FormData,e=this;if(e._onBeforeUploadItem(b),a.forEach(b.formData,function(b){a.forEach(b,function(a,b){d.append(b,a)})}),"number"!=typeof b._file.size)throw new TypeError("The file specified is no longer valid");d.append(b.alias,b._file,b.file.name),c.upload.onprogress=function(a){var c=Math.round(a.lengthComputable?100*a.loaded/a.total:0);e._onProgressItem(b,c)},c.onload=function(){var a=e._parseHeaders(c.getAllResponseHeaders()),d=e._transformResponse(c.response,a),f=e._isSuccessCode(c.status)?"Success":"Error",g="_on"+f+"Item";e[g](b,d,c.status,a),e._onCompleteItem(b,d,c.status,a)},c.onerror=function(){var a=e._parseHeaders(c.getAllResponseHeaders()),d=e._transformResponse(c.response,a);e._onErrorItem(b,d,c.status,a),e._onCompleteItem(b,d,c.status,a)},c.onabort=function(){var a=e._parseHeaders(c.getAllResponseHeaders()),d=e._transformResponse(c.response,a);e._onCancelItem(b,d,c.status,a),e._onCompleteItem(b,d,c.status,a)},c.open(b.method,b.url,!0),c.withCredentials=b.withCredentials,a.forEach(b.headers,function(a,b){c.setRequestHeader(b,a)}),c.send(d),this._render()},g.prototype._iframeTransport=function(b){var c=a.element('<form style="display: none;" />'),d=a.element('<iframe name="iframeTransport'+Date.now()+'">'),e=b._input,f=this;b._form&&b._form.replaceWith(e),b._form=c,f._onBeforeUploadItem(b),e.prop("name",b.alias),a.forEach(b.formData,function(b){a.forEach(b,function(b,d){var e=a.element('<input type="hidden" name="'+d+'" />');e.val(b),c.append(e)})}),c.prop({action:b.url,method:"POST",target:d.prop("name"),enctype:"multipart/form-data",encoding:"multipart/form-data"}),d.bind("load",function(){try{var a=d[0].contentDocument.body.innerHTML}catch(c){}var e={response:a,status:200,dummy:!0},g={},h=f._transformResponse(e.response,g);f._onSuccessItem(b,h,e.status,g),f._onCompleteItem(b,h,e.status,g)}),c.abort=function(){var a,g={status:0,dummy:!0},h={};d.unbind("load").prop("src","javascript:false;"),c.replaceWith(e),f._onCancelItem(b,a,g.status,h),f._onCompleteItem(b,a,g.status,h)},e.after(c),c.append(e).append(d),c[0].submit(),this._render()},g.prototype._onWhenAddingFileFailed=function(a,b,c){this.onWhenAddingFileFailed(a,b,c)},g.prototype._onAfterAddingFile=function(a){this.onAfterAddingFile(a)},g.prototype._onAfterAddingAll=function(a){this.onAfterAddingAll(a)},g.prototype._onBeforeUploadItem=function(a){a._onBeforeUpload(),this.onBeforeUploadItem(a)},g.prototype._onProgressItem=function(a,b){var c=this._getTotalProgress(b);this.progress=c,a._onProgress(b),this.onProgressItem(a,b),this.onProgressAll(c),this._render()},g.prototype._onSuccessItem=function(a,b,c,d){a._onSuccess(b,c,d),this.onSuccessItem(a,b,c,d)},g.prototype._onErrorItem=function(a,b,c,d){a._onError(b,c,d),this.onErrorItem(a,b,c,d)},g.prototype._onCancelItem=function(a,b,c,d){a._onCancel(b,c,d),this.onCancelItem(a,b,c,d)},g.prototype._onCompleteItem=function(b,c,d,e){b._onComplete(c,d,e),this.onCompleteItem(b,c,d,e);var f=this.getReadyItems()[0];return this.isUploading=!1,a.isDefined(f)?void f.upload():(this.onCompleteAll(),this.progress=this._getTotalProgress(),void this._render())},g.isFile=g.prototype.isFile,g.isFileLikeObject=g.prototype.isFileLikeObject,g.isArrayLikeObject=g.prototype.isArrayLikeObject,g.isHTML5=g.prototype.isHTML5,g.inherit=function(a,b){a.prototype=Object.create(b.prototype),a.prototype.constructor=a,a.super_=b},g.FileLikeObject=h,g.FileItem=i,g.FileDirective=j,g.FileSelect=k,g.FileDrop=l,g.FileOver=m,h.prototype._createFromFakePath=function(a){this.lastModifiedDate=null,this.size=null,this.type="like/"+a.slice(a.lastIndexOf(".")+1).toLowerCase(),this.name=a.slice(a.lastIndexOf("/")+a.lastIndexOf("\\")+2)},h.prototype._createFromObject=function(b){this.lastModifiedDate=a.copy(b.lastModifiedDate),this.size=b.size,this.type=b.type,this.name=b.name},i.prototype.upload=function(){try{this.uploader.uploadItem(this)}catch(a){this.uploader._onCompleteItem(this,"",0,[]),this.uploader._onErrorItem(this,"",0,[])}},i.prototype.cancel=function(){this.uploader.cancelItem(this)},i.prototype.remove=function(){this.uploader.removeFromQueue(this)},i.prototype.onBeforeUpload=function(){},i.prototype.onProgress=function(a){},i.prototype.onSuccess=function(a,b,c){},i.prototype.onError=function(a,b,c){},i.prototype.onCancel=function(a,b,c){},i.prototype.onComplete=function(a,b,c){},i.prototype._onBeforeUpload=function(){this.isReady=!0,this.isUploading=!0,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!1,this.progress=0,this.onBeforeUpload()},i.prototype._onProgress=function(a){this.progress=a,this.onProgress(a)},i.prototype._onSuccess=function(a,b,c){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!0,this.isCancel=!1,this.isError=!1,this.progress=100,this.index=null,this.onSuccess(a,b,c)},i.prototype._onError=function(a,b,c){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onError(a,b,c)},i.prototype._onCancel=function(a,b,c){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!0,this.isError=!1,this.progress=0,this.index=null,this.onCancel(a,b,c)},i.prototype._onComplete=function(a,b,c){this.onComplete(a,b,c),this.removeAfterUpload&&this.remove()},i.prototype._destroy=function(){this._input&&this._input.remove(),this._form&&this._form.remove(),delete this._form,delete this._input},i.prototype._prepareToUploading=function(){this.index=this.index||++this.uploader._nextIndex,this.isReady=!0},i.prototype._replaceNode=function(a){var b=f(a.clone())(a.scope());b.prop("value",null),a.css("display","none"),a.after(b)},j.prototype.events={},j.prototype.bind=function(){for(var a in this.events){var b=this.events[a];this.element.bind(a,this[b])}},j.prototype.unbind=function(){for(var a in this.events)this.element.unbind(a,this.events[a])},j.prototype.destroy=function(){var a=this.uploader._directives[this.prop].indexOf(this);this.uploader._directives[this.prop].splice(a,1),this.unbind()},j.prototype._saveLinks=function(){for(var a in this.events){var b=this.events[a];this[b]=this[b].bind(this)}},g.inherit(k,j),k.prototype.events={$destroy:"destroy",change:"onChange"},k.prototype.prop="select",k.prototype.getOptions=function(){},k.prototype.getFilters=function(){},k.prototype.isEmptyAfterSelection=function(){return!!this.element.attr("multiple")},k.prototype.onChange=function(){var a=this.uploader.isHTML5?this.element[0].files:this.element[0],b=this.getOptions(),c=this.getFilters();this.uploader.isHTML5||this.destroy(),this.uploader.addToQueue(a,b,c),this.isEmptyAfterSelection()&&this.element.prop("value",null)},g.inherit(l,j),l.prototype.events={$destroy:"destroy",drop:"onDrop",dragover:"onDragOver",dragleave:"onDragLeave"},l.prototype.prop="drop",l.prototype.getOptions=function(){},l.prototype.getFilters=function(){},l.prototype.onDrop=function(b){var c=this._getTransfer(b);if(c){var d=this.getOptions(),e=this.getFilters();this._preventAndStop(b),a.forEach(this.uploader._directives.over,this._removeOverClass,this),this.uploader.addToQueue(c.files,d,e)}},l.prototype.onDragOver=function(b){var c=this._getTransfer(b);this._haveFiles(c.types)&&(c.dropEffect="copy",this._preventAndStop(b),a.forEach(this.uploader._directives.over,this._addOverClass,this))},l.prototype.onDragLeave=function(b){b.currentTarget===this.element[0]&&(this._preventAndStop(b),a.forEach(this.uploader._directives.over,this._removeOverClass,this))},l.prototype._getTransfer=function(a){return a.dataTransfer?a.dataTransfer:a.originalEvent.dataTransfer},l.prototype._preventAndStop=function(a){a.preventDefault(),a.stopPropagation()},l.prototype._haveFiles=function(a){return a?a.indexOf?-1!==a.indexOf("Files"):a.contains?a.contains("Files"):!1:!1},l.prototype._addOverClass=function(a){a.addOverClass()},l.prototype._removeOverClass=function(a){a.removeOverClass()},g.inherit(m,j),m.prototype.events={$destroy:"destroy"},m.prototype.prop="over",m.prototype.overClass="nv-file-over",m.prototype.addOverClass=function(){this.element.addClass(this.getOverClass())},m.prototype.removeOverClass=function(){this.element.removeClass(this.getOverClass())},m.prototype.getOverClass=function(){return this.overClass},g}]).directive("nvFileSelect",["$parse","FileUploader",function(a,b){return{link:function(c,d,e){var f=c.$eval(e.uploader);if(!(f instanceof b))throw new TypeError('"Uploader" must be an instance of FileUploader');var g=new b.FileSelect({uploader:f,element:d});g.getOptions=a(e.options).bind(g,c),g.getFilters=function(){return e.filters}}}}]).directive("nvFileDrop",["$parse","FileUploader",function(a,b){return{link:function(c,d,e){var f=c.$eval(e.uploader);if(!(f instanceof b))throw new TypeError('"Uploader" must be an instance of FileUploader');if(f.isHTML5){var g=new b.FileDrop({uploader:f,element:d});g.getOptions=a(e.options).bind(g,c),g.getFilters=function(){return e.filters}}}}}]).directive("nvFileOver",["FileUploader",function(a){return{link:function(b,c,d){var e=b.$eval(d.uploader);if(!(e instanceof a))throw new TypeError('"Uploader" must be an instance of FileUploader');var f=new a.FileOver({uploader:e,element:c});f.getOverClass=function(){return d.overClass||this.overClass}}}}]),b});
//# sourceMappingURL=angular-file-upload.min.map 
/** **************************************************** **/
/** ********************** angular-isotope ****************************** **/
 /*! angular-isotope 26-05-2014 */
!function(a){angular.module("iso.config",[]).value("iso.config",{debug:!0}),angular.module("iso.directives",["iso.services"]),angular.module("iso.services",[]),angular.module("iso",["iso.config","iso.directives","iso.services"]),angular.module("iso.controllers",["iso.config","iso.services"]).controller("angularIsotopeController",["iso.config","iso.topics","$scope","$timeout","optionsStore",function(b,c,d,e,f){"use strict";var g,h,i,j,k,l,m,n,o;l="isotope.onLayout",n=!1,j=null,g=[],o="",i="",d.$on(l,function(){}),d.layoutEventEmit=function(){return e(function(){return d.$apply(function(){return d.$emit(l)})})},f.store({onLayout:d.layoutEventEmit}),h=function(a,b,c){return b?a.call(d,b,c):void 0},d.delayInit=function(a){f.storeInit(a)},d.delayedInit=function(){var a=f.retrieveInit();d.init(a)},d.$on("iso-init",function(){d.delayedInit()}),d.init=function(b){return f.storeInit(b),j=b.element,h(d.$on,b.isoOptionsEvent||c.MSG_OPTIONS,m),h(d.$on,b.isoMethodEvent||c.MSG_METHOD,k),d.isoMode=b.isoMode||"addItems",e(function(){var b=f.retrieve();if(!a.jQuery||!j.isotope(b)){var c=new Isotope(j[0],b);j.isotope=function(a,b){var d=Array.prototype.slice.call(arguments,1);return"string"==typeof a?c[a].apply(c,d):(c.option(a),void c._init(b))}}n=!0})},d.setIsoElement=function(a){return n?e(function(){return j.isotope(d.isoMode,a)}):void 0},d.refreshIso=function(){return n?j.isotope():void 0},d.updateOptions=function(a){j?j.isotope(a):f.store(a)},d.updateMethod=function(a,b,c){return j.isotope(a,b,c)},m=function(a,b){return d.updateOptions(b)},k=function(a,b){var c,e;return c=b.name,e=b.params,d.updateMethod(c,e,null)},d.removeAll=function(a){return j.isotope("remove",j.data("isotope").$allAtoms,a)},d.refresh=function(){return j.isotope()},d.$on(b.refreshEvent,function(){return d.refreshIso()}),d.$on(c.MSG_REMOVE,function(a,b){return d.removeElement(b)}),d.$on(c.MSG_OPTIONS,function(a,b){return m(a,b)}),d.$on(c.MSG_METHOD,function(a,b){return k(a,b)}),d.removeElement=function(a){return j&&j.isotope("remove",a)}}]).controller("isoSortByDataController",["iso.config","$scope","optionsStore",function(a,b,c){var d,e;b.getHash=function(a){return"opt"+a},b.storeMethods=function(a){return c.store({getSortData:a})},b.optSortData=function(a,c){var e,f,g,h,i,j,k;return f={},e=angular.element(c),i=e.attr("ok-sel"),k=e.attr("ok-type"),j=b.getHash(i),g=e.attr("opt-convert")?eval_("["+e.attr("opt-convert")+"]")[0]:null,h=function(a,b,c){return function(e){return d(a,e,b,c)}},f[j]=h(i,k,g),f},b.createSortByDataMethods=function(a){var c,d;return c=$(a),d=e(c.map(b.optSortData))},e=function(a){var b;return b={},angular.forEach(a,function(a){return angular.extend(b,a)}),b},d=function(a,b,c,d){var e,f,g,h,i;return e=function(a,b,c){var d;if(!b.length)return a.text();switch(d="",c.charAt(0)){case"#":d=b.text();break;case".":d=b.text();break;case"[":d=b.attr(c.replace("[","").replace("]","").split()[0])}return d},h=function(a,b){var c,d;return c=function(a){return isNaN(a)?Number.POSITIVE_INFINITY:a},d={text:function(a){return a.toString()},integer:function(a){return c(parseInt(a,10))},"float":function(a){return c(parseFloat(a))},"boolean":function(a){return"true"===a}},d[b]?d[b](a):a},f=b.find(a),g=e(b,f,a),i=h(g,c),d?d(i):i}}]),angular.module("iso.directives",["iso.config","iso.services","iso.controllers"]),angular.module("iso.directives").directive("isotopeContainer",["$injector","$parse",function(a,b){"use strict";var c;return c={},{controller:"angularIsotopeController",link:function(a,c,d){var e,f,g;return g=[],f=d.isoOptions,e={},f&&(g=b(f)(a),angular.isObject(g)&&a.updateOptions(g)),e.element=c,e.isoOptionsEvent=d.isoOptionsSubscribe,e.isoMethodEvent=d.isoMethodSubscribe,e.isoMode=d.isoMode,"true"===d.isoUseInitEvent?a.delayInit(e):a.init(e),c}}}]).directive("isotopeItem",["$rootScope","iso.config","iso.topics","$timeout",function(a,b,c,d){return{restrict:"A",require:"^isotopeContainer",link:function(e,f,g){return e.setIsoElement(f),e.$on("$destroy",function(){a.$broadcast(c.MSG_REMOVE,f)}),g.ngRepeat&&!0===e.$last&&"addItems"===e.isoMode&&f.ready(function(){return d(function(){return e.refreshIso()},b.refreshDelay||0)}),g.ngRepeat||f.ready(function(){return d(function(){return e.refreshIso()},b.refreshDelay||0)}),f}}}]).directive("isoSortbyData",function(){return{restrict:"A",controller:"isoSortByDataController",link:function(a,b){var c,d,e,f,g,h;return g=angular.element(b),f=g.attr("ok-key"),e="iso-opts",h={},c=g.find("[ok-sel]"),c.each(function(){var b;return b=angular.element(this),b.attr("ok-sortby-key",a.getHash(b.attr("ok-sel")))}),d=a.createSortByDataMethods(c),a.storeMethods(d)}}}).directive("optKind",["optionsStore","iso.topics",function(a,b){return{restrict:"A",controller:"isoSortByDataController",link:function(c,d,e){var f,g,h,i,j,k,l,m,n,o,p;if(m=$(d),k=e.okPublish||e.okOptionsPublish||b.MSG_OPTIONS,l=e.okMethodPublish||b.MSG_METHOD,j=m.attr("ok-key"),determineActiveClass=function(){n=e.okActiveClass,n||(n=m.find(".selected").length?"selected":"active"),o="."+n,p=m.find(o)},f=function(a){var b,d,e,f;return e=a.attr("ok-key"),"sortBy"===e?(f={},b=a.find("[ok-sel]"),b.each(function(){var a;return a=angular.element(this),a.attr("ok-sortby-key",c.getHash(a.attr("ok-sel")))}),d=c.createSortByDataMethods(b),c.storeMethods(d)):void 0},g=function(a){var b,c,d,e;return a?(d={},e=a.attr("ok-sortby-key"),b=a.attr("opt-ascending"),c=e||a.attr("ok-sel"),e&&(d.sortAscending=b?"true"===b:!0),d[j]=c,d):void 0},i=function(b){return a.store(b),c.$emit(k,b)},h=function(a){var b;return a.preventDefault(),b=angular.element(a.target),b.hasClass(n)?!1:(m.find(o).removeClass(n),b.addClass(n),i(g(b)),!1)},determineActiveClass(),f(m),p.length){var q=g(p);a.store(q)}return m.on("click",function(a){return h(a)})}}}]),angular.module("iso.services",["iso.config"],["$provide",function(a){return a.factory("optionsStore",["iso.config",function(a){"use strict";var b,c;return b=a.defaultOptions||{},{store:function(a){return angular.extend(b,a),b},retrieve:function(){return b},storeInit:function(a){c=a},retrieveInit:function(){return c}}}])}]).value("iso.topics",{MSG_OPTIONS:"iso-option",MSG_METHOD:"iso-method",MSG_REMOVE:"iso-remove"})}(window,document); 
/** **************************************************** **/
/** ********************** angular-ui-date ****************************** **/
 (function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("angular"), require("jquery-ui/datepicker"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "angular", "jquery-ui/datepicker"], factory);
	else if(typeof exports === 'object')
		exports["angularUiDate"] = factory(require("jquery"), require("angular"), require("jquery-ui/datepicker"));
	else
		root["angularUiDate"] = factory(root["jQuery"], root["angular"], root["jquery-ui/datepicker"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _jquery = __webpack_require__(1);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _angular = __webpack_require__(2);

	var _angular2 = _interopRequireDefault(_angular);

	var _datepicker = __webpack_require__(3);

	var _datepicker2 = _interopRequireDefault(_datepicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// sets up jQuery with the datepicker plugin

	exports.default = _angular2.default.module('ui.date', []).constant('uiDateConfig', {}).constant('uiDateFormatConfig', '').factory('uiDateConverter', ['uiDateFormatConfig', function (uiDateFormatConfig) {
	  return {
	    stringToDate: stringToDate,
	    dateToString: dateToString
	  };

	  function dateToString(uiDateFormat, value) {
	    var dateFormat = uiDateFormat || uiDateFormatConfig;
	    if (value) {
	      if (dateFormat) {
	        try {
	          return _jquery2.default.datepicker.formatDate(dateFormat, value);
	        } catch (formatException) {
	          return undefined;
	        }
	      }

	      if (value.toISOString) {
	        return value.toISOString();
	      }
	    }
	    return null;
	  }

	  function stringToDate(dateFormat, valueToParse) {
	    dateFormat = dateFormat || uiDateFormatConfig;

	    if (_angular2.default.isDate(valueToParse) && !isNaN(valueToParse)) {
	      return valueToParse;
	    }

	    if (_angular2.default.isString(valueToParse)) {
	      if (dateFormat) {
	        return _jquery2.default.datepicker.parseDate(dateFormat, valueToParse);
	      }

	      var isoDate = new Date(valueToParse);
	      return isNaN(isoDate.getTime()) ? null : isoDate;
	    }

	    if (_angular2.default.isNumber(valueToParse)) {
	      // presumably timestamp to date object
	      return new Date(valueToParse);
	    }

	    return null;
	  }
	}]).directive('uiDate', ['uiDateConfig', 'uiDateConverter', function uiDateDirective(uiDateConfig, uiDateConverter) {

	  return {
	    require: '?ngModel',
	    link: function link(scope, element, attrs, controller) {

	      var $element = (0, _jquery2.default)(element);

	      var getOptions = function getOptions() {
	        return _angular2.default.extend({}, uiDateConfig, scope.$eval(attrs.uiDate));
	      };
	      var initDateWidget = function initDateWidget() {
	        var showing = false;
	        var opts = getOptions();

	        function setVal(forcedUpdate) {
	          var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
	          var isDate = _angular2.default.isDate(controller.$modelValue);
	          var preserve = {};

	          if (!forcedUpdate && isDate && controller.$modelValue.toDateString() === $element.datepicker('getDate').toDateString()) {
	            return;
	          }

	          if (isDate) {
	            _angular2.default.forEach(keys, function (key) {
	              preserve[key] = controller.$modelValue['get' + key]();
	            });
	          }

	          var newViewValue = $element.datepicker('getDate');

	          if (isDate) {
	            _angular2.default.forEach(keys, function (key) {
	              newViewValue['set' + key](preserve[key]);
	            });
	          }

	          controller.$setViewValue(newViewValue);
	        }

	        // If we have a controller (i.e. ngModelController) then wire it up
	        if (controller) {
	          // Set the view value in a $apply block when users selects
	          // (calling directive user's function too if provided)
	          var _onSelect = opts.onSelect || _angular2.default.noop;
	          opts.onSelect = function (value, picker) {
	            scope.$apply(function () {
	              showing = true;
	              setVal();
	              $element.blur();
	              _onSelect(value, picker, $element);
	            });
	          };

	          var _beforeShow = opts.beforeShow || _angular2.default.noop;
	          opts.beforeShow = function (input, picker) {
	            showing = true;
	            _beforeShow(input, picker, $element);
	          };

	          var _onClose = opts.onClose || _angular2.default.noop;
	          opts.onClose = function (value, picker) {
	            showing = false;
	            _onClose(value, picker, $element);
	          };

	          element.on('focus', function (focusEvent) {
	            if (attrs.readonly) {
	              focusEvent.stopImmediatePropagation();
	            }
	          });

	          $element.off('blur.datepicker').on('blur.datepicker', function () {
	            if (!showing) {
	              scope.$apply(function () {
	                $element.datepicker('setDate', $element.datepicker('getDate'));
	                setVal();
	              });
	            }
	          });

	          controller.$validators.uiDateValidator = function uiDateValidator(modelValue, viewValue) {
	            return viewValue === null || viewValue === '' || _angular2.default.isDate(uiDateConverter.stringToDate(attrs.uiDateFormat, viewValue));
	          };

	          controller.$parsers.push(function uiDateParser(valueToParse) {
	            return uiDateConverter.stringToDate(attrs.uiDateFormat, valueToParse);
	          });

	          // Update the date picker when the model changes
	          controller.$render = function () {
	            // Force a render to override whatever is in the input text box
	            if (_angular2.default.isDate(controller.$modelValue) === false && _angular2.default.isString(controller.$modelValue)) {
	              controller.$modelValue = uiDateConverter.stringToDate(attrs.uiDateFormat, controller.$modelValue);
	            }
	            $element.datepicker('setDate', controller.$modelValue);
	          };
	        }
	        // Check if the $element already has a datepicker.
	        //

	        if ($element.data('datepicker')) {
	          // Updates the datepicker options
	          $element.datepicker('option', opts);
	          $element.datepicker('refresh');
	        } else {
	          // Creates the new datepicker widget
	          $element.datepicker(opts);

	          // Cleanup on destroy, prevent memory leaking
	          $element.on('$destroy', function () {
	            $element.datepicker('hide');
	            $element.datepicker('destroy');
	          });
	        }

	        if (controller) {
	          controller.$render();
	          // Update the model with the value from the datepicker after parsed
	          setVal(true);
	        }
	      };

	      // Watch for changes to the directives options
	      scope.$watch(getOptions, initDateWidget, true);
	    }
	  };
	}]).directive('uiDateFormat', ['uiDateConverter', function (uiDateConverter) {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, modelCtrl) {
	      var dateFormat = attrs.uiDateFormat;

	      // Use the datepicker with the attribute value as the dateFormat string to convert to and from a string
	      modelCtrl.$formatters.unshift(function (value) {
	        return uiDateConverter.stringToDate(dateFormat, value);
	      });

	      modelCtrl.$parsers.push(function (value) {
	        return uiDateConverter.dateToString(dateFormat, value);
	      });
	    }
	  };
	}]);

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }
/******/ ])
});
;
//# sourceMappingURL=date.js.map 
/** **************************************************** **/
/** ********************** angular-ui-mask ****************************** **/
 /*!
 * angular-ui-mask
 * https://github.com/angular-ui/ui-mask
 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
 * License: MIT
 */
!function(){"use strict";angular.module("ui.mask",[]).value("uiMaskConfig",{maskDefinitions:{9:/\d/,A:/[a-zA-Z]/,"*":/[a-zA-Z0-9]/},clearOnBlur:!0,clearOnBlurPlaceholder:!1,escChar:"\\",eventsToHandle:["input","keyup","click","focus"],addDefaultPlaceholder:!0,allowInvalidValue:!1}).provider("uiMask.Config",function(){var e={};this.maskDefinitions=function(n){return e.maskDefinitions=n},this.clearOnBlur=function(n){return e.clearOnBlur=n},this.clearOnBlurPlaceholder=function(n){return e.clearOnBlurPlaceholder=n},this.eventsToHandle=function(n){return e.eventsToHandle=n},this.addDefaultPlaceholder=function(n){return e.addDefaultPlaceholder=n},this.allowInvalidValue=function(n){return e.allowInvalidValue=n},this.$get=["uiMaskConfig",function(n){var t=n;for(var a in e)angular.isObject(e[a])&&!angular.isArray(e[a])?angular.extend(t[a],e[a]):t[a]=e[a];return t}]}).directive("uiMask",["uiMask.Config",function(e){function n(e){return e===document.activeElement&&(!document.hasFocus||document.hasFocus())&&!!(e.type||e.href||~e.tabIndex)}return{priority:100,require:"ngModel",restrict:"A",compile:function(){var t=angular.copy(e);return function(e,a,i,r){function l(e){return angular.isDefined(e)?(w(e),L?(h(),d(),!0):f()):f()}function u(e){e&&(B=e,!L||0===a.val().length&&angular.isDefined(i.placeholder)||a.val(m(p(a.val()))))}function o(){return l(i.uiMask)}function c(e){return L?(j=p(e||""),R=g(j),r.$setValidity("mask",R),j.length&&(R||Q.allowInvalidValue)?m(j):void 0):e}function s(e){return L?(j=p(e||""),R=g(j),r.$viewValue=j.length?m(j):"",r.$setValidity("mask",R),R||Q.allowInvalidValue?J?r.$viewValue:j:void 0):e}function f(){return L=!1,v(),angular.isDefined(q)?a.attr("placeholder",q):a.removeAttr("placeholder"),angular.isDefined(W)?a.attr("maxlength",W):a.removeAttr("maxlength"),a.val(r.$modelValue),r.$viewValue=r.$modelValue,!1}function h(){j=F=p(r.$modelValue||""),H=_=m(j),R=g(j),i.maxlength&&a.attr("maxlength",2*S[S.length-1]),!q&&Q.addDefaultPlaceholder&&a.attr("placeholder",B);for(var e=r.$modelValue,n=r.$formatters.length;n--;)e=r.$formatters[n](e);r.$viewValue=e||"",r.$render()}function d(){Z||(a.bind("blur",$),a.bind("mousedown mouseup",V),a.bind("keydown",E),a.bind(Q.eventsToHandle.join(" "),O),Z=!0)}function v(){Z&&(a.unbind("blur",$),a.unbind("mousedown",V),a.unbind("mouseup",V),a.unbind("keydown",E),a.unbind("input",O),a.unbind("keyup",O),a.unbind("click",O),a.unbind("focus",O),Z=!1)}function g(e){return e.length?e.length>=T:!0}function p(e){var n,t,i="",r=a[0],l=A.slice(),u=N,o=u+C(r),c="";return e=e.toString(),n=0,t=e.length-B.length,angular.forEach(I,function(a){var i=a.position;i>=u&&o>i||(i>=u&&(i+=t),e.substring(i,i+a.value.length)===a.value&&(c+=e.slice(n,i),n=i+a.value.length))}),e=c+e.slice(n),angular.forEach(e.split(""),function(e){l.length&&l[0].test(e)&&(i+=e,l.shift())}),i}function m(e){var n="",t=S.slice();return angular.forEach(B.split(""),function(a,i){e.length&&i===t[0]?(n+=e.charAt(0)||"_",e=e.substr(1),t.shift()):n+=a}),n}function b(e){var n,t=angular.isDefined(i.uiMaskPlaceholder)?i.uiMaskPlaceholder:i.placeholder;return angular.isDefined(t)&&t[e]?t[e]:(n=angular.isDefined(i.uiMaskPlaceholderChar)&&i.uiMaskPlaceholderChar?i.uiMaskPlaceholderChar:"_","space"===n.toLowerCase()?" ":n[0])}function k(){var e,n,t=B.split("");S&&!isNaN(S[0])&&angular.forEach(S,function(e){t[e]="_"}),e=t.join(""),n=e.replace(/[_]+/g,"_").split("_"),n=n.filter(function(e){return""!==e});var a=0;return n.map(function(n){var t=e.indexOf(n,a);return a=t+1,{value:n,position:t}})}function w(e){var n=0;if(S=[],A=[],B="",angular.isString(e)){T=0;var t=!1,a=0,i=e.split(""),r=!1;angular.forEach(i,function(e,i){r?(r=!1,B+=e,n++):Q.escChar===e?r=!0:Q.maskDefinitions[e]?(S.push(n),B+=b(i-a),A.push(Q.maskDefinitions[e]),n++,t||T++,t=!1):"?"===e?(t=!0,a++):(B+=e,n++)})}S.push(S.slice().pop()+1),I=k(),L=S.length>1?!0:!1}function $(){if((Q.clearOnBlur||Q.clearOnBlurPlaceholder&&0===j.length&&i.placeholder)&&(N=0,z=0,R&&0!==j.length||(H="",a.val(""),e.$apply(function(){r.$pristine||r.$setViewValue("")}))),j!==U){var n=a.val(),t=""===j&&n&&angular.isDefined(i.uiMaskPlaceholderChar)&&"space"===i.uiMaskPlaceholderChar;t&&a.val(""),y(a[0]),t&&a.val(n)}U=j}function y(e){var n;angular.isFunction(window.Event)&&!e.fireEvent?(n=new Event("change",{view:window,bubbles:!0,cancelable:!1}),e.dispatchEvent(n)):"createEvent"in document?(n=document.createEvent("HTMLEvents"),n.initEvent("change",!1,!0),e.dispatchEvent(n)):e.fireEvent&&e.fireEvent("onchange")}function V(e){"mousedown"===e.type?a.bind("mouseout",M):a.unbind("mouseout",M)}function M(){z=C(this),a.unbind("mouseout",M)}function E(e){var n=8===e.which,t=P(this)-1||0,i=90===e.which&&e.ctrlKey;if(n){for(;t>=0;){if(D(t)){x(this,t+1);break}t--}K=-1===t}i&&(a.val(""),e.preventDefault())}function O(n){n=n||{};var t=n.which,i=n.type;if(16!==t&&91!==t){var l,u=a.val(),o=_,c=!1,s=p(u),f=F,h=P(this)||0,d=N||0,v=h-d,g=S[0],b=S[s.length]||S.slice().shift(),k=z||0,w=C(this)>0,$=k>0,y=u.length>o.length||k&&u.length>o.length-k,V=u.length<o.length||k&&u.length===o.length-k,M=t>=37&&40>=t&&n.shiftKey,E=37===t,O=8===t||"keyup"!==i&&V&&-1===v,A=46===t||"keyup"!==i&&V&&0===v&&!$,I=(E||O||"click"===i)&&h>g;if(z=C(this),!M&&(!w||"click"!==i&&"keyup"!==i&&"focus"!==i)){if(O&&K)return a.val(B),e.$apply(function(){r.$setViewValue("")}),void x(this,d);if("input"===i&&V&&!$&&s===f){for(;O&&h>g&&!D(h);)h--;for(;A&&b>h&&-1===S.indexOf(h);)h++;var T=S.indexOf(h);s=s.substring(0,T)+s.substring(T+1),s!==f&&(c=!0)}for(l=m(s),_=l,F=s,!c&&u.length>l.length&&(c=!0),a.val(l),c&&e.$apply(function(){r.$setViewValue(l)}),y&&g>=h&&(h=g+1),I&&h--,h=h>b?b:g>h?g:h;!D(h)&&h>g&&b>h;)h+=I?-1:1;(I&&b>h||y&&!D(d))&&h++,N=h,x(this,h)}}}function D(e){return S.indexOf(e)>-1}function P(e){if(!e)return 0;if(void 0!==e.selectionStart)return e.selectionStart;if(document.selection&&n(a[0])){e.focus();var t=document.selection.createRange();return t.moveStart("character",e.value?-e.value.length:0),t.text.length}return 0}function x(e,t){if(!e)return 0;if(0!==e.offsetWidth&&0!==e.offsetHeight)if(e.setSelectionRange)n(a[0])&&(e.focus(),e.setSelectionRange(t,t));else if(e.createTextRange){var i=e.createTextRange();i.collapse(!0),i.moveEnd("character",t),i.moveStart("character",t),i.select()}}function C(e){return e?void 0!==e.selectionStart?e.selectionEnd-e.selectionStart:window.getSelection?window.getSelection().toString().length:document.selection?document.selection.createRange().text.length:0:0}var S,A,B,I,T,j,H,R,_,F,N,z,K,L=!1,Z=!1,q=i.placeholder,W=i.maxlength,G=r.$isEmpty;r.$isEmpty=function(e){return G(L?p(e||""):e)};var J=!1;i.$observe("modelViewValue",function(e){"true"===e&&(J=!0)}),i.$observe("allowInvalidValue",function(e){Q.allowInvalidValue=""===e?!0:!!e,c(r.$modelValue)});var Q={};i.uiOptions?(Q=e.$eval("["+i.uiOptions+"]"),Q=angular.isObject(Q[0])?function(e,n){for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(void 0===n[t]?n[t]=angular.copy(e[t]):angular.isObject(n[t])&&!angular.isArray(n[t])&&(n[t]=angular.extend({},e[t],n[t])));return n}(t,Q[0]):t):Q=t,i.$observe("uiMask",l),angular.isDefined(i.uiMaskPlaceholder)?i.$observe("uiMaskPlaceholder",u):i.$observe("placeholder",u),angular.isDefined(i.uiMaskPlaceholderChar)&&i.$observe("uiMaskPlaceholderChar",o),r.$formatters.unshift(c),r.$parsers.unshift(s);var U=a.val();a.bind("mousedown mouseup",V),Array.prototype.indexOf||(Array.prototype.indexOf=function(e){if(null===this)throw new TypeError;var n=Object(this),t=n.length>>>0;if(0===t)return-1;var a=0;if(arguments.length>1&&(a=Number(arguments[1]),a!==a?a=0:0!==a&&a!==1/0&&a!==-(1/0)&&(a=(a>0||-1)*Math.floor(Math.abs(a)))),a>=t)return-1;for(var i=a>=0?a:Math.max(t-Math.abs(a),0);t>i;i++)if(i in n&&n[i]===e)return i;return-1})}}}}])}(); 
/** **************************************************** **/
/** ********************** angular-socialshare ****************************** **/
 /*
 * angular-socialshare
 * 2.2.1
 * 
 * A social media url and content share module for angularjs.
 * http://720kb.githb.io/angular-socialshare
 * 
 * MIT license
 * Tue Jun 21 2016
 */
!function(e){"use strict";var o="socialshare",i="Socialshare",a=["facebook","facebook-messenger","twitter","linkedin","google","pinterest","tumblr","reddit","stumbleupon","buffer","digg","delicious","vk","pocket","wordpress","flipboard","xing","hackernews","evernote","whatsapp","telegram","viber","skype","email","ok"],s=function(){var o=[{provider:"email",conf:{subject:"",body:"",to:"",cc:"",bcc:"",trigger:"click"}},{provider:"facebook",conf:{url:"",text:"",media:"",type:"",via:"",to:"",from:"",ref:"",display:"",source:"",caption:"",redirectUri:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"facebook-messenger",conf:{url:""}},{provider:"twitter",conf:{url:"",text:"",via:"",hashtags:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"linkedin",conf:{url:"",text:"",description:"",source:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"reddit",conf:{url:"",text:"",subreddit:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"vk",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"ok",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"digg",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"delicious",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"stumbleupon",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pinterest",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"google",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"tumblr",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"buffer",conf:{url:"",text:"",via:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pocket",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"flipboard",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"hackernews",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"wordpress",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"xing",conf:{url:"",text:"",media:"",follow:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"evernote",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"whatsapp",conf:{url:"",text:""}},{provider:"telegram",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"viber",conf:{url:"",text:""}},{provider:"skype",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}}];return{configure:function(i){var s,t,r,h,c=0,p=0,n=e.injector(["ng"]).get("$log");if(i&&i.length>0)for(;c<i.length;c+=1)if(i[c].provider&&a.indexOf(i[c].provider)>-1){for(;p<o.length;p+=1)if(h=o[p],h&&h.provider&&i[c].provider===h.provider){for(s=Object.keys(h.conf),t=0;t<s.length;t+=1)r=s[t],r&&i[c].conf[r]&&(h.conf[r]=i[c].conf[r]);p=0;break}}else n.warn("Invalid provider at element "+c+" with name:"+i[c].provider)},$get:function(){return o}}},t=function(e,o,i){var a;i.socialshareType&&"feed"===i.socialshareType?(a="https://www.facebook.com/dialog/feed?",i.socialshareVia&&(a+="&app_id="+encodeURIComponent(i.socialshareVia)),i.socialshareRedirectUri&&(a+="&redirect_uri="+encodeURIComponent(i.socialshareRedirectUri)),i.socialshareUrl&&(a+="&link="+encodeURIComponent(i.socialshareUrl)),i.socialshareTo&&(a+="&to="+encodeURIComponent(i.socialshareTo)),i.socialshareDisplay&&(a+="&display="+encodeURIComponent(i.socialshareDisplay)),i.socialshareRef&&(a+="&ref="+encodeURIComponent(i.socialshareRef)),i.socialshareFrom&&(a+="&from="+encodeURIComponent(i.socialshareFrom)),i.socialshareDescription&&(a+="&description="+encodeURIComponent(i.socialshareDescription)),i.socialshareText&&(a+="&name="+encodeURIComponent(i.socialshareText)),i.socialshareCaption&&(a+="&caption="+encodeURIComponent(i.socialshareCaption)),i.socialshareMedia&&(a+="&picture="+encodeURIComponent(i.socialshareMedia)),i.socialshareSource&&(a+="&source="+encodeURIComponent(i.socialshareSource)),e.open(a,"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)):i.socialshareType&&"send"===i.socialshareType?(a="https://www.facebook.com/dialog/send?",i.socialshareVia&&(a+="&app_id="+encodeURIComponent(i.socialshareVia)),i.socialshareRedirectUri&&(a+="&redirect_uri="+encodeURIComponent(i.socialshareRedirectUri)),i.socialshareUrl&&(a+="&link="+encodeURIComponent(i.socialshareUrl)),i.socialshareTo&&(a+="&to="+encodeURIComponent(i.socialshareTo)),i.socialshareDisplay&&(a+="&display="+encodeURIComponent(i.socialshareDisplay)),i.socialshareRef&&(a+="&ref="+encodeURIComponent(i.socialshareRef)),e.open(a,"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)):e.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),"Facebook","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},r=function(e,o,i){var a="mailto:";i.socialshareTo&&(a+=encodeURIComponent(i.socialshareTo)),a+="?",i.socialshareBody&&(a+="body="+i.socialshareBody),i.socialshareSubject&&(a+="&subject="+encodeURIComponent(i.socialshareSubject)),i.socialshareCc&&(a+="&cc="+encodeURIComponent(i.socialshareCc)),i.socialshareBcc&&(a+="&bcc="+encodeURIComponent(i.socialshareBcc)),e.open(a,"_self")},h=function(e,o,i,a){var s="fb-messenger://share?link="+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},c=function(e,o,i){var a="https://www.twitter.com/intent/tweet?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)),i.socialshareVia&&(a+="&via="+encodeURIComponent(i.socialshareVia)),i.socialshareHashtags&&(a+="&hashtags="+encodeURIComponent(i.socialshareHashtags)),a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Twitter","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},p=function(e,o,i){e.open("https://plus.google.com/share?url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),"Google+","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},n=function(e,o,i){var a="https://www.reddit.com/";a+=i.socialshareSubreddit?"r/"+i.socialshareSubreddit+"/submit?url=":"submit?url=",i.socialsharePopupWidth<900&&(i.socialsharePopupWidth=900),i.socialsharePopupHeight<650&&(i.socialsharePopupHeight=650),e.open(a+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Reddit","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},l=function(e,o,i){e.open("https://www.stumbleupon.com/submit?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"StumbleUpon","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},d=function(e,o,i){var a="https://www.linkedin.com/shareArticle?mini=true";a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),i.socialshareDescription&&(a+="&summary="+encodeURIComponent(i.socialshareDescription)),i.socialshareSource&&(a+="&source="+encodeURIComponent(i.socialshareSource)),e.open(a,"Linkedin","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},u=function(e,o,i){e.open("https://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&media="+encodeURIComponent(i.socialshareMedia)+"&description="+encodeURIComponent(i.socialshareText),"Pinterest","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},g=function(e,o,i){e.open("https://www.digg.com/submit?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Digg","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},f=function(e,o,i){if(i.socialshareMedia){var a="https://www.tumblr.com/share/photo?source="+encodeURIComponent(i.socialshareMedia);i.socialshareText&&(a+="&caption="+encodeURIComponent(i.socialshareText)),e.open(a,"Tumblr","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)}else e.open("https://www.tumblr.com/share/link?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&description="+encodeURIComponent(i.socialshareText),"Tumblr","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},b=function(e,o,i){var a="https://www.vk.com/share.php?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),i.socialshareMedia&&(a+="&image="+encodeURIComponent(i.socialshareMedia)),i.socialshareDescription&&(a+="&description="+encodeURIComponent(i.socialshareDescription)),e.open(a,"Vk","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},m=function(e,o,i){e.open("http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&st.comments="+encodeURIComponent(i.socialshareText),"Ok","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},U=function(e,o,i){e.open("https://www.delicious.com/save?v=5&noui&jump=close&url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+"&title="+encodeURIComponent(i.socialshareText),"Delicious","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},k=function(e,o,i){var a="https://bufferapp.com/add?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)),i.socialshareVia&&(a+="&via="+encodeURIComponent(i.socialshareVia)),a+="&url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Buffer","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},w=function(e,o,i){var a="https://news.ycombinator.com/submitlink?";i.socialshareText&&(a+="t="+encodeURIComponent(i.socialshareText)+"&"),a+="u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Hackernews","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},P=function(e,o,i){var a="https://share.flipboard.com/bookmarklet/popout?v=2&";i.socialshareText&&(a+="title="+encodeURIComponent(i.socialshareText)+"&"),a+="url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Flipboard","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},H=function(e,o,i){var a="https://getpocket.com/save?";i.socialshareText&&(a+="text="+encodeURIComponent(i.socialshareText)+"&"),a+="url="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Pocket","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},v=function(e,o,i){var a="http://wordpress.com/press-this.php?";i.socialshareText&&(a+="t="+encodeURIComponent(i.socialshareText)+"&"),i.socialshareMedia&&(a+="i="+encodeURIComponent(i.socialshareMedia)+"&"),a+="u="+encodeURIComponent(i.socialshareUrl||o.absUrl()),e.open(a,"Wordpress","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},W=function(e,o,i){var a="";i.socialshareFollow&&(a="&follow_url="+encodeURIComponent(i.socialshareFollow)),e.open("https://www.xing.com/spi/shares/new?url="+encodeURIComponent(i.socialshareUrl||o.absUrl())+a,"Xing","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},R=function(e,o,i){var a="http://www.evernote.com/clip.action?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&title="+encodeURIComponent(i.socialshareText)),e.open(a,"Evernote","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},C=function(e,o,i,a){var s="whatsapp://send?text="+encodeURIComponent(i.socialshareText+" ")+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},I=function(e,o,i,a){var s="viber://forward?text="+encodeURIComponent(i.socialshareText+" ")+encodeURIComponent(i.socialshareUrl||o.absUrl());a.attr("href",s)},x=function(e,o,i){var a="https://telegram.me/share/url?url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&text="+encodeURIComponent(i.socialshareText)),e.open(a,"Telegram","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},S=function(e,o,i){var a="https://web.skype.com/share?source=button&url="+encodeURIComponent(i.socialshareUrl||o.absUrl());i.socialshareText&&(a+="&text="+encodeURIComponent(i.socialshareText)),e.open(a,"Skype","toolbar=0,status=0,resizable=yes,width="+i.socialsharePopupWidth+",height="+i.socialsharePopupHeight+",top="+(e.innerHeight-i.socialsharePopupHeight)/2+",left="+(e.innerWidth-i.socialsharePopupWidth)/2)},y=["$window","$location",function(e,o){this.emailShare=r,this.facebookShare=t,this.twitterShare=c,this.stumbleuponShare=l,this.pinterestShare=u,this.googleShare=p,this.bufferShare=k,this.hackernewsShare=w,this.okShare=m,this.deliciousShare=U,this.pocketShare=H,this.vkShare=b,this.flipboardShare=P,this.xingShare=W,this.diggShare=g,this.linkedinShare=d,this.wordpressShare=v,this.telegramShare=x,this.redditShare=n,this.evernoteShare=R,this.tumblrShare=f,this.skypeShare=S,this.share=function(i){switch(i.provider){case"email":this.emailShare(e,o,i.attrs);break;case"facebook":this.facebookShare(e,o,i.attrs);break;case"twitter":this.twitterShare(e,o,i.attrs);break;case"pinterest":this.pinterestShare(e,o,i.attrs);break;case"ok":this.okShare(e,o,i.attrs);break;case"vk":this.vkShare(e,o,i.attrs);break;case"delicious":this.deliciousShare(e,o,i.attrs);break;case"digg":this.diggShare(e,o,i.attrs);break;case"google+":this.googleShare(e,o,i.attrs);break;case"reddit":this.redditShare(e,o,i.attrs);break;case"hackernews":this.hackernewsShare(e,o,i.attrs);break;case"skype":this.skypeShare(e,o,i.attrs);break;case"evernote":this.evernoteShare(e,o,i.attrs);break;case"pocket":this.pocketShare(e,o,i.attrs);break;case"tumblr":this.tumblrShare(e,o,i.attrs);break;case"telegram":this.telegramShare(e,o,i.attrs);break;case"xing":this.xingShare(e,o,i.attrs);break;case"buffer":this.bufferShare(e,o,i.attrs);break;case"stumbleupon":this.stumbleuponShare(e,o,i.attrs);break;case"linkedin":this.linkedinShare(e,o,i.attrs);break;case"wordpress":this.wordpressShare(e,o,i.attrs);break;case"flipboard":this.flipboardShare(e,o,i.attrs);break;default:return}}}],T=["$window","$location","socialshareConf","Socialshare","$log",function(e,o,i,s){var t=function(t,r,h){for(var c,p=0,n=(function(){return h.socialshareProvider in z?void z[h.socialshareProvider](e,o,h,r):!0});p<i.length;p+=1)if(i[p].provider===h.socialshareProvider){c=i[p];break}-1===a.indexOf(c.provider)&&s.warn("Invalid Provider Name : "+h.socialshareProvider),h.socialshareUrl=h.socialshareUrl||c.conf.url,h.socialshareText=h.socialshareText||c.conf.text,h.socialshareMedia=h.socialshareMedia||c.conf.media,h.socialshareType=h.socialshareType||c.conf.type,h.socialshareVia=h.socialshareVia||c.conf.via,h.socialshareTo=h.socialshareTo||c.conf.to,h.socialshareFrom=h.socialshareFrom||c.conf.from,h.socialshareRef=h.socialshareRef||c.conf.ref,h.socialshareDislay=h.socialshareDislay||c.conf.display,h.socialshareSource=h.socialshareSource||c.conf.source,h.socialshareCaption=h.socialshareCaption||c.conf.caption,h.socialshareRedirectUri=h.socialshareRedirectUri||c.conf.redirectUri,h.socialshareTrigger=h.socialshareTrigger||c.conf.trigger,h.socialsharePopupHeight=h.socialsharePopupHeight||c.conf.popupHeight,h.socialsharePopupWidth=h.socialsharePopupWidth||c.conf.popupWidth,h.socialshareSubreddit=h.socialshareSubreddit||c.conf.subreddit,h.socialshareDescription=h.socialshareDescription||c.conf.description,h.socialshareFollow=h.socialshareFollow||c.conf.follow,h.socialshareHashtags=h.socialshareHashtags||c.conf.hashtags,h.socialshareBody=h.socialshareBody||c.conf.body,h.socialshareSubject=h.socialshareSubject||c.conf.subject,h.socialshareCc=h.socialshareCc||c.conf.cc,h.socialshareBcc=h.socialshareBcc||c.conf.bcc,h.socialshareTrigger?r.bind(h.socialshareTrigger,n):n()};return{restrict:"A",link:t}}],z={email:r,facebook:t,"facebook-messenger":h,twitter:c,google:p,reddit:n,stumbleupon:l,linkedin:d,pinterest:u,digg:g,tumblr:f,vk:b,ok:m,delicious:U,buffer:k,hackernews:w,flipboard:P,pocket:H,wordpress:v,xing:W,evernote:R,whatsapp:C,telegram:x,viber:I,skype:S};e.module("720kb.socialshare",[]).provider(o+"Conf",s).service(i,y).directive(o,T)}(angular);
//# sourceMappingURL=angular-socialshare.js.map
 
/** **************************************************** **/;

/** ****************************************************
  Module mrShared.controllers
**************************************************** **/
angular.module('mrShared.controllers', ['ngResource']).
controller('DynoCtl', ['$scope', '$injector', function($scope, $injector) {
  var thisCtl = this;

  $scope.injectAs = function(modules) {
    Object.keys(modules).forEach(function(scopeName) {
      $scope[scopeName] = $injector.get(modules[scopeName]);
    });
  };

  $scope.require = function(requirements) {
    if (Array.isArray(requirements)) {
      requirements.forEach(function(requirement) {
        $scope[requirement] = $injector.get(requirement);
      });
    } else {
      $scope[requirements] = $injector.get(requirements);
    }
  };

  $scope.defineFunc = function(name, args, code) {
    if (arguments.length === 2) {
      code = args;
      args = [];
    }
    args.unshift('$scope');
    var theFunc = new Function(args, code);
    $scope[name] = theFunc.bind(thisCtl, $scope);
  };


}])
.
controller('searchPaginatorCtl', ['$scope', '$location', 'cmsSvc', function($scope, $location, cmsSvc) {

  $scope.page = 1;
  $scope.pageOneSize = 10;
  $scope.pageSize = 10;
  $scope.searchField = '_all';
  $scope.searchType ='';
  $scope.searchVal = '';
  $scope.searchFunc = 'queryAll';
  $scope.numResults = 0;
  $scope.searchResults = [];

  $scope.initVals = function initVals(page, pageSize, numResults, searchFunc, searchType, searchVal, pageOneSize) {
    if (typeof page === 'object') {
      Object.keys(page).forEach(function(key) {
        $scope[key] = page[key];
      });
      return;
    }

    $scope.page = page || $scope.page;
    $scope.renderedPage = page;
    $scope.pageSize = pageSize || $scope.pageSize;
    $scope.numResults = numResults || $scope.numResults;
    $scope.searchFunc = searchFunc || $scope.searchFunc;
    $scope.searchType = searchType || $scope.searchType;
    $scope.searchVal = searchVal || $scope.searchVal;
    $scope.pageOneSize = pageOneSize || $scope.pageOneSize;
  };

  $scope.pageUp = function pageUp() {
    if (lastItemIndex() < $scope.numResults) {
      $scope.page ++;
      doSearch();
    }
  };
  
  $scope.pageDown = function pageDown() {
    $scope.page --;
    doSearch();
  };

  $scope.hasNextPage = function hasNextPage() {
    return $scope.nextPageSize();
  };

  $scope.nextPageSize = function nextPageSize() {
    var size = $scope.page === 1 ? ($scope.pageOneSize * $scope.page) : ( ($scope.pageSize * $scope.page) + Math.abs($scope.pageOneSize - $scope.pageSize) );
    var remaining = $scope.numResults - size;

    remaining = remaining <= 0 ? 0 : remaining;
    return remaining < $scope.pageSize ? remaining : $scope.pageSize;
  };

  $scope.prevPageSize = function prevPageSize() {
    if ($scope.page === 2) {
      return $scope.pageOneSize;
    }
    return $scope.pageSize;
  };

  function lastItemIndex() {
    return (($scope.page-1) * $scope.pageSize) + $scope.pageOneSize;
  }

  function getSearchFieldParams($scope, packet) {
    packet.params = {
      s: $scope.pageSize,
      p: $scope.page,
      searchType: $scope.searchType,
      searchVal: $scope.searchVal
    }
  }

  function getSearchParams($scope, packet) {
    packet.params = {
      s: $scope.pageSize,
      p: getPageCount(),
      searchType: $scope.searchType,
      searchVal: $scope.searchVal
    }
  }

  function doSearch() {
    var packet = {
      moduleName: 'content',
      methodName: 'searchBlogContent'
    };

    if ($scope.searchType !== 'search' && $scope.searchVal) {
      getSearchFieldParams($scope, packet);
    } else if ($scope.searchType === 'search' && $scope.searchVal) {
      getSearchParams($scope, packet);
    } else {
      packet.params = {
        s: $scope.pageSize,
        s1: $scope.pageOneSize,
        p: $scope.page,
        searchType: $scope.searchType,
        searchVal: $scope.searchVal
      };
    }

    if ($scope.searchVal) {
      packet.q = $scope.searchVal;
    }

    cmsSvc.callDeferedGetterMethod(packet, function(results) {
      $scope.numResults = results.total;
      $scope.searchResults = results.hits;

      //punting on saving paginated history
      // window.history.pushState({}, 'Madison Reed | Blog', '?p=' + $scope.page);
      // window.history.pushState({}, 'M.reload(false);
      
      var loc = window.location;
      var baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
      var thisUrl = baseUrl;
      if ($scope.page !== 1) {
          thisUrl += '?p=' + $scope.page;
      }
      
      var prevUrl = $scope.page === 1 ? '' : $scope.page === 2 ? baseUrl : baseUrl + '?p=' + ($scope.page - 1);
      var nextUrl = $scope.nextPageSize()  ? baseUrl + '?p=' + ($scope.page + 1) : '';
      
      $('link[rel=canonical]').attr('href', thisUrl);
      
      var prevLink = $('link[rel=prev]');
      
      if (prevUrl) {
        if (prevLink.length) {
          prevLink.attr('href', prevUrl);
        } else {
          $('head').append('<link rel="prev" href="' + prevUrl + '" />');
        }
      } else if (prevLink.length){
        prevLink.remove();
      }
      
      var nextLink = $('link[rel=next]');
      if (nextUrl) {
        if (nextLink.length) {
          nextLink.attr('href', nextUrl);
        } else {
          $('head').append('<link rel="next" href="' + nextUrl + '" />');
        }
      } else {
        nextLink.remove();
      }
      
      
    }, function(err) {
      console.log('Search err', err);
    });
  }

  function getPageCount() {
    return $scope.page === 1 ? 0 : (($scope.page-2) * $scope.pageSize) + ($scope.pageOneSize == $scope.pageSize ? $scope.pageOneSize + 1 : $scope.pageOneSize);
  }

}])
.
controller('siteSearchCtl', ['$scope', 'cmsSvc', 'trackerSvc', function($scope, cmsSvc, trackerSvc) {

  $scope.page = 1;
  $scope.pageOneSize = 10;

  $scope.pageSize = 10;
  $scope.searchVal = '';
  $scope.searchFunc = '';
  $scope.numResults = 0;
  $scope.searchResults = [];

  $scope.initVals = function initVals(paginatorData) {
    if (typeof paginatorData.currentPage === 'object') {
      Object.keys(paginatorData.currentPage).forEach(function(key) {
        $scope[key] = paginatorData.currentPage[key];
      });
      return;
    }

    $scope.page = paginatorData.currentPage || $scope.page;
    $scope.pageSize = paginatorData.pageSize || $scope.pageSize;
    $scope.numResults = paginatorData.totalSearchMatches || $scope.numResults;
    $scope.searchFunc = paginatorData.searchFunc  || '';
    $scope.searchVal = paginatorData.searchVal || $scope.searchVal;
    $scope.pageOneSize = paginatorData.pageOneSize || $scope.pageSize;
    $scope.searchResults = paginatorData.searchResults || [];

    trackerSvc.trackEvent('Site Search', {
      term: $scope.searchVal,
      hits: $scope.numResults
    });
  };


  $scope.pageUp = function pageUp() {
    if (lastItemIndex() < $scope.numResults) {
      $scope.page ++;
      doSearch();
    }
  }
  $scope.pageDown = function pageDown() {
    $scope.page --;
    doSearch();
  }

  $scope.hasNextPage = function hasNextPage() {
    return $scope.nextPageSize();
  }

  $scope.nextPageSize = function nextPageSize() {
    var size = $scope.page === 1 ? ($scope.pageOneSize * $scope.page) : ( ($scope.pageSize * $scope.page) + Math.abs($scope.pageOneSize - $scope.pageSize) );
    var remaining = $scope.numResults - size;

    remaining = remaining <= 0 ? 0 : remaining;
    return remaining < $scope.pageSize ? remaining : $scope.pageSize;
  }

  $scope.prevPageSize = function prevPageSize() {
    if ($scope.page === 2) {
      return $scope.pageOneSize;
    }
    return $scope.pageSize;
  }

  function lastItemIndex() {
    return (($scope.page-1) * $scope.pageSize) + $scope.pageOneSize;
  }

  function doSearch() {
    // set results to nothing so that on page refresh is noticable
    $scope.searchResults = [];
    var packet = {
      moduleName: 'content',
      methodName: $scope.searchFunc,
      params: {
        pageSize: $scope.pageSize,
        currentPage: $scope.page,
        searchVal: $scope.searchVal
      }
    };

    if ($scope.searchVal) {
      packet.q = $scope.searchVal;
    }

    cmsSvc.callDeferedGetterMethod(packet, function(results) {
      $scope.numResults = results.total;
      $scope.searchResults = results.hits;
    }, function(err) {
      $scope.notify('warn', 'We could not complete the request.');
    })
  }
}])
;

/** ****************************************************
  Module mrShared.directives
**************************************************** **/
angular.module('mrShared.directives', ['ngResource']).
directive('convertToNumber', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attr, ngModel) {
      ngModel.$parsers.push(function(val) {
        return val != null ? parseInt(val, 10) : null;
      });
      ngModel.$formatters.push(function(val) {
        return val != null ? '' + val : null;
      });
    }
  };
})
.
/* global directive */
directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function(){
        scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
}])
.
directive('imgBox', ['$window', '$compile', '$timeout', 'imgCropUtilSvc', function($window, $compile, $timeout, imgCropUtilSvc) {
  return {
    template: '<div></div>',
    replace: true,
    restrict: 'E',
    scope: {
      src: '@',
      alt: '@',
      image: '=',
      autoResize: '@',
      resizeInterval: '@',
      crop: '=?',
      cropSettings: '@',
      deferredSrc: '@?',
      cacheBust: '=?'
    },
    link: function(scope, iElement, iAttr, ctrl, transcludeFunc) {
      scope.imgSrc = scope.src ? scope.src : scope.deferredSrc
      if (scope.deferredSrc) {
        scope.$watch('deferredSrc', function(newSrc, oldSrc) {
          if (newSrc == oldSrc) {
            return;
          }
          scope.imgSrc = newSrc;
          //force redraw
          drawImg(iElement.width(), iElement.height());
        });
      }
      scope.autoResize = scope.autoResize || true;

      if (typeof scope.autoResize === 'string') {
        scope.autoResize = scope.autoResize !== 'false';
      }
      scope.resizeInterval = scope.resizeInterval || 50;
      scope.crop = scope.crop || false;

      if (scope.image && scope.image.url) {
        scope.imgSrc = scope.image.url;
      }

      if (scope.crop) {
        iElement.addClass('full-height');
      }

      var imgElement, lastWidth, baseUrl, timeoutPromise, lastAspect, lastCropKey, lastUrl;
      // the following line may look bizarre but I assure you it is necessary...
      // the crops may or may not be populated before this link function runs
      var crops = scope.crops = scope.crops || [];
      var cropsInited = false;
      var wndw = angular.element($window);

      if (scope.cropSettings) {
        scope.crops = eval(scope.cropSettings);
        scope.crops.forEach(function(crop) {
          if (crop.url) {
            crop.url = imgCropUtilSvc.remapUrl(crop.url);
          }
        });
        initCrops();
      }

      scope.windowWidth = function() {
        return wndw.width();
      };

      scope.$watch('image', function(newImage, oldImage) {
        if (!(newImage && (newImage.url || typeof newImage === 'string' || newImage.file_type === 'an'))) {
          return;
        }
        if (typeof newImage === 'string') {
          scope.imgSrc = newImage;
        } else {
          scope.imgSrc = newImage.url;
        }
        baseUrl = imgCropUtilSvc.remapUrl(scope.imgSrc);
        if (newImage.aspects && newImage.aspects.length) {
          scope.crops = newImage.aspects.map(convertToCrop);
          initCrops();
        }
        lastWidth = -1; // force redraw
        doRedraw(iElement.width(), iElement.height());
      });

      scope.setCrops = function(cropArray) {
        scope.crops = cropArray;
        initCrops();
      };

      if (!scope.image || scope.image.file_type !== 'an') {

        scope.$watch("src", function(newSrc, oldSrc) {
          if (newSrc != oldSrc) {
            doRedraw(iElement.width() || lastWidth, iElement.height());
          }
        });

        if (scope.autoResize) {
          scope.$watch(scope.windowWidth, function(newWidth, oldWidth) {
            doRedraw(iElement.width(), iElement.height());
          });
        }

        scope.$watch(elementWidth, function(newVal, oldVal) {
          doRedraw(newVal, iElement.height());
        });

        scope.$watch(elementHeight, function(newHeight, oldHeight) {
          if (scope.crop && newHeight) {
            doRedraw(iElement.width() || lastWidth, newHeight);
          }
        });

        scope.$watch('crop', function() {
          if (typeof scope.crop === 'string') {
            scope.crop = /(1|true|TRUE)/.test(scope.crop);
          }
        });

        scope.$watch('crops', function() {
          doRedraw(iElement.width(), iElement.height())
        });
      }

      function doRedraw(newWidth, newHeight) {
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(redrawImg.bind(this, newWidth, newHeight), 75);
      }

      function drawImg(width, height) {
        if (!scope.imgSrc && !(scope.image && scope.image.file_type === 'an')) {
          return;
        }

        if (scope.image && scope.image.file_type === 'an') {
          imgElement = angular.element(scope.image.data.html);
          iElement.append(imgElement);
          iElement.append(angular.element('<script>' + scope.image.data.js + '</script>'));
          return;
        }

        baseUrl = imgCropUtilSvc.remapUrl(scope.imgSrc);
        lastUrl = baseUrl;
        lastWidth = width;
        lastAspect = Math.round((height / lastWidth) * 100);

        var url = getUrl(width, height);
        // we only provide alt_text if it exists.  alt-text=undefined can hurt SEO
        var altLine = scope.alt ? ('alt="' + scope.alt + '"') : '';
        var imgHtml = [
          '<img src="',
          url,
          '"',
          altLine,
          'style="width:100%"/>'
        ].join('');

        imgElement = angular.element(imgHtml);
        iElement.empty();
        iElement.append(imgElement);
      }

      function redrawImg(newWidth, newHeight) {
        newWidth = newWidth || iElement.width();
        newHeight = newHeight || iElement.height();
        if (!newWidth) {
          return;
        }
        if (!imgElement) {
          return drawImg(newWidth, newHeight);
        }

        var newAspect = Math.round((newHeight / newWidth) * 100);
        if (!lastWidth || (newWidth > lastWidth && (newWidth - lastWidth) / lastWidth * 100 >= scope.resizeInterval) || newAspect !== lastAspect || lastUrl != baseUrl) {
          lastWidth = newWidth;
          lastAspect = newAspect;
          lastUrl = baseUrl;
          var url = getUrl(newWidth, newHeight);
          imgElement.attr('src', url);
        }
      }

      function getUrl(w, h) {
        var url = [
          baseUrl,
          '?w=', w
        ];
        if (scope.cacheBust) {
          url.push('&ts=', Date.now());
        }
        if (scope.crop) {
          url.push('&h=', h+1);
          var cropSettings = getCropSettings(w, h);
          url.push('&' + cropSettings.cropQuery);
          if (cropSettings.url) {
            url.splice(0, 1, cropSettings.url);
          }
        }
        if (isRetina()) {
          url.push('&dpr=1.7&q=50');
        }
        return url.join('');
      }

      function isRetina(){
        var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\ (min--moz-device-pixel-ratio: 1.5),\ (-o-min-device-pixel-ratio: 3/2),\ (min-resolution: 1.5dppx)";
        if (window.devicePixelRatio > 1) {
          return true;
        }
        if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
          return true;
        }
        return false;
      }

      function getCropSettings(w, h) {
        var crop;
        if (!cropsInited) {
          initCrops();
        }
        var targetIndex = w / h;
        for (var i = 0; i < crops.length; i++) {
          crop = crops[i];
          if (targetIndex <= crop.cutoff  ) {
            return crop;
          }
        }
        return { cropQuery: 'fit=crop&crop=faces' };
      }

      function initCrops() {
        if (!(scope.crops && scope.crops.length)) {
          return;
        }
        crops = scope.crops;

        crops.sort(function(a, b) {
          return a.aspectIndex < b.aspectIndex ? -1 : a.aspectIndex === b.aspectIndex ? 0 : 1;
        });
        // note that crops is the same array as scope.crops
        var lastIndex = crops[0].aspectIndex;

        for (var i = 1; i < crops.length; i++) {
          var diff = (crops[i].aspectIndex - lastIndex) / 2;
          crops[i-1].cutoff = lastIndex + diff;
          lastIndex = crops[i].aspectIndex;
        }
        crops[crops.length-1].cutoff = Infinity;
      }

      function convertToCrop(aspect) {
        var cropObj = {};
        if (aspect.k) {
          cropObj.key = aspect.k,
          cropObj.aspectIndex = aspect.m,
          cropObj.cropQuery = aspect.q
        } else {
          cropObj.key = aspect.key;
          cropObj.aspectIndex = aspect.aspectIndex || aspect.m;
          cropObj.cropQuery = aspect.cropQuery;
        }
        if (aspect.url) {
          cropObj.url = imgCropUtilSvc.remapUrl(aspect.url);
        }
        return cropObj;
      }

      function elementWidth() {
        return iElement.width();
      }

      function elementHeight() {
        return iElement.height();
      }
    }
  };
}])
.
/**
 * Description
 * @module scrollIntoView
 * @moduleType ngDirective
 */
directive('scrollIntoView', ['$compile', function($compile) {
  return {
    restrict: 'A',
    scope: {
      onEnterView: '&',
      onLeaveView: '&',
      triggerViewOnce: '=',
      triggerOnPartial: '=',
      elemName: '@'
    },
    link: function(scope, iElement, iAttr) {
      var triggerOnce = castAsBoolean(scope.triggerViewOnce);
      var usePartial = castAsBoolean(scope.triggerOnPartial, true);
      var onEnter = scope.onEnterView;
      var onLeave = scope.onLeaveView;
      var $window = $(window);

      var inView = false;
      var inViewTriggered = false;

      $window.on('scroll', checkViewable);

      checkViewable();

      function checkViewable() {
        if (isInView()) {
          // call the function if it just entered and (it hasn't been triggered before or triggerOnce is false
          if (!inView) {
            // just showed up
            if (onEnter && (!inViewTriggered || !triggerOnce)) {
              onEnter();
              inViewTriggered = true;
            }
            inView = true;
          }
        } else if(onLeave && inView) {
          onLeave();
          inView = false;
        }
      }

      function isInView() {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = iElement.offset().top;
        var elemBottom = elemTop + iElement.height();

        if (usePartial) {
          return ((elemBottom <= docViewBottom) || (elemTop >= docViewTop));
        }
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
      }

      function castAsBoolean(value, defaultValue) {
        if (arguments.length === 1) {
          defaultValue = false;
        }
        switch (typeof value) {
          case 'boolean':
            return value;
          case 'string':
            return ['true', '1'].indexOf(value.toLowerCase()) === 0;
          case 'number':
            return value !== 0;
          default:
            return defaultValue;
        }
      }
    }
  };
}]);

/** ****************************************************
  Module mrShared.filters
**************************************************** **/
angular.module('mrShared.filters', ['ngResource']).
/**
 formats mintues into hour-minutes format
 **/
filter('appointmentTime', function() {
  return function(val) {
    if (parseInt(val) < 60) {
      return parseInt(val) + ' minutes';
    }

    if (parseInt(val) / 60 < 2) {
      if (parseInt(val) % 60 == 0) {
        return '1 hour';
      } else {
        return '1 hour ' + (parseInt(val) % 60) + ' minutes';
      }
    } else {
      if (parseInt(val) % 60 == 0) {
        return Math.floor(parseInt(val) / 60) + ' hours';
      } else {
        return Math.floor(parseInt(val) / 60) + ' hours ' + parseInt(val) % 60 + ' minutes';
      }
    }
  };
}).
/**
  formats a duration of time expressed in minutes into a string
**/
filter('duration', function() {
  return function(val) {
    if (typeof val != 'number') {
      return val;
    }
    var hrs = Math.floor(val / 60);
    var mins = val % 60;
    var rslt = [mins + ' minute' + (mins != 1 ? 's' : '')];
    if (hrs) {
      rslt.unshift(hrs + ' hour' + (hrs > 1 ? 's' : ''));
    }
    return rslt.join(' ');
  };
}).
/**
 * Created by donkaiser on 6/24/16.
 */
filter('ifEmpty', function() {
  return function(val, defText) {
    defText = defText || 'n/a';
    if (isNonValue(val)) {
      return defText;
    }
    return val;
  };

  var re = /\[object (Undefined|Null)\]/;
  function isNonValue(val) {
    var valType = Object.prototype.toString.call(val);
    return re.test(valType) || val === '';
  }
}).
/**
  formats a phone number
**/
filter('phone', function() {
  return function(val) {
    if (typeof val != 'string') {
      return val;
    }
    var phone = val.replace(/[^0-9]/g, '');
    switch(phone.length) {
      case 10:
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3' );
      case 7:
        return phone.replace(/(\d{3})(\d{4})/, '$1-$2' );
      default:
        return val;
    }
  };
}).
filter('prettyLabel', function() {

  function fixCase(ltr, toUpper) {
    if (toUpper) {
      return ltr.toUpperCase();
    } else {
      return ltr.toLowerCase();
    }
  }

  return function (theStr, wordcaps) {
    wordcaps = arguments.length === 2 ? wordcaps : true;
    if (theStr != null) {
      theStr = '' + theStr;
      theStr = theStr.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
      theStr = theStr.replace(/([a-zA-Z])([0-9])/g, '$1 $2');
      theStr = theStr.replace(/_/g, ' ');
      theStr = theStr.replace(/([0-9])([a-zA-Z])/g, '$1 $2');
      theStr = theStr.replace(/^([a-z])/, function(ltr) {
        return ltr.toUpperCase();
      });
      theStr = theStr.replace(/ (\w)/g, function(m, ltr) {
        return ' ' + fixCase(ltr, wordcaps);
      });
    }
    return theStr;
  };
});

/** ****************************************************
  Module mrShared.services
**************************************************** **/
angular.module('mrShared.services', ['ngResource']).
factory('imgCropUtilSvc', [function() {
  return {
    standardAspects: standardAspects,
    remapUrl: remapUrl,
    getCropQueryString: getCropQueryString,
    getStaticImageUrl: getStaticImageUrl,
    getCustomMediaObj: getCustomMediaObj
  }

  function standardAspects() {
    return [
      {key: '1x1', w: 400, h: 400, m: 1/1},
      {key: '1x2', w: 200, h: 400, m: 1/2},
      {key: '1x3', w: 110, h: 330, m: 1/3},
      {key: '1x4', w: 100, h: 400, m: 1/4},
      {key: '2x1', w: 400, h: 200, m: 2/1},
      {key: '2x3', w: 300, h: 450, m: 2/3},
      {key: '3x1', w: 600, h: 200, m: 3/1},
      {key: '3x2', w: 600, h: 400, m: 3/2},
      {key: '3x4', w: 300, h: 400, m: 3/4},
      {key: '4x1', w: 800, h: 200, m: 4/1},
      {key: '4x3', w: 400, h: 300, m: 4/3},
      {key: '4x5', w: 300, h: 375, m: 4/5},
      {key: '7x2', w: 400, h: 130, m: 7/2},
      {key: '8x5', w: 400, h: 250, m: 8/5},
      {key: '10x9', w: 400, h: 360, m: 10/9},
      {key: '12x5', w: 600, h: 250, m: 12/5},
      {key: '16x9', w: 400, h: 225, m: 16/9}
    ];
  };

  function remapUrl(url) {
    if (!url) {
      return url;
    }
    var imgixHostMap = {
      'd3ewrnwdcmri66.cloudfront.net': 'mr-cdn.imgix.net',
      'ddxs94deh28np.cloudfront.net': 'mr-cdn-staging.imgix.net'
    };
    var hostRE = /https?:\/\/([^\/]+)\/.*$/;
    var awsHost = url.replace(hostRE, '$1');
    var imgxHost = imgixHostMap[awsHost];
    if (imgxHost) {
      return url.replace(awsHost, imgxHost);
    }
    return url;
  };

  function getCropQueryString(aspect) {
    var params = [
      'fit=' + aspect.fit
    ];
    if (aspect.fit === 'crop' && !aspect.useRect) {
      params.push('crop=' + aspect.crop.txt);
    }
    if (aspect.useRect) {
      var r = aspect.rect;
      params.push('rect=' + [r.x, r.y, r.w, r.h].join(','));
    }
    return params.join('&');
  };

  function getStaticImageUrl(mediaObj, aspectRatio, width) {
    var cropSettings = mediaObj.aspects.find(function(aspect) {
      return aspect.key == aspectRatio.key;
    });
    var url = [remapUrl(mediaObj.url)];
    var height = (width / cropSettings.m) + 1;

    url.push('?w=', width);
    url.push('&h=', height);
    url.push('&' + cropSettings.cropQuery);
    url = url.join('');

    return url;
  };

  function getCustomMediaObj(mediaObj, crops) {
    var newMediaObj = angular.copy(mediaObj);
    newMediaObj.aspects = newMediaObj.aspects.filter(function(aspect) {
      var isCrop = false;
      crops.forEach(function(crop) {
        if (aspect.key == crop.key) {
          isCrop = true;
        }
      });
      return isCrop;
    });
    return newMediaObj;
  }
}])
;

/** ****************************************************
  Module mrWebsite.directives
**************************************************** **/
angular.module('mrWebsite.directives', ['ngResource']).
directive('addToCart', ['newCartSvc', function(newCartSvc) {
  return {
    restrict: 'A',
    scope: {
      addToCart: '='
    },
    link: function(scope, elem, attrs, ctrl) {
      elem.click(function() {
        newCartSvc.addProduct(scope.addToCart, function() {
          window.location = elem.attr('href');
        });
      });
    }
  };
}]).
directive('mrAssociatedSubsModal', [function() {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/associated-subs-modal',
    scope: {
      modal: '='
    }
  };
}])
.
directive('blogGetter', ['$compile', '$anchorScroll', '$location', 'cmsSvc', function($compile, $anchorScroll, $location, cmsSvc) {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {
      contentId: '@',
      moduleName: '@',
      methodName: '@',
      params: '@'
    },
    link: function(scope, element, attrs, controller, transclude) {
      scope.getter = {};
      scope.getter.data = null;
      scope.getter.params = JSON.parse(scope.params);
      scope.isOriginalPage = false;

      var originalPage = scope.getter.params.fromLanding ? scope.getter.params.p - 1 : null;
      var width = window.innerWidth;
      var mediaRange = {
        mobile: {
          min: 0,
          max: 559
        },
        tablet: {
          min: 560,
          max: 759
        }
      };

      if (width <= mediaRange.mobile.max) {
        if (scope.getter.params.mobileLimit) {
          scope.getter.params.s = scope.getter.params.mobileLimit + 1;
        }
      }

      if (width >= mediaRange.tablet.min && width <= mediaRange.tablet.max) {
        if (scope.getter.params.tabletLimit) {
          scope.getter.params.s = scope.getter.params.tabletLimit + 1;
        }
      }

      var getterScope = scope;
      var transclusionScope;

      transclude(function(clone, scope) {
        element.append(clone);
        $compile(element.contents())(getterScope);
        transclusionScope = scope;
      });

      scope.scrollToElement = function() {
        $location.hash('topAnchor');
        $anchorScroll();
      }

      scope.$watch('getter.params', function(newValue) {
        if (newValue.p == originalPage) {
          scope.isOriginalPage = true;
        } else {
          scope.isOriginalPage = false;
        }

        cmsSvc.callDeferedGetterMethod({
          moduleName: scope.moduleName,
          methodName: scope.methodName,
          params: newValue
        }, function(data) {
          if (!scope.isOriginalPage) {
            data.blogPosts.unshift({});
            data.blogPosts.pop();
          }

          transclusionScope.data = data;
          transclusionScope.isOriginalPage = scope.isOriginalPage;
          scope.getter.data = data;
          scope.getter.isOriginalPage = scope.isOriginalPage;
        });
      }, true);
    }
  }
}])
.
directive('bundleBuilderModal', ['$cookies', 'newCartSvc', function($cookies, newCartSvc) {
  return {
    templateUrl: '/ngpartials/directives/bundle-builder-modal',
    scope: {
      cartItems: '=',
      subTotal: '=',
      recentAddedProduct: '=',
      bundleBuilderProducts: '=',
      freeShip: '=',
      addToCartMethod: '='
    },
    link: function(scope, element, attrs) {
      scope.bundleBuilderModal = {
        visible: true,
        products: []
      };
      scope.setCookie = scope.$parent.setCookie || scope.$parent.$parent.setCookie || scope.$parent.$parent.$parent.setCookie;
      var bundlesViewed = angular.fromJson($cookies.bundlesViewed) || [];

      scope.calculateDiscount = function() {
        var total = scope.subTotal ? scope.subTotal : 0;
        var percentages = [0, 15, 20, 25];
        var currentPercentage = 0;

        scope.bundleBuilderModal.products.forEach(function(product) {
          if (product.selected) {
            currentPercentage++;
            total += product.price;
          }
        });

        var threshold = 44.90;

        scope.cartItems.forEach(function(item) {
          if (item.subscription) {
            threshold = 39.90;
          }
        });

        scope.currentDiscount = currentPercentage ? total * percentages[currentPercentage] / 100 : 0;
        
        scope.willFreeShip = false;
        if (total - scope.currentDiscount >= threshold && scope.freeShip) {
          scope.willFreeShip = true;
        }
      }

      function updateProducts(products) {
        products.forEach(function(product) {
          product.selected = true;
          scope.bundleBuilderModal.products.push(product);

          if (product.colorFamily) {
            scope.bundleBuilderModal.colorFamily = product.colorFamily == 'Brown' ? 'Brunette' : product.colorFamily;
          }

          var productViewed = bundlesViewed.some(function(code) {
            code == product.code;
          });

          if (!productViewed) {
            bundlesViewed.push(product.code);
            scope.setCookie('bundlesViewed', angular.toJson(bundlesViewed), 2);
          } else {
            bundleBuilderModal.visible = false;
          }
        });

        scope.calculateDiscount();
      }

      updateProducts(scope.bundleBuilderProducts);

      if (scope.recentAddedProduct) {
        scope.cartItems.forEach(function(item) {
          if (item.id == scope.recentAddedProduct) {
            scope.bundleBuilderModal.addedProduct = item;
          }
        });
      }

      scope.addProducts = function() {
        if (scope.addingBundleProducts) {
          return;
        }
        scope.addingBundleProducts = true;
        var payload = [];

        scope.bundleBuilderModal.products.forEach(function(product) {
          if (product.selected) {
            payload.push({
              product_id: product.id,
              qty: 1,
              ctaSource: 'bundle-builder-modal'
            });
          }
        });

        scope.addToCartMethod(payload);
        scope.bundleBuilderModal.visible = false;
      };
    }
  }
}])
.
directive('component', ['$compile', 'cmsSvc', function($compile, cmsSvc) {
  return {
    restrict: 'E',
    scope: {
      namespace: '@'
    },
    link: function(scope, element, attrs) {
      // TODO: renderDeferedComponent
      // cmsSvc.renderDeferedComponent({ namespace: scope.namespace }, function(result) {
      //   element.html(result);
      //   $compile(element.contents())(scope);
      // });
    }
  }
}]).
directive('datepicker', function() {
  return {
    link: function(scope, element, attrs, ngModelCtrl) {
      var opts = {
        defaultDate: scope.date,
        onSelect: function(date) {
          scope.date = date;
          scope.$apply();
          if (scope.control.onDateChange) {
            scope.control.onDateChange(date);
          }
        }
      };

      scope.control.setDate = function(date) {
        element.datepicker("setDate", date);
        scope.$parent.dateIsSet = true;
      };

      if (scope.minDate) {
        opts.minDate = opts.defaultDate = new Date(scope.minDate);

        scope.$watch('minDate', function(newVal, oldVal) {
          if (!angular.equals(newVal, oldVal)) {
            element.datepicker('destroy');
          }

          opts.minDate = new Date(newVal);
          scope.$apply();
          element.datepicker(opts);
        });
        return;
      }
    },
    scope: {
      date: '=',
      control: '=',
      minDate: '=?'
    }
  };
}).
directive('dropdown', function($timeout) {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      ngModel: '='
    },
    link: function(scope, element, attrs) {      
      scope.$watch('ngModel', function(val) {
        delayApply();
      });

      var oldLength;
      scope.$watch(function() {
        var changed = element[0].childNodes.length != oldLength;
        oldLength = element[0].childNodes.length;
        return changed;
      }, delayApply);

      function delayApply() {
        $timeout(function() {
          element.customDropdown();
        }, 100);
      }
    }
  };
})
.
directive('dropdownItem', ['$parse', '$compile', function($parse, $compile) {
  return {
    require: '^mrDropdown',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="dropdown-item" ng-click="changeModel(header)" ng-class="{unselected: !dropDowns[header].selected}" ng-transclude>' +
    '</div>',
    scope: {
      value: '=',
      header: '='
    },
    link: function(scope, element, attrs, ctrl, transclude) {
      scope.changeModel = ctrl.changeModel;
      scope.dropDowns = ctrl.dropDowns;
      ctrl.addItem(scope.header, scope.value, element);
    }
  };
}]).
//This attribute directive emits an 'init' event after it has been initialized
directive('elementInit', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.on('load', function() {
        scope.$emit('init');
      });
    }
  };
}).
directive( 'elementReady', ['$parse', function($parse) {
  //tag this directive onto an element in order to tell angular to parse it once it and its children are finished initializing
  //initialization is considered finished on an element when all synchronous tasks within angular-core, dependency-injection,
  //and our own synchronous JS is finished
  return {
     restrict: 'A',
     link: function( $scope, element, attrs ) {
        element.ready(function(){
          $scope.$apply(function(){
            var parseFunc = $parse(attrs.elementReady);
            parseFunc($scope);
            performance.mark('angularFinished'); // custom perf metric
          });
        });
     }
  }
}])
.
directive('errSrc', function() {
  return {
    scope: {
      errClassTarget: '='
    },
    link: function(scope, element, attrs) {
      element.bind('error', function() {
        element.attr('src', attrs.errSrc);
        if (scope.errClassTarget) {
          $(scope.errClassTarget).addClass('ng-err-src');
        } else {
          element.addClass('ng-err-src');
        }
      });
    }
  };
}).
directive('fbSignIn', ['$window', 'customerSvc', function($window, customerSvc) {
  return {
    scope: {
      callback: '=',
      extraBody: '='
    },
    link: function(scope, element, attrs) {
      element.bind('click', signIn);

      function signIn() {
        var FB = $window.FB;
        if (!FB) {
          setTimeout(signIn, 300);
          return;
        }

        FB.login(function(res) {
          var fields = [
            'id',
            'email',
            'name',
            'first_name',
            'last_name',
            'middle_name',
            'gender',
            'birthday',
            'hometown',
            'link',
            'locale',
            'location',
            'timezone',
            'updated_time',
            'verified',
          ];
          FB.api('/me', {fields: fields.join(',')}, function(resp) {
            FB.getLoginStatus(function(statusRes) {
              if (statusRes.authResponse.accessToken && statusRes.authResponse.expiresIn) {
                resp.accessToken = statusRes.authResponse.accessToken;
                resp.accessTokenExpires = statusRes.authResponse.expiresIn;
              }

              if (scope.extraBody) {
                for (var k in scope.extraBody) {
                  if (resp[k] === undefined) {
                    resp[k] = scope.extraBody[k];
                  }
                }
              }

              customerSvc.facebook(resp, function(data) {
                if (data.success == 0 && data.err == 'bad-facebook-data') {
                  scope.$emit(data.err);
                  return;
                }

                if (scope.callback) {
                  scope.callback(data);
                }

                if (element.attr('href')) {
                  $window.location = element.attr('href');
                } else if (redirectUrl) {
                  $window.location = redirectUrl;
                } else {
                  $window.location.reload(true);
                }
              });
            });
          });
        }, {
          scope: [
            'email',
            'user_about_me',
            'user_likes'
          ].join(',')
        });
      }
    }
  };
}])
.
directive('fixedWidth', [function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var xs = attrs.xs ? parseInt(attrs.xs) : 'auto';
      var sm = attrs.sm ? parseInt(attrs.sm) : 'auto';
      var md = attrs.md ? parseInt(attrs.md) : 'auto';
      var lg = attrs.lg ? parseInt(attrs.lg) : 'auto';
      var xsMediaList = window.matchMedia("only screen and (min-width: 0px) and (max-width: 559px)");
      var smMediaList = window.matchMedia("only screen and (min-width: 560px) and (max-width: 759px)");
      var mdMediaList = window.matchMedia("only screen and (min-width: 760px) and (max-width: 959px)");
      var lgMediaList = window.matchMedia("only screen and (min-width: 960px)");

      if (xsMediaList.matches) {
        elem.css('width', xs);
      }
      if (smMediaList.matches) {
        elem.css('width', sm);
      }
      if (mdMediaList.matches) {
        elem.css('width', md);
      }
      if (lgMediaList.matches) {
        elem.css('width', lg);
      }

      xsMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', xs);
        }
      });
      smMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', sm);
        }
      });
      mdMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', md);
        }
      });
      lgMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', lg);
        }
      });
    }
  };
}])
.
directive('fixedWidthTweakUpper', [function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var xs = attrs.xs ? parseInt(attrs.xs) : 'auto';
      var sm = attrs.sm ? parseInt(attrs.sm) : 'auto';
      var md = attrs.md ? parseInt(attrs.md) : 'auto';
      var lg = attrs.lg ? parseInt(attrs.lg) : 'auto';
      var xsTweakLowerMediaList = window.matchMedia("only screen and (min-width: 0px) and (max-width: 439px)");
      var smTweakLowerMediaList = window.matchMedia("only screen and (min-width: 560px) and (max-width: 659px)");
      var mdTweakLowerMediaList = window.matchMedia("only screen and (min-width: 760px) and (max-width: 859px)");
      var lgTweakLowerMediaList = window.matchMedia("only screen and (min-width: 960px) and (max-width: 1079px)");
      var xsTweakUpperMediaList = window.matchMedia("only screen and (min-width: 439px) and (max-width: 559px)");
      var smTweakUpperMediaList = window.matchMedia("only screen and (min-width: 659px) and (max-width: 759px)");
      var mdTweakUpperMediaList = window.matchMedia("only screen and (min-width: 859px) and (max-width: 959px)");
      var lgTweakUpperMediaList = window.matchMedia("only screen and (min-width: 1080px)");

      if (xsTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (xsTweakUpperMediaList.matches) {
        elem.css('width', xs);
      }
      if (smTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (smTweakUpperMediaList.matches) {
        elem.css('width', sm);
      }
      if (mdTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (mdTweakUpperMediaList.matches) {
        elem.css('width', md);
      }
      if (lgTweakLowerMediaList.matches) {
        elem.css('width', 'auto');
      }
      if (lgTweakUpperMediaList.matches) {
        elem.css('width', lg);
      }

      xsTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      xsTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', xs);
        }
      });
      smTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      smTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', sm);
        }
      });
      mdTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      mdTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', md);
        }
      });
      lgTweakLowerMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', 'auto');
        }
      });
      lgTweakUpperMediaList.addListener(function(mdl) {
        if (mdl.matches) {
          elem.css('width', lg);
        }
      });
    }
  };
}])
.
directive('getter', ['$compile', '$anchorScroll', '$location', 'cmsSvc', function($compile, $anchorScroll, $location, cmsSvc) {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {
      contentId: '@',
      moduleName: '@',
      methodName: '@',
      params: '@'
    },
    link: function(scope, element, attrs, controller, transclude) {
      scope.getter = {};
      scope.getter.data = null;
      scope.getter.params = JSON.parse(scope.params);

      var getterScope = scope;
      var transclusionScope;

      transclude(function(clone, scope) {
        element.append(clone);
        $compile(element.contents())(getterScope);
        transclusionScope = scope;
      });

      scope.scrollToElement = function() {
        $location.hash('topAnchor');
        $anchorScroll();
      }

      scope.$watch('getter.params', function(newValue) {
        cmsSvc.callDeferedGetterMethod({
          moduleName: scope.moduleName,
          methodName: scope.methodName,
          params: newValue
        }, function(data) {
          transclusionScope.data = data;
          scope.getter.data = data;
        });
      }, true);
    }
  }
}])
.
/* global directive */
/* global greenhouseJobs */
// This directive requires specific greenhouse scripts to be on the page
//   script.
//     var greenhouseJobs = greenhouseJobs || {};
//     var callback#{params.jobId} = function(data) {
//       console.log('data: ', data);
//       greenhouseJobs['#{params.jobId}'] = data;
//     };
    
//   script(type="text/javascript" src="https://api.greenhouse.io/v1/boards/madisonreed/jobs/#{params.jobId}?callback=callback#{params.jobId}?questions=true" ng-cloak)
//   greenhouse-job-application(control="#{params.jobBoard}" job-board="#{params.jobBoard}" job-id="'#{params.jobId}'")

directive('greenhouseJobApplication', ['$http', '$sce', 'FileUploader', 'greenhouseSvc', 'notifySvc', function($http, $sce, FileUploader, greenhouseSvc, notifySvc) {
  return {
    restrict: 'AE',
    scope: {
      control: '=',
      jobBoard: '@',
      jobId: '@'
    },
    link: function(scope) {
      scope.uploader = new FileUploader();
      scope.control = scope.control || {};
      scope.control.job = greenhouseJobs[scope.jobId];
      scope.control.jobContent = greenhouseJobs[scope.jobId].content;
      scope.control.jobContent = scope.control.jobContent.replace(new RegExp('&lt;', 'g'), '<').replace(new RegExp('&gt;', 'g'), '>').replace(new RegExp('&amp;', 'g'), '&');
      scope.control.form = {};
      scope.control.requiredFields = {};

      scope.control.submitApplication = function() {
        if (scope.control.submittingApplication || badFormInput()) {
          return;
        }
        scope.control.submittingApplication = true;

        var fd = new FormData();
        fd.append('jobBoard', scope.jobBoard);
        fd.append('jobId', scope.jobId);

        Object.keys(scope.control.form).forEach(function(key) {
          if (scope.control.form[key]) {
            fd.append(key, scope.control.form[key]);
          }
        });
        
        $http.post('/api/greenhouse/submitJobApplication', fd, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        }).success(function() {
          scope.control.submittingApplication = false;
          scope.control.applicationSubmitted = true;
          notifySvc.notify('success', 'Your application has been submitted.');
        }).error(function() {
          scope.control.submittingApplication = false;
          notifySvc.notify('error', 'We\'re Sorry, something went wrong.');
        });
      };

      function badFormInput() {
        var hasBadInput = false;

        // check for required fields
        scope.control.job.questions.forEach(function(question) {
          var hasRequiredField = false;

          if (question.required) {
            question.fields.forEach(function(field) {
              if (scope.control.form[field.name]) {
                hasRequiredField = true;
              }
            });
          } else {
            hasRequiredField = true;
          }

          if (!hasRequiredField) {
            notifySvc.notify('error', 'Missing required fields.');
            question.missingRequired = true;
            hasBadInput = true;
          }
        });

        // check for bad files
        var validFileTypes = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
        var maxFileSize = 10000000; // 10MB

        Object.keys(scope.control.form).forEach(function(key) {
          var value = scope.control.form[key];
          if (value.name) { // assume file if value has a name
            var fileType = value.name.split('.').pop();

            if (!~validFileTypes.indexOf(fileType)) {
              notifySvc.notify('error', 'Invalid file format selected. Allowed formats are: pdf, doc, docx, txt, rtf');
              scope.control.form[key] = null;
              hasBadInput = true;
            }

            if (value.size > maxFileSize) {
              notifySvc.notify('error', 'File to large, must be under 10MB.');
              scope.control.form[key] = null;
              hasBadInput = true;
            }
          }
        });

        return hasBadInput;
      }
    }
  };
}])
.
// This directive requires specific greenhouse scripts to be on the page
//   script.
//     var greenhouseJobs = greenhouseJobs || {};
//     var #{settings.jobBoard}Callback = function(data) {
//       console.log('data: ', data);
//       greenhouseJobs['#{settings.jobBoard}'] = data;
//     };
    
//   script(type="text/javascript" src="https://api.greenhouse.io/v1/boards/madisonreedcolorbar/jobs?callback=#{settings.jobBoard}Callback" ng-cloak)
//   greenhouse-jobs(control="greenhouse" job-board="'#{settings.jobBoard}'")

directive('greenhouseJobs', [function() {
  return {
    restrict: 'AE',
    scope: {
      control: '=',
      jobBoard: '='
    },
    link: function(scope, element, attrs) {
      scope.control = scope.control || {};
      scope.control.greenhouseJobs = greenhouseJobs;
      scope.control.jobs = greenhouseJobs[scope.jobBoard].jobs;
      scope.control.departments = getDepartmentMap();

      function getDepartmentMap() {
        var departmentMap = {};

        scope.control.jobs.forEach(function(job) {
          job.mixin = job.title.toLowerCase();
          job.mixin = job.mixin.replace(/[^a-zA-Z0-9 ]/g, ''); // remove special characters
          job.mixin = job.mixin.replace(/^\s+|\s+$/g,''); // remove leading/trailing spaces
          job.mixin = job.mixin.replace(/\s+/g, '-'); // replace spaces with dashes
          
          job.departments.forEach(function(department) {
            if (!departmentMap[department.name]) {
              departmentMap[department.name] = {
                title: department.name,
                jobs: []
              };
            }
            departmentMap[department.name].jobs.push(job);
          });
        });
        
        return departmentMap;
      }
    }
  }
}])
.
directive('inputDate', ['$filter', function($filter) {
  var dateFilter = $filter('date');

  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      parentForm: '='
    },
    link: function(scope, element, attrs, ngModel) {
      var fakeBirthdayYear = 1896;
      var format = 'MM/dd';
      ngModel.$formatters.push(function(value) {
        return dateFilter(value, format);
      });

      scope.$watch(attrs.ngModel, function(val) {
        if (val === undefined || val === null || val === '') {
          setValidity(true);
        } else if (val.length >= format.length) {
          var date = new Date(val);
          if (~val.indexOf('/')) {
            date = new Date(val + '/' + fakeBirthdayYear);
          }
          var dateString = dateFilter(date, format);

          if (date != 'Invalid Date' && (val === dateString || dateFilter(val, format) === dateString)) {
            setValidity(true);
          } else {
            setValidity(false);
          }
        } else {
          setValidity(false);
        }

        function setValidity(value) {
          scope.parentForm.birthday.$setValidity("date", value);
        }
      });
    }
  };
}]).
directive('inverted', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(val) {
        return !val;
      });
      ngModel.$formatters.push(function(val) {
        return !val;
      });
    }
  };
}).
directive('match', function() {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      match: '='
    },
    link: function(scope, elem, attrs, ctrl) {
      scope.$watch(function() {
        return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || scope.match === ctrl.$modelValue;
      }, function(currentValue) {
        ctrl.$setValidity('match', currentValue);
      });
    }
  };
}).
// As many as all sections can be opened at a time
directive('mrAccordion', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-accordion" ng-transclude>' +
    '</div>',
    controller: function($scope) {
      var sections = this.sections = {};

      this.toggleSection = function(section, options) {
        options = options || {};
        options.cancelToggle = options.hasOwnProperty('cancelToggle') ? options.cancelToggle: false;

        // If cancelToggle flag option is passed and section is already open, do not toggle
        if (options.cancelToggle && sections[section]) {
          return;
        }
        else if (!sections[section]) {
          sections[section] = true;
        } else {
          sections[section] = !sections[section];
        }
      };

      this.addSection = function(section) {
        sections[section] = false;
      };
    }
  };
}).
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
 
directive('mrAccountEditSubLeftNav', ['$location', function($location) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-account-edit-sub-left-nav',
    scope: {
       subs: '=',
       orderSubTotal: '=',
       annualSavings: '=',
       user: '='
    },
    link: function(scope) {
      //This is a cancel flag that is used to display alternative content
      //if a user is canceling a subscription
      scope.isCancel = ~$location.$$url.indexOf('cancel');
      //Make sure that subs is in array format
      scope.subsCopy = Array.isArray(scope.subs) ? scope.subs : [scope.subs];
    }
  };
}])
.
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrAccountTopNav', [function() {
   return {
     restrict: 'E',
     templateUrl: '/ngpartials/directives/mr-account-top-nav',
     scope: {
      backToText: "@",
      backToUrl: "@"
     },
     link: function(scope) {
     }
   };
}])
.
directive('mrAddToCart', ['newCartSvc', function(newCartSvc) {
  return {
    restrict: 'E',
    transclude: true,
    template: '<a class="add-to-cart" ng-transclude ng-click="addToCart()" data-mr-ass="add-to-cart-directive"></a>',
    scope: {
      productId: '=',
      ctaSource: '@'
    },
    link: function(scope, elem) {
      scope.addToCart = function() {
        var payload = {
          product: {
            id: scope.productId
          },
          ctaSource: scope.ctaSource
        };

        newCartSvc.addToCart(payload, function() {
          if (elem.attr('href')) {
            window.location = elem.attr('href');
          } else {
            window.location = '/cart';
          }
        });
      };
    }
  };
}]).
directive('mrAddressInputs', ['$timeout', 'appLookupSvc', 'addressSvc', function($timeout, appLookupSvc, addressSvc) {
    return {
      restrict: 'EA',
      templateUrl: '/ngpartials/directives/mr-address-inputs-v2',
      scope: {
        addressForm: '=',
        address: '=',
        blur: '=?'
      },
      link: function(scope) {
        scope.regions = [];
        scope.addressSvc = addressSvc;
        scope.blur = scope.blur || angular.noop;

        getRegions();
        var zipCheckTimeout;
        var lastZip;

        scope.defferedZipCheck = function(address, input) {
          clearTimeout(zipCheckTimeout);
          zipCheckTimeout = setTimeout(function() {
            scope.zipCheck(address, input);
          }, 100);
        };

        scope.zipCheck = function(address, input) {
          if (!address) {
            return;
          }

          var zip = input.$viewValue;

          if (lastZip == zip) {
            return;
          }

          lastZip = zip;

          if (!zip || zip.length < 5) {
            address.validZip = false;
            input.$setValidity('validZip', address.validZip);
            return;
          }

          var payload = {
            zip: zip
          };

          addressSvc.zipCheck(payload, function(res) {
            //- if zipCheck is successful prepopulate city and state
            if (res.city && res.state) {
              address.city = res.city;
              address.region = res.state;
            }

            address.post_code = res.zip;
            address.validZip = true;
            input.$setValidity('validZip', address.validZip);
          }, function(err) {
            //- invalid zip code? clear city and state
            if (err.data && err.data.message == 'Invalid Zip Code.') {
              address.city = '';
              address.state = '';
              address.validZip = false;
              return;
            }
            //- any other errors should not keep the user from filling out address form
            address.validZip = true;
            input.$setValidity('validZip', address.validZip);
          });
        };

        function getRegions(cb) {
          cb = cb || angular.noop;
          if (scope.regions.length) {
            return cb();
          }

          appLookupSvc.getRegionsByCountry({country: 'US'}, function(regions) {
            scope.regions = regions;
            cb();
          });
        }
      }
   };
}])
.
directive('mrAddressList', ['addressSvc', function(addressSvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-address-list',
    scope: {
      saveCallback: '=?',
      regions: '=?'
    },
    link: function(scope) {
      scope.saveCallback ? scope.saveCallback : angular.noop;
      scope.addressSvc = addressSvc;
    }
  };
}])
.
directive('mrAutoFocus', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.focus();
    }
  };
}).
directive('mrBlogCarousel', [function() {
  return {
    templateUrl: '/ngpartials/directives/blog-carousel',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      blogPosts: '@'
    },
    link: function(scope, element, attr) {
      scope.posts = JSON.parse(scope.blogPosts);
      scope.limit = scope.limit || scope.posts.length;
      scope.posts.forEach(function(post) {
        post.mainTag = post.tags[0] || 'madison reed';
      });
      scope.selected = scope.posts[0];
      scope.selectedPost = {
        0: true,
        1: false,
        2: false,
        3: false
      };

      var count = 1;
      var t = setInterval(animatePostImages, 5000);

      scope.selectPost = function(post) {
        scope.selected = post;
      };

      scope.stopTransitions = function() {
        clearInterval(t);
      };

      scope.hover = function(index) {
        scope.selected = scope.posts[index];
        Object.keys(scope.selectedPost).forEach(function(key) {
          scope.selectedPost[key] = false;
        })
        scope.selectedPost[index] = true;
        clearInterval(t);
      };

      function animatePostImages() {
        if (count == 3) {
          clearInterval(t);
        }
        scope.selected = scope.posts[count];
        Object.keys(scope.selectedPost).forEach(function(key) {
          scope.selectedPost[key] = false;
        })
        scope.selectedPost[count] = true;
        scope.$apply();
        count++;
      }
    }
  };
}])
.
directive('mrCalendar', ['colorBarSvc', function(colorBarSvc) {
  return {
    templateUrl: '/ngpartials/directives/mr-calendar',
    restrict: 'E',
    scope: {
      dates: '=',
      getDatesForMonth: '=',
      getTimesForSelectedDate: '=',
      control: '=',
      location: '='
    },
    link: function(scope, element, attr, ctrl) {
      var calendarBoxes = 42;
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var now = new Date();
      var currentMonth = now.getMonth();
      var currentYear = now.getFullYear();
      var startDate, endDate, daysInMonth;
      var selectedMonth = currentMonth;
      var selectedYear = currentYear;

      scope.calendarDays = [];
      scope.currentMonth = currentMonth;
      scope.currentYear = currentYear;
      scope.futureMonthLimit = new Date(now.setDate(now.getDate() + scope.dates.maxDaysInAdvance)).getMonth();
      scope.futureYearLimit = new Date(now.setDate(now.getDate() + scope.dates.maxDaysInAdvance)).getFullYear();

      if (scope.control) {
        scope.control.redraw = drawCalendar;
      }

      //------- Functions
      function drawCalendar() {
        var currentCal = {
          month: selectedMonth,
          year: selectedYear,
          calendarDays: new Date(selectedYear, (selectedMonth + 1), 0).getDate(),
          firstDay: new Date(selectedYear, (selectedMonth), 1).getDay() + 1,
          lastDay: new Date(selectedYear, (selectedMonth + 1), 0).getDay() + 1
        };

        scope.selectedMonth = selectedMonth;
        scope.selectedYear = selectedYear;
        scope.selectedMonthText = months[selectedMonth];

        var newDays = [];
        var monthDay = 1;
        for (var i = 1; i <= calendarBoxes; i++) {
          if (i / currentCal.firstDay < 1) {
            newDays.push({
              day: -1,
              open: false,
              available: false,
              month: selectedMonth,
              year: selectedYear
            });
          } else if (monthDay > currentCal.calendarDays) {
            newDays.push({
              day: -1,
              open: false,
              available: false,
              month: selectedMonth,
              year: selectedYear
            });
          } else {
            var obj = scope.dates.available[ monthDay ];
            if (!obj) {
              obj = {
                open: false,
                available: false
              };
            }
            obj.day = monthDay;
            obj.month = selectedMonth;
            obj.year = selectedYear;
  
            newDays.push(obj);
            monthDay++;
          }
        }

        scope.calendarDays = newDays;
      }

      scope.previousMonth = function() {
        if (selectedYear == currentYear && selectedMonth == currentMonth) {
          return;
        }

        startDate = new Date(selectedYear, selectedMonth - 1, 1);
        selectedMonth = startDate.getMonth();
        selectedYear = startDate.getFullYear();
        endDate = new Date(selectedYear, selectedMonth + 1, 0);
        daysInMonth = endDate.getDate();

        scope.getDatesForMonth(startDate, endDate, daysInMonth);
      };

      scope.nextMonth = function() {
        if (selectedYear == scope.futureYearLimit && selectedMonth == scope.futureMonthLimit) {
          return;
        }

        startDate = new Date(selectedYear, selectedMonth + 1, 1);
        selectedMonth = startDate.getMonth();
        selectedYear = startDate.getFullYear();
        endDate = new Date(selectedYear, selectedMonth + 1, 0);
        daysInMonth = endDate.getDate();

        scope.getDatesForMonth(startDate, endDate, daysInMonth);
      };

      scope.getCalendarClass = function(box, index, dates) {
        var waitlist = false;
        if (box.calDate) {
          waitlist = colorBarSvc.waitlistEligible(box.calDate, scope.location.schedulingOpts.maxWaitlistDays);
        }

        var classes = [box.open ? 'open' : 'closed', box.available || (box.open && waitlist) ? 'available' : 'unavailable'];

        if (dates.selected && box.calDate == dates.selected.calDate) {
          classes.push('selected');
        }

        return classes;
      };

      drawCalendar();
    }
  }
}]).
directive('mrCarousel', ['$swipe', function($swipe) {
  return {
    templateUrl: '/ngpartials/directives/carousel',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      images: '=',
      limit: '=?'
    },
    link: function(scope, element, attr) {
      scope.limit = scope.limit || scope.images.length;

      scope.$watch('images', function() {
        scope.selected = scope.images[0];
      });

      scope.moveLeft = function() {
        var img = scope.images[scope.images.indexOf(scope.selected) - 1];
        if (scope.images.indexOf(img) !== -1) {
          scope.selected = img;
        } else {
          scope.selected = scope.images[scope.images.length - 1];
        }
      };

      scope.moveRight = function() {
        var img = scope.images[scope.images.indexOf(scope.selected) + 1];
        if (scope.images.indexOf(img) !== -1) {
          scope.selected = img;
        } else {
          scope.selected = scope.images[0];
        }
      };

      scope.selectImage = function(image) {
        scope.selected = image;
      };
    }
  };
}]).
// mrCart:
//    control - binding to the parent controller,
//    type - template type (checkout or desktop),
directive('mrCart', ['newCartSvc', 'productCatalogSvc', 'promoSvc', 'freeCurrencyFilter', 'Modal', '$timeout', '$cookies', 'cdata', '$window', 'trackerSvc', 'mrNgUtils', function(newCartSvc, productCatalogSvc, promoSvc, freeCurrencyFilter, Modal, $timeout, $cookies, cdata, $window, trackerSvc, mrNgUtils) {
  return {
    templateUrl: function(tElement, tAttrs) {
      if (tAttrs.type == 'desktop') {
        return '/ngpartials/directives/desktop-cart';
      }
      if (tAttrs.type == 'checkout') {
        return '/ngpartials/directives/checkout-cart';
      }
    },
    replace: true,
    restrict: 'E',
    scope: {
      type: '=',
      shippingAddress: '=',
      cartItems: '=',
      testFlag: '@',
      initialCartDataView: '=?',
      recentAddedProduct: '=',
      bundleBuilderProducts: '=?',
      freeShip: '=?'
    },
    link: function(scope, element, attr, ctrl) {
      scope.params = mrNgUtils.locationSearchParams();
      // Mobile and Desktop
      var loadingCartSummary = true;
      scope.cartType = $cookies.cartType || 'active';
      scope.isPreOrder = scope.cartType == 'preorder';
      scope.cdata = cdata;
      scope.isCheckout = attr.type == 'checkout';
      scope.editingProd = null;
      scope.editShipping = false;
      scope.coupon = '';
      scope.showCouponInput = false;
      scope.promoError = '';
      scope.xSellImpressionCounter = 1;
      scope.$parent.promoRemoveModal = Modal.newModal('promoRemoveModal');
      scope.$parent.shippingMethodChangeModal = Modal.newModal('shippingMethodChangeModal');
      scope.removePromoId = null;
      scope.shippingMethods = {
        all: null,
        selected: null
      };
      scope.modalVersion = null;
      scope.emptyCartFlag = false;
      scope.bundlesCookie = [];

      scope.formatPrice = formatPrice;
      scope.applyCoupon = applyCoupon;
      scope.editProduct = editProduct;
      scope.removeCoupon = removeCoupon;
      scope.updateSubFreq = updateSubFreq;
      scope.updateProdQty = updateProdQty;
      scope.addXSellToCart = addXSellToCart;
      scope.setShippingMethod = setShippingMethod;
      scope.removeItemFromCart = removeItemFromCart;
      scope.activateCouponInput = activateCouponInput;
      scope.setSelectedShipMethod = setSelectedShipMethod;
      scope.addonConversionGAEvent = addonConversionGAEvent;
      scope.addonImpressionGAEvent = addonImpressionGAEvent;
      scope.removeXSellToConvertItem = removeXSellToConvertItem;
      scope.moveToOtherCart = moveToOtherCart;
      scope.shipRefillWithCart = shipRefillWithCart;
      scope.freeItemsMap = {};
      scope.modals = {
        subPendingModal: Modal.newModal('subPendingModal')
      };
      scope.modals.subPendingModal.data = {};
      scope.modals.subPendingModal.contactUs = function() {
        window.location = '/support';
        scope.modals.subPendingModal.close();
      };
      scope.upsellModalProducts = [];
      scope.addons = [];
      scope.addonsByContext = {};
      scope.batchEditProducts = [];

      var removeItems = {};
      var xsellKeys = ['position', 'impression', 'product', 'category', 'sku', 'productId'];
      var initialCache = scope.isCheckout ? ['items', 'totals', 'shippingMethods'] : ['all'];
      // initialCartDataView from ng-init in desktop-cart.jade
      initialCache.initalCartDataCache = scope.initialCartDataView || null;

      newCartSvc.getInitialCache(initialCache, function(result) {
        setVarsFromResponse(result);
        initialCache.initalCartDataCache = null;
        loadingCartSummary = false;
      });

      scope.$on('highlightSubItems', function() {
        scope.highlightSubItems = true;
      });

      scope.isDoneLoadingCartSummary = function() {
        return !loadingCartSummary;
      };
      //- once amazon is in its own service this should go and we should use
      //- addressSvc and amazonSvc in here instead of passing it through directive scope
      scope.$watch('shippingAddress', function(newVal) {
        //- amazon address will not have id so check specificaly
        if (!newVal.id && !newVal.amazonAddress) {
          return;
        }

        if (!scope.isDoneLoadingCartSummary()) {
          //- make sure everything is loaded correctly
          $timeout(function() {
            setCartShipAddress();
          }, 500);
        }

        setCartShipAddress();
      });

      scope.prodQty = [];
      for (var qty = 1; qty <= 10; qty++) {
        scope.prodQty.push(qty);
      }

      function shipRefillWithCart(subscriptionId) {
        // check for existing pending orders
        var payload = {
          subscriptionId: subscriptionId
        };
        newCartSvc.shipRefillWithCart(payload, function(res) {
          $window.location = '/checkout';
        }, function(err) {
          if (err.data && err.data.code == 'PENDING_ORDERS') {
            scope.modals.subPendingModal.open();
          } else {
            scope.notifySvc.notify('error', 'Sorry, something went wrong.');
          }
        });
      }

      function moveToOtherCart(from, to, index) {
        var params = {
          from: from,
          to: to,
          index: index
        };
        newCartSvc.moveToOtherCart(params, setVarsFromResponse);
      }

      function setCartShipAddress() {
        newCartSvc.setShippingAddress({ address: scope.shippingAddress }, setVarsFromResponse);
      }

      function activateCouponInput() {
        scope.promoError = '';
        scope.showCouponInput = true;
        window.setTimeout(function() {
          document.getElementById('promoCodeInput').focus();
        }, 10);
      }

      function setSelectedShipMethod() {
        if (scope.shippingMethods.all) {
          angular.forEach(scope.shippingMethods.all, function(method) {
            if (scope.shippingMethods.selected.code == method.code) {
              scope.shippingMethods.selected = method;
            }
          });
          checkShippingMessage();
        }
      }

      function setShippingMethod() {
        checkShippingMessage();
        newCartSvc.setShippingMethod({ code: scope.shippingMethods.selected.code }, setVarsFromResponse);
      }

      function formatPrice(price) {
        return freeCurrencyFilter(price);
      }

      function addonConversionGAEvent() {
        var xSellCookie = $cookies.xSellConverted;
        var xSellConverted;
        if (xSellCookie) {
          xSellConverted = JSON.parse(xSellCookie);
        } else {
          xSellConverted = [];
        }

        if (xSellConverted.length) {
          xSellConverted.forEach(function(row) {
            var gaEvent = {
              'event': 'MRCustom',
              'category': 'cart',
              'action': 'addon converted',
              'label': 'position: ' + row[xsellKeys.indexOf('position')] + ', impression: ' + row[xsellKeys.indexOf('impression')] + ', product: ' + row[xsellKeys.indexOf('product')] + ', category: ' + row[xsellKeys.indexOf('category')] + ', sku: ' + row[xsellKeys.indexOf('sku')]
            };
            dataLayer.push(gaEvent);
          });
        }
      }

      function checkShippingMessage() {
        if (scope.shippingMethods.selected && scope.shippingMethods.selected.code != 'SHIP_DEFAULT') {
          scope.shippingMessage = 'Orders placed before 12pm (ET) Mon-Fri will ship same day.';

          if (scope.shippingMethods.selected.start == 1 && scope.shippingMethods.selected.end == 1) {
            scope.shippingMessage = 'One-day shipping is not available for PO Boxes. Orders placed before 12pm (ET) Mon-Fri will ship same day.'
          }
        } else {
          scope.shippingMessage = null;
        }
      }

      var addonTimeout = null;

      function addXSellToCart(addonItem) {
        var payload = {};
        var product = addonItem.prod;
        var easierToReadIdx = addonItem.idx + 1;

        //Track in Optimizely
        if (angular.isDefined(window.optimizely)) {
          window.optimizely.push(["trackEvent", "addToCart"]);
        }

        // Adding AddToCart event for Facebook Pixel Tracking
        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            content_name: 'Shopping Cart',
            content_ids: [product.product_type_name + ' - ' + product.name],
            content_type: 'product',
            value: '' + product.price,
            currency: 'USD'
          });
        }
        // Track in GA
        addonGAEvent(product, easierToReadIdx);
        addAddonToCookie(product, easierToReadIdx);
        // Add addon to cart
        payload = {
          product: {
            id: product.id
          },
          qty: 1,
          ctaSource: addonItem.ctaSource
        };

        if (product.validOffer) {
          payload.validOffer = product.validOffer;
        }

        //Manually remove addon on from ui array
        scope.addons.splice(addonItem.idx, 1);
        newCartSvc.addToCart(payload, function(result) {
          scope.hideBundleModal = true;
          setVarsFromResponse(result);
          loadingCartSummary = false;
          scope.$broadcast('prodAddedToBag');
        });
      }

      // Will be used on checkout in google tag
      function addAddonToCookie(product, addonIdx) {
        // Local storage is a key-value pair storage on every browser that is persistent to page reloads.
        var xSellCookie = $cookies.xSellConverted;
        var xSellConverted;
        if (xSellCookie) {
          xSellConverted = JSON.parse(xSellCookie);
        } else {
          xSellConverted = [];
        }

        xSellConverted.push([addonIdx, scope.xSellImpressionCounter, product.name, product.trackCategory, product.sku, product.id]);

        $cookies.xSellConverted = JSON.stringify(xSellConverted);
      }

      function removeItemFromCart(index) {
        if (removeItems[index]) {
          return;
        }

        removeItems[index] = true;
        newCartSvc.removeItemFromCart({ index: index }, function(result) {
          delete removeItems[index];
          scope.hideBundleModal = true;
          setVarsFromResponse(result);
          //Close edit mode
          scope.editingProd = null;
        });
      }

      function addonGAEvent(product, position) {
        var addOnClick = {
          'event': 'MRCustom',
          'category': 'cart',
          'action': 'addon click',
          'label': 'position: ' + position + ', impression: ' + scope.xSellImpressionCounter + ', product: ' + product.name + ', category: ' + product.trackCategory + ', sku: ' + product.sku
        };
        var addAddon = {
          'event': 'MRCustom',
          'category': 'cart',
          'action': 'add addon',
          'label': 'product: ' + product.id + ', index: ' + position + ', name: ' + product.name
        };

        dataLayer.push(addOnClick);
        dataLayer.push(addAddon);
      }

      function removeXSellToConvertItem(prodId) {
        var xSellCookie = $cookies.xSellConverted;
        if (xSellCookie) {
          var xSellConverted = JSON.parse(xSellCookie);
          for (var i = 0; i < xSellConverted.length; i++) {
            var row = xSellConverted[i];
            if (row[xsellKeys.indexOf('productId')] == prodId) {
              xSellConverted.splice(i, 1);
            }
          }

          $cookies.xSellConverted = JSON.stringify(xSellConverted);
        }
      }

      function addonImpressionGAEvent() {
        if (scope.addons && scope.addons.length) {
          var gaEvent = {
            'event': 'MRCustom',
            'category': 'cart',
            'action': 'addons impression',
            'label': getAddonsSnapshot()
          };
          dataLayer.push(gaEvent);
        }
      }

      function getAddonsSnapshot() {
        var addonString = '';
        var addons = scope.addons;
        var loopLength = addons.length > 4 ? 4 : addons.length;

        for (var i = 0; i < loopLength; i++) {
          addonString = i == 0 ? addonString.concat('impression ' + scope.xSellImpressionCounter + ': [') : addonString;
          addonString = addonString.concat('{position: ' + (i + 1) + ', product: ' + addons[i].name + ', category: ' + addons[i].trackCategory + ', sku: ' + addons[i].code + '}, ');
          addonString = i == 3 ? addonString.substr(0, addonString.length - 2).concat(']') : addonString;
        }
        return addonString;
      }

      scope.blurPromo = function() {
        if (!scope.coupon || !scope.coupon.length) {
          scope.showCouponInput = false;
        }
      };

      function applyCoupon() {
        var params = { code: scope.coupon.toUpperCase() };
        scope.promoError = '';
        newCartSvc.applyCoupon(params, function(result) {
          scope.showCouponInput = false;
          scope.coupon = '';
          //- removing bundle to avoid bundle upsell display after adding coupon
          result.bundle = null;
          //- setPromoMessage needs to be above setVarsFromResponse because it uses the previous value in scope.cost (winston)
          setPromoMessage(result, params.code);
          //- setVarsFromResponse updates scope.cost
          setVarsFromResponse(result);
        }, function(err) {
          scope.coupon = '';
          scope.showCouponMessage = true;
          scope.showCouponInput = true;
          if (angular.isArray(err.data)) {
            scope.promoError = err.data[0];
            return;
          }
          scope.promoError = err.data.message;
        });
      }

      function removeCoupon(id) {
        scope.removePromoId = id;
        scope.$parent.promoRemoveModal.open();
      }

      scope.$parent.$on('promoRemove', function() {
        var payload = {
          id: scope.removePromoId
        };

        newCartSvc.removeCoupon(payload, function(result) {
          //- removing bundle to avoid bundle upsell display after removing coupon
          result.bundle = null;
          setVarsFromResponse(result);
          scope.showCouponMessage = false;
        });
      });

      function editProduct(index) {
        if (index === scope.editingProd) {
          scope.editingProd = null;
        } else {
          scope.editingProd = index;
        }
      }

      scope.isBatchEdited = function(index) {
        return scope.batchEditProducts.indexOf(index) != -1 ? true : false;
      };

      scope.editOneTimeProducts = function() {
        if (scope.batchEditProducts.length > 0) {
          return;
        }

        scope.cartItems.forEach(function(item, index) {
          if (item.subscription == 0 && item.product_type_sub_frequencies && item.product_type_sub_frequencies != "" && !item.isExtraTube) {
            scope.batchEditProducts.push(index);
          }
        });

        trackerSvc.trackEvent('Cart Auto Delivery Batch Edit');
      };

      scope.popFromBatchEdit = function(index) {
        if (index === scope.editingProd) {
          scope.editingProd = null;
          return;
        }

        var i = scope.batchEditProducts.indexOf(index);
        scope.batchEditProducts.splice(i, 1);
      };

      function updateSubFreq(index, subscription) {
        var payload = {
          index: index,
          subscription: subscription
        };

        if (scope.isBatchEdited(index)) {
          payload.ctaSource = 'subscribeToSave';
        }

        newCartSvc.updateItemSubscription(payload, function(result) {
          scope.hideBundleModal = true;
          setVarsFromResponse(result);
        });
      }

      function updateProdQty(index, qty) {
        if (qty < 1 || qty > 10) {
          return;
        }

        var payload = {
          index: index,
          qty: qty,
          ctaSource: 'cart-edit-qty'
        };

        if (scope.isBatchEdited(index)) {
          payload.ctaSource = 'subscribeToSave';
        }

        newCartSvc.updateItemQty(payload, setVarsFromResponse);
      }

      setSelectedShipMethod();

      function setVarsFromResponse(result) {
        if (result.addonsByContext) {
          scope.addonsByContext = result.addonsByContext;
        }
        
        if (result.addons) {
          //always evaluate the properties on result as we dont alwas re-eval addons/bundles from every result body that comes from a cart action and we dont want to override directive globals;
          scope.addons = result.addons;
          Array.prototype.push.apply(scope.upsellModalProducts, scope.addons.filter((function(addon) {
            return !!addon.validOffer;
          })));

          // The following is a hack to get root reboot to take over exclusive control of the modal when RTU is in the cart
          var hasRTU = (result.items || []).filter(function(item) {
            return item.product_type == 'root_touch_up';
          }).length > 0;

          if (hasRTU) {
            var rrbIndex = 0;
            var rrbTakeOver = false;
            scope.upsellModalProducts.forEach(function(addon, index) {
              if (addon.productType == 'root_reboot') {
                rrbIndex = index;
                rrbTakeOver = true;
                scope.upsellModalProducts[index].takeover = true;
              }
            });
          }

          if (rrbTakeOver && hasRTU) {
            var firstProduct = angular.copy(scope.upsellModalProducts[0]);
            scope.upsellModalProducts[0] = angular.copy(scope.upsellModalProducts[rrbIndex]);
            scope.upsellModalProducts[rrbIndex] = firstProduct;
          }

          var broadcastData = { upsellModalProducts: scope.upsellModalProducts };
          scope.$broadcast('upsellProductsUpdated', broadcastData);
          addonImpressionGAEvent();
          scope.xSellImpressionCounter++;
        }

        if (result.shippingMethods) {
          scope.shippingMethods.all = [];
          var previousShippingMethod = scope.shippingMethods.selected;
          scope.shippingMethods.all = result.shippingMethods.methods;
          scope.shippingMethods.selected = result.shippingMethods.selected;
          setSelectedShipMethod();

          if (previousShippingMethod && scope.shippingMethods.selected && scope.shippingMethods.selected.id != previousShippingMethod.id) {
            // check for equivalent shipping method
            var replacementMethod = {};
            scope.shippingMethods.all.forEach(function(method) {
              if (method.start == previousShippingMethod.start && method.end == previousShippingMethod.end) {
                replacementMethod = method;
              }
            });

            // check for one day shipping downgrade for PO Boxes
            if (previousShippingMethod.start == 1 && previousShippingMethod.end == 1) {
              scope.shippingMethods.all.forEach(function(method) {
                if (method.start < replacementMethod.start) {
                  replacementMethod = method;
                }
                if (method.end < replacementMethod.end) {
                  replacementMethod = method;
                }
              });
              scope.shippingMethods.selected = replacementMethod;
              scope.$parent.shippingMethodChangeModal.previousShippingMethod = previousShippingMethod;
              scope.$parent.shippingMethodChangeModal.replacementMethod = replacementMethod;
              scope.$parent.shippingMethodChangeModal.open();
            }

            setShippingMethod();
          }
        }

        if (result.items) {
          scope.cartItems = result.items;

          if (result.currentUpsellAddon) {
            setCartCurrentUpsellItem(result.currentUpsellAddon, result.items);
          }
          scope.$parent.showSubAgreement = scope.cartItems.some(function(item) {
            return item.subscription > 0 && !item.subscription_id;
          });
          scope.shippingRequired = scope.cartItems.some(function(item) {
            //- if cart contains anything else besides gift card shipping is required
            return !item.giftCard;
          });
          scope.$parent.subscriptionConsent = !scope.$parent.showSubAgreement;
          scope.oneTimeItemSubscribableExists = scope.cartItems.some(function(item) {
            if (item.subscription == 0 && item.product_type_sub_frequencies && item.product_type_sub_frequencies != "" && !item.isExtraTube) {
              return true;
            }
          });
        }

        if (result.totals) {
          var totals = result.totals;
          var appliedPromos = angular.copy(totals.appliedPromos);
          totals.discounts = promoSvc.extractDiscounts(appliedPromos, scope.shippingMethods.selected);
          scope.cost = totals;
          scope.freeItemsMap = scope.cost.freeItemsMap;
        }

        if (result.refillCart) {
          scope.refillCart = result.refillCart;
        }
      }

      function setCartCurrentUpsellItem(currentUpsellAddon, items) {
        currentUpsellAddon = currentUpsellAddon || null;

        // Empty cart flag used to delay show of auto-modal when adding first item
        if (!items.length) {
          scope.emptyCartFlag = true;
        }

        // If there is no bundle available or user has already added a bundle, then return and not show modal
        if (!currentUpsellAddon || $cookies.bundleAdded) {
          return;
        }

        scope.quickLookProduct = currentUpsellAddon.product;
        scope.upsellPromo = currentUpsellAddon.promotion;
        scope.modalVersion = 'upSell';

        if (scope.emptyCartFlag) {
          setTimeout(function() {
            scope.quickLookVisible = true; //launches modal
            scope.$apply();
          }, 1500);
          scope.emptyCartFlag = false;
        } else {
          // Only show modal on load and when cart is empty
          if (scope.hideBundleModal) {
            scope.hideBundleModal = false;
            return;
          }
        }

        if ($cookies.bundlesViewed) {
          scope.bundlesCookie = angular.fromJson($cookies.bundlesViewed);
        }

        scope.bundlesCookie.push(scope.quickLookProduct.code);
        scope.bundlesCookie = angular.toJson(scope.bundlesCookie);
        scope.$parent.setCookie('bundlesViewed', scope.bundlesCookie, 2);
      }

      // Message to user why a promo was/wasn't applied
      function setPromoMessage(result, code) {
        var totals = result.totals;
        var appliedPromos = {};
        var promosDropped = [];
        var isFreeShipping = false;
        var promoTxt = 'Promotions cannot be combined. We\'ve applied the discount with highest savings for you.';
        code = code || '';

        //Was the promo just submitted applied?
        var lastPromoApplied = totals.appliedPromos.filter(function(item) {
          return item.code && item.code.toUpperCase() === code.toUpperCase();
        }).length;

        var giftCard = result.giftCard || [];

        var giftCardApplied = giftCard.indexOf(code.toUpperCase()) >= 0;

        // Create new applied promo hash
        totals.appliedPromos.forEach(function(promo) {
          appliedPromos[promo.id] = true;
          isFreeShipping = !!promo.offers.filter(function(offer) {
            return offer.type && offer.type === 'freeShipping';
          }).length;
        });

        // Compare old applied promos with new promo applied hash and look for any dropped promos
        scope.cost.appliedPromos.forEach(function(promo) {
          if (!appliedPromos[promo.id]) {
            promosDropped.push(promo);
          }
        });

        if (giftCardApplied) {
          scope.showCouponMessage = true;
        }

        // If last promo/gift card not applied or any existing promos have been dropped
        if ((!lastPromoApplied && !giftCardApplied) || promosDropped.length) {
          scope.showCouponMessage = true;
          // In some cases, ex. site wide free two day shipping can be overridden by another shipping promo for $0
          // therefore we do not show them any messaging for now
          scope.promoError = isFreeShipping ? '' : promoTxt;
        }
      }

      scope.$on('showQuickLookEvent', function(event, data) {
        scope.modalVersion = data.validOffer ? 'upSell' : 'quickLook';
        scope.quickLookVisible = true;
        scope.quickLookProduct = data.prod;
        scope.quickLookProductIndex = data.index;
      });

      // CATCHES CLOSE EVENT FROM MRQUICKLOOK TO CLOSE THE MODAL
      scope.$on('hideQuickLookEvent', function(event) {
        scope.quickLookVisible = false;
        scope.modalVersion = null;
      });

      // CATCHES EVENT TO ADD UPSELL PRODUCT TO CART
      scope.$on('addUpSelledProdToCart', function(event, data) {
        var payload = {
          product: {
            id: data.prod.id
          },
          qty: 1,
          ctaSource: data.ctaSource
        };

        if (data.prod.validOffer) {
          payload.validOffer = data.prod.validOffer;
        }

        newCartSvc.addToCart(payload, function(result) {
          scope.quickLookVisible = false;
          scope.upsellModalProducts = []; // closes upsell modal
          scope.$broadcast('upSellProdAdded');
          scope.$parent.setCookie('bundleAdded', 'true', 2);
          scope.hideBundleModal = true;
          setVarsFromResponse(result);
        }, function(err) {
          var errMsg = err.data.message || angular.isArray(err.data) ? err.data[0] : 'Sorry, something went wrong';
          scope.notify('error', errMsg);
        });
      });

      scope.addBundleBuilderToCart = function(items) {
        newCartSvc.addMultipleItemsToCart({items: items}, function(res) {
          setVarsFromResponse(res);
          newCartSvc.applyCoupons({ codes: ['15_BUNDLE', '20_BUNDLE', '25_BUNDLE'], ignorePromoErrors: true }, function(res) {
            setVarsFromResponse(res);
          });
        });
      }
    }
  };
}])
.
directive('mrCartTimer', ['$interval', 'dateFilter', function($interval, dateFilter) {
  // This directive takes two attributes: time to the countdown and a
  // callback that should be executed when timer is finished
  function link(scope, element, attrs) {
    var timeOutRange;
    var timer;
    var timerDate;
    var counter;
    scope.twoMinsLeft = false;

    scope.$watch('reservedTime', function(value) {
      timer = value;
      $interval.cancel(counter);
      timeOutRange = new Date(timer) - new Date();

      counter = $interval(function() {
        if (timer && timeOutRange > 1000) {
          updateTimer();
        } else {
          $interval.cancel(counter);
          scope.timerCallback();
        }
      }, 1000);
    });

    scope.cancel = function() {
      $interval.cancel(counter);
    };

    function updateTimer() {
      timeOutRange = new Date(timer) - new Date();
      if (timeOutRange < 120 * 1000) {
        scope.twoMinsLeft = true;
      }

      timerDate = new Date(timeOutRange);
      scope.timeLeft = dateFilter(timerDate, 'mm:ss');
    }

    element.on('$destroy', function() {
      $interval.cancel(counter);
    });
  }

  return {
    template: '<div class="mr-cart-timer">' +
    '<span>Expires in:&nbsp;</span>' +
    '<span ng-class="{redTimer: twoMinsLeft }">{{timeLeft}}</span>' +
    '</div>',
    link: link,
    replace: true,
    scope: {
      timerCallback: '=',
      reservedTime: '=',
      cancel: '='
    }
  };
}]).
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrConfirmationBtns', [function() {
    return {
      restrict: 'E',
      templateUrl: '/ngpartials/directives/mr-confirmation-btns',
      scope: {
        btnSaveText: '@?',
        btnSaveDisabledFlag: '=?',
        btnSaveMethod: '&',
        btnCancelText: '@?',
        btnCancelDisabledFlag: '=?',
        btnCancelShowFlag: '=?',
        btnCancelMethod: '&',
        leftAlign: '@'
      },
      link: function(scope) {
        // Always show cancel button by default
        scope.btnCancelText = scope.btnCancelText ? scope.btnCancelText : 'Nevermind';
        scope.btnSaveText = scope.btnSaveText ? scope.btnSaveText : 'Save Changes';
        scope.btnCancelShowFlag = angular.isUndefined(scope.btnCancelShowFlag) ? true : scope.btnCancelShowFlag;
        scope.hideKeyboard = function() {
          var textField = document.activeElement;
          textField.blur();
        }
      }
   };
}])
.
/*
When in my account editing a sub this directive is the left navigation that
displays the product and savings
 */
directive('mrCreditCardInputs', ['mrNgUtils', 'paymentProfileSvc', function(mrNgUtils, paymentProfileSvc) {
    return {
      restrict: 'E',
      templateUrl: '/ngpartials/directives/mr-credit-card-inputs-v2',
      scope: {
        billingForm: '=',
        billing: '=',
        blur: '=?',
        shippingAddress: '=',
        forBooking: '@',
        cdata: '=?'
      },
      link: function(scope) {
        scope.paymentProfileSvc = paymentProfileSvc;
        scope.blur = scope.blur || angular.noop;
        scope.ccType = 'default';
        scope.ccCvLength = ccTypes.default.cvc;
        scope.ccLength = ccTypes.default.formSize;
        scope.ccMask = ccTypes.default.mask;
        scope.cvvRegex = new RegExp('[0-9]{' + ccTypes.default.cvc + '}');
        scope.ccStandInType = 'Credit Card';
        scope.ccStandIn = '************0000';
        paymentProfileSvc.billingForm = scope.billingForm;

        // Prevent scope.billing from becoming undefined on page reload.
        if (!scope.billing) {
          scope.billing = paymentProfileSvc.profileInEdit;
        }

        scope.now = new Date(Date.now());
        scope.cc_months = [];
        scope.cc_years = [];
        var currYear = scope.now.getFullYear();
        var lastCCNumber = undefined;

        for(var i = 1; i < 13; i++) {
          var m = {};
          m.val = i;
          m.key = i < 10 ? '0' + i : i.toString();
          scope.cc_months.push(m);
        }

        for(var y = currYear; y < currYear + 20; y++) {
          scope.cc_years.push(y);
        }

        if (!scope.shippingAddress || !scope.shippingAddress.id) {
          scope.billing.same_as_shipping = false;
        }

        scope.checkCard = function($event) {
          var num = scope.billing.cc_number;
          var key, test;
          if ($event && mrNgUtils.specialKey($event)) {
            return;
          }

          if (num == lastCCNumber) {
            scope.ccCvLength = ccTypes.default.cvc;
            scope.ccLength = ccTypes.default.formSize;
            scope.ccMask = ccTypes.default.mask;
            return;
          }
          
          if (num) {
            for (key in ccTypes) {
              if (ccTypes[key].regex.test(num)) {
                scope.ccType = key;
                scope.ccCvLength = ccTypes[key].cvc;
                scope.cvvRegex = new RegExp('[0-9]{' + scope.ccCvLength + '}');
                scope.ccLength = ccTypes[key].formSize;
                scope.ccMask = ccTypes[key].mask;
                scope.cvcMask = ccTypes[key].cvcMask;

                var valid = num.replace(/\D/g, '').length == ccTypes[key].size && mod10Check(num);
                scope.billingForm.cardNumber.$setValidity('cardNumber', valid);
                if (valid) {
                  scope.blur();
                }
                lastCCNumber = num;
                return;
              }
            }
          } else {
            scope.ccType = 'default';
            scope.ccCvLength = ccTypes.default.cvc;
            scope.ccLength = ccTypes.default.formSize;
            scope.ccMask = ccTypes.default.mask;
            lastCCNumber = num;
          }
        };

        scope.checkMonthYear = function($event) {
          if ($event && mrNgUtils.specialKey($event)) {
            return;
          }
          var validMonth = true;
          var currentMonth = scope.now.getMonth() + 1;
          var currentYear = scope.now.getFullYear();

          if (scope.billing.cc_exp_year === currentYear) {
            validMonth = false;
            if (scope.billing.cc_exp_month >= currentMonth) {
              validMonth = true;
            }
          }
          scope.billingForm.ccmonth.$setValidity('ccmonth', validMonth);
        };
      }
   };
}])
.
// As many as all sections can be opened at a time
directive('mrDropdown', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    require: 'ngModel',
    template: '<div class="mr-dropdown" ng-class="{open: open}">' +
    '<div class="selected-item", ng-click="toggleDropDown()">' +
    '{{selectedHeader}}<span class="arrow" ng-class="{\'icon-caret-down\': !open, \'icon-caret-up\': open}"></span>' +
    '</div>' +
    '<div class="mr-dropdown-items" ng-show="open" ng-transclude></div>' +
    '</div>',
    scope: {
      ngModel: '=',
      defaultHeader: '@'
    },
    controller: function($scope) {
      $scope.selectedHeader = $scope.defaultHeader;
      $scope.dropDowns = this.dropDowns = {};
      $scope.open = false;

      $scope.toggleDropDown = function() {
        $scope.open = !$scope.open;
        if ($scope.open) {
          $scope.selectedHeader = $scope.defaultHeader;
        }
      };

      this.changeModel = function(header) {
        var dropDown = $scope.dropDowns[header];
        dropDown.selected = true;
        $scope.selectedHeader = dropDown.header;
        $scope.ngModel = dropDown.value;
        $scope.open = false;
      };

      this.addItem = function(header, value, element) {
        $scope.dropDowns[header] = {
          element: element,
          value: value,
          header: header,
          selected: false
        };
      };
    }
  };
}).
/*
This directive handles the email gate that appears in the hair-color recommendation page to new customers.
 */
directive('mrEmailGate', ['customerSvc', function(customerSvc) {
  return {
    templateUrl: '/ngpartials/directives/mr-email-gate',
    replace: true,
    restrict: 'E',
    link: function(scope, element, attrs) {
      //////////////////////////////////
      // Initialization
      //////////////////////////////////
      scope.email = "";

      //////////////////////////////////
      // Scope variables
      //////////////////////////////////
      scope.hideGate = function() {
        var noOp = function() {};
        element.hide();
        customerSvc.disableEmailGate({}, noOp);
      };

      scope.addEmail = function() {
        var params = {
          email: scope.email,
          source: 'quiz_email_gate'
        };

        customerSvc.createCustomer(params, function() {
          element.hide();
        });
      };
    }
  };
}]).
/*
This directive needs to be in a container
For example:
.sm-hide.md-hide.lg-hide
    !{components.fixedCtaScroll}
 */
directive('mrFixedSection', [function() {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-fixed-section',
    transclude: true,
    scope: {
      extraOffset: '@',
      useScreenTop: '@'
    },
    link: function(scope, element, attrs) {
      var stopElement = $('.stop-element');
      var fixedElement = $('.fixed-element');
      //Add extra offset to prevent scroll from passing element on mobile device
      var windowScrollTop = null;
      var windowBottom = null;
      var windowHeight = $(window).height();
      var elementTop = stopElement.offset().top - scope.extraOffset;
      var useTop = scope.useScreenTop || false;

      // Default to fixed
      scope.isFixed = true;

      // Add scroll event listener
      $(window).scroll(function() {
        windowHeight = $(window).height();
        elementTop = stopElement.offset().top - scope.extraOffset;
        scope.extraOffset = +scope.extraOffset ? +scope.extraOffset : 0;
        windowScrollTop = $(this).scrollTop() + fixedElement.outerHeight();
        windowBottom = windowScrollTop;
        if (!useTop) {
          windowBottom = windowBottom + windowHeight;
        }

        var fixIt = !(windowBottom > elementTop);

        if (fixIt === scope.isFixed) {
          return;
        }

        if (fixIt) {
          scope.$apply(function() {
            scope.isFixed = true;
          });
        } else {
          scope.$apply(function() {
            scope.isFixed = false;
          });
        }
      });
    }
  };
}])
.
/*
* Example:
* *.jade
*   mr-fixed-wrap(fixed-class='fixed' stop-class='stopped' stop-at-element-selector='footer')
*     .the-element-to-be-fixed
*   
* *.styl
*   mr-fixed-wrap
*     &.fixed
*       .the-element-to-be-fixed
*         position fixed
*         top 0
*         left 0
*         right 0
*/

directive('mrFixedWrap', [function() {
  return {
    restrict: 'EA',
    scope: {
      fixedClass: '@', // class to be applied when the element should become fixed
      stopClass: '@', // class to be applied when the element stops
      stopAtElementSelector: '@', // selector for the element to stop at
      useScreenBottom: '=' // when true, the fixedClass will be applied based on the bottom of the element and window
    },
    link: function(scope, element, attrs) {
      var isFixed = false;
      var isStopped = false;

      scope.$on('windowScroll', function(event, windowData) {
        fixIt(windowData.scrollTop, windowData.scrollBottom);
      });

      function fixIt(windowScrollTop, windowScrollBottom) {
        var elementTop = element.offset().top;

        if (scope.useScreenBottom) {
          var elementBottom = elementTop + element.height();
          
          if (elementBottom <= windowScrollBottom && !isFixed) {
            isFixed = true;
            element.addClass(scope.fixedClass);
          } else if (elementBottom > windowScrollBottom && isFixed) {
            isFixed = false;
            element.removeClass(scope.fixedClass);
          }
        } else {
          if (elementTop <= windowScrollTop && !isFixed) {
            isFixed = true;
            element.addClass(scope.fixedClass);
          } else if (elementTop > windowScrollTop && isFixed) {
            isFixed = false;
            element.removeClass(scope.fixedClass);
          }
        }

        if (scope.stopAtElementSelector) {
          var stopAtHeight = $(scope.stopAtElementSelector).offset().top - $(window).height();

          if (stopAtHeight > 0 && windowScrollTop >= stopAtHeight && !isStopped) {
            isStopped = true;
            element.addClass(scope.stopClass);
          } else if (stopAtHeight > 0 && windowScrollTop < stopAtHeight && isStopped) {
            isStopped = false;
            element.removeClass(scope.stopClass);
          }
        }
      }
    }
  };
}])
.
directive('mrIframeModal', ['$sce', function($sce) {
  return {
    restrict: 'AE',
    scope: {
      url: '@',
      show: '=?'
    },
    templateUrl: '/ngpartials/directives/mr-iframe-modal',
    link: function(scope, element, attrs) {
      scope.iframeModal = {
        show: scope.show
      };

      scope.trustedUrl = $sce.trustAsResourceUrl(scope.url);
    }
  };
}])
.
directive('mrInputCalendarDate', ['$parse', function($parse) {
  return {
    replace: true,
    require: '?ngModel',
    restrict: 'E',
    template: '<div class="mr-input-calendar-date">' +
                '<input type="text" ui-date="dateOptions" ng-model="ngModel" ng-change="onChangeMethod" />' +
                '<div class="calendar" ng-click="showDatePicker()">' +
                  '<i class="icon-calendar xs-font-xgrande" />' +
                '</div>' +
              '</div>',
    scope: {
      uiDate: '=',
      onChangeMethod: '=',
      ngModel: '=',
      dateOptions: '='
    },
    link: function(scope, elem, attrs, ctrl) {
      scope.showDatePicker = function() {
        angular.element(elem).datepicker('show');
      }

    }
  };
}]).
/*
 Validate two inputs where both values should match
 */
directive('mrInputMatch', ['$parse', function($parse) {
  return {
    require: '?ngModel',
    restrict: 'A',
    link: function(scope, elem, attrs, ctrl) {

      var matchGetter = $parse(attrs.mrInputMatch);
      var caselessGetter = $parse(attrs.matchCaseless);

      scope.$watch(getMatchValue, function(){
        ctrl.$$parseAndValidate();
      });

      ctrl.$validators.match = function(){
        var match = getMatchValue();
        if(caselessGetter(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)){
          return ctrl.$viewValue.toLowerCase() === match.toLowerCase();
        }
        return ctrl.$viewValue === match;
      };

      function getMatchValue(){
        var match = matchGetter(scope);
        if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
          match = match.$viewValue;
        }
        return match;
      }
    }
  };
}]).
directive('mrLoader', function() {
  return {
    restrict: 'E',
    replace: true,
    template: '<div ng-show="loading", class="mrloader-container">' +
    '<img src="/images/ajax-loader.gif"/>' +
    '</div>',
    scope: {
      loading: '='
    }
  }
}).
//- remove after mr-mask is removed from cms templates and replaced with ui-mask
directive('mrMask', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      attrs.$observe('usemask', applyMask);

      var stop = scope.$watch(function() {
        return ngModel.$modelValue;
      }, function(val) {
        if (val) {
          $timeout(function() {
            element.keyup();
            element.mask(attrs.usemask);
          }, 0);
        }
      });

      applyMask();
      function applyMask() {
        element.mask(attrs.usemask);
      }
    }
  };
}]).
/**
* @module mrMultiVideo
* @moduleType angular directive
* @desc This is an angular directive that uses video.js to play videos, with support for pause, play, fullscreen, and changing the video being played.<br>
*       Example .jade:
* ```
* .video-player-wrap(ng-init="myPlayer = { video: { title: 'initialVideoTitle', description: 'initialVideoDescription', code: 'initialVideoCode' }, autoplay: true, aspectRatio: 9/16 }")
*   video(mr-multi-video control="myPlayer" player-id="myPlayerId" id="myPlayerId")
*
* .example-controls(ng-click="myPlayer.playing ? myPlayer.pause() : myPlayer.play()")
* 
* .example-change-video(ng-click="myPlayer.changeVideo('newVideoTitle', 'newVideoDescription', 'newVideoCode')")
* ```
*/

directive('mrMultiVideo', ['$rootScope', 'trackerSvc', function($rootScope, trackerSvc) {
  return {
    restrict: 'A',
    scope: {
      control: '=',
      playerId: '@'
    }, link: function(scope, element, attrs) {
      $rootScope.mrVideoJsPlayers = $rootScope.mrVideoJsPlayers || [];
      $rootScope.autoPause = false;
      scope.control = scope.control || {}; // the control object lets you control the player from outside this directive
      scope.control.video = scope.control.video || {}; // the video to play
      scope.control.playing = scope.control.playing || false; // true when the video is playing
      scope.control.autoplay = scope.control.autoplay || false; // autoplay the video when ready
      scope.control.fullscreenMode = scope.control.fullscreenMode || false; // plays the video when requesting fullscreen, and pauses when leaving fullscreen
      scope.control.open = scope.control.open || false; // used for open and closed styles
      scope.control.ready = scope.control.ready || false; // true when the player is ready
      var aspectRatio = scope.control.aspectRatio || 9/16;
      var playerId = scope.playerId;
      var playerSource = 'https://www.youtube.com/watch?v=' + scope.control.video.code;

      var player = videojs(playerId, {
        controls: true,
        autoplay: false,
        techOrder: ["youtube", "html5", "flash"],
        sources: [
          {
            type: "video/youtube",
            src: playerSource
          }
        ],
        youtube: {
          "modestbranding": 1
        }
      }, function() {
        //the video ready calback;
        var self = this;

        //init google analytics with all tracking options
        self.ga();

        // setup controls

        scope.control.play = function(open) {
          if (open) {
            scope.control.open = true;
          }
          player.play();
        };

        scope.control.pause = function(close) {
          if (close) {
            scope.control.open = false;
          }
          player.pause();
        };

        scope.control.requestFullscreen = function() {
          player.requestFullscreen();
          if (scope.control.fullscreenMode) {
            player.play();
          }
        }

        scope.control.changeVideo = function(title, description, code, open) {
          scope.control.video.title = title;
          scope.control.video.description = description;
          scope.control.video.code = code;
          playerSource =  'https://www.youtube.com/watch?v=' + code;

          if (open) {
            scope.control.open = true;
          }

          var newSrc = [{
            type: 'video/youtube',
            src: playerSource
          }];

          player.src(newSrc);
          player.play();
        };

        $(function() {
          // set up event handling

          self.on('play', function(e) {
            $rootScope.mrVideoJsPlayers.forEach(function(p) {
              if (p.id_ == playerId) {
                return;
              }

              if (p.paused()) {
                return;
              }

              $rootScope.autoPause = true;
              p.pause();
              $rootScope.autoPause = false;
            });


            if (!scope.control.autoplay) {
              trackerSvc.trackEvent('Video Played',
                {
                  videoTitle: scope.control.video.title,
                  videoSrc: playerSource
                }
              );
            }
            
            scope.control.playing = true;
            scope.control.autoplay = false;
            scope.$apply();
          });

          self.on('fullscreenchange', function(e) {
            if (!self.isFullscreen()) {
              scope.control.isFullscreen = false;
              scope.$apply();

              if (scope.control.fullscreenMode) {
                player.pause();
              }

              return;
            }
            scope.control.isFullscreen = true;
            scope.$apply();

            if (!scope.control.fullscreenMode) {
              trackerSvc.trackEvent('Video Fullscreen',
                {
                  videoTitle: scope.control.video.title,
                  videoSrc: playerSource
                }
              );
            }
          });

          self.on('pause', function(e) {
            if ($rootScope.autoPause) {
              // dont fire pause events when auto-pausing the video for the user (when multiple videos are playing)
              $rootScope.autoPause = false;
              scope.control.playing = false;
              return;
            }
            scope.control.playing = false;
            if (scope.control.fullscreenMode && player.isFullscreen()) {
              player.exitFullscreen();
              scope.control.isFullscreen = false;
            }
            scope.$apply();
            var pausedDuration = self.currentTime();
            var videoDuration = self.duration();

            trackerSvc.trackEvent('Video Paused',
              {
                videoTitle: scope.control.video.title,
                videoSrc: playerSource,
                videoPausedAt: +pausedDuration.toFixed(2),
                videoPercentWatched: +((pausedDuration/videoDuration) * 100).toFixed(2)
              }
            );
          });

          self.on('ended', function(e) {
            scope.control.playing = false;
            scope.$apply();
            trackerSvc.trackEvent('Video Completed',
              {
                videoTitle: scope.videoTitle,
                videoSrc: scope.playerSrc
              }
            );
          });

          self.on('error', function(e) {
            console.log('mr-video-js error:', e);
          });

          player.ready(function() {
            scope.control.ready = true;
            scope.$apply();

            // autoplay handling
            if (scope.control.autoplay) {
              player.play();
              scope.control.playing = true;
              scope.$apply();
            }
          });
        });

        resizeVideo(player);
        $rootScope.mrVideoJsPlayers.push(player);

        function resizeVideo(player) {
          var width = document.getElementById(player.id()).parentElement.offsetWidth;
          player.width(width).height( width * aspectRatio );
        }

        if (!window.onresize) {
          //only assign this once as there can be multiple videos per page
          function resizeVideos() {
            $rootScope.mrVideoJsPlayers.forEach(function(player) {
             resizeVideo(player);
            });
          }

          window.onresize = resizeVideos;
        }
      });
    }
  }
}])
.
directive('mrNewsletterSubscription', ['customerSvc', function(customerSvc) {
  //- keeping this directive since its used in cms in various places
  //- this allows it to keep the same template accross all of them. logic currently resides in customerSvc
  return {
    templateUrl: '/ngpartials/directives/mr-newsletter-subscription',
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      source: '@',
      listId: '@',
      buttonText: '@'
    },
    link: function(scope, element, attr) {
      scope.customerSvc = customerSvc;
    }
  };
}])
.
directive('mrOrderSummary', ['promoSvc', 'cdata', function(promoSvc, cdata) {
  return {
    templateUrl:  '/ngpartials/directives/mr-order-summary',
    restrict: 'E',
    scope: {
      summary: '='
    },
    link: function(scope, elem, attrs) {
      scope.cdata = cdata;
      scope.appliedPromos = promoSvc.extractDiscounts(scope.summary.promos);
    }
  }
}])
.
directive('mrPaymentList', ['paymentProfileSvc', 'notifySvc', function(paymentProfileSvc, notifySvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-payment-list',
    scope: {
      saveCallback: '=?',
      billingForm: '=?', //- used in checkout.js
      editUrl:'@',
      forBooking: '@',
      cdata: '=?'
    },
    link: function(scope) {
      function defaultSaveCallback(msg) {
        notifySvc.notify('success', msg);
      }
      scope.saveCallback ? scope.saveCallback : defaultSaveCallback;
      scope.paymentProfileSvc = paymentProfileSvc;
    }
  };
}]).
//- format phone nr from config.support.contact.phone ( 0-000-000-0000 to 0.000.000.0000 )

directive('mrPhone', [function() {
  return {
    restrict: 'A',
    template: '<span>{{ formatedPhone }}</span>',
    scope: {
      phone: '@'
    },
    link: function(scope, element, attrs, ngModel) {
      scope.formatedPhone = scope.phone.toString().replace(/-/g, '.');
    }
  }
}])
.
directive('mrPrice', ['productCatalogSvc', function(productCatalogSvc) {
  function link(scope, element, attrs) {
    productCatalogSvc.getProductPrices({ id: scope.productId }, function(prices) {
      var price = scope.subPrice && prices.subPrice ? prices.subPrice : prices.price;
      element.append(' $' + price);
    });
  }
  return {
    link: link,
    restrict: 'A',
    scope: {
      productId: '@',
      subPrice: '@'
    }
  };
}]).
directive('mrPromos', ['promoSvc', 'cdata', function(promoSvc, cdata) {
  return {
    templateUrl: function(tElement, tAttrs) {
      var tempUrl = '/ngpartials/directives/mr-promos';
      if (tAttrs.version == 2) {
        tempUrl = '/ngpartials/directives/mr-promos-v2';
      }
      return tempUrl;
    },
    restrict: 'E',
    scope: {
      promos: '=',
      removeCoupon: '=?'
    },
    link: function(scope, elem, attrs) {
      scope.cdata = cdata;
      scope.inCheckout = ~window.location.pathname.indexOf('/checkout');
    }
  }
}])
.
/*
This directive handles the quick look modal that displays additional information for the x-sell items
 */
directive('mrQuickLook', ['$timeout', '$anchorScroll', 'newCartSvc', function($timeout, $anchorScroll, newCartSvc) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr-quick-look',
    scope: {
      product: '=',
      promo: '=',
      ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
      addToBag: '=?',
      isMobile: '=',
      context: '=?',
      index: '=?',
      modalVersion: '=?',
      secondSection: '=?',
      addToString: '@?'
    },
    link: function(scope, element, attrs) {
      scope.addToString = scope.addToString || 'add to bag';
      scope.hideQuickLookByClickingOnX = function() {
        scope.$emit('hideQuickLookEvent');
      };

      scope.hideQuickLookByClickingOnVeil = function($event) {
        if ($event.target.id == 'quick-look-veil') {
          scope.$emit('hideQuickLookEvent');
        }
      };

      scope.$watch('product', function(newProduct) {
        scope.showMedia = false;
        scope.showCarousel = false;

        if (newProduct && newProduct.imagery) {
          if (newProduct.imagery.pdpCarousel && newProduct.imagery.pdpCarousel.length >= 1) {
            scope.showCarousel = true;
          }

          scope.prod = newProduct;

          if (!scope.addToBag) {
            scope.addToBag = function() {
              var product = scope.prod;
              // Add addon to cart
              var payload = {
                product: {
                  id: product.id
                },
                qty: 1,
                ctaSource: {
                  name: formatSourceName(scope.ctaSource)
                }
              };

              if (scope.prod.validOffer) {
                payload.validOffer = scope.prod.validOffer;
              }
              
              newCartSvc.addToCart(payload, function(){
                window.location.href = "/cart";
              });
            };
          }

          // This timeout is required due to a race condition bug happening in Safari.
          $timeout(function() {
            scope.showMedia = true;
          }, 75);
        }
      });

      // ADDS CROSS-SELL PRODUCT TO CART
      scope.addProdToBag = function() {
        if (scope.avoidCrossSellDoubleClick) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        scope.avoidCrossSellDoubleClick = true;
        var context = scope.context || {};
        var payload = {
          prod: scope.prod,
          context: context,
          idx: scope.index,
          ctaSource: {
            name: formatSourceName(scope.ctaSource),
            index: scope.index
          }
        };

        if (scope.prod.validOffer) {
          payload.validOffer = scope.prod.validOffer;
        }

        scope.addToBag(payload, context);
        scope.$emit('hideQuickLookEvent');
        $anchorScroll('#quick-look-veil');
      };

      // ADDS UPSELL PRODUCT TO CART
      scope.addUpSelledProdToCart = function(prod) {
        if (scope.avoidUpSellDoubleClick) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        scope.avoidUpSellDoubleClick = true;
        var eventData = {
          ctaSource: {
            name: formatSourceName(scope.ctaSource),
            index: scope.index
          },
          prod: prod
        };
        scope.$emit('addUpSelledProdToCart', eventData);
      };

      // ENABLES ADD TO BAG BUTTON AGAIN IN CASE THE XSELL ITEM WAS REMOVED FROM THE CART
      scope.$on('prodAddedToBag', function(event) {
        scope.avoidCrossSellDoubleClick = false;
      });

      // ENABLES ADD TO BAG BUTTON AGAIN IN CASE THE UPSELLED ITEM WAS REMOVED FROM THE CART
      scope.$on('upSellProdAdded', function(event) {
        scope.avoidUpSellDoubleClick = false;
      });

      scope.$on('prod_added_to_refill', function() {
        scope.avoidCrossSellDoubleClick = false;
      });

      function formatSourceName(source) {
        return source + scope.modalVersion.charAt(0).toUpperCase() + scope.modalVersion.slice(1);
      }
    }
  };
}])
.
directive('mrReviewSection', [function() {
  return {
    require: '^mrAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="accordion-section", id="{{name}}" ng-class="{open: sections[name]}">' +
    '<a href="" ng-click="toggleSection(name)" ng-class="{\'icon-neg\': sections[name], \'icon-pos\': !sections[name]}">' +
    '<h5>{{header}}</h5>' +
    '<div class="ave">' +
    '<mr-stars rating="reviewAvg"></mr-stars>' +
    '<span>({{reviewCount}})</span>' +
    '</div>' +
    '</a>' +
    '<div class="details">' +
    '<div class="details-wrap review-details">' +
    '<mr-reviews product-id="productId" per-page="perPage" url-key="urlKey"></mr-reviews>' +
    '</div>' +
    '</div>' +
    '</div>',
    scope: {
      header: '@',
      name: '@',
      urlKey: '=',
      productId: '=',
      product: '=',
      reviewInfo: '=',
      perPage: '=?',
      openSection: '=?',
      open: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.toggleSection = ctrl.toggleSection;
      scope.openSection = ctrl.toggleSection.bind(ctrl, scope.name);
      scope.reviewAvg = 0;
      scope.reviewCount = 0;

      scope.toggleSection(scope.name);
      
      scope.$watch('reviewInfo.productId', function(info) {
        if (info) {
          scope.reviewAvg = scope.reviewInfo.average;
          scope.reviewCount = scope.reviewInfo.count;
        }
      });
    }
  };
}]).
/*
This directive handles the product reviews widget found in the pdp page
 */
directive('mrReviews', ['$location', 'contentSvc', 'reviewSvc', function($location, contentSvc, reviewSvc) {
  return {
    replace: true,
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr_reviews',
    scope: {
      productId: '=',
      productName: '=',
      urlKey: '=',
      perPage: '=?'
    },
    link: function(scope, element, attrs) {
      scope.reviews = [];
      scope.reviewAverage = 0;
      scope.reviewCount = 0;
      scope.startPage = 1;
      scope.perPage = scope.perPage ? scope.perPage : 2;
      scope.reviewSortByConstants = {};
      scope.sortByOptions = [];

      scope.nextUrl = null;
      scope.prevUrl = null;

      reviewSvc.getSortByConstants(function(res) {
        scope.reviewSortByConstants = res;
        scope.sortByOptions = [
          {value: scope.reviewSortByConstants.NEWEST, label: 'DATE (Recent - Oldest)'},
          {value: scope.reviewSortByConstants.OLDEST, label: 'DATE (Oldest - Recent)'},
          {value: scope.reviewSortByConstants.HIGHEST, label: 'RATING (Highest - Lowest)'},
          {value: scope.reviewSortByConstants.LOWEST, label: 'RATING (Lowest - Highest)'},
          {value: scope.reviewSortByConstants.HELPFUL, label: 'MOST HELPFUL'}
        ];
      });


      scope.sortingBy = null;
      scope.canReview = true;

      var params = $location.search();
      //- when reviews params is present ensure its a valid number and set page
      if (!isNaN(+params.reviews)) {
        scope.startPage = params.reviews;
      }

      contentSvc.canUserReview({
        product_id: scope.productId
      }, function(result) {
        scope.canReview = result.canReview;
      });

      getReviews(scope.startPage);

      scope.$watch('sortingBy', function(val) {
        if (val == null) {
          return;
        }

        getReviews(1, val);
      });

      function getReviews(page, sortingBy) {
        if (!scope.productId) {
          return;
        }

        var payload = {
          product_id: scope.productId,
          items_per_page: scope.perPage,
          start_page: page,
        };
        if (sortingBy != undefined && sortingBy != null) {
          payload.sort_by = sortingBy;
        } else {
          //- sorted by most helpful by default for SEO reasons
          payload.sort_by = 'helpful';
        }

        contentSvc.getProductReviews(payload, function(result) {
          scope.reviewAverage = result.average;
          scope.reviewCount = result.total_count;
          scope.numPages = Math.ceil(scope.reviewCount / scope.perPage);
          scope.reviews = result.reviews;
          scope.startPage = result.page;
          handlePaginationSEO(scope.startPage, scope.numPages);
        });
      }

      function handlePaginationSEO(currentPage, totalPages) {
        var loc = window.location;
        var baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
        var thisUrl = baseUrl;

        if (currentPage !== 1) {
          thisUrl += '?reviews=' + currentPage;
        }

        scope.prevUrl = currentPage === 1 ? '' : currentPage === 2 ? baseUrl : baseUrl + '?reviews=' + (currentPage - 1);
        scope.nextUrl = currentPage < totalPages  ? baseUrl + '?reviews=' + (currentPage + 1) : '';

        $('link[rel=canonical]').attr('href', thisUrl);

        var prevLink = $('link[rel=prev]');

        if (scope.prevUrl) {
          if (prevLink.length) {
            prevLink.attr('href', scope.prevUrl);
          } else {
            $('head').append('<link rel="prev" href="' + scope.prevUrl + '" />');
          }
        } else if (prevLink.length){
          prevLink.remove();
        }

        var nextLink = $('link[rel=next]');
        if (scope.nextUrl) {
          if (nextLink.length) {
            nextLink.attr('href', scope.nextUrl);
          } else {
            $('head').append('<link rel="next" href="' + scope.nextUrl + '" />');
          }
        } else {
          nextLink.remove();
        }
      }

      scope.$on("$locationChangeSuccess", function(event, next, current) {
        var page = $location.search().reviews;
        scope.startPage = page ? page : 1;
        getReviews(scope.startPage, scope.sortingBy);
      });

      function sendHelpful(rev, helpful) {
        rev.voted = true;
        var payload = {
          helpful: helpful,
          reviewId: rev.id,
          productId: scope.productId
        };
        contentSvc.voteForReview(payload);
      }

      scope.reviewHelpful = function(rev) {
        sendHelpful(rev, true);
      };

      scope.reviewUnhelpful = function(rev) {
        sendHelpful(rev, false);
      };
    }
  };
}])
.
directive('mrScrollTimePicker', function() {
  return {
    templateUrl: '/ngpartials/directives/mr-scroll-time-picker',
    restrict: 'E',
    scope: {
      times: '=',
      selectTime: '='
    },
    link: function (scope, element, attr, ctrl) {
      scope.$watch('times', function(value) {
        // $('.slick-container').slick('unslick');
        // $('.slick-container').slick();
      });
    }
  }
}).
directive('mrSection', ['$parse', function($parse) {
  return {
    require: '^mrAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="accordion-section" id="{{name}}" ng-class="{open: sections[name]}">' +
    '<a href="" ng-click="toggleSection(name)" ng-class="{\'icon-neg\': sections[name], \'icon-pos\': !sections[name]}">' +
    '<h5>{{header}}</h5>' +
    '</a>' +
    '<div class="details">' +
    '<div class="details-wrap" ng-transclude></div>' +
    '</div>' +
    '</div>',
    scope: {
      header: '@',
      name: '@',
      open: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.toggleSection = ctrl.toggleSection;
      ctrl.addSection(scope.name);
      if (scope.open) {
        scope.toggleSection(scope.name);
      }
    }
  };
}]).
/* global redirectUrl */
directive('mrSignIn', ['$location', '$timeout', '$window', 'customerSvc', 'notifySvc', function($location, $timeout, $window, customerSvc, notifySvc) {
  return {
    restrict: 'EA',
    templateUrl: '/ngpartials/directives/mr-sign-in',
    scope: {
      control: '=',
      buyingSubscription : '=',
      view: '@?',
      type: '@?',
      createAccountHeading: '@?',
      defaultSubmitButton: '=?',
      data: '=?',
      next: '@?',
      authed: '=?',
      focusOnEmailInput:'=?',
      backgroundImages: '=?'
    },
    link: function(scope) {
      scope.data = scope.data ||  {};
      scope.showInfo = {};
      var resetPassword = window.resetPassword || {};
      scope.urlPath = $location.path();
      var qs = $location.search() || {};
      // redirectUrl here refers to global variable and is used for facebook login
      redirectUrl = decodeURIComponent(scope.next || qs.next || '/');
      var processing = false;
      scope.data.email = qs.email || scope.data.email  || null;
      scope.showOptIn = !scope.data.email;
      scope.data.view = scope.view || resetPassword.view || qs.view || 'signIn';
      var code = resetPassword.code || qs.code;
      scope.isCheckOut = (scope.type == 'checkout');
      scope.createAccountHeading = scope.createAccountHeading || 'New to Madison Reed?';
      scope.fbAuthed = false;

      // FYI, if the submitButtonType is submit, the enter button will automatically submit form
      scope.submitButtonType = (scope.defaultSubmitButton == false ? 'button' : 'submit');
      scope.data.optInEmail = scope.data.hasOwnProperty('optInEmail') ? scope.data.optInEmail : true;

      // Are you authenticated with facebook?
      if (scope.type == 'checkout') {
        customerSvc.getCustomerInfo(function(customer) {
          if (scope.authed && customer.fbObj) {
            scope.fbAuthed = true;
          }
        });
      }

      if (code) {
        scope.data.code = code;
        customerSvc.verifyCipherStr({code: code}, function(res) {
          scope.data.email = res.email;
        }, function(err) {
          notifySvc.notify('error', err.data.message, 15000);
          scope.data.view = 'forgot';
        });
      }

      if (scope.data.view !== 'resetPassword' && scope.data.view !== 'setPassword') {
        customerSvc.getSignInData(function(res) {
          if (res.email) {
            scope.data.email = res.email;
            scope.showOptIn = false;
          }

          if (res.view) {
            scope.data.view = res.view;
          }
        });
      }

      scope.$watch('view', function(val) {
        if (scope.focusOnEmailInput) {
          $timeout(function() {
            if (scope.data.email) {
              $('.mr-sign-in input[type="password"]:visible').first().focus();
            } else {
              $('.mr-sign-in input[type="email"]:visible').focus();
            }
          }, 700);
        }

        var title;
        switch (val) {
          case 'signIn':
            title = "Log In";
            break;

          case 'forgot':
          case 'emailSent':
            title = "Forgot Password";
            break;

          case 'create':
          case 'setPassword':
            title = "Sign Up";
        }

        if (title) {
          $window.document.title = title;
        }
      });

      scope.$on('bad-facebook-data', function() {
        notifySvc.notify('error', 'There was a problem retrieving your data from facebook. Please submit an email and password to log in or create an account.', 15000);
      });

      scope.signIn = function() {
        if (processing) {
          return;
        }
        processing = true;

        var payload = {
          email: scope.data.email,
          password: scope.data.password,
          keepMeSignedIn: scope.data.keepMeSignedIn
        };

        customerSvc.login(payload, function() {
          processing = false;
          if (scope.type != 'signinModal') {
            location.href = redirectUrl;
          } else {
            scope.control.open = false;
            location.href = window.location;
          }
        }, function(err) {
          processing = false;
          scope.data.signInErr = err.data.message;
          shakeElement('#sign_in_form');
        });
      };

      scope.createAccount = function() {
        if (processing) {
          return;
        }
        scope.data.createErr = scope.data.createErr || [];
        processing = true;

        var payload = customerSvc.createAccountPayload(scope.data);

        customerSvc.createCustomer(payload, function(res) {
          processing = false;
          scope.data = {};

          if (scope.type != 'signinModal') {
            location.href = redirectUrl;
          } else {
            scope.control.open = false;
            location.href = window.location;
          }
        }, function(err) {
          processing = false;
          scope.data.createErr = [err.data.message];
          if (err.data.validation) {
            scope.data.createErr = [];
            Object.keys(err.data.validation).forEach(function(validationError) {
              scope.data.createErr.push(err.data.validation[validationError]);
            });
          }

          shakeElement('#create_account_form');
          return;
        });
      };

      scope.forgotPassword = function() {
        if (processing) {
          return;
        }
        processing = true;

        var payload = {
          email: scope.data.email
        };

        customerSvc.forgotPassword(payload, function() {
          processing = false;
          scope.data.view = 'emailSent';
        }, function(err) {
          processing = false;
          var doRedirect = false;

          var errMessage;
          if (err && err.data) {
            if (err.data.message == 'Invalid Email') {
              doRedirect = true;
              errMessage = err.data.message + ', redirecting to support page, one moment.';
            }

            if (err.data.code == 'UNSUBSCRIBED') {
              notifySvc.notify('warn', 'It looks like you might not be getting our password reset emails. If you do not receive one shortly please contact Color Crew for assistance.', 10000);
            }

            if (err.data.code == 'UNSUBSCRIBED_HAS_MOBILE') {
              scope.data.view = 'forgotSms';
            }
          }


          scope.data.forgotErr = errMessage;
          shakeElement('#forgot_password_form');

          if (doRedirect) {
            setTimeout(function() {
              window.location = '/support';
            }, 4000);
          }

        });
      };

      scope.sendPasswordResetSMS = function() {
        customerSvc.sendPasswordResetSMS({email: scope.data.email}, function() {
          scope.data.view = 'smsSent';
        }, function() {
          notifySvc.notify('error', 'Something went wrong and we might have not been able to send SMS, try again or please contact Color Crew for assistance.', 10000);
        });
      };

      scope.resetPassword = function() {
        var payload = {
          account_email: scope.data.email,
          accountPassword: scope.data.newPassword,
          accountPasswordConfirm: scope.data.confirmNewPassword,
          code: scope.data.code
        };

        customerSvc.resetPassword(payload, function() {
          scope.data.password = angular.copy(scope.data.newPassword);
          scope.data.newPassword = '';
          scope.data.confirmNewPassword = '';
          scope.signIn();
        }, function(err) {
          scope.data.newPassword = '';
          scope.data.confirmNewPassword = '';
          notifySvc.notify('error', err.data.message);
        });
      };

      function shakeElement(elem) {
        $(elem).addClass('shake');
        $timeout(function() {
          $(elem).removeClass('shake');
        }, 1200, false);
      }

      scope.toggleInfo = function(key) {
        scope.showInfo[key] = !scope.showInfo[key];
      };
    }
  };
}])
.
// Only one section open at a time
directive('mrSingleAccordion', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-single-accordion" ng-transclude>' +
    '</div>',
    controller: function($scope) {
      var sections = this.sections = {};

      this.toggleSection = function(section) {
        Object.keys(sections).forEach(function(sectionKey) {
          sections[sectionKey] = false;
        });

        sections[section] = true;
      }

      this.addSection = function(section) {
        sections[section] = false;
      };
    }
  }
}).
directive('mrSingleSection', ['$parse', function($parse) {
  return {
    require: '^mrSingleAccordion',
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="mr-single-section" id="{{name}}" ng-class="{open: sections[name]}">' +
    '<a href="" ng-click="toggleSection(name)", class="icon-caret-right">' +
    '<h2>{{header}}</h2>' +
    '</a>' +
    '<div class="details">' +
    '<div class="wrap" ng-transclude></div>' +
    '</div>' +
    '</div>',
    scope: {
      header: '@',
      open: '@',
      name: '@',
      mrClick: '=?'
    },
    link: function(scope, element, attrs, ctrl) {
      scope.sections = ctrl.sections;
      scope.mrClick = scope.mrClick || function() {
        };

      scope.toggleSection = function(name) {
        ctrl.toggleSection(name);
        scope.mrClick();
      }
      ctrl.addSection(scope.name);
      if (scope.open == 'true') {
        ctrl.toggleSection(scope.name);
      }
    }
  };
}]).
// usage: mr-site-messages(topics="cart, checkout")
// include mrDirectives styles in to your stylesheet: @import 'mrDirectives'
directive('mrSiteMessages', ['siteMessagesSvc', function(siteMessagesSvc) {
  return {
    templateUrl: '/ngpartials/directives/site-messages',
    restrict: 'EA',
    transclude: true,
    scope: {
      topics: '@?'
    },
    link: function(scope, elem, attrs, ctrl) {
      scope.siteMessages = siteMessagesSvc.getByTopics(scope.topics);
      scope.setMessageClass = function(val) {
        var msgClass = '';
        if (val == 'high') {
          msgClass = 'color-red';
        } else if (val == 'medium') {
          msgClass = 'color-mr-blue';
        }

        return msgClass;
      };
    }
  };
}]).
directive('mrSiteSearch', ['$window', 'notifySvc', function($window, notifySvc) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/ngpartials/directives/mr-site-search',
    scope: {
      control: '='
    },
    link: function(scope, element, attrs) {
      scope.control = scope.control ? scope.control : {};
      scope.control.open = scope.control.open || false;
      scope.control.searchTerm = scope.control.searchTerm || '';
      scope.searchPlaceholder = 'search';

      scope.control.focusSearch = function() {
        setTimeout(function() {
          element[0].querySelector('input').focus();
        }, 1);
      };
      
      scope.performSearch = function() {
        if (!scope.control.searchTerm.length) {
          return notifySvc.notify('warn', 'Nothing entered in the search form.');
        }
        scope.control.open = false;

        $window.location = '/search/' + scope.control.searchTerm;
      };

      scope.$on('breakpointChange', function(event, data) {
        if (data.breakpoint == 'mobile' || data.breakpoint == 'tablet' || data.breakpoint == 'desktop-md') {
          scope.searchPlaceholder = 'Search';
        } else {
          scope.searchPlaceholder = '';
        }
      });
    }
  };
}])
.
// usage: mr-stars(rating="averageStars")
// include mrDirectives styles in to your stylesheet: @import 'mrDirectives'
directive('mrStars', function() {
  return {
    template: '<div class="mr-stars"><span ng-repeat="star in stars", ng-class="getClass(star)"></span><span ng-transclude></span></div>',
    restrict: 'EA',
    transclude: true,
    scope: {
      rating: '='
    },
    link: function(scope, elem, attrs, ctrl) {
      scope.Math = window.Math;
      scope.stars = [1, 2, 3, 4, 5];
    
      scope.getClass = function(star) {
        var floorRating = Math.floor(scope.rating);
        var ceilRating = Math.ceil(scope.rating);
        if (star <= floorRating) {
          return 'icon-star-full';
        }

        if (star == ceilRating && ceilRating != floorRating) {
          return 'icon-star-half';
        } else {
          return 'icon-star';
        }
      };
    }
  };
}).
directive('mrSticky', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attr, ctrl) {
      $(window).scroll(function() {
        if ($('body').hasClass('no-scroll')) {
          return;
        }

        if ($(this).scrollTop() > 1) {
          element.addClass("mr-sticky");
        } else {
          element.removeClass("mr-sticky");
        }
      });
    }
  };
}).
// used for stoping a bottom fixed element at a specific element on the page
// Example jade: .some-fixed-element(mr-stop-at="footer")

directive('mrStopAt', [function() {
  return {
    retrict: 'EA',
    link: function(scope, element, attrs) {
      var stopAtSelector = attrs.mrStopAt;
      var originalPosition = element.css('position');
      var originalBottom = element.css('bottom');
      var win = $(window);
      setInterval(stopAtWatcher, 200);

      function stopAtWatcher() {
        var stopAt = $(stopAtSelector).offset().top;
        var windowBottom = win.scrollTop() + win.height();
        var height = element.outerHeight();

        if (windowBottom >= stopAt) {
          element.css('position', 'absolute');
          element.css('bottom', 'initial');
          element.css('top', stopAt - height);
        } else {
          element.css('position', originalPosition);
          element.css('bottom', originalBottom);
          element.css('top', 'initial');
        }
      }
    }
  }
}]).
directive('mrSubDropdown', ['$timeout', function($timeout) {
  return {
    restrict: 'E',
    templateUrl: '/ngpartials/directives/mr_sub_dropdown',
    scope: {
      product: '=',
      freqField: '@',
      freqModel: '=',
      idx: '=',
      onChange: '=',
      onChange2: '=',
      showPrice: '=?',
      oneTimePurchase: '=?'
    },
    link: function(scope, element, attrs) {
      scope.show = false;
      scope.$watch('product', function(val) {
        if (val) {
          //Set frequency
          scope.freqModel[scope.freqField] = scope.freqModel[scope.freqField] || val.product_type_sub_frequency_default || 0;
          //Set select options
          updateSubDropdown(val.product_type_sub_frequencies);
        }
      });

      //When drop down value changes
      scope.updateSubFrequency = function() {
        if (scope.onChange) {
          scope.onChange(scope.idx, scope.freqModel[scope.freqField]);
        }

        if (scope.onChange2) {
          scope.onChange2();
        }
      };

      function updateSubDropdown(frequencyString) {
        frequencyString = frequencyString || '';
        var frequencyArray = frequencyString.split(',').map(Number);
        var subFrequency = parseInt(scope.freqModel.subFrequency);
        
        if (!frequencyArray.length) {
          frequencyArray = [2, 3, 4, 5, 6, 7, 8];
        }

        if (subFrequency > frequencyArray[frequencyArray.length-1]) {
          frequencyArray.push(subFrequency);
        }

        if (scope.oneTimePurchase) {
          frequencyArray.unshift(0);
        }

        scope.freqModel[scope.freqField] = updateSubscription(frequencyArray, scope.freqModel[scope.freqField]);
        scope.subOptions = frequencyArray.map(function(val) {
          if (val === 0) {
            return {
              val: val,
              label: 'One time' + (scope.showPrice ? ' - $' + scope.product.one_time_price : '')
            };
          } else {

            return {
              val: val,
              label: 'Every ' + val + ' weeks' + (scope.showPrice ? ' - $' + scope.product.sub_price : '')
            };
          }
        });

        $timeout(function() {
          element.find('select').customDropdown();
          scope.show = true;
        }, 0);
      }

      //If product is not in frequency list then change product to a higher product
      //ex. arr = [2,4,6] and product = 5, set product = 6
      function updateSubscription(arr, frequency) {
        var sub = null;

        //If frequency is undefined
        if (isNaN(parseInt(frequency, 10))) {
          return;
        }

        //Check if frequency is not in frequency list
        if (arr.indexOf(frequency) === -1) {

          //Set to next higher frequency
          sub = arr.filter(function(val) {
            if (val - frequency >= 1) {
              return val;
            }
          })[0];

          //If sub is not populated then set to the highest frequency
          if (isNaN(sub)) {
            sub = arr[arr.length - 1];
          }
        } else {
          sub = frequency;
        }

        return sub;
      }
    }
  };
}])
.
directive('mrTab', function() {
  return {
    require: '^mrTabset',
    restrict: 'E',
    transclude: true,
    template: '<div class="tab-container"><div class="tab-content"ng-show="selected" id="{{header}}" ng-transclude></div></div>',
    scope: {
      header: '@',
      hideTab: '=?'
    },
    link: function(scope, element, attr, ctrl) {
      ctrl.addTab(scope);
    }
  };
})
.
directive('mrTabset', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: '<div class="mr-tabs">' +
    '<div class="wrap"><ul class="nav-tabs">' +
    '<li ng-repeat="tab in tabs" ng-class="{selected: tab.selected}" ng-if="!tab.hideTab">' +
    '<a href="" ng-click="select(tab); scrollToTab($event)">{{tab.header}}</a>' +
    '</li>' +
    '</ul></div>' +
    '<div class="tab-container", ng-transclude></div>' +
    '</div>',
    controller: function($scope) {
      var tabs = $scope.tabs = [];

      $scope.select = function(tab) {
        angular.forEach(tabs, function(tab) {
          tab.selected = false;
        });
        tab.selected = true;
      };

      $scope.scrollToTab = function(event) {
        var top = $(event.target).parent().offset().top;
        $('html, body').animate({
          scrollTop: top - 20
        }, 500, 'swing');
      };

      $scope.selectTab = function(header) {
        angular.forEach(tabs, function(tab) {
          tab.selected = false;
          if (tab.header == header) {
            tab.selected = true;
          }
        });
      };

      this.addTab = function(tab) {
        if (tabs.length === 0) {
          $scope.select(tab);
        }
        tabs.push(tab);
      };
    },
    scope: {
      selectTab: '=?'
    }
  };
}).
/**
* The ng-thumb directive
* @author: nerv
* @version: 0.1.2, 2014-01-09
*/
// Mostly used to show thumbnails in FileUploader
directive('mrThumb', ['$window', function($window) {
  var helper = {
    support: !!($window.FileReader && $window.CanvasRenderingContext2D),
    isFile: function(item) {
      return angular.isObject(item) && item instanceof $window.File;
    },
    isImage: function(file) {
      var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
      return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
    }
  };

  return {
    restrict: 'A',
    template: '<canvas/>',
    link: function(scope, element, attributes) {
      if (!helper.support) {
        return;
      } 

      var params = scope.$eval(attributes.mrThumb);

      if (!helper.isFile(params.file)) {
        return;
      } 

      if (!helper.isImage(params.file)) {
        return;
      }

      var canvas = element.find('canvas');
      var reader = new FileReader();
      var orientation = 0;

      reader.onloadend = function(e) {
        orientation = getOrientation(e);
        reader.onloadend = onLoadFile;
        reader.readAsDataURL(params.file);
      }

      function getOrientation(e) {
        var view = new DataView(e.target.result);

        if (view.getUint16(0, false) != 0xFFD8) {
          return -2;
        }

        var length = view.byteLength;
        var offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return -1;
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                return view.getUint16(offset + (i * 12) + 8, little);
              }
            }
          } else if ((marker & 0xFF00) != 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }

        return -1;
      }

      reader.readAsArrayBuffer(params.file);

      function onLoadFile(event) {
        var img = new Image();
        img.onload = onLoadImage;
        img.src = event.target.result;
      }

      function onLoadImage() {
        var width = this.width;
        var height = this.height;
        var marginTop = 0;
        var marginLeft = 0;

        if (params.width && !params.height) {
          width = params.width;
          height = this.height * params.width / this.width;
        }

        if (params.height && !params.width) {
          height = params.height;
          width = this.width * params.height / this.height;
        }

        if (params.width && params.height) {
          if (width < height) {
            width = params.width;
            height = this.height * params.width / this.width;
            marginTop = Math.floor((params.height - height) / 2);
          } else {
            height = params.height;
            width = this.width * params.height / this.height;
            marginLeft = Math.floor((params.width - width) / 2)
          }
        }

        var rotation = 'rotate-0';

        switch(orientation) {
          case 8:
            rotation = 'rotate-270';
            break;
          case 3:
            rotation = 'rotate-180';
            break;
          case 6:
            rotation = 'rotate-90';
            break;
        }

        canvas.attr({ width: width, height: height });
        canvas.css({ 'margin-top': marginTop, 'margin-left': marginLeft });
        canvas.addClass(rotation);
        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
      }
    }
  };
}]).
directive('mrThumbSelector', ['mrNgUtils', function(mrNgUtils) {
  return {
    templateUrl: '/ngpartials/directives/thumb-selector',
    transclude: true,
    restrict: 'E',
    scope: {
      products: '=',
      selectedUrlKey: '=?',
      bestMatch: '=?',
      titleOnBottom: '=',
      customFieldOne: '@',
      customFieldTwo: '@',
      itemsPerLine: '=?'
    },
    link: function(scope, element, attrs) {
      scope.showElement = false;

      scope.$on('init', function(event, mass) {
        scope.$apply(function() {
          scope.showElement = true
        });
      });

      scope.changeSwatchName = function(hoveredProduct, selectedName) {
        if (selectedName) {
          scope.hoveredProduct = scope.selectedProd;
        } else {
          scope.hoveredProduct = hoveredProduct;
        }
      };

      scope.$watch('products', function(val) {
        if (val) {
          scope.products.forEach(function(prod) {
            if (prod.url_key === scope.selectedUrlKey) {
              scope.hoveredProduct = prod;
              scope.selectedProd = prod;
            }
          });

          if (!scope.selectedProd) {
            scope.selectedProd = scope.products[0];
          }
          scope.chunkedProducts = mrNgUtils.chunkArray(scope.products, scope.itemsPerLine ? scope.itemsPerLine : 4);
        }
      });

      scope.selectProd = function(prod) {
        scope.selectedProd = prod;
      };
    }
  };
}])
.
directive('mrTouch', function() {
  return {
    link: function(scope, element, attrs) {
      var touchOrClick = window.isMobileDevice ? 'touchstart' : 'click';
      // Older Androids don't like 'touchstart' so we switch to click
      if (/(android\s4)/i.test(navigator.userAgent)) {
        touchOrClick = 'click';
      }

      element.on(touchOrClick, function(event) {
        event.preventDefault();
        event.stopPropagation();
        scope.$event = event;
        scope.$apply(attrs.mrTouch);
      });
    }
  };
}).
directive('mrVideoJs', ['$rootScope', 'trackerSvc', function($rootScope, trackerSvc) {
  return {
    restrict: 'A',
    scope: {
      playerId: '@',
      playerSrc: '@',
      videoTitle: '@'
    },
    link: function(scope, element, attrs) {
      $rootScope.mrVideoJsPlayers = $rootScope.mrVideoJsPlayers || [];
      $rootScope.autoPause = false;
      var aspectRatio = 9/16;
      var playerId = scope.playerId;

      var player = videojs(playerId, {
        controls: true,
        autoplay: false,
        techOrder: ["youtube", "html5", "flash"],
        sources: [
          {
            type: "video/youtube",
            src: scope.playerSrc
          }
        ],
        youtube: {
          "modestbranding": 1
        }
      }, function() {
        //the video ready calback;
        var self = this;
        //init google analytics with all tracking options
        self.ga();

        $(function() {
          var videoDescription = $('#' + playerId).next('.video-description');
          var videoDuration = self.duration();

          self.on('play', function() {
            //set a listener to show/hide video descriptions
            videoDescription.hide();

            //ensure all other players are paused
            $rootScope.mrVideoJsPlayers.forEach(function(p) {
              if (p.id_ == playerId) {
                return;
              }

              if (p.paused()) {
                return;
              }
              $rootScope.autoPause = true;
              p.pause();
              $rootScope.autoPause = false;
            });

            //fire segment event
            trackerSvc.trackEvent('Instruction Video Played',
              {
                videoTitle: scope.videoTitle,
                videoSrc: scope.playerSrc
              }
            );
          });

          self.on('fullscreenchange', function(e) {
            if (!self.isFullscreen()) {
              return;
            }

            trackerSvc.trackEvent('Instruction Video Fullscreen',
              {
                videoTitle: scope.videoTitle,
                videoSrc: scope.playerSrc
              }
            );
          });

          self.on('pause', function(e) {
            videoDescription.show();
            if ($rootScope.autoPause) {
              //dont fire pause events when auto-pausing the video for the user (whem multiple vids are playing);
              $rootScope.autoPause = false;
              return;
            }

            var pausedDuration = self.currentTime();

            trackerSvc.trackEvent('Instruction Video Paused',
              {
                videoTitle: scope.videoTitle,
                videoSrc: scope.playerSrc,
                videoPausedAt: +pausedDuration.toFixed(2),
                videoPercentWatched: +((pausedDuration/videoDuration) * 100).toFixed(2)
              }
            );
          });

          self.on('ended', function() {
            videoDescription.show();

            trackerSvc.trackEvent('Instruction Video Completed',
              {
                videoTitle: scope.videoTitle,
                videoSrc: scope.playerSrc
              }
            );
          });

          self.on('error', function(e) {
            console.log('mr-video-js error:', e)
          });
        });//end jq ready
      });

      //we want to call this as soon as the instance has been started
      resizeVideoJs(player);
      $rootScope.mrVideoJsPlayers.push(player);

      if (!window.onresize) {
        //only assign this once as there can be multiple videos per page
        function resizeVideos() {
          $rootScope.mrVideoJsPlayers.forEach(function(player) {
           resizeVideoJs(player);
          });
        }
        window.onresize = resizeVideos;
      }

      // Resize a single player
      function resizeVideoJs(player){
        // Get the parent element's actual width
        var width = document.getElementById(player.id()).parentElement.offsetWidth;
        // Set width to fill parent element, Set height
        player.width(width).height( width * aspectRatio );
      }

    }
  };
}])
.
/* global MR */
directive('mrWaitlist', ['waitlistSvc', 'notifySvc', function(waitlistSvc, notifySvc) {
  return {
    restrict: 'A',
    scope: {
      control: '=',
      waitlistType: '@',
      email: '@', // optional default
      zip: '@', // optional default
      phone: '@' // optional default
    },
    link: function(scope) {
      scope.control.requiredFields = scope.control.requiredFields || ['email'];
      scope.control.missingFields = {};
      scope.control.email = scope.email || '';
      scope.control.zip = scope.zip || '';
      scope.control.phone = scope.phone || '';

      scope.control.addToWaitlist = function() {
        if (!checkRequiredFields() || scope.control.addingToWaitlist) {
          return;
        }
        scope.control.addingToWaitlist = true;
        var params = {
          waitlist_type: scope.waitlistType
        };

        scope.control.requiredFields.forEach(function(field) {
          params[field] = scope.control[field];
        });

        waitlistSvc.addToWaitlist(params, function() {
          scope.control.addingToWaitlist = false;
          scope.control.addedToWaitlist = true;
        }, function(err) {
          scope.control.addingToWaitlist = false;
          var error = 'We weren\'t able to update our waiting list. Please contact Color Crew at ' + MR.config.contactPhone; //- <- global
          if (err.data && err.data.message) {
            error = err.data.message;
          }

          notifySvc.notify('error', error);
        });
      };

      function checkRequiredFields() {
        var hasRequired = true;
        scope.control.requiredFields.forEach(function(field) {
          if (!scope.control[field]) {
            notifySvc.notify('warn', 'Please enter a valid ' + field + '.');
            scope.control.missingFields[field] = true;
            hasRequired = false;
          }
        });
        return hasRequired;
      }
    }
  };
}])
.
directive('mrXSell', ['$routeParams', function($routeParams) {
    return {
      restrict: 'E',
      templateUrl: '/ngpartials/directives/mr-x-sell',
      scope: {
        addons: '=',
        addToCartMethod: '=',
        ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
        showBundlesInXsell: '=?',
        context: '=?',
        addToString: '@?'
      },
      link: function(scope) {
        scope.addToString = scope.addToString || 'add to bag';
        scope.addAddon = function(prod, idx) {
          // Ability to tie the parent context to the addon item being clicked on (added to cart)
          var context = scope.context || {};
          var payload = {
            prod: prod,
            idx: idx,
            context: context,
            ctaSource: {
              name: scope.ctaSource,
              index: idx
            }
          };

          if (scope.showBundlesInXsell && prod.validOffer) {
            payload.validOffer = prod.validOffer;
          }
          // Call parent method and pass data from item being added
          scope.addToCartMethod(payload, context);
        };

        scope.showQuickLook = function(prod, index) {
          var data = {
            prod: prod,
            index: index,
            context: scope.context,
            ctaSource: {
              name: scope.ctaSource,
              index: index
            } //- pass ctaSource to quicklook
          };

          if (scope.showBundlesInXsell && prod.validOffer) {
            data.validOffer = prod.validOffer;
            prod.showBundlePrice = true;
          }
          scope.$emit('showQuickLookEvent', data);
        };
      }
   };
}])
.
directive('mrXSellByContext', ['$routeParams', 'trackerSvc', function($routeParams, trackerSvc) {
    return {
      restrict: 'E',
      templateUrl: '/ngpartials/directives/mr-xsell-by-context',
      scope: {
        addonsByContext: '=',
        addToCartMethod: '=',
        ctaSource: '@?', //- used for segment tracking to identify from where product was added to cart
        showBundlesInXsell: '=?',
        context: '=?',
        addToString: '@?'
      },
      link: function(scope) {
        scope.trackerSvc = trackerSvc;
        scope.addToString = scope.addToString || 'add to bag';
        
        scope.addAddon = function(prod, idx) {
          var context = scope.context || {};
          var payload = {
            prod: prod,
            idx: idx,
            context: context,
            validBundle: prod.validBundle,
            ctaSource: {
              name: scope.ctaSource,
              index: idx
            }
          };

          scope.addToCartMethod(payload, context);
        };

        scope.showQuickLook = function(prod, index) {
          var data = {
            prod: prod,
            index: index,
            context: scope.context,
            validBundle: prod.validBundle,
            ctaSource: {
              name: scope.ctaSource,
              index: index
            }
          };

          scope.$emit('showQuickLookEvent', data);
        };
      }
   };
}])
.
/*
  This directive handles the cross sell modal for bundles.
*/

directive('mrXsellModal', ['trackerSvc', '$cookies', function(trackerSvc, $cookies) {
  return {
    templateUrl: '/ngpartials/directives/mr-xsell-modal-single',
    scope: {
      cartItems: '=',
      upsellModalProducts: '=',
      recentAddedProduct: '=',
      addToBag: '=',
      testFlag: '=?'
    },
    link: function(scope, element, attrs) {
      scope.xsellModal = {
        visible: true,
        products: []
      };
      scope.setCookie = scope.$parent.setCookie || scope.$parent.$parent.setCookie || scope.$parent.$parent.$parent.setCookie;
      var bundlesViewed = angular.fromJson($cookies.bundlesViewed) || [];

      updateAddons(scope.upsellModalProducts);
      function updateAddons(modalProducts) {
        modalProducts.forEach(function(addon, index) {
          addon.index = index;
          if (addon.validOffer) {
            scope.xsellModal.products.push(addon);
            if (!scope.xsellModal.addon && !~bundlesViewed.indexOf(addon.code)) {
              scope.xsellModal.addon = addon;
              bundlesViewed.push(addon.code);
              scope.setCookie('bundlesViewed', angular.toJson(bundlesViewed), 2);
            }
          }
        });

        if (!scope.xsellModal.products.length) {
          scope.xsellModal.visible = false;
        }
      }

      scope.closeXsellModal = function() {
        trackerSvc.trackEvent('Xsell Modal Closed');
        scope.xsellModal.visible = false;
      };

      scope.$on('upsellProductsUpdated', function(event, data) {

        data.upsellModalProducts.forEach(function(prod) {
          if (prod.id == scope.recentAddedProduct) {
            scope.xsellModal.addedProduct = prod;
          }
        });

        updateAddons(data.upsellModalProducts);
      });

      if (!scope.xsellModal.addon) {
        scope.xsellModal.visible = false;
      }

      if (scope.recentAddedProduct) {
        scope.cartItems.forEach(function(item) {
          if (item.id == scope.recentAddedProduct) {
            scope.xsellModal.addedProduct = item;
          }
        });
      }

      scope.addProduct = function(prod) {
        if (prod.added) {
          return;
        }
        // Flag to disable add to bag button and avoid double clicks
        prod.added = true;
        scope.recentAddedProduct = prod.id;
        scope.xsellModal.recentProductDiscount = prod.id;
        scope.xsellModal.addedProduct = prod;
        scope.xsellModal.products = [];

        var eventData = {
          ctaSource: {
            name: 'mr-xsell-modal',
            index: scope.index
          },
          prod: prod
        };

        if (scope.testFlag) {
          eventData.ctaSource.name + '-' +scope.testFlag;
        }

        scope.$emit('addUpSelledProdToCart', eventData);
      };
    }
  }
}])
.
directive('mrYoutube', ['$sce', function($sce) {
  return {
    restrict: 'EA',
    replace: true,
    template: '<div class="mr-youtube"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" ng-src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
    scope: {
      code: '='
    },
    link: function(scope) {
      scope.$watch('code', function(newVal) {
        if (newVal) {
          scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
        }
      });
    }
  };
}]).
directive('mrYoutubeVideo', function() {
  return {
    restrict: 'A',
    scope: {
      videoId: '@',
      autoPlay: '=?',
      autoMute: '=?',
      rel: '=?'
    },
    link: function(scope, element, attrs) {
      var player;
      var playerId = 'player-' + scope.videoId;
      var tag = document.getElementById("YOUTUBE_IFRAME_API");
      element.append("<div id=" + playerId + "></div>");

      if (!tag) {
        tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        tag.id = "YOUTUBE_IFRAME_API"
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = function () {
          initializePlayer();
        }
      } else {
        initializePlayer();
      }

      function initializePlayer() {
        player = new YT.Player(playerId, {
          //height and width should be handled on the parent/wrapper div in markup/css
          videoId: scope.videoId,
          playerVars: {
            'origin': window.location.origin,
            'rel': scope.rel ? 1 : 0
          },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }

      function onPlayerReady(event) {
        var player = event.target;
        if (scope.autoMute) {
          player.mute();
        }
        if (scope.autoPlay) {
          player.playVideo();
        }
      }

      function onPlayerStateChange(event) {
        //register when play/pause occurs
      }

      function stopVideo() {
        player.stopVideo();
      }
    }
  };
})
.
directive('ngInvisible', ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngInvisible, function ngShowWatchAction(value) {
        $animate[value ? 'addClass' : 'removeClass'](element, 'ng-invisible');
      });
    }
  };
}]).
directive('productimages', ['$http', function($http) {
  return {
    link: function(scope, element, attrs) {
      scope.mainImage = {
        url: scope.item.images.pdp
      };

      scope.hostUrl = attrs.hostUrl;

      scope.images = [];

      function preload(item) {
        var imageCount = scope.images.length + 1;
        scope.images[imageCount] = new Image();
        scope.images[imageCount].src = item;
      }

      preload(scope.item.images.pdp);

      for (var i = 0; i < 3; i++) {
        var itemPath = scope.hostUrl + '/' + scope.item.similarImages[i].image;
        scope.item.similarImages[i].thumb = scope.hostUrl + '/' + scope.item.similarImages[i].image.replace('/pdp/', '/102/');
        preload(itemPath);
      }

      scope.changeImage = function() {
        var url = this.$parent.hostUrl;
        this.$parent.mainImage.url = url + '/' + this.thumb.image;
      };

      scope.changeBack = function() {
        this.$parent.mainImage.url = this.$parent.item.images.pdp;
      };
    },
    restrict: 'EA',
    template: [
      '<div class="main-image">',
      '<img ng-src="{{mainImage.url}}">',
      '</div>',
      '<div class="thumbs">',
      '<img ng-repeat="thumb in item.similarImages | limitTo: 3", ng-mouseover="changeImage()", ng-mouseleave="changeBack()", ng-src="{{thumb.thumb}}", err-src="/images/my-account/default-picture.png">',
      '</div>'
    ].join(''),
    scope: {
      item: '=',
      host_url: '='
    }
  };
}]).
directive('pullQuoteLeft', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="pull-quote-left"><div class="start-quote">&ldquo;</div><div class="quote-text"><span ng-transclude></span>&rdquo;</div></div>'
  }
}).
directive('pullQuoteRight', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div class="pull-quote-right"><div class="start-quote">&ldquo;</div><div class="quote-text"><span ng-transclude></span>&rdquo;</div></div>'
  }
}).
// scrollingCarousel directive for adding left and right nav buttons for scrolling a horizontally scrollable element
// scrollingCarousel assumes "element" is horizontally scrollable, and uses "element.children[0].width" divided by some number
// of "sections" to determine the amount to scroll each time "leftNav" or "rightNav" is clicked

directive('scrollingCarousel', ['$compile', function($compile) {
  return {
    restrict: 'EA',
    scope: {
      leftNav: '@', // (optional) jquery selector for the left nav element
      rightNav: '@', // (optional) jquery selector for the right nav element
      sections: '@', // (optional) number of section to divide the scrollable area into
      scrollTime: '@' // (optional) number of milliseconds for the animation
    },
    link: function(scope, element, attrs) {
      var leftNav = scope.leftNav ? $(scope.leftNav) : null;
      var rightNav = scope.rightNav ? $(scope.rightNav) : null;
      scope.scrollTime = scope.scrollTime ? scope.scrollTime : 400;

      setInterval(function() { // setInterval shows better performance than on scroll event
        checkNav();
      }, 200);

      // hide nav if all children are visible within element
      // hide left nav if within 15 pixels of the left side
      // hide right nav if within 15 pixels of the right side
      function checkNav() {
        var width = element.width();
        var widthInner = innerWidth();
        var left = element.scrollLeft();
        var right = widthInner - (left + width);
        var hideLeft = false;
        var hideRight = false;

        if (width >= innerWidth || left <= 15) {
          hideLeft = true;
        } else {
          hideLeft = false;
        }

        if (width >= innerWidth || right <= 15) {
          hideRight = true
        } else {
          hideRight = false;
        }

        if (leftNav && hideLeft) {
          leftNav.hide();
        } else if (leftNav) {
          leftNav.show();
        }

        if (rightNav && hideRight) {
          rightNav.hide();
        } else if (rightNav) {
          rightNav.show();
        }
      }

      if (leftNav) {
        leftNav.click(function() {
          scrollCarousel(-1);
        }); 
      }

      if (rightNav) {
        rightNav.click(function() {
          scrollCarousel(1);
        });
      }

      // direction should be -1 for left and 1 for right
      function scrollCarousel(direction) {
        var numSections = scope.sections ? scope.sections : element[0].children.length;
        var leftPos = element.scrollLeft();
        var pixels = direction * innerWidth() / numSections;

        element.animate({scrollLeft: leftPos + pixels}, scope.scrollTime);
      }

      function innerWidth() {
        var width = 0;
        for(var x = 0; x < element[0].children.length; x++) {
          width += element[0].children[x].clientWidth;
        }
        return width;
      }
    }
  };
}])
.
directive('showMore', ['$compile', function($compile) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {
      scope.collapsed = false;
      scope.toggle = function() {
        scope.collapsed = !scope.collapsed;
      };

      attrs.$observe('showMore', function() {
        var text = element.text();
        var maxLength = scope.$eval(attrs.showMore);

        if (text.length > maxLength) {
          // split the text in two parts, the first always showing
          var firstPart = String(text).substring(0, maxLength);
          var secondPart = String(text).substring(maxLength, text.length);

          // create some new html elements to hold the separate info
          var bodySpan = $compile('<span itemprop="reviewBody"><span>' +  firstPart + '</span>' + '<span ng-class="{ hide: !collapsed }">' + secondPart + '</span></span>')(scope);
          var moreIndicatorSpan = $compile('<span ng-if="!collapsed">... </span>')(scope);
          var lineBreak = $compile('<br ng-if="collapsed">')(scope);
          var toggleButton = $compile('<span class="show-more-text" ng-click="toggle()">{{collapsed ? "less" : "more"}}</span>')(scope);

          // remove the current contents of the element
          // and add the new ones we created
          element.empty();
          element.append(bodySpan);
          element.append(moreIndicatorSpan);
          element.append(lineBreak);
          element.append(toggleButton);
        } else {
          var bodySpan = $compile('<span itemprop="reviewBody">' + text + '</span>')(scope);
          element.empty();
          element.append(bodySpan);
        }
      });
    }
  };
}]).
directive('slick', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'AEC',
      scope: {
        initOnload: '@',
        data: '=',
        currentIndex: '=',
        accessibility: '@',
        adaptiveHeight: '@',
        arrows: '@',
        asNavFor: '@',
        appendArrows: '@',
        appendDots: '@',
        autoplay: '@',
        autoplaySpeed: '@',
        centerMode: '@',
        centerPadding: '@',
        cssEase: '@',
        customPaging: '&',
        dots: '@',
        draggable: '@',
        easing: '@',
        fade: '@',
        focusOnSelect: '@',
        infinite: '@',
        initialSlide: '@',
        lazyLoad: '@',
        onBeforeChange: '&',
        onAfterChange: '&',
        onInit: '&',
        onReInit: '&',
        onSetPosition: '&',
        pauseOnHover: '@',
        pauseOnDotsHover: '@',
        responsive: '=',
        rtl: '@',
        slide: '@',
        slidesToShow: '@',
        slidesToScroll: '@',
        speed: '@',
        swipe: '@',
        swipeToSlide: '@',
        touchMove: '@',
        touchThreshold: '@',
        useCSS: '@',
        variableWidth: '@',
        vertical: '@',
        prevArrow: '@',
        nextArrow: '@'
      },
      link: function (scope, element, attrs) {
        var destroySlick, initializeSlick, isInitialized;
        destroySlick = function () {
          return $timeout(function () {
            var slider;
            slider = $(element);
            slider.slick('unslick');
            slider.find('.slick-list').remove();
            return slider;
          });
        };
        initializeSlick = function () {
          return $timeout(function () {
            var currentIndex, customPaging, slider;
            slider = $(element);
            if (scope.currentIndex != null) {
              currentIndex = scope.currentIndex;
            }
            customPaging = function (slick, index) {
              return scope.customPaging({
                slick: slick,
                index: index
              });
            };

            // Init needs to be done before slick is called
            slider.on('init', function (event, slick) {
              checkForNoSlide(slick);
              if (attrs.onInit) {
                scope.onInit();
              }
              if (currentIndex != null) {
                return sl.slideHandler(currentIndex);
              }
            });

            slider.slick({
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? $(scope.appendArrows) : $(element),
              appendDots: scope.appendDots ? $(scope.appendDots) : $(element),
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attrs.customPaging ? customPaging : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              easing: scope.easing || 'linear',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              infinite: scope.infinite !== 'false',
              initialSlide: scope.initialSlide || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              beforeChange: attrs.onBeforeChange ? scope.onBeforeChange : void 0,
              onReInit: attrs.onReInit ? scope.onReInit : void 0,
              onSetPosition: attrs.onSetPosition ? scope.onSetPosition : void 0,
              pauseOnHover: scope.pauseOnHover !== 'false',
              responsive: scope.responsive || void 0,
              rtl: scope.rtl === 'true',
              slide: scope.slide || 'div',
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              prevArrow: scope.prevArrow ? $(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? $(scope.nextArrow) : void 0
            });

            slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
              checkForNoSlide(slick);
              if (scope.onAfterChange) {
                scope.onAfterChange();
              }
              if (currentIndex != null) {
                return scope.$apply(function () {
                  currentIndex = currentSlide;
                  return scope.currentIndex = currentSlide;
                });
              }
            });

            function checkForNoSlide(slick) {
              if (slick.slideCount <= slick.options.slidesToShow) {
                slider.addClass('slick-no-slide');
              } else {
                slider.removeClass('slick-no-slide');
              }
            }

            return scope.$watch('currentIndex', function (newVal, oldVal) {
              if (currentIndex != null && newVal != null && newVal !== currentIndex) {
                return slider.slick('slickGoTo', newVal);
              }
            });
          });
        };

        if (scope.initOnload) {
          isInitialized = false;
          return scope.$watch('data', function (newVal, oldVal) {
            if (newVal != null) {
              if (isInitialized) {
                destroySlick();
              }
              initializeSlick();
              return isInitialized = true;
            }
          }, true);
        } else {
          return initializeSlick();
        }
      }
    };
  }
]).
// Used to rate product, it will redirect to review page and pass
// rating as a param
directive('stars', [function() {
  function linker(scope, element, attrs) {
    var retVal = '';
    var rating = scope.review;
    scope.goToRanking = function(starRating) {
      if (scope.code === '41004' || scope.code === '41005') {
        scope.onSet(starRating, 'shampoo-and-conditioner');
      } else {
        scope.onSet(starRating, scope.url);
      }
    };
    scope.stars = [
      {rank: 5},
      {rank: 4},
      {rank: 3},
      {rank: 2},
      {rank: 1}
    ];
  }

  return {
    link: linker,
    restrict: 'EA',
    template: '<span ng-repeat="star in stars" ng-class="{selected: star.rank <= review}" ng-click="goToRanking(star.rank)">&#x2605;</span>',
    scope: {
      review: '=',
      onSet: '=',
      code: '=',
      url: '='
    }
  };
}]).
directive('swatchDropdown', ['$location', function($location) {
  return {
    templateUrl: '/ngpartials/directives/swatch_dropdown',
    transclude: true,
    restrict: 'E',
    scope: {
      products: '=',
      callback: '=?',
      open: '=?',
      selectedUrlKey: '=?',
      bestMatch: '=?'

    },
    link: function(scope, element, attrs) {
      scope.showElement = false;
      scope.initOpen = true;
      scope.callback = scope.callback || function() {
        };

      var closeDropdown = function(e) {
        // Transverse up the parents of the clikced element (e.target and
        // search for the 'swatch-dropdown' tag/directive tag (using jQuery closest() method).
        // If found then then do nothing,
        // else unbind all click events on the document and a tags and close the swatch
        var swatchEl = $(e.target).closest('swatch-dropdown').length;
        var documentEl = $(document);
        var allLinks = $('.mr-accordion a');

        if (swatchEl) {
          return;
        }

        if (scope.open) {
          //unbind closeDropdown
          documentEl.unbind('click', closeDropdown);
          allLinks.unbind('click', closeDropdown);

          scope.$apply(function() {
            scope.open = false;
          });
        }
      };

      var addDropdownListener = function(flag) {
        var documentEl = $(document);
        var allLinks = $('.mr-accordion a');

        setTimeout(function() {
          //If you click anywhere but on a swatch, and the swatch is open, it should close
          //Unbind just in case there are other click listeners else it will fire multiple times
          //Also, we are specifically listening to the a tags because ng-click on the accordion section  a tag
          //that calls toggleSection is preventing click event from bubbling up to the document
          //where we have the first click listener on.
          documentEl.unbind('click', closeDropdown);
          documentEl.bind('click', closeDropdown);
          allLinks.unbind('click', closeDropdown);
          allLinks.bind('click', closeDropdown);

        }, 100);
      };

      scope.$on('init', function(event, mass) {
        scope.$parent.safeApply(function() {
          scope.showElement = true
        });
      });

      scope.$watch('products', function(val) {

        if (val) {
          scope.products.forEach(function(prod) {
            if (prod.url_key === scope.selectedUrlKey) {
              scope.selectProd(prod);
            }
          });

          if (!scope.selectedProd) {
            scope.selectedProd = scope.products[0];
          }
        }
      });

      scope.toggleSwatches = function() {
        scope.open = !scope.open;

        // If the dropdown is open then bind closeDropdown handler
        if (scope.open) {
          addDropdownListener();
        }

      };

      scope.selectProd = function(prod, url) {
        scope.selectedProd = prod;
        if (scope.initOpen) {

          //If a (mobile and not comming from shop/hair-color) or (rtu) open dropdown
          if ((isMobileDevice && document.referrer.indexOf('shop/hair-color') < 0) || prod.product_type === 'root_touch_up') {
            addDropdownListener();
            scope.open = true;
          }

          scope.initOpen = false;
          scope.callback(prod);
        } else {
          scope.open = false;
          $location.path(url);
          scope.callback(prod);
        }
      };
    }
  };
}])
.
directive('testimonial', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      quotes: '@',
      sig: '@'
    },
    template: '<div class="quote"><span class="quote-text">{{quotes}}</span><span class="sig"> — {{sig}}</span></div>'
  }
}).
/**
 * When page loses focus and regains focus the page will reload
 * Originally created for users that have a delinced amazon payment profile.
 * User will be directed to click the edit link on my account payment profile. A new browser tab opens to their amazon payments.
 * When user fixes payment info and they go back to the MR browser tab, the my account page will reload to reflect the updated amazon payments profile
 */
directive('windowFocusRefresh', [function() {
  return {
      restrict: 'A',
    link: function(scope, element, attrs) {
      var refresh;

      // Set variable refresh to true when target element is clicked
      $(element).on('click', function() {
        refresh = true;
      });

      // When page loses focus and regains focus the page will reload
      // if variable refresh is true, meaning user has clicked on the target element
      $(window).on('focus', function() {
        if (refresh) {
          location.reload();
        }
      });
    }
  };
}]);

/** ****************************************************
  Module mrWebsite.filters
**************************************************** **/
angular.module('mrWebsite.filters', ['ngResource']).
filter('YesNoBlank', function() {
  return function(val) {
    if (val === undefined || val === null || val === '') {
      return '';
    }

    return !!+val ? 'Yes' : 'No';
  };
}).
filter('advisorValue', function() {
  var mapping = {
    wantLevel: {
      darker: 'Darker',
      same: 'Stay same',
      lighter: 'Lighter'
    },
    hairTone: {
      red: 'Red',
      gold: 'Gold',
      mahogany: 'Mahogany',
      copper: 'Copper',
      ash: 'Ash/Violet',
    },
    colorTreated: {
      no: 'No',
      permanent_color: 'Permanent Color',
      semi_permanent_color: 'Semi-Permanent Color',
      henna: 'Henna',
      highlights: 'Highlights',
      all_over_color: 'All Over Color',
    },
    colorResistantGrays: {
      yes: 'Yes',
      no: 'No',
      maybe: 'Maybe',
      not_sure: 'Unsure'
    },
    grayQuantity: {
      no_gray: 'None',
      less_than_50: 'Some',
      more_than_50: 'Mostly',
      all: 'All',
      not_sure: 'Unsure',
    },
    level: function(value) {
      if (value) {
        return 'Level ' + value;
      }
    }
  };
  return function(value, key) {
    if (value === undefined) {
      return '';
    }

    value = ('' + value).toLowerCase();
    if (mapping[key] instanceof Function) {
      return mapping[key](value) || '';
    }
    return (mapping[key] || {})[value] || '';
  };
}).
filter('advisorWeeks', function() {
  return function(val, allFrequencies) {
    allFrequencies = allFrequencies || [];
    var max = allFrequencies.reduce(function(prev, cur) {
      return Math.max(prev, cur);
    }, 8);
    if (!val) {
      return 'Select frequency';
    }

    var plus = val == max ? '+' : '';
    var weeks = 'Week' + (val > 1 ? 's' : '');

    return 'Every ' + val + plus + ' ' + weeks;
  };
}).
filter('blogDate', ['$filter', function($filter) {
  return function(date, format) {
    format = format || 'MMMM d, y';
    var offset = 180 * 24 * 60 * 60 * 1000; // 6 months
    var dateFilter = $filter('date');
    date = new Date(date);

    if (+date > Date.now() - offset) {
      return 'on ' + dateFilter(date, format);
    }

    return '';
  };
}])
.
filter('capitalize', function() {
  //this filter will greedily capitalize the first character and lowercase all others unless the nameSafe argument is passsed
  //Ex. DrGene McSimmons => Drgene Mcsimmons
  //Ex. with nameSafe argument DrGene McSimmons => DrGene McSimmons
  return function(input, nameSafe) {
    if (!!input) {
      return input.replace(/([^\W_]+[^\s-]*) */g, function(txt){
        var subStr = txt.substr(1);
        if (!nameSafe) {
          subStr = subStr.toLowerCase();
        }
        return txt.charAt(0).toUpperCase() + subStr;
      });
    } else {
      return '';
    }
  };
})
.
filter('ccDeclinedFilter', function() {
  return function(orders) {
    var filtered = [];
    angular.forEach(orders, function(order) {
      if (order.payment_status != 'declined') {
        filtered.push(order);
      }
    });
    return filtered;
  };
}).
filter('checkStatus', function() {
  return function(status) {
    switch (status) {
      case 'pending':
        return 'Pending';
      case 'reshipped':
      case 'shipped':
        return 'Shipped';
      case 'declined':
        return 'Credit Card Failure';
      case 'canceled':
        return 'Canceled';
      case 'returned':
        return 'Returned';
      case 'completed':
        return 'Completed';
      case 'scheduled':
        return 'Scheduled';
      case 'backordered':
        return 'Back-ordered';
      case 'delivered':
        return 'Delivered';
      default:
      case 'processing':
        return 'Processing';
    }
  };
}).
filter('customCurrency', ["$filter", function ($filter) {
  return function(amount, currencySymbol){
    var currency = $filter('currency');

    if (amount < 0) {
      return currency(amount, currencySymbol).replace("(", "‑").replace(")", ""); // It may not look like it, but "‑" isn't the same as "-". The one used here is a non-breaking hyphen.
    }

    return currency(amount, currencySymbol);
  };
}]).
filter('freeCurrency', ['$filter', function($filter) {
  return function(amount, currencySymbol) {
    var currency = $filter('currency');
    if (amount === 0) {
      return 'FREE';
    } else {
      return currency(amount, currencySymbol);
    }
  };
}]).
filter('lpad', function() {
  return function(val, size, char) {
    if (val === undefined) {
      return;
    }
    size = size || 4;
    char = char ? String(char) : '0';
    val = String(val);
    while (val.length < size) {
      val = char + val;
    }
    return val;
  };
}).
filter('minMaxRange', function() {
  return function(input, min, max) {
    min = parseInt(min);
    max = parseInt(max);

    for (var i = min; i <= max; i++) {
      input.push(i);
    }
    return input;
  };
}).
filter('naturalSort',function(){
 function naturalSort (a, b) {
    var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
      sre = /(^[ ]*|[ ]*$)/g,
      dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
      i = function(s) { return naturalSort.insensitive && (''+s).toLowerCase() || ''+s },
      // convert all to strings strip whitespace
      x = i(a).replace(sre, '') || '',
      y = i(b).replace(sre, '') || '',
      // chunk/tokenize
      xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
      yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
      // numeric, hex or date detection
      xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
      yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
      oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD)
      if ( xD < yD ) return -1;
      else if ( xD > yD ) return 1;
  // natural sorting through split numeric strings and default strings
    for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
          oFxNcL += '';
          oFyNcL += '';
      }
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
  }
  return function(arrInput) {
    var arr = arrInput.sort(function(a, b) {
      return naturalSort(a.booth,b.booth);
    });
    return arr;
  }
}).
filter('numberText', function() {
  return function (number) {
    var numText = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
    return numText[+number] || '';
  }
})
.
filter('orderYearsFilter', function() {
  return function(orders, year) {
    var filtered = [];
    angular.forEach(orders, function(order) {
      if (order.orderYear == year || year === 'all') {
        filtered.push(order);
      }
    });
    return filtered;
  };
}).
filter('partition', function() {
  var cache = {};
  var filter = function(arr, size) {
    if (!arr) { return; }
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    var arrString = JSON.stringify(arr);
    var fromCache = cache[arrString+size];
    if (JSON.stringify(fromCache) === JSON.stringify(newArr)) {
      return fromCache;
    }
    cache[arrString+size] = newArr;
    return newArr;
  };
  return filter;
}).
filter('phoneNumber', function() {
  return function (phoneNr) {

    if (!phoneNr) {
      return '';
    }

    var value = phoneNr.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return phoneNr;
    }

    var country, city, number;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;

      default:
        return phoneNr;
    }

    if (country == 1) {
      country = "";
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + " (" + city + ") " + number).trim();
  };
}).
filter('plural', function() {
  return function(txt, val, extra) {
    var end = 's';
    if (extra) {
      end = extra;
    }
    return val > 1 ? txt + end : txt;
  };
}).
filter('range', function() {
  return function(input, total) {
    total = parseInt(total);
    for (var i = 0; i < total; i++) {
      input.push(i);
    }
    return input;
  };
}).
filter('rpad', function() {
  return function(val, size, char) {
    if (val === undefined) {
      return;
    }
    size = size || 4;
    char = char ? String(char) : '0';
    val = String(val);
    while (val.length < size) {
      val += char;
    }
    return val;
  };
}).
filter('sortByParam', ['$filter', function($filter) {
  return function(arr, param, reverse) {
    if (reverse === '') {
      return arr;
    }

    return $filter('orderBy')(arr, param, reverse);
  };
}]).
filter('startFrom', function() {
  return function(input, start) {
    if (input === undefined) {
      return input;
    } else {
      return input.slice(+start);
    }
  };
}).
filter('subStatusFilter', function() {
  return function(subs, status) {
    var filtered = [];
    angular.forEach(subs, function(sub) {
      if (sub.status === status || status === 'All') {
        filtered.push(sub);
      }
    });
    return filtered;
  };
}).
filter('superscriptCurrency', ["$filter", '$sce', function ($filter, $sce) {
  return function(amount, currencySymbol){
    var currency = $filter('currency');

    var formatted;
    if (amount < 0) {
      formatted = currency(amount, currencySymbol).replace("(", "‑").replace(")", ""); // It may not look like it, but "‑" isn't the same as "-". The one used here is a non-breaking hyphen.
    } else {
      formatted = currency(amount, currencySymbol);
    }

    if (!formatted) {
      return formatted;
    }

    var symbol = formatted[0];
    var html = [];
    if (isNaN(symbol)) {
      formatted = formatted.replace(symbol, '');
      html.push('<sup>' + symbol + '</sup>');
    }
    var parts = formatted.split('.');
    html.push(parts[0]);
    html.push('<sup>' + parts[1] + '</sup>');
    return $sce.trustAsHtml(html.join(''));
  };
}]).
filter('trustHtml', ['$sce', function($sce) {
  return function(input) {
    return $sce.trustAsHtml(input);
  };
}]).
filter('valueExists', function() {
  return function(val) {
    if (val === undefined || val === null || val === '') {
      return false;
    }

    return true;
  };
});

/** ****************************************************
  Module mrWebsite.services
**************************************************** **/
angular.module('mrWebsite.services', ['ngResource']).
factory('addressSvc', ['$rootScope', 'resource', 'loader', 'notifySvc', 'subscriptionSvc', 'phoneNumberFilter', 'Modal', function($rootScope, resource, loader, notifySvc, subscriptionSvc, phoneNumberFilter, Modal) {

  var httpSvc = resource('/api/customer', {}, {
    getAllAddresses: { method: 'GET', url: '/api/customer/getAllAddresses' },
    deleteAddress: { method: 'POST', url: '/api/customer/deleteAddress' },
    addOrUpdateAddress: { method: 'POST', url: '/api/customer/addOrUpdateAddress' },
    setDefaultShipAddress: { method: 'POST', url: '/api/customer/setDefaultShipAddress' },
    validateAddressViaUsps: { method: 'POST', url: '/api/customer/validateAddressViaUsps' },
    getSubscriptionsWithItemsByAddressId: { method: 'GET', url: '/api/subscription/getSubscriptionsWithItemsByAddressId', isArray: true },
    updateShipAddressForSubscriptions: { method: 'POST', url: '/api/subscription/updateShipAddressForSubscriptions' },
    zipCheck: { method: 'GET', url: '/api/usps/zipCheck'}
  });

  var exports = {};

  exports.messages = {
    incomplete: 'Please complete your shipping information.',
    invalid: 'Your shipping information is invalid. Please review.',
    default: 'We were unable to save your shipping address. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    success: 'Thanks! Your default shipping information has been updated.',
    login: 'We were unable to authenticate your user, please log in again.'
  };

  exports.addressKeys = ['first_name', 'last_name', 'street_1', 'street_2', 'post_code', 'city', 'region', 'phone'];
  //- set up address validation and subscription check modals
  exports.confirmAddressModal = Modal.newModal('confirmAddressModal');

  exports.confirmAddressModal.confirmAddressSave = function() {
    stopSaveProcess();
    addOrUpdateAddress(exports.confirmAddressModal.addrToSave, exports.confirmAddressModal.finishAddrSave);
  };
  exports.confirmAddressModal.cancelAddressSave = function() {
    $rootScope.$broadcast('cancel_address_save');
    exports.savingShipping = false;
  };

  exports.addresses = {};
  exports.addressArr = [];
  exports.inEditMode = false; //- address form is visible when true
  exports.addressInEdit = {}; //- address object being edited
  exports.selectedAddress = {}; //- address currently selected (checkout, sub edit)
  exports.defaultShipAddress = null; //- address object based on is_default_shipping
  exports.hasExistingAddresses = false; //- indicates if user has any addresses
  exports.confirmedShippingAddress = false; //- used in checkout, when false order can not be placed

  exports.cancelEdit = cancelEdit;
  exports.editAddress = editAddress;
  exports.getAddresses = getAddresses;
  exports.deleteAddress = deleteAddress;
  exports.setSelectedAddress = setSelectedAddress;
  exports.startSaveShipAddress = startSaveShipAddress;
  exports.checkForDefaultAddrs = checkForDefaultAddrs;
  exports.runAddressValidation = runAddressValidation;
  exports.updateDefaultShipAddress = updateDefaultShipAddress;
  exports.updateAddressForAllSubs = updateAddressForAllSubs;

  exports.zipCheck = httpSvc.zipCheck;

  getAddresses();

  function Address() {
    this.first_name = '';
    this.last_name = '';
    this.street_1 = '';
    this.street_2 = '';
    this.city = '';
    this.post_code = '';
    this.region = '';
    this.phone = '';
    this.is_default_shipping = true;
    this.updateAllSubs = true;
  }

  $rootScope.$on('reload_addresses', function() {
    getAddresses();
  });

  function getAddresses(cb) {
    cb = cb || angular.noop;
    httpSvc.getAllAddresses(function(res) {
      exports.addressArr = [];
      exports.addresses = res.addresses;

      if (!!Object.keys(exports.addresses).length) {
        exports.hasExistingAddresses = true;
        Object.keys(exports.addresses).forEach(function(addressId) {
          //- make sure that address id exists on exports.addresses
          if (!exports.addresses.hasOwnProperty(addressId)) {
            return;
          }
          exports.addressArr.push(exports.addresses[addressId]);
          exports.addresses[addressId].phone = phoneNumberFilter(exports.addresses[addressId].phone);
          // update object reference for angular
          if (exports.selectedAddress &&  exports.selectedAddress.id == addressId) {
            exports.selectedAddress = exports.addresses[addressId] || {};
          }
        });
      } else {
        exports.inEditMode = true;
      }

      $rootScope.$broadcast('address_loaded_all');
      checkForDefaultAddrs(cb);
    });
  }

  function checkForDefaultAddrs(callback) {
    var addressKeys = Object.keys(exports.addresses);
    if (addressKeys.length > 0) {
      addressKeys.forEach(function(key) {
        var addr = exports.addresses[key];
        addr.fullDisplayName = [addr.street_1, addr.street_2, addr.city, addr.region, addr.post_code].join(' ');
        if (addr.is_default_shipping) {
          exports.defaultShipAddress = addr;
          exports.defaultShipAddress.phone = phoneNumberFilter(exports.defaultShipAddress.phone);

          if (!exports.selectedAddress.id) {
            exports.selectedAddress = exports.defaultShipAddress || {};
          }
          exports.confirmedShippingAddress = true;
        }
      });
      callback();
    }
  }

  function updateDefaultShipAddress(addressId) {
    httpSvc.setDefaultShipAddress({address_id: addressId}, function(res) {
      getAddresses();
      $rootScope.$broadcast('address_set_default');
      notifySvc.notify('success', exports.messages.success);
    }, function(err) {
      notifySvc.notify('error', err.message);
    });
  }

  function editAddress(addressId) {
    var address = exports.addresses[addressId] || new Address();
    //- isDefaultOnLoad tracks the state of is_default_shipping before edit was initiated
    address.isDefaultOnLoad = address.is_default_shipping;
    exports.shippingConfirmed = false;
    exports.addressInEdit = angular.copy(address);
    exports.addressInEdit.phone = phoneNumberFilter(exports.addressInEdit.phone);
    exports.inEditMode = true;
    $rootScope.$broadcast('edit_address');
  }

  function cancelEdit(form) {
    if (!exports.hasExistingAddresses) {
      return;
    }

    if (exports.selectedAddress && exports.selectedAddress.paymentProfileId) {
      exports.confirmedShippingAddress = true;
    }

    exports.inEditMode = false;
    exports.addressInEdit = null;

    if (form) {
      form.$setPristine();
    }
  }

  function setSelectedAddress(addressId) {
    exports.selectedAddress = exports.addresses[addressId] || {};
    exports.confirmedShippingAddress = true;
    $rootScope.$broadcast('address_new_selected', exports.selectedAddress);
  }

  function startSaveShipAddress(addressForm, callback) {
    if (!callback) {
      callback = angular.noop;
    }
    exports.confirmAddressModal.validatedAddress = {};

    if (exports.savingShipping) {
      return;
    }

    if (addressForm.$invalid) {
      addressForm.$setDirty();
      Object.keys(addressForm).forEach(function(key) {
        if (addressForm[key] && addressForm[key].$setDirty) {
          addressForm[key].$setDirty();
        }
      });
      return;
    }

    if (!addressForm.$dirty) {
      exports.selectedAddress = angular.copy(exports.addressInEdit);
      callback();
      return;
    }

    exports.savingShipping = true;
    //- pass address through validation
    runAddressValidation(exports.addressInEdit, function() {
      exports.inEditMode = false;
      addressForm.$setPristine();
      callback();
    });
  }

  //- takes address Obj and callback to execute after address has been saved
  function runAddressValidation(rawAddress, callback) {
    var modal = exports.confirmAddressModal;
    modal.finishAddrSave = callback;

    modal.validatedAddress = {};
    modal.notValidatedAddr = angular.copy(rawAddress);
    httpSvc.validateAddressViaUsps(modal.notValidatedAddr, function(validated) {
      modal.validatedAddress = validated;
      modal.addrToSave = modal.validatedAddress;

      //- compare validated and entered address
      var addrKeys = ["street_1", "street_2", "post_code", "city", "region"];
      for (var i = 0; i < addrKeys.length; i++) {
        // if address does't match open confirm modal
        var key = addrKeys[i];
        var addrPart = modal.notValidatedAddr[key] || '';
        var validPart = validated[key] || '';
        if (addrPart.toUpperCase() != validPart.toUpperCase()) {
          modal.open();
          // avoid validation on save if customer choses notValidated address
          modal.notValidatedAddr.skip_usps = true;
          stopSaveProcess();
          return;
        }
      }

      addOrUpdateAddress(modal.addrToSave, modal.finishAddrSave);
    }, function (err) {
      stopSaveProcess();
      if (err.data && err.data.code && err.data.code == 'INVALID_ADDRESS') {
        //- if address is not valid and doesn't have corrected suggestions prompt user to confirm save with invalid address skipping usps validation
        modal.addrToSave = modal.notValidatedAddr;
        modal.open();
        modal.notValidatedAddr.skip_usps = true;
        return;
      }

      notifySvc.notify('error', 'Your shipping information is invalid. Please review.');
    });
  }

  function stopSaveProcess() {
    exports.savingShipping = false;
    exports.confirmedShippingAddress = false;
    loader.finish();
  }

  function addOrUpdateAddress(address, callback) {
    if (address.updateAllSubs) {
      if (!Array.isArray(address.update_address_for_subs)) {
        address.update_address_for_subs = [];
      }

      angular.forEach(subscriptionSvc.subscriptions, function(sub) {
        address.update_address_for_subs.push(sub.id);
      });
    }

    httpSvc.addOrUpdateAddress(address, function(res) {
      if (res.err) {
        notifySvc.notify('error', exports.messages.default);
        return;
      }

      getAddresses(function() {
        setSelectedAddress(res.id);
        exports.savingShipping = false;
        $rootScope.$broadcast('address_save');
        callback();
      });
    }, function(err) {
      if (err && err.data && err.data.code == "REST_ACCESS_DENIED") {
        notifySvc.notify('error', exports.messages.login);
        window.location = window.location;
      } else {
        notifySvc.notify('error', exports.messages.invalid);
      }
      exports.savingShipping = false;
    });
  }

  function updateAddressForAllSubs(address) {
    address.updateAllSubs = true;
    //- this will also become customers default shipping
    address.is_default_shipping = true;
    exports.savingShipping = true;
    //- pass address through validation
    runAddressValidation(address, function() {
      exports.inEditMode = false;
      $rootScope.$broadcast('update_address_for_subs');
      notifySvc.notify('success', 'Shipping address for all auto-deliveries has been updated');
    });
  }

  function deleteAddress(address_id, callback) {
    callback = callback || angular.noop;
    
    var payload = {
      address_id: address_id
    };

    httpSvc.deleteAddress(payload, function(res) {
      if (res.err) {
        notifySvc.notify("warn", exports.messages.cantDelete);
        return;
      }
      notifySvc.notify('success', 'Your address was successfully removed.');
      $rootScope.$broadcast('address_deleted');
      getAddresses();
    }, function(err) {
      notifySvc.notify('warn', err.data.message);
    });
  }

  return exports;
}])
.
factory('advisorSvc', ['resource', function(resource, loader) {
  return resource('/api/advisor', {}, {
    getRecommendations: { method: 'POST', url: '/api/advisor/getRecommendations' },
    save: { method: 'POST', url: '/api/advisor/save' },
    syncSession: { method: 'POST', url: '/api/advisor/syncSession' },
    getTranslatorData: { method: 'GET', url: '/api/advisor/getTranslatorData' },
    getRebootTranslatorData: { method: 'GET', url: '/api/advisor/getRebootTranslatorData' },
    getHairToneOptions: { method: 'POST', url: '/api/advisor/getHairToneOptions' },
    getCompareShadesData: { method: 'GET', url: '/api/advisor/getCompareShadesData' },
    trackTranslationComplete: { method: 'POST', url: '/api/advisor/trackTranslationComplete' },
    saveRecommendations: { method: 'POST', url: '/api/customer/saveRecommendations' }
  });
}])
.
factory('amazonSvc', ['resource', function(resource, loader) {
  return resource('/api/amazon', {}, {
    getProfile: { method: 'GET', url: '/api/amazon/getProfile' },
    syncProfile: { method: 'GET', url: '/api/amazon/syncProfile' },
    getDefaultPayment: { method: 'GET', url: '/api/amazon/getDefaultPayment' },
    setAndConfirmBillingAgreement: { method: 'POST', url: '/api/amazon/setAndConfirmBillingAgreement' },
    getAddressFromBillingAgreementId: { method: 'GET', url: '/api/amazon/getAddressFromBillingAgreementId' }
  });
}]).
factory('appLookupSvc', ['$resource', function($resource) {
  var httpSvc = $resource('/api/appLookup', {}, {
    getRegionsByCountry: { method: 'GET', url: '/api/appLookup/getRegionsByCountry', isArray: true }
  });

  var data = {};

  return {
    getRegionsByCountry: function(params, onSuccess, onError) {
      var country = params.country;
      if (data.regions && data.regions[country]) {
        return onSuccess(data.regions[country]);
      }
      onError = onError || angular.noop;
      httpSvc.getRegionsByCountry(params, function(regions) {
        data.regions = data.regions || {};
        data.regions[country] = regions;
        onSuccess(regions);
      }, onError);
    }
  }
}]).
factory('checkoutSvc', ['resource', function(resource, loader) {
  return resource('/api/checkout', {}, {
    placeOrder: { method: 'POST', url: '/api/checkout/placeOrder' }
  });
}]).
factory('clientLoggingSvc', ['resource', function(resource) {
  var httpSvc = resource('/api/clientLogging', {}, {
    logDebug: { method: 'POST', url: '/api/clientLogging/logDebug' },
    logError: { method: 'POST', url: '/api/clientLogging/logError' },
    logInfo: { method: 'POST', url: '/api/clientLogging/logInfo' },
    logSilly: { method: 'POST', url: '/api/clientLogging/logSilly' },
    logWarn: { method: 'POST', url: '/api/clientLogging/logWarn' },
  });

  function logDebug(origin, err, path) {
    httpSvc.logDebug({origin: origin, error: splitError(err), path: path});
  }
  
  function logError(origin, err, path) {
    httpSvc.logError({origin: origin, error: splitError(err), path: path});
  }

  function logInfo(origin, err, path) {
    httpSvc.logInfo({origin: origin, error: splitError(err), path: path});
  }

  function logSilly(origin, err, path) {
    httpSvc.logSilly({origin: origin, error: splitError(err), path: path});
  }

  function logWarn(origin, err, path) {
    httpSvc.logWarn({origin: origin, error: splitError(err), path: path});
  }

  // The only way to get stack trace to back end. JS errors are weird.
  function splitError(err) {
    if (!err.stack) {
      return err;
    }

    return err.stack.split('\n');
  }

  return {
    logDebug: logDebug,
    logError: logError,
    logInfo: logInfo,
    logSilly: logSilly,
    logWarn: logWarn
  };
}]).
factory('cmsSvc', ['resource', function(resource) {
  return resource('/api/cmsSvc', {}, {
    renderDeferedComponent: { method: 'GET', url: '/api/cmsSvc/renderDeferedComponent', isArray: false },
    //Must keep POST because we are passing query params or will break blog
    callDeferedGetterMethod: { method: 'POST', url: '/api/cmsSvc/callDeferedGetterMethod', isArray: false }
  });
}]).
factory('colorBarSvc', ['$rootScope', 'resource', 'notifySvc', 'dateFilter', '$window', function($rootScope, resource, notifySvc, dateFilter, $window) {
  var httpSvc = resource('/api/colorbar', {}, {
    loadLocationByCode: { method: 'GET', url: '/api/colorbar/loadLocationByCode' },
    getActiveLocationList: { method: 'GET', url: '/api/colorbar/getActiveLocationList', isArray: true},
    getAvailableDates: { method: 'GET', url: '/api/colorbar/getAvailableDates'},
    getAvailableTimes: { method: 'GET', url: '/api/colorbar/getAvailableTimes', isArray: true},
    createHold: { method: 'POST', url: '/api/colorbar/createHold'},
    createHoldWithAltResource: { method: 'POST', url: '/api/colorbar/createHoldWithAltResource'},
    createAppointment: { method: 'POST', url: '/api/colorbar/createAppointment'},
    loadCustomerUpcomingAppointments: { method: 'GET', url: '/api/colorbar/loadCustomerUpcomingAppointments', isArray: true},
    applyServicePromo: { method: 'POST', url: '/api/colorbar/applyServicePromo'},
    checkIfCustomerEmailExists: { method: 'GET', url: '/api/colorbar/checkIfCustomerEmailExists'},
    loadUnsavedAppointmentsFromSession: { method: 'GET', url: '/api/colorbar/loadUnsavedAppointmentsFromSession'},
    storeUnsavedBookingToSessionAndLogIn: { method: 'POST', url: '/api/colorbar/storeUnsavedBookingToSessionAndLogIn'},
    cancelAppointment: { method: 'POST', url: '/api/colorbar/cancelAppointment'},
    loadAppointment: { method: 'GET', url: '/api/colorbar/loadAppointment'},
    loadPreviousAppointment: { method: 'GET', url: '/api/colorbar/loadPreviousAppointment'},
    confirmAppointment: { method: 'POST', url: '/api/colorbar/confirmAppointment'},
    createCustomer: { method: 'POST', url: '/api/colorbar/createCustomer'}
  });

  var exports = {};

  exports.loadLocationByCode = httpSvc.loadLocationByCode;
  exports.getActiveLocationList = httpSvc.getActiveLocationList;
  exports.getAvailableTimes = httpSvc.getAvailableTimes;
  exports.createHold = httpSvc.createHold;
  exports.createHoldWithAltResource = httpSvc.createHoldWithAltResource;
  exports.createAppointment = httpSvc.createAppointment;
  exports.loadCustomerUpcomingAppointments = httpSvc.loadCustomerUpcomingAppointments;
  exports.applyServicePromo = httpSvc.applyServicePromo;
  exports.checkIfCustomerEmailExists = httpSvc.checkIfCustomerEmailExists;
  exports.loadUnsavedAppointmentsFromSession = httpSvc.loadUnsavedAppointmentsFromSession;
  exports.storeUnsavedBookingToSessionAndLogIn = httpSvc.storeUnsavedBookingToSessionAndLogIn;
  exports.cancelAppointment = httpSvc.cancelAppointment;
  exports.loadAppointment = httpSvc.loadAppointment;
  exports.loadPreviousAppointment = httpSvc.loadPreviousAppointment;
  exports.confirmAppointment = httpSvc.confirmAppointment;
  exports.createCustomer = httpSvc.createCustomer;

  exports.initializeAppointmentData = initializeAppointmentData;
  exports.getAvailableDates = getAvailableDates;
  exports.fromCalDate = fromCalDate;
  exports.waitlistEligible = waitlistEligible;

  exports.editAppointment = null;

  function getAvailableDates(payload, callback) {
    httpSvc.getAvailableDates(payload, function(dates) {
      exports.dates.available = dates;
      callback();
    });
  }

  function waitlistEligible(calDate, maxWaitlistDays) {
    if (!calDate || !maxWaitlistDays) {
      return false;
    }
    var today = new Date();
    today.setHours(0,0,0,0);
    var formattedCalDate = fromCalDate(calDate);
    var oneDay = 24*60*60*1000;
    var diffDays = Math.round(Math.abs((today.getTime() - formattedCalDate.getTime())/(oneDay)));
    return diffDays < maxWaitlistDays ? true : false;
  }

  function fromCalDate(calDate) {
    var dArr = calDate.toString().replace(/([0-9]{4})([0-9]{2})([0-9]{2})/, '$1-$2-$3').split('-');
    return new Date(parseInt(dArr[0]), parseInt(dArr[1]) - 1, parseInt(dArr[2]), 0, 0, 0);
  }

  function initializeAppointmentData() {
    exports.booking = {
      location: null,
      service: true,
      date: null,
      time: null,
      customer: null,
      comments: null,
      hold: null
    };

    exports.services = {
      all: [],
      selected: null,
      selectedAddon: null
    };

    exports.dates = {
      available: {},
      selected: {
        day: null
      },
      maxDaysInAdvance: 0,
      maxWaitlistDays: 0
    };

    exports.times = {
      selected: {
        time: null
      },
      available: {}
    };

    exports.extraInfo = {
      notes: '',
      longHair: false
    };

    exports.promos = {
      all: [],
      displaySubtotal: null
    };

    exports.promoErrors = {
      all: [],
      isEmpty: false
    };

    exports.coupon = {
      code: null
    };
  }

  initializeAppointmentData();
  return exports;
}])
.
factory('contactSvc', ['resource', 'loader', 'FileUploader', 'notifySvc', 'scrollToSvc', function(resource, loader, FileUploader, notifySvc, scrollToSvc) {
  var exports = {};
  var httpSvc = resource('/api/contact/', {}, {
    getCustomerBasicInfo: { method: 'GET', url: '/api/contact/getCustomerBasicInfo' },
    saveCustomerPhoneFromEmail: { method: 'POST', url: '/api/contact/saveCustomerPhoneFromEmail' },
    sendEmail: { method: 'POST', url: '/api/contact/sendEmail' },
    isDuringWorkHours: { method: 'GET', url: '/api/contact/isDuringWorkHours'},
    getColorBarLocations: { method: 'GET', url: '/api/colorbar/listLocations', isArray: true }
  });

  var contact = {
    email: '',
    name: '',
    phone: '',
    preference: '',
    subject: '',
    subjectObj: {},
    message: '',
    first_name: '',
    last_name: ''
  };

  var authedUser = false;

  exports.sendEmail = httpSvc.sendEmail;
  exports.uploader = initUploader();
  exports.submit = submit;
  exports.showForm = true;
  exports.sendSalonEmail = sendSalonEmail;
  exports.getColorBarLocations = getColorBarLocations;
  exports.contact = contact;
  exports.cbLocations = {};
  exports.selectedCbLocation = null;

  var appointments = {
    upcoming: {},
    last: {}
  };

  var uploadError = false;
  getCustomerBasicInfo();
  isDuringWorkHours();

  function getColorBarLocations() {
    if (Object.keys(exports.cbLocations).length) {
      //- in case we already loaded locations no need to do it again
      return;
    }

    httpSvc.getColorBarLocations({}, function(locations) {
      (locations || []).forEach(function(location) {
        exports.cbLocations[location._id] = location;
      });

      if (appointments.upcoming.locationId) {
        exports.selectedCbLocation = exports.cbLocations[appointments.upcoming.locationId];
      } else if (appointments.last.locationId) {
        exports.selectedCbLocation = exports.cbLocations[appointments.last.locationId];
      }
    });
  }

  function initUploader() {
    // Create new instance of FileUploader plugin
    return new FileUploader({
      url: '/api/customer/uploadCustomerImage',
      filters: [{
        name: 'checkMaxSize', 
        fn: function(item) {
          // Check if file is over maxSize
          var maxSize = 10000000;
          if (item.size > maxSize) {
            notifySvc.notify('error', item.name + ' is too large. Photos must be less than 7 MB in size.');
            return false;
          }
          return true;
        }
      },{
        name: 'checkFileLimit', 
        fn: function() {
        // Make sure the amount of files being uploaded is not over maxLimit
        var maxLimit = 3;
        if (exports.uploader.queue.length >= maxLimit) {
          notifySvc.notify('error', "We're sorry. We currently allow up to " + maxLimit + " photos per request.");
          return false;
        } else {
          return true;
          }
        }
      }, {
        name: 'imageFilter',
        fn: function(item, options) {
          var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
          return '|jpg|png|jpeg|bmp|'.indexOf(type) !== -1;
        }
      }]
    });
  }

  function submit(uploader) {
    contact.photos = [];
    loader.start();
    // If nothing to upload then just send email
    if (!uploader || !uploader.queue.length) {
      return sendEmail();
    }

    // Send email with attachments
    upload(uploader);
  }

  function upload(uploader) {
    // upload all photos in uploader queue
    uploader.uploadAll();

    // uploader event handlers
    uploader.onErrorItem = function() {
      exports.showForm = true;
      notifySvc.notify('error', 'Sorry, something went wrong while uploading your photo.');
      uploadError = true;
      loader.finish();
    };

    uploader.onCompleteItem = function(fileItem, response) {
      // when each uploads completes push into that contact object that will eventually be submitted
      var photo = {
        name: response.file_name,
        path: response.url,
        type: response.file_type
      };
      contact.photos.push(photo);
    };

    uploader.onCompleteAll = function() {
      if (!uploadError) {
        return sendEmail();
      }
      return;
    };
  }

  function sendEmail() {
    if (contact.subjectObj && contact.subjectObj.ticketType == 'colorbar') {
      contact.colorbar_location_name = exports.selectedCbLocation.name;
      contact.colorbar_location_code = exports.selectedCbLocation.code;
    }

    httpSvc.sendEmail(contact, function() {
      exports.showForm = false;
      // you need to have a '.thankyou-div' otherwise by default it will scroll to top of page
      setTimeout(function() {
        scrollToSvc.scrollToElement('.thankyou-div', 40);
      }, 300);
      loader.finish();
      if (authedUser) {
        saveCustomerPhoneFromEmail();
      }
    }, function(err) {
      if (err.data && err.data.validations) {
        var validations = err.data.validations;
        Object.keys(validations).forEach(function (validationError) {
          notifySvc.notify('error', validations[validationError].message);
        });
      } else {
        notifySvc.notify('error', 'Sorry, something went wrong while submitting your email.');
      }

      loader.finish();
      throw err;
    });
  }

  function sendSalonEmail() {
    // Salon contact form has first_name and last_name field instead of name
    if (contact.name == '') {
      contact.name = contact.first_name + ' ' + contact.last_name;
    }
    contact.ticketType = 'salon';
    submit();
  }

  function getCustomerBasicInfo() {
    httpSvc.getCustomerBasicInfo(function(result) {
      var customer = result.customer;
      appointments.upcoming = result.upcomingAppointment || {};
      appointments.last = result.pastAppointment || {};
      // If the user is authenticated, then we must save the phone number (only) to her profile.
      if (customer.email !== '') {
        authedUser = true;
      }
      contact.email = customer.email;
      contact.first_name = customer.firstName;
      contact.last_name = customer.lastName;
      contact.name = customer.firstName;

      if (customer.lastName && customer.lastName !== '') {
        contact.name += ' ' + customer.lastName;
      }
      if (customer.phoneMain && customer.phoneMain !== '') {
        contact.phone = '(' + customer.phoneMain.substr(0, 3) + ') ' + customer.phoneMain.substr(3, 3) + '-' + customer.phoneMain.substr(6,4);
      }
    });
  }

  function saveCustomerPhoneFromEmail() {
    var noOp = function() {};
    var customer = {
      email: contact.email,
      phone: contact.phone
    };
    httpSvc.saveCustomerPhoneFromEmail(customer, noOp);
  }

  function isDuringWorkHours() {
    httpSvc.isDuringWorkHours(function(results) {
      exports.workingHoursNoHoliday = results.workingHoursNoHoliday;
    }, function(err) {
      exports.workingHoursNoHoliday = false;
    });
  }

  return exports;
}])
.
factory('contentSvc', ['resource', function(resource) {
  var svc = resource('/api/contentReview', {}, {
    getProductReviews: { method: 'GET', url: '/api/contentReview/getProductReviews' },
    getApprovedReviewsInfo: { method: 'GET', url: '/api/contentReview/getProductReviewsSummary' },
    getReviewSummariesForProducts: { method: 'GET', url: '/api/contentReview/getReviewSummariesForProducts' },
    canUserReview: { method: 'GET', url: '/api/contentReview/canUserReview' },
    getRandomFiveStarReview: { method: 'GET', url: '/api/contentReview/getRandomFiveStarReview' },
    voteForReview: { method: 'POST', url: '/api/contentReview/voteForReview' }
  });

  svc.getProductReviewsSummary = function(product, callback) {
    var payload = { product_id: product.id };

    return svc.getApprovedReviewsInfo(payload, callback);
  };

  return svc;
}])
.
factory('customerSvc', ['$rootScope', 'resource', 'notifySvc', 'dateFilter', '$window', function($rootScope, resource, notifySvc, dateFilter, $window) {
  var httpSvc = resource('/api/customer', {}, {
    newsletterSignUp: { method: 'POST', url: '/api/customer/newsletterSignUp' },
    smsOptInOut: { method: 'POST', url: '/api/customer/smsOptInOut' },
    saveRecommendations: { method: 'POST', url: '/api/customer/saveRecommendations' },
    createCustomer: { method: 'POST', url: '/api/customer/createCustomer' },
    disableEmailGate: { method: 'POST', url: '/api/customer/disableEmailGate' },
    getCustomerInfo: { method: 'GET', url: '/api/customer/getCustomerInfo' },
    gatherCustomerShoppingData: { method: 'GET', url: '/api/customer/gatherCustomerShoppingData' },
    facebook: { method: 'POST', url: '/api/customer/facebookLogin' },
    updateAcc: { method: 'POST', url: '/api/account/updateAccount' },
    uploadPhoto: { method: 'POST', url: '/api/account/uploadPhoto' },
    login: { method: 'POST', url: '/api/customer/login' },
    forgotPassword: { method: 'POST', url: '/api/customer/forgotPassword' },
    sendPasswordResetSMS: { method: 'POST', url: '/api/customer/sendPasswordResetSMS' },
    logOut: { method: 'POST', url: '/api/customer/logout' },
    getSignInData: { method: 'GET', url: '/api/customer/getSignInData' },
    verifyCipherStr: { method: 'GET', url: '/api/customer/verifyCipherStr' },
    resetPassword: { method: 'POST', url: '/api/customer/resetPassword' },
    updatePassword: { method: 'POST', url: '/api/customer/updatePassword' },
    isSoftLoggedIn: { method: 'POST', url: '/api/customer/isSoftLoggedIn' },
    getRecsChatStatus: { method: 'GET', url: '/api/customer/getRecsChatStatus' },
    getMarketingPreferencesByUserId: { method: 'GET', url: '/api/customer/getMarketingPreferencesByUserId' },
    setMarketingPreferences: { method: 'POST', url: '/api/customer/setMarketingPreferences' },
    setRecsChatStatus: { method: 'POST', url: '/api/customer/setRecsChatStatus' },
    createConciergeZendeskTicket: { method: 'POST', url: '/api/customer/createConciergeZendeskTicket' },
    getAllCustomInstructionsForCustomer: { method: 'GET', url: '/api/customer/getAllCustomInstructionsForCustomer', isArray: true }
  });

  var exports = {};

  exports.createCustomer = httpSvc.createCustomer;
  exports.disableEmailGate = httpSvc.disableEmailGate;
  exports.facebook = httpSvc.facebook;
  exports.uploadPhoto = httpSvc.uploadPhoto;
  exports.login = httpSvc.login;
  exports.create = httpSvc.create;
  exports.forgotPassword = httpSvc.forgotPassword;
  exports.sendPasswordResetSMS = httpSvc.sendPasswordResetSMS;
  exports.logOut = httpSvc.logOut;
  exports.resetPassword = httpSvc.resetPassword;
  exports.getSignInData = httpSvc.getSignInData;
  exports.verifyCipherStr = httpSvc.verifyCipherStr;
  exports.isSoftLoggedIn = httpSvc.isSoftLoggedIn;

  exports.getCustomerInfo = getCustomerInfo;
  exports.checkIfExistingUser = checkIfExistingUser;
  exports.newsletterSignUp = newsletterSignUp;
  exports.wifiSignUp = wifiSignUp;
  exports.saveRecommendations = saveRecommendations;
  exports.getRecsChatStatus = getRecsChatStatus;
  exports.setRecsChatStatus = setRecsChatStatus;
  exports.createConciergeZendeskTicket = createConciergeZendeskTicket;
  exports.updatePassword = updatePassword;
  exports.resetEditProfile = resetEditProfile;
  exports.cancelEditProfile = cancelEditProfile;
  exports.updateCustomerInfo = updateCustomerInfo;
  exports.checkUserLoginError = checkUserLoginError;
  exports.writeReview = writeReview;
  exports.checkSmsInputs = checkSmsInputs;
  exports.getMarketingPreferencesByUserId = getMarketingPreferencesByUserId;
  exports.gatherCustomerShoppingData = gatherCustomerShoppingData;
  exports.updateMarketingPrefsStatus = updateMarketingPrefsStatus;
  exports.getAllCustomInstructionsForCustomer = getAllCustomInstructionsForCustomer;
  exports.createAccountPayload = createAccountPayload;

  exports.existingUser = {
    email: ''
  };

  exports.customer = {};
  exports.passwordData = {};
  exports.editProfileInfo = {};
  exports.recentOrders = {};
  exports.phoneMask = '(999) 999-9999';

  exports.userAttemptedSubmit = false;
  exports.newsletterMessage = null;
  exports.marketingPreferences = {
    loaded: false
  };

  exports.isSubscribed = null;
  exports.customerEmail = '';
  exports.customerSource = '';
  exports.colorConcierge = {
    showForm: false,
    messageFormElement: 'input',
    message: ""
  };

  exports.smsOptions = {
    mobileNumber: '',
    optInSms: false
  };

  exports.groupedSubs = null;
  exports.inactiveSubs = [];
  exports.purchaseHistory = [];
  exports.customInstructions = [];
  exports.upcomingAppointments = [];

  checkIfExistingUser();
  getRecsChatStatus();

  $rootScope.$on('reload_customer_credits', function() {
    getCustomerInfo();
  });
  //- in case where customer updates payment profile that needs attention
  $rootScope.$on('payment_profile_modified', function() {
    gatherCustomerShoppingData();
  });

  function getCustomerInfo(callback) {
    callback = callback || angular.noop;
    httpSvc.getCustomerInfo({}, function(customer) {
      exports.customer = customer;
      exports.marketingPreferences = customer.marketingPreferences;

      if (customer.phone_mobile) {
        exports.smsOptions.mobileNumber = formatPhoneNumber(customer.phone_mobile);
      }
      exports.smsOptions.optInSms = exports.marketingPreferences.optInSms;

      $rootScope.$broadcast('customer_loaded');
      callback(customer);
    }, function(err) {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function gatherCustomerShoppingData() {
    httpSvc.gatherCustomerShoppingData({}, function(res) {
      exports.inactiveSubs = res.groupedSubs.inactive || [];
      delete res.groupedSubs.inactive;

      if (!Object.keys(res.groupedSubs).length) {
        res.groupedSubs = null;
      }

      exports.groupedSubs = res.groupedSubs;
      exports.purchaseHistory = res.purchaseHistory;
      exports.recentOrders = res.recentOrders;
      exports.declinedPayments = res.declinedPayments;
      //- leave it null when nothing there so we can use this on the template for ng-if
      exports.customerPromos = Object.keys(res.customerPromos).length ? res.customerPromos : null;
      exports.upcomingAppointments = res.upcomingAppointments;

      $rootScope.$broadcast('shopping_data_loaded');
    });
  }

  function saveRecommendations(email, source, listId) {
    exports.userAttemptedSubmit = true;
    //- clear message
    exports.newsletterMessage = null;
    var params = {
      email: email,
      email_source: source,
      list_id: listId
    };

    httpSvc.saveRecommendations(params, function(res) {
      var MessengerExtensions = MessengerExtensions || null;
      exports.isSubscribed = true;
      if (MessengerExtensions) {
        setTimeout(function() {
          MessengerExtensions.requestCloseBrowser(function() {}, function() {});
        }, 2000);
      }
    }, function(err) {
      if (err.data && err.data.message) {
        return exports.newsletterMessage = err.data.message;
      }
      exports.newsletterMessage = 'We were not able to save your recommendations.';
    });
  }

  function newsletterSignUp(email, source, listId) {
    //- clear message
    exports.newsletterMessage = null;
    var params = {
      email: email,
      email_source: source,
      list_id: listId
    };

    httpSvc.newsletterSignUp(params, function(res) {
      exports.isSubscribed = true;
    }, function(err) {
      if (err.data && err.data.message) {
        return exports.newsletterMessage = err.data.message;
      }
      exports.newsletterMessage = 'We were not able to save your email.';
    });
  };

  function checkIfExistingUser() {
    httpSvc.getSignInData(function(data) {
      if (!data.email) {
        exports.isSubscribed = false;
        return;
      }
      exports.isSubscribed = true;
      exports.existingUser.email = data.email;
    });
  };

  function getRecsChatStatus() {
    httpSvc.getRecsChatStatus(function(results) {
      exports.recsChatStatus = results.status;
    }, function(err) {
      if (err) {
        exports.recsChatStatus = 'expanded';
      }
    });
  };

  function setRecsChatStatus() {
    exports.recsChatStatus = 'collapsed';
    params = {
      status: "collapsed"
    };
    httpSvc.setRecsChatStatus(params, function(){});
  }

  function createConciergeZendeskTicket() {
    var params = {
      message: exports.colorConcierge.message
    };

    httpSvc.createConciergeZendeskTicket(params, function() {
      exports.colorConcierge.messageFormElement = 'success';
      setTimeout(function() {
        exports.colorConcierge.showForm = !exports.colorConcierge.showForm;
        exports.colorConcierge.messageFormElement = 'input';
      }, 5000);
    }, function(err) {
      exports.colorConcierge.messageFormElement = 'error';
      setTimeout(function() {
        exports.colorConcierge.showForm = !exports.colorConcierge.showForm;
        exports.colorConcierge.messageFormElement = 'input';
      }, 5000);
    });
  }

  function cancelEditProfile() {
    resetEditProfile();
  }

  function resetEditProfile() {
    exports.editProfileInfo = angular.copy(exports.customer);
  }

  function updateMarketingPrefsStatus(unsubChanged) {
    if (unsubChanged && exports.marketingPreferences.unsub) {
      Object.keys(exports.marketingPreferences.messages).forEach(function(key) {
        exports.marketingPreferences.messages[key] = false;
      });
    }

    if (exports.marketingPreferences.unsub) {
      Object.keys(exports.marketingPreferences.messages).some(function(key) {
        if (exports.marketingPreferences.messages[key]) {
          exports.marketingPreferences.unsub = false;
          return true;
        }
      });
    }

    var unsubMessages = [];
    exports.marketingPreferences.allMessageTypes.forEach(function(key) {
      if (!exports.marketingPreferences.messages[key] || exports.marketingPreferences.unsub) {
        unsubMessages.push(key);
      }
    });

    exports.marketingPreferences.unsubMessages = unsubMessages;

    var payload = {
      email: exports.customer.email,
      marketingPreferences: exports.marketingPreferences
    };

    httpSvc.setMarketingPreferences(payload, function(res) {
      notifySvc.notify('success', 'Your marketing preferences have been updated.');
    }, function(err) {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function updateCustomerInfo() {
    exports.savingProfile = true;

    var birthday;
    if (exports.editProfileInfo.birthday) {
      birthday = exports.editProfileInfo.birthday.substring(0, 2) + '/' + exports.editProfileInfo.birthday.substring(2, 4) + '/1896';
    }

    if (dateFilter(birthday, 'shortDate') !== dateFilter(exports.customer.birthday, 'shortDate')) {
      exports.editProfileInfo.birthday = birthday;
    } else {
      delete exports.editProfileInfo.birthday;
    }

    if (exports.editProfileInfo.phone_main && exports.editProfileInfo.sameAsPrimary) {
      exports.editProfileInfo.phone_mobile = exports.editProfileInfo.phone_main;
    }

    exports.editProfileInfo.marketingPreferences = exports.marketingPreferences;

    exports.editProfileInfo.marketingPreferences.mobilePhone = exports.editProfileInfo.phone_mobile;

    httpSvc.updateAcc(exports.editProfileInfo, function(res) {
      exports.savingProfile = false;
      if (res.validation) {
        angular.forEach(res.validation, function(err) {
          var errMsg = err;
          if (err == 'invalid date') {
            errMsg = 'Birthday date is invalid. Please update and try again.';
          }
          notifySvc.notify('error', errMsg);
        });
        return;
      }
      getCustomerInfo(resetEditProfile);
      notifySvc.notify('success', 'Your account has been updated.');

      if (res.sendSMSOptIn) {
        notifySvc.notify('info', "You've opted-in to receive SMS messages. Check your phone to complete the process");
      }
    }, function(err) {
      exports.savingProfile = false;
      checkUserLoginError(err);
      var error = 'We were not able to update your info. Please try again or contact Color Crew';
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  };

  function updatePassword(callback) {
    callback = callback || angular.noop;
    exports.passwordData.savingPassword = true;

    httpSvc.updatePassword(exports.passwordData, function(res) {
      exports.passwordData = {};
      notifySvc.notify('success', 'You have successfully updated you password.');
      callback();
    }, function(err) {
      exports.passwordData = {};
      notifySvc.notify('error', 'We were not able to update your password. Please try again or contact Color Crew');
    });
  }

  //- checks error is user not logged in error, if so will redirect to signin and return true
  function checkUserLoginError(errObj) {
    if (!(errObj && errObj.data && errObj.data.message)) {
      return false;
    }
    //If the error message has 'not logged in'
    var isNotLogged = ~errObj.data.message.indexOf('not logged in');
    //Redirect to login page
    var errorDetails = errObj.data.errorDetails || [];
    var doRedirect = errorDetails.some(function(detail) {
      return detail.doRedirect;
    });

    if (doRedirect && isNotLogged) {
      $window.location.reload();
      return true;
    }
    return false;
  }

  function getAllCustomInstructionsForCustomer() {
    exports.customInstructions = [];
    httpSvc.getAllCustomInstructionsForCustomer(function(instructions) {
      exports.customInstructions = instructions;
    }, function(err) {
      notifySvc.notify('error', 'Sorry, we couldn\'t find any instructions. Please contact Color Crew if you keep experiencing this issue.');
    });
  }

  function getMarketingPreferencesByUserId() {
    httpSvc.getMarketingPreferencesByUserId(function(res) {
      exports.marketingPreferences = res;
      if (res.mobile_number) {
        exports.smsOptions.mobileNumber = formatPhoneNumber(res.mobile_number);
      }
      exports.smsOptions.phoneMask = '(999) 999-9999';
      exports.marketingPreferences.loaded = true;
    });
  }

  function checkSmsInputs(noPhoneCallback) {
    noPhoneCallback = noPhoneCallback || angular.noop;
    if (!exports.smsOptions.mobileNumber || !exports.smsOptions.mobileNumber.length) {
      exports.smsOptions.optInSms = false;
      noPhoneCallback();
      notifySvc.notify('warn', 'Not able to update SMS notifications, please check your mobile phone number.');
      return;
    }
    exports.savingProfile = true;

    // check to update phone_mobile
    if (exports.customer.id && !exports.customer.phone_mobile) {
      httpSvc.updateAcc({phone_mobile: exports.smsOptions.mobileNumber}, function(res) {
        callSMSOptInOut();
      });
    } else {
      callSMSOptInOut();
    }

    function callSMSOptInOut() {
      exports.smsOptions.email = exports.existingUser.email;
      httpSvc.smsOptInOut(exports.smsOptions, function(res) {
        exports.savingProfile = false;
        var message = ['You have ' + (!exports.smsOptions.optInSms ? 'unsubscribed' : 'subscribed') + ' to order updates & reminders via SMS'];
        if (exports.smsOptions.optInSms) {
          message.push('Check your phone to complete the process.');
        }
        notifySvc.notify('success', message.join(' '));
      }, function(err) {
        exports.savingProfile = false;
        notifySvc.notify('error', 'We were not able to update your SMS preferences');
      });
    }
  }

  function formatPhoneNumber(phone) {
    var newPhone = phone.replace('+1', '');
    return '(' + newPhone.slice(0, 3) + ')' + ' ' + newPhone.slice(3, 6) + '-' + newPhone.slice(6, 10);
  }

  function writeReview(url, rating) {
    var href = '/product/' + url + '/review';
    if (rating !== undefined) {
      href += '?stars=' + rating;
    }
    $window.location.href = href;
  };

  function wifiSignUp(user, baseGrantUrl, userContinueUrl) {
    if (!user.email) {
      return notifySvc.notify('error', 'Email field is empty');
    }
    user.email_source = 'colorBarWiFi';
    var payload = createAccountPayload(user);
    httpSvc.newsletterSignUp(payload, function(res) {
      $window.location.href = decodeURIComponent(baseGrantUrl) + '?continue_url=' + decodeURIComponent(userContinueUrl);
    }, function(err) {
      notifySvc.notify('error', 'Sorry, something went wrong. Please try again.');
    });
  }

  function createAccountPayload(user) {
    var fakeBirthdayYear = 1896;
    var birthday;
    if (user.birthday) {
      birthday = new Date(user.birthday + '/' + fakeBirthdayYear);
    }

    return {
      email: user.email,
      password: user.password,
      confirm: user.password,
      url: redirectUrl || false,
      email_source: user.email_source || 'website',
      optInEmail: user.optInEmail,
      birthday: birthday
    };
  }

  return exports;
}])
.
factory('dataHub', function(){
  var data = {};

  return {
    getData: function(key) {
      return data[key];
    },
    saveData: function(key, val) {
      data[key] = val;
    },
    resetData: function(key) {
      delete data[key];
    }
  };
}).
factory('dispositionSvc', ['resource', function(resource, loader) {
  return resource('/api/disposition', {}, {
    getEmailUnsubscribeReasons: { method: 'GET', url: '/api/disposition/getEmailUnsubscribeReasons', isArray: true },
    setEmailUnsubscribeDisposition: { method: 'POST', url: '/api/disposition/setEmailUnsubscribeDisposition', isArray: false }
  });
}])
.
factory('emailSvc', ['notifySvc', 'preferenceSvc', 'cdata', 'resource', 'mrNgUtils', '$cookies', function(notifySvc, preferenceSvc, cdata, resource, mrNgUtils, $cookies) {
  var exports = {};

  exports.setEmailSubPreferences = setEmailSubPreferences;
  exports.preferencesUpdatedModal = {
    show: false
  };
  exports.email = '';
  exports.allMessageTypes = [];

  if ($cookies.iterableEndUserId) {
    exports.email = decodeURIComponent($cookies.iterableEndUserId);
  } else if (cdata.user && cdata.user.email) {
    exports.email = cdata.user.email;
  }

  exports.iterable = {};

  preferenceSvc.getMarketingPreferences({email: exports.email}, function(res) {
    res = res || {};


    var unsubbedChannels = res.iterableChannel || [];
    var unsubbedMessages = res.iterableMessages || [];
    exports.allMessageTypes = res.allMessageTypes || [];

    if (unsubbedChannels.length) {
      exports.iterable.unsubscribe = true;
    }

    exports.allMessageTypes.forEach(function(key) {
      exports.iterable[key] = unsubbedMessages.indexOf(key) == -1;
    });
  });

  exports.onChange = function(unsub) {
    if (unsub && exports.iterable.unsubscribe) {
      Object.keys(exports.iterable).forEach(function(key) {
        if (key != 'unsubscribe') {
          exports.iterable[key] = false;
        }
      });
    }

    if (exports.iterable.unsubscribe) {
      Object.keys(exports.iterable).some(function(key) {
        if (exports.iterable[key] && key != 'unsubscribe') {
          exports.iterable.unsubscribe = false;
          return true;
        }
      });
    }
  };

  //- update customer email subscription preferences
  function setEmailSubPreferences() {
    var unsubMessages = [];
    exports.allMessageTypes.forEach(function(key) {
      if (!exports.iterable[key] || exports.iterable.unsubscribe) {
        unsubMessages.push(key);
      }
    });

    var payload = {
      email: exports.email,
      marketingPreferences: {
        unsub: exports.iterable.unsubscribe,
        unsubMessages: unsubMessages
      },
      hideSpinner: true
    };

    // Automatically pop modal. User should not have to wait for response back to see update confirmation modal.
    exports.preferencesUpdatedModal.show = true;

    preferenceSvc.setMarketingPreferences(payload,
      // For success callback status do nothing (angular.noop)
      angular.noop,
      // Error callback notify user of error
      function() {
        exports.preferencesUpdatedModal.show = false;
        notifySvc.notify('error', 'Sorry, something went wrong while updating your preferences.');
    });
  }

  return exports;
}])
.
factory('experimentSvc', ['resource', function(resource) {
  return resource('/experiment', {}, {
    getVariantForExperiment: { method: 'GET', url: '/api/experiment/getVariantForExperiment' },
  });
}])
.
factory('gaEventSvc', [], function() {
  // custom events for google analytics
  var exports = {};
  exports.gaEvents = {
    'orders': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'manage orders'
    },
    'profile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'my profile'
    },
    'shipping': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'shipping & billing'
    },
    'changeDelivery': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change delivery date'
    },
    'shipNow': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'ship now'
    },
    'cancelOrders': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'cancel all future orders'
    },
    'changeColor': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change my color'
    },
    'changeColorReorder': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'change my color and reorder'
    },
    'reorder': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'reorder now',
      'nonInteraction': true
    },
    'accountInformation': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'account information'
    },
    'fbConnect': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'connect with facebook'
    },
    'editAccountInfo': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit account information'
    },
    'hairProfile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'hair profile'
    },
    'editHairProfile': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit hair profile'
    },
    'customInstructions': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'my customized instructions'
    },
    'message': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'message center'
    },
    'editEmail': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit email'
    },
    'unsubscribe': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'unsubscribe from all the emails above'
    },
    'editAddress': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit address'
    },
    'addAddress': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'add a new address'
    },
    'editPayment': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'edit payment'
    },
    'addPayment': {
      'event': 'MRCustom',
      'category': 'my account',
      'action': 'click',
      'label': 'add payment'
    }
  };

  return exports;
}).
factory('giftcardSvc', ['$rootScope', 'resource', 'notifySvc', 'newCartSvc', function($rootScope, resource, notifySvc, newCartSvc) {

  var httpSvc = resource('/api/customer', {}, {
    getAllGiftcards: { method: 'GET', url: '/api/giftcard/getAllGiftcards', isArray: true },
    saveGiftcard: { method: 'POST', url: '/api/giftcard/saveGiftcard' },
    addToCart: { method: 'POST', url: '/api/cart/addToCart', isArray: false },
    getProductsByType: { method: 'GET', url: '/api/product/getProductsByType', isArray: true },
    redeem: { method: 'POST', url: '/api/giftcard/redeem' }
  });

  var exports = {};

  exports.messages = {
    giftcardAdded: 'Succesfully added gift card to your profile.',
    somethingWrong: 'Something went wrong, please try again or contact Color Crew'
  };

  exports.giftCard = {
    senderEmail: '',
    senderName: '',
    giftcardProduct: {},
    sendNow: true
  };

  var future = new Date();
  var minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);
  future.setMonth(future.getMonth() + 3);

  exports.sendDateOptions = {
    minDate: new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate()),
    maxDate: new Date(future.getFullYear(), future.getMonth(), future.getDate())
  };

  exports.giftcards = [];

  exports.getAllGiftcards = getAllGiftcards;
  exports.addGiftcardToCart = addGiftcardToCart;
  exports.redeem = redeem;
  exports.showDatePicker = showDatePicker;

  function getAllGiftcards() {
    httpSvc.getAllGiftcards(function(res) {
      // check cart for existing giftcard in session and if found prepopulate the form
      newCartSvc.getCartItems(function(items) {
        // sort them here instead of on the template so we can assign default value
        exports.giftcards = res.sort(function(a, b) {
          return a.price - b.price;
        });
        // select $50 gift card by default (after sort it is second element in the array)
        exports.giftCard.giftcardProduct = exports.giftcards[1];

        items.some(function(item) {
          if (item.giftCard) {
            exports.giftCard = item.giftCard;
            var sendAt = exports.giftCard.sendAt;

            if (sendAt) {
              exports.giftCard.sendAt = new Date(exports.giftCard.sendAt);
            }

            exports.giftcards.forEach(function(card) {
              if (card.id == exports.giftCard.giftcardProduct.id) {
                exports.giftCard.giftcardProduct = card;
              }
            });
            return true;
          }
        });
      });
    }, function() {
      notifySvc.notify('error', exports.messages.somethingWrong);
    });
  }

  function addGiftcardToCart() {
    if (exports.giftCard.sendNow) {
      exports.giftCard.sendAt = null;
    }
    
    var payload = {
      product_id: exports.giftCard.giftcardProduct.id, // Whatever the ID for the gift card is
      qty: 1,
      subscription: 0,
      giftCard: exports.giftCard
    };
    
    httpSvc.addToCart(payload, function() {
      redirect('/cart');
    }, function(err) {
      var error = exports.messages.somethingWrong;
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  }

  function redeem(giftCode) {
    httpSvc.redeem({code: giftCode}, function() {
      $rootScope.$broadcast('reload_customer_credits');
      notifySvc.notify('success', exports.messages.giftcardAdded);
    }, function(err) {
      var error = exports.messages.somethingWrong;
      if (err.data && err.data.message) {
        error = err.data.message;
      }
      notifySvc.notify('error', error);
    });
  }

  function showDatePicker(elementId) {
    angular.element(elementId).datepicker('show');
  }

  return exports;
}])
.
factory('greenhouseSvc', ['resource', function(resource) {
  return resource('/api/greenhouse', {}, {
    submitJobApplication: { method: 'POST', url: '/api/greenhouse/submitJobApplication', isArray: false }
  });
}])
.
factory('imageSvc', ['$window', 'loader', 'FileUploader', 'notifySvc', 'trackerSvc', function($window, loader, FileUploader, notifySvc, trackerSvc) {
  var exports = {};

  exports.uploadSupport = uploadSupport;
  exports.upload = upload;
  exports.eventName = 'Photo Submitted';
  exports.uploading = false;
  exports.uploader = new FileUploader({
    url: '/api/customer/uploadCustomerImage'
  });

  exports.uploader.filters.push({
    name: 'checkMaxSize', 
    fn: function(item) {
      // Check if file is over maxSize
      var maxSize = 10000000;
      if (item.size > maxSize) {
        notifySvc.notify('error', item.name + ' is too large. Photos must be less than 7 MB in size.');
        return false;
      }
      return true;
    }
  });

  exports.uploader.filters.push({
    name: 'checkFileLimit', 
    fn: function() {
    // Make sure the amount of files being uploaded is not over maxLimit
    var maxLimit = 3;
    if (exports.uploader.queue.length >= maxLimit) {
      notifySvc.notify('error', "We're sorry. We currently allow up to " + maxLimit + " photos per request.");
      return false;
    } else {
      return true;
      }
    }
  });

  exports.uploader.filters.push({
    name: 'imageFilter',
    fn: function(item, options) {
      var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
      var isImage = '|jpg|png|jpeg|bmp|'.indexOf(type) !== -1;
      if (!isImage) {
        notifySvc.notify('error', item.name + ' is not a recognized image type.');
      }
      return isImage;
    }
  });

  function uploadSupport() {
    return !!($window.FileReader && $window.CanvasRenderingContext2D);
  };

  function upload(cb) {
    cb = cb || angular.noop;

    if (exports.uploading) {
      return;
    }
    
    if (!exports.uploader || !exports.uploader.queue.length) {
      return cb();
    }

    exports.uploading = true;

    loader.start();
    trackerSvc.trackEvent(exports.eventName, {
      numImages: exports.uploader.queue.length
    });
    exports.uploader.uploadAll();

    exports.uploader.onErrorItem = function() {
      notifySvc.notify('error', 'Sorry, something went wrong while uploading your photo.');
      exports.uploading = false;
      cb();
    };

    exports.uploader.onCompleteAll = function() {
      exports.uploader.clearQueue();
      loader.finish();
      exports.uploading = false;
      cb();
    };
  };

  return exports;
}])
.
factory('loader', ['$timeout', function($timeout) {
  var loaderBG = $('#ajaxLoaderBG');
  var loaderContent = $('#ajaxLoaderContent');
  var reqCount = 0;
  var timeoutId;

  function startLoader() {
    timeoutId = $timeout(function() {
      loaderBG.fadeIn('fast');
      loaderContent.show();
    }, 2000);
  }

  function stopLoader() {
    $timeout.cancel(timeoutId);
    loaderBG.fadeOut('fast');
    loaderContent.fadeOut('fast');
  }

  return {
    start: function() {
      if (!reqCount) {
        startLoader();
      }

      reqCount++;
    },

    finish: function() {
      reqCount--;

      if (!reqCount) {
        stopLoader();
      }
    }
  };
}])
.
service('location', ['$location', '$rootScope', function($location, $rootScope) {
  $location.skipReload = function () {
    var un = $rootScope.$on('$stateChangeStart', function(event) {
      event.preventDefault();
      un();
    });
    return $location;
  };

  return $location;
}]).
factory('Modal', function() {
  var modalFactory = {
    modals: {},
    veil: false,
    veilDisabled: false
  };

  modalFactory.newModal = function(name) {
    var modal = modalFactory.modals[name] = {
      show: false
    };

    modal.close = function() {
      var hideVeil = true;
      modal.show = false;
      angular.forEach(modalFactory.modals, function(modal) {
        if (modal.show == true) {
          hideVeil = false;
        }
      });
      if (hideVeil) {
        modalFactory.hideVeil();
      }
    };

    modal.open = function() {
      modal.show = true;
      modalFactory.showVeil();
    };

    return modal;
  };

  modalFactory.closeAll = function() {
    for (var modal in modalFactory.modals) {
      modalFactory.modals[modal].close();
    }
  };

  modalFactory.hideVeil = function() {
    modalFactory.veil = false;
    // $('body').removeClass('noscroll');
  };

  modalFactory.showVeil = function() {
    modalFactory.veil = true;
    // $('body').addClass('noscroll');
  };

  return modalFactory;
})
.
factory('modalSvc', ['mrNgUtils', function(mrNgUtils) {
  var exports = {};
  exports.modals = {};

  exports.createModal = createModal;
  exports.showModal = showModal;
  exports.hideModal = hideModal;

  function createModal(modalId, limitCookie, urlParam, urlParamValue) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {
        show: true
      };

      if (limitCookie) {
        exports.modals[modalId].cookie = limitCookie;
        if ($.cookie(limitCookie)) {
          exports.modals[modalId].show = false;
        }
        $.cookie(limitCookie, "viewed", { expires: 1 }); // cookie expires in 1 day
      }

      if (urlParam && urlParamValue) {
        exports.modals[modalId].urlParam = urlParam;
        exports.modals[modalId].urlParamValue = urlParamValue;
        checkUrlParams(urlParam, urlParamValue) ? '' : exports.modals[modalId].show = false;
      }
    }
  }

  function showModal(modalId) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {
        show: true
      };
    } else if (exports.modals[modalId].cookie) {
      if (!$.cookie()[limitCookie]) {
        exports.modals[modalId].show = true;
      }
    }
  }

  function hideModal(modalId) {
    if (!exports.modals[modalId]) {
      exports.modals[modalId] = {};
    }
    exports.modals[modalId].show = false;
  }

  // Helper functions

  function checkUrlParams(param, value) {
    var params = mrNgUtils.locationSearchParams();
    return params[param] && ~params[param].indexOf(value);
  }

  return exports;
}])
.
factory('mrNgUtils', function() {
  var mrNgUtils = {};

  mrNgUtils.locationSearchParams = locationSearchParams;
  mrNgUtils.updateQueryStringParameter = updateQueryStringParameter;
  // splits data array in sub arrays by size attribute
  mrNgUtils.chunkArray = function(arr, size) {
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    return newArr;
  };

  // this function returns true if the event has a key code
  // for tab, shift, or an arrow key
  mrNgUtils.specialKey = function ($event) {
    var keyCode = $event.keyCode;
    if (keyCode == 9 || keyCode == 16 || keyCode == 19 || keyCode == 37 || keyCode == 38 || keyCode == 39 || keyCode == 40) {
      return true;
    }
  };

  mrNgUtils.isJson = function(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  function locationSearchParams() {
    var search = window.location.search;
    if (!search) {
      return {};
    }
    var params = {};
    search.replace(/^\?/, '').split('&').forEach(function(paramStr) {
      var part = paramStr.split('=');
      params[part[0]] = part[1];
    });
    return params;
  }

  return mrNgUtils;
}).
factory('mrProductCatalogUtils', function() {
  var mrProductCatalogUtils = {};

  // Filter products active and visible
  mrProductCatalogUtils.filterActive = function(products) {
    return products.filter(function(val) {
      return (val.status === 1 && val.visible === 1);
    });
  };

  mrProductCatalogUtils.filterColorNumber = function(products) {
    return products.sort(function(a, b) {
      return a.color_number > b.color_number;
    });
  };

  return mrProductCatalogUtils;
})
.
// The old cartSvc that is located in mrServices should be depreciated
// as soon as mr cart is refactored and we got rid of old endpoints
factory('newCartSvc', ['resource', '$cookies', 'cdata', function(resource, $cookies, cdata) {
  var cartHttpSvc = resource('/api/cart', {}, {
    getCartItems: { method: 'GET', url: '/api/cart/getCartItems', isArray: true },
    getShippingMethods: { method: 'GET', url: '/api/cart/getShippingMethods', isArray: false },
    getShipDate: { method: 'GET', url: '/api/cart/getShipDate', isArray: false },
    getAddons: { method: 'GET', url: '/api/cart/getAddons', isArray: true },
    getTotals: { method: 'POST', url: '/api/cart/getTotals', isArray: false },
    getCartItemCount: { method: 'GET', url: '/api/cart/getCartItemCount', isArray: false },

    addProduct: { method: 'POST', url: '/api/cart/addProduct', isArray: false },
    addProducts: { method: 'POST', url: '/api/cart/addProducts', isArray: false },
    addToCart: { method: 'POST', url: '/api/cart/addToCart', isArray: false },
    addMultipleItemsToCart: { method: 'POST', url: '/api/cart/addMultipleItemsToCart', isArray: false },
    reorderAddToCart: { method: 'POST', url: '/api/cart/reorderAddToCart', isArray: false },
    updateItemQty: { method: 'POST', url: '/api/cart/updateItemQty', isArray: false },
    applyCoupon: { method: 'POST', url: '/api/cart/applyCoupon', isArray: false },
    applyCoupons: { method: 'POST', url: '/api/cart/applyCoupons', isArray: false },
    applyPromo: { method: 'POST', url: '/api/cart/applyPromo', isArray: false },
    removeItemFromCart: { method: 'POST', url: '/api/cart/removeItemFromCart', isArray: false },
    updateItemSubscription: { method: 'POST', url: '/api/cart/updateItemSubscription', isArray: false },
    setShippingMethod: { method: 'POST', url: '/api/cart/setShippingMethod', isArray: false },
    setUseGiftCards: { method: 'POST', url: '/api/cart/setUseGiftCards', isArray: false },
    setShippingAddress: { method: 'POST', url: '/api/cart/setShippingAddress', isArray: false },
    removeCoupon: { method: 'POST', url: '/api/cart/removeCoupon', isArray: false },
    moveToOtherCart: { method: 'POST', url: '/api/cart/moveToOtherCart', isArray: false },
    shipRefillWithCart: { method: 'POST', url: '/api/cart/shipRefillWithCart', isArray: false },
    getCartDataForView: { method: 'GET', url: '/api/cart/getCartDataForView', isArray: false }
  });

  var exports = {
    cartType: $cookies.cartType || 'active'
  };
  var noOp = function() {};

  exports.cart = {};
  exports.reloading = {
    items: false,
    shippingMethods: false,
    shipDate: false,
    addons: false,
    addonsByContext: false,
    totals: false
  };
  exports.waiting = [];
  exports.highlightSubItems = false;

  exports.getInitialCache = getInitialCache;
  exports.getCartItems = getCartItems;
  exports.getShippingMethods = getShippingMethods;
  exports.getShipDate = getShipDate;
  exports.getAddons = getAddons;
  exports.getTotals = getTotals;
  exports.setCartItemCountInCookie = setCartItemCountInCookie;
  exports.addProduct = addProduct;
  exports.addProducts = addProducts;
  exports.addToCart = addToCart;
  exports.addMultipleItemsToCart = addMultipleItemsToCart;
  exports.reorderAddToCart = reorderAddToCart;
  exports.updateItemQty = updateItemQty;
  exports.applyCoupon = applyCoupon;
  exports.applyCoupons = applyCoupons;
  exports.applyPromo = applyPromo;
  exports.removeItemFromCart = removeItemFromCart;
  exports.updateItemSubscription = updateItemSubscription;
  exports.setShippingMethod = setShippingMethod;
  exports.setShippingAddress = setShippingAddress;
  exports.setUseGiftCards = setUseGiftCards;
  exports.removeCoupon = removeCoupon;
  exports.moveToOtherCart = moveToOtherCart;
  exports.shipRefillWithCart = shipRefillWithCart;

  getInitialCache();

  // Helper functions
  function recacheCartDataIfNeeded(key, args) {
    var cb;
    for (var i = 0; i < args.length; i++) {
      if (cb) {
        break;
      }

      if (typeof args[i] == 'function') {
        cb = args[i];
      }
    }

    if (!cb) {
      cb = angular.noOp;
    }

    if (exports.reloading[key]) {
      exports.waiting.push(function() {
        cb(exports.cart[key]);
      });
      return;
    }

    if (exports.cart.hasOwnProperty(key)) {
      return cb(exports.cart[key]);
    }

    recacheCartData(key, function() {
      cb(exports.cart[key]);
    });
  }

  function recacheCartData(specifics, cb) {
    var initalCartDataCache = null;

    if (arguments.length == 1) {
      cb = specifics;
      specifics = ['all'];
    }

    if (specifics.initalCartDataCache) {
      initalCartDataCache = specifics.initalCartDataCache;
    }

    if (!Array.isArray(specifics)) {
      specifics = [specifics];
    }

    if (specifics.length == 1 && specifics[0] == 'all') {
      specifics = Object.keys(exports.reloading);
    }

    specifics.forEach(function(key) {
      exports.reloading[key] = true;
    });
    var params = {
      keys: specifics
    };

    // If initalCartDataCache
    if (initalCartDataCache) {
      specifics.forEach(function(key) {
        exports.reloading[key] = false;
      });

      trackCrossSell(cdata, initalCartDataCache.addons);
      return cb(initalCartDataCache);
    }

    params.cartType = exports.cartType;

    cartHttpSvc.getCartDataForView(params, function(data) {
      // Updating values that changed, not overwriting the whole cached cart object
      Object.keys(data).forEach(function(key) {
        if (key.indexOf('$') === 0) {
          return;
        }
        exports.cart[key] = data[key];
      });

      // reset selectedShippingMethod
      exports.cart.shippingMethods.methods.forEach(function(method) {
        if (method.code == exports.cart.shippingMethods.selected.code) {
          exports.cart.shippingMethods.selected = method;
        }
      });

      cb(data);
      while (exports.waiting.length) {
        exports.waiting.pop()(data);
      }
      if (exports.reloading.addons) {
        trackCrossSell(cdata, exports.cart.addons);
      }
      specifics.forEach(function(key) {
        exports.reloading[key] = false;
      });
    });
  }

  function trackCrossSell(cdata, addons) {
    addons = addons || [];

    var trackProps = {
      dig: cdata.dig,
      dug: cdata.dug,
      isIOS: cdata.isIOS,
      sessionId: cdata.sessionId,
      agent_id: cdata.agent_id
    };

    trackProps.products = addons.map(function(product, index) {
      return {
        id: product.id,
        name: product.name,
        code: product.code,
        position: index + 1
      };
    });

    analytics.track('Cross-sell Items Viewed', trackProps);
  }

  function callHttpSvc(method, params, reloadPartial, successFunc, failFunc) {
    if (reloadPartial && reloadPartial.length == 1 && reloadPartial[0] == 'all') {
      reloadPartial = Object.keys(exports.reloading);
    }
    if (!successFunc) {
      successFunc = noOp;
    }
    if (!failFunc) {
      failFunc = noOp;
    }

    params.cartType = exports.cartType;

    cartHttpSvc[method](params, function(response) {
      (reloadPartial || []).forEach(function(key) {
        if (response.hasOwnProperty(key)) {
          exports.cart[key] = response[key];
        }
      });

      successFunc(response);
    }, failFunc);
  }
  // end Helper functions

  function getInitialCache(specifics, cb) {
    switch (arguments.length) {
      case 1:
        cb = specifics;
        specifics = ['all'];
        break;
      case 0:
        cb = noOp;
        specifics = ['all'];
        break;
    }

    recacheCartData(specifics, cb);
  }

  function getCartItems(params, successFunc, failFunc) {
    recacheCartDataIfNeeded('items', arguments);
  }

  function getShippingMethods(params, successFunc, failFunc) {
    recacheCartDataIfNeeded('shippingMethods', arguments);
  }

  function getShipDate(params, successFunc, failFunc) {
    cartHttpSvc.getShipDate(function(res) {
      exports.cart.shipDate = res.shipDate;
    });
  }

  function getAddons(params, successFunc, failFunc) {
    recacheCartDataIfNeeded('addons', arguments);
  }

  function getTotals(params, successFunc, failFunc) {
    recacheCartDataIfNeeded('totals', arguments);
  }

  function setCartItemCountInCookie() {
    cartHttpSvc.getCartItemCount(function(res) {
      if (res.count) {
        $cookies.cic = res.count;
      }
    });
  }

  function addProduct(params, successFunc, failFunc) {
    callHttpSvc('addProduct', params, false, successFunc, failFunc);
  }

  function addProducts(params, successFunc, failFunc) {
    callHttpSvc('addProducts', params, false, successFunc, failFunc);
  }

  function addToCart(params, successFunc, failFunc) {
    callHttpSvc('addToCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function addMultipleItemsToCart(params, successFunc, failFunc) {
    callHttpSvc('addMultipleItemsToCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function reorderAddToCart(params, successFunc, failFunc) {
    callHttpSvc('reorderAddToCart', params, ['items', 'totals', 'addons'], successFunc, failFunc);
  }

  function updateItemQty(params, successFunc, failFunc) {
    callHttpSvc('updateItemQty', params, ['items', 'totals'], successFunc, failFunc);
  }

  function applyCoupon(params, successFunc, failFunc) {
    callHttpSvc('applyCoupon', params, ['all'], successFunc, failFunc);
  }

  function applyCoupons(params, successFunc, failFunc) {
    callHttpSvc('applyCoupons', params, ['all'], successFunc, failFunc);
  }

  function applyPromo(params, successFunc, failFunc) {
    callHttpSvc('applyPromo', params, ['all'], successFunc, failFunc);
  }

  function removeItemFromCart(params, successFunc, failFunc) {
    callHttpSvc('removeItemFromCart', params, ['items', 'totals', 'addons', 'addonsByContext'], successFunc, failFunc);
  }

  function updateItemSubscription(params, successFunc, failFunc) {
    callHttpSvc('updateItemSubscription', params, ['items', 'totals'], successFunc, failFunc);
  }

  function setShippingMethod(params, successFunc, failFunc) {
    callHttpSvc('setShippingMethod', params, ['totals'], successFunc, failFunc);
  }

  function setShippingAddress(params, successFunc, failFunc) {
    callHttpSvc('setShippingAddress', params, ['totals', 'shippingMethods'], successFunc, failFunc);
  }

  function removeCoupon(params, successFunc, failFunc) {
    callHttpSvc('removeCoupon', params, ['all'], successFunc, failFunc);
  }

  function moveToOtherCart(params, successFunc, failFunc) {
    callHttpSvc('moveToOtherCart', params, ['items', 'totals', 'addons', 'refillCart'], successFunc, failFunc);
  }

  function shipRefillWithCart(params, successFunc, failFunc) {
    callHttpSvc('shipRefillWithCart', params, false, successFunc, failFunc);
  }

  function setUseGiftCards(params, successFunc, failFunc) {
   callHttpSvc('setUseGiftCards', params, ['totals'], successFunc, failFunc);
  }

  return exports;
}])
.
factory('notifySvc', ['resource', '$rootScope', '$timeout', function(resource, $rootScope, $timeout) {
  var exports = {};
  var httpSvc = resource('/api/notify/', {}, {
    emptyBackendNotificationsArray: { method: 'GET', url: '/api/notify/emptyBackendNotificationsArray' }
  });

  /**
   * Utility function for displaying notification messages in the UI.
   * @param type [string] - The message type. [error, warn, info, success] This string is used as a class for the notification so you can make custom notification styles.
   * @param message [string] - The text of the notification.
   * @param displayTime [number] - [Optional] length of time in milliseconds that you want the notification to display. Defaults to 5000 (5s). If you pass 0 the user will have to click the close box to dismiss it.
   **/
  // This varable is used to generate incremental notification ids
  var notification_id = 0;
  exports.notifications = [];
  exports.messages = {
    canNotCompleteTransaction: 'Sorry, we couldn\'t finish the transaction. Please contact Color Crew if you keep experiencing this issue'
  }

  exports.notify = notify;
  exports.removeNotification = removeNotification;
  exports.emptyBackendNotificationsArray = emptyBackendNotificationsArray;

  function notify(type, message, displayTime) {
    if (angular.isUndefined(displayTime)) {
      displayTime =  5000;
    }
    var noteId = notification_id++;

    for (var i = 0; exports.notifications.length > i; i++) {
      if (exports.notifications[i].message === message) {
        return;
      }
    }

    exports.notifications.push({
      id: noteId,
      class: type,
      message: message
    });

    $rootScope.$applyAsync();
    if (displayTime) {
      $timeout(removeNotification.bind(null, noteId), displayTime);
    }
    return noteId;
  };

  function removeNotification(noteId) {
    var noteIdx;
    var notes = exports.notifications;
    for( noteIdx = 0; noteIdx < notes.length; noteIdx++ ) {
      if (notes[noteIdx].id == noteId) {
        break;
      }
    }
    if (noteIdx < notes.length) {
      exports.notifications.splice(noteIdx, 1);
      $rootScope.$applyAsync();
    }
  }

  function emptyBackendNotificationsArray() {
    httpSvc.emptyBackendNotificationsArray({}, angular.noop);
  }

  return exports;
}])
.
factory('ordersSvc', ['resource', function(resource) {
  return resource('/portal', {}, {
    getSubs: { method: 'GET', url: '/api/subscription/getSubscriptionsByCustomerId' },
    getOrderAndSubInfoByProductType: { method: 'GET', url: '/api/account/getOrderAndSubInfoByProductType' },
    getOrderSummary: { method: 'POST', url: '/api/account/getOrderSummary' }
  });
}])
.
factory('Pagination', function() {

  var pagination = {};

  pagination.getNew = function(perPage) {

    perPage = perPage === undefined ? 5 : perPage;

    var paginator = {
      numPages: 1,
      perPage: perPage,
      page: 0
    };

    paginator.prev = function() {
      if (paginator.page > 0) {
        paginator.page -= 1;
      }
    };

    paginator.next = function() {
      if (paginator.page < paginator.numPages - 1) {
        paginator.page += 1;
      }
    };

    paginator.toPageId = function(id) {
      if (id >= 0 && id <= paginator.numPages - 1) {
        paginator.page = id;
      }
    };

    return paginator;
  };

  return pagination;
}).
factory('partySvc', ['cdata', 'mrNgUtils', function(cdata, mrNgUtils) {
  var exports = {};

  exports.confetti = confetti;
  exports.flashParty = flashParty;
  exports.birthdayParty = birthdayParty;

  // plays a confetti animation inside canvas "canvasId"
  function confetti(canvasId, callback) {
    var canvas = document.getElementById(canvasId);
    var context = canvas.getContext("2d");
    var width = canvas.width = canvas.parentElement.clientWidth;
    var height = canvas.height = canvas.parentElement.clientHeight;

    var particle = [];
    var particleCount = 300;
    var gravity = 10;
    var timeInitial = + new Date();
    var timePassed = 0;
    var timeTotal = 0;

    var colors = [
      '#600057', '#e91e63', '#9c27b0', '#600057', '#3f51b5',
      '#2196f3', '#03a9f4', '#600057', '#009688', '#4CAF50',
      '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
      '#FF5722', '#600057'
    ];

    for(var i = 0; i < particleCount; i++) {
      particle.push({ 
        x: width/2 * randomRange(0.6, 1.4),
        y: height/2 * randomRange(0.8, 1.2),
        boxW: randomRange(5, 20),
        boxH: randomRange(5, 20),
        size: randomRange(2, 8),
        velX: randomRange(-12, 12),
        velY: randomRange(-30, -5),
        friction: randomRange(0.4, 0.6),
        angle: convertToRadians(randomRange(0, 360)),
        color: colors[Math.floor(Math.random() * colors.length)],
        anglespin: randomRange(-0.2, 0.2),
        inframe: true,

        draw: function() {
          if (this.inframe) {
            context.save();
            context.translate(this.x, this.y);
            context.rotate(this.angle);
            context.fillStyle = this.color;
            context.beginPath();
            context.fillRect(this.boxW/2 * -1, this.boxH/2 * -1, this.boxW, this.boxH);
            context.fill();
            context.closePath();
            context.restore();

            this.angle += this.anglespin;
            var secondsPassed = timePassed / 1000;
            var gravityVector = gravity * secondsPassed;
            var frictionVectorY = this.friction * this.velY * secondsPassed;
            var changeInVelocity = gravityVector - frictionVectorY;
            
            this.velY += changeInVelocity;

            this.x += this.velX;
            this.y += this.velY;

            if (this.x + this.boxW < 0 || this.x - this.boxW > width || this.y - this.boxH > height) {
              this.inframe = false;
            }
          }
        }
      });
    }

    function drawScreen() {
      for (var i = 0; i < particle.length; i++) {
        particle[i].draw();
      }
    }

    function update() {
      context.clearRect(0, 0, width, height);
      var newTimeTotal = + new Date() - timeInitial;
      timePassed = newTimeTotal - timeTotal;
      timeTotal = newTimeTotal;
      drawScreen();

      if (timeTotal < 5000) {
        requestAnimationFrame(update);
      } else {
        context.clearRect(0, 0, width, height);
        if (callback) {
          callback();
        }
      }
    }

    update();
  }

  // fades in element "flashId", plays confetti on canvas "canvasId" then fades out "flashId"
  // if limitCookie is preset don't play the animation
  function flashParty(canvasId, flashId, limitCookie, ignoreCookie) {
    if (!$.cookie()[limitCookie] || ignoreCookie) {
      setTimeout(function() {
        $('#' + flashId).fadeIn(600, function() {
          confetti(canvasId, function() {
            $('#' + flashId).fadeOut();
          });
        });
      }, 500);

      if (limitCookie) {
        $.cookie(limitCookie, "partied", { expires: 7 }); // cookie expires in 7 days
      }
    }
  }

  // has a flashParty only if it's the users birthday, or a specific "urlParam" is present
  function birthdayParty(canvasId, flashId, urlParam) {
    var params = mrNgUtils.locationSearchParams();
    var month = new Date().getMonth();
    
    if (params[urlParam]) {
      flashParty(canvasId, flashId, 'bday', true);
    } else if (cdata.birthday && new Date(cdata.birthday).getMonth() == month) {
      flashParty(canvasId, flashId, 'bday');
    }
  }

  // Helper functions

  function randomRange(min, max) {
    return min + Math.random() * (max - min );
  }

  function convertToRadians(degree) {
    return degree*(Math.PI/180);
  }

  return exports;
}])
.
factory('paymentProfileSvc', ['$rootScope', 'resource', 'loader', 'notifySvc', 'addressSvc', 'phoneNumberFilter', 'Modal', function($rootScope, resource, loader, notifySvc, addressSvc, phoneNumberFilter, Modal) {

  var httpSvc = resource('/api/paymentProfile', {}, {
    updateBillingInfo: { method: 'POST', url: '/api/customer/updateBillingInfo'},
    setDefaultShipAddress: { method: 'POST', url: '/api/customer/setDefaultShipAddress' },
    setDefaultPaymentMethod: { method: 'POST', url: '/api/customer/setDefaultPaymentMethod' },
    getPaymentProfiles: { method: 'GET', url: '/api/paymentProfile/getActivePaymentProfiles', isArray: true },
    deletePaymentProfile: { method: 'POST', url: '/api/customer/deletePaymentProfile' },
    getActiveSubscriptionsByPaymentProfileId: { method: 'GET', url: '/api/subscription/getActiveSubscriptionsByPaymentProfileId', isArray: true },
    updatePaymentProfileForAllUserSubscriptions: { method: 'POST', url: '/api/subscription/updatePaymentProfileForAllUserSubscriptions' },
    getClientToken: { method: 'GET', url: '/api/paymentProfile/getClientToken' }
  });

  var exports = {};

  function PaymentProfile() {
    this.cc_cvc = '';
    this.cc_exp_month = '';
    this.cc_exp_year = '';
    this.cc_number = '';
    this.is_default = true;
    this.address = {
      first_name: '',
      last_name: '',
      street_1: '',
      street_2: '',
      city: '',
      post_code: '',
      region: '',
      phone: ''
    };
  }

  exports.messages = {
    declined: 'Your card has been declined. Please verify your information and resubmit your order. Thank you!',
    default: 'We were unable to process your payment method. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    success: 'Thanks! Your billing information has been updated.',
    deleted: 'Your payment method was successfully removed.',
    generalError: 'Something went wrong and your changes could not be saved. Please review your information or call us at ' + MR.config.contactPhone, //- <- global
    subBillingUpdate: 'Thanks! Your billing information has been updated and your subscription will process as scheduled.',
    updatedDefaultPayment: 'Your default payment method was successfully updated.',
    allSubPayment: 'Payment profile for all your active auto-deliveries has been updated'
  };

  exports.associatedSubsModal = Modal.newModal('associatedSubsModal');

  exports.profiles = [];
  exports.profileMap = {};
  exports.inEditMode = false;
  exports.initialized = false;
  exports.selectedProfile = {};
  exports.defaultProfile = null;
  exports.savingPayment = false;
  exports.confirmedPayment = false;
  exports.profileInEdit = {same_as_shipping: true};

  exports.sameAsShipping = sameAsShipping;
  exports.cancelEdit = cancelEdit;
  exports.editPayment = editPayment;
  exports.deletePayment = deletePayment;
  exports.clearBillingForm = clearBillingForm;
  exports.getPaymentProfiles = getPaymentProfiles;
  exports.savePaymentProfile = savePaymentProfile;
  exports.checkSameShippingBilling = checkSameShippingBilling;
  exports.updateDefaultPaymentProfile = updateDefaultPaymentProfile;
  exports.updatePaymentProfileForAllUserSubscriptions = updatePaymentProfileForAllUserSubscriptions;

  exports.setSelectedPaymentProfile = setSelectedPaymentProfile;

  getPaymentProfiles();

  function getPaymentProfiles() {
    httpSvc.getPaymentProfiles({}, function(profiles) {
      exports.profiles = profiles;

      if (profiles.length) {
        exports.confirmedPayment = true;
      } else {
        exports.inEditMode = true;
      }

      for(var i = 0; i < exports.profiles.length; i++) {
        var profile = exports.profiles[i];
        exports.profileMap[profile.paymentProfileId] = profile;
        if (exports.selectedProfile && exports.selectedProfile.paymentProfileId == profile.paymentProfileId) {
          setSelectedPaymentProfile(profile.paymentProfileId);
        }

        if (profile.is_default) {
          exports.defaultProfile = profile;
        }
      }

      if (exports.profiles.length && !exports.selectedProfile || !exports.selectedProfile.paymentProfileId) {
        exports.selectedProfile = exports.defaultProfile || exports.profiles[0] || {};
      }

      exports.initialized = true;
      $rootScope.$broadcast('payment_profile_profiles_loaded', profiles);
    });
  }

  function sameAsShipping(profileAddress, shippingAddress) {
    if (!profileAddress || !shippingAddress) {
      return false;
    }
    return !Object.keys(profileAddress).some(function(key) {
      var a = profileAddress[key] || null;
      var b = shippingAddress[key] || null;
      return a != b;
    });
  }

  function editPayment(profileId) {
    var profile = exports.profileMap[profileId] || new PaymentProfile();
    exports.profileInEdit = angular.copy(profile);

    exports.inEditMode = true;
    exports.confirmedPayment = false;
  }

  function cancelEdit(form) {
    clearBillingForm(form);

    if (exports.selectedProfile && exports.selectedProfile.paymentProfileId) {
      exports.confirmedPayment = true;
    }

    exports.inEditMode = false;
  }

  function clearBillingForm(form) {
    exports.profileInEdit = new PaymentProfile();
    exports.savingPayment = false;
    if (form) {
      form.$setPristine();
    }
  }

  function setSelectedPaymentProfile(paymentProfileId) {
    exports.selectedProfile = exports.profileMap[paymentProfileId] || {};
    exports.confirmedPayment = true;
    $rootScope.$broadcast('payment_profile_selected', exports.selectedProfile);
  }

  function updatePaymentProfileForAllUserSubscriptions(paymentProfileId) {
    var payload = {
      paymentProfileId: paymentProfileId
    };

    httpSvc.updatePaymentProfileForAllUserSubscriptions(payload, function(res) {
      $rootScope.$broadcast('update_payment_for_subs');
      notifySvc.notify('success', exports.messages.subBillingUpdate);
      updateDefaultPaymentProfile(paymentProfileId);
    }, function(err) {
      var message = exports.messages.generalError;
      if (err.data && err.data.message) {
        message = err.data.message;
      }

      notifySvc.notify('warn', message);
    });
  }

  function updateDefaultPaymentProfile(paymentProfileId, callback) {
    callback = callback || angular.noop;
    var payload = {
      paymentProfileId: paymentProfileId
    };

    httpSvc.setDefaultPaymentMethod(payload, function(res) {
      getPaymentProfiles();
      notifySvc.notify('success', exports.messages.updatedDefaultPayment);
      callback();
    }, function(err) {
      notifySvc.notify('error', exports.messages.generalError);
    });
  }

  // When called from the Booking flow, no address info is present. Instead, send userInfo containing first and last name. 
  function savePaymentProfile(form, userInfo, callback) {
    switch (arguments.length) {
      case 2:
        callback = arguments[1];
        break;
    }

    if (exports.savingPayment) {
      return;
    }

    if (form.$invalid) {
      $rootScope.$broadcast('payment_profile_save_failed');
      form.$setDirty();
      Object.keys(form).forEach(function(key) {
        if (form[key] && form[key].$setDirty) {
          form[key].$setDirty();
        }
      });
      return;
    }

    exports.savingPayment = true;

    callback = callback || angular.noop;
    var address = exports.profileInEdit.address;
    if (!address) {
      address = {};
    }

    if (exports.profileInEdit.same_as_shipping && !addressSvc.confirmedShippingAddress) {
      exports.savingPayment = false;
      notifySvc.notify('error', addressSvc.messages.incomplete);
      //- without timeout form is not cleared. Angular issue.
      setTimeout(function() {
        form.$setPristine();
      }, 100);
      $rootScope.$broadcast('payment_profile_save_failed');
      return;
    }

    var payload = {
      paymentProfileId: exports.profileInEdit.paymentProfileId,
      updateDeclinedCC: exports.profileInEdit.isDeclined,
      is_default: exports.profileInEdit.is_default,
      updateAllSubs: exports.profileInEdit.updateAllSubs
    };

    // if same_as_shipping use shipping address as billing address
    if (exports.profileInEdit.same_as_shipping) {
      address = angular.copy(addressSvc.selectedAddress);
      address.id = null;
    }
    
    if (address) {
      address.is_default_shipping = false;
    }

    payload.address = address;

    if (exports.profileInEdit.cc_exp_month_year) {
      var expStr = exports.profileInEdit.cc_exp_month_year;
      exports.profileInEdit.cc_exp_month = expStr.substr(0, 2);
      exports.profileInEdit.cc_exp_year = '20' + expStr.substr(-2, 2);
    }

    var firstName = address.first_name || userInfo.firstName;
    var lastName = address.last_name || userInfo.lastName;

    var card = {
      number: exports.profileInEdit.cc_number,
      cardholderName: [firstName, lastName].filter(Boolean).join(' '),
      expirationMonth: exports.profileInEdit.cc_exp_month,
      expirationYear: exports.profileInEdit.cc_exp_year,
      cvv: exports.profileInEdit.cc_cvc,
      billingAddress: {
        firstName: firstName,
        lastName: lastName,
        streetAddress: address.street_1 || '',
        extendedAddress: address.street_2 || '',
        locality: address.city || '',
        region: address.region || '',
        postalCode: address.post_code || ''
      }
    };

    httpSvc.getClientToken(function(clientToken) {
      var client = new braintree.api.Client(clientToken);
       client.tokenizeCard(card, function (err, nonce) {
        if (err) {
          $rootScope.$broadcast('payment_profile_save_failed');
          return;
        }

        payload.nonce = nonce;

        if (userInfo) {
          payload.address.first_name = userInfo.firstName;
          payload.address.last_name = userInfo.lastName;
        }

        httpSvc.updateBillingInfo(payload, function(profile) {
          if (exports.profileInEdit.paymentProfileId) {
            $rootScope.$broadcast('payment_profile_modified', profile);
          } else {
            $rootScope.$broadcast('payment_profile_created', profile);
          }

          if (form) {
            clearBillingForm(form);
          }

          // set selectedProfile before getting paymentProfiles to keep track of selected
          exports.selectedProfile = profile;
          getPaymentProfiles();

          exports.confirmedPayment = true;
          exports.profileInEdit = {};
          exports.inEditMode = false;
          exports.savingPayment = false;
          var notifyMsg;

          if (payload.updateDeclinedCC) {
            notifyMsg = exports.messages.subBillingUpdate;
          } else {
            notifyMsg = exports.messages.success;
          }

          callback();
        }, function(err) {
          $rootScope.$broadcast('payment_profile_save_failed');
          var error = exports.messages.default;
          if (isDeclineError(err)) {
            error = exports.messages.declined;
          } else if (err.data.message) {
            error = err.data.message;
          }
          exports.savingPayment = false;
          exports.confirmedPayment = false;
          //- without timeout form is not cleared. Angular issue.
          setTimeout(function() {
            form.$setPristine();
          }, 100);
          loader.finish();
          notifySvc.notify('error', error);
        });
      });
    }, function (err) {
      exports.savingPayment = false;
      notifySvc.notify('error', exports.messages.generalError);
      $rootScope.$broadcast('payment_profile_save_failed', err);
    });
    return;
  }

  function deletePayment(payment_id, callback) {
    if (!callback) {
      callback = angular.noop;
    }
    var payload = {
      paymentProfileId: payment_id
    };

    httpSvc.deletePaymentProfile(payload, function(res) {
      notifySvc.notify('success', exports.messages.deleted);
      getPaymentProfiles();
    }, function(err) {
      var message = exports.messages.generalError;
      if (err.data && err.data.message) {
        message = err.data.message;
      }

      notifySvc.notify('warn', message);
    });
  }

  // If shipAddress and billAdress are the same set same_as_shipping to true
  function checkSameShippingBilling() {
    //- if payment is in edit mode no need to compare addresses
    if (exports.inEditMode) {
      return;
    }

    var shipping = addressSvc.selectedAddress;
    // shipping.phone needs to be filtered in order to be compare to billing.phone
    shipping.phone = phoneNumberFilter(shipping.phone);
    var billing = exports.selectedProfile.address || {};
    var isSameFlag = isShippingSameBilling(shipping, billing);

    //Clear form
    if (!isSameFlag) {
      clearBillingForm();
    }

    exports.selectedProfile.same_as_shipping = angular.equals(billing, {}) ? true : isSameFlag;
  }

  // Helper functions
  function isShippingSameBilling(shipping, billing) {
    // If shipping fields different from billing set flag false
    for (var i = 0; i < addressSvc.addressKeys.length; i++) {
      var key = addressSvc.addressKeys[i];
      if ((shipping[key] || '').toLowerCase() != (billing[key] || '').toLowerCase()) {
        return false;
      }
    }
    return true;
  }

  function isDeclineError(msg) {
    msg = '' + msg;
    return msg.toLowerCase().indexOf('credit card declined') >= 0;
  }

  return exports;
}])
.
factory('preOrderSvc', ['resource', function(resource, loader) {
  return resource('/api/preOrder', {}, {
    getPreOrderId: { method: 'GET', url: '/api/preOrder/getPreOrderId' },
    cancelPreOrder: { method: 'POST', url: '/api/preOrder/cancelPreOrder' }
  });
}]).
factory('preferenceSvc', ['resource', function(resource) {
  return resource('/api/preferences', {}, {
    getMarketingPreferences: { method: 'GET', url: '/api/customer/getMarketingPreferences' },
    setMarketingPreferences: { method: 'POST', url: '/api/customer/setMarketingPreferences' },
    smsOptInOut: { method: 'POST', url: '/api/customer/smsOptInOut' }
  });
}]).
factory('pressAssetSvc', ['$rootScope', 'resource', 'notifySvc', 'mrNgUtils', function($rootScope, resource, notifySvc, mrNgUtils) {

  var httpSvc = resource('/rest/press', {}, {
    loadAllPressAssets: {method: 'GET', url: '/api/press/loadAllPressAssets' }
  });

  var exports = {};
  var initializing = false;
  exports.pressImages = [];
  exports.pressVideos = [];
  exports.pressFactSheets = [];
  exports.pressLogos = [];

  exports.loadPressAssets = loadPressAssets;

  function loadPressAssets() {
    if (initializing) {
      return;
    }

    initializing = true;
    httpSvc.loadAllPressAssets({}, function(res) {
      exports.pressImages = res.pressImages.filter(filterVisible);
      exports.pressVideos = res.pressVideos.filter(filterVisible);
      exports.pressFactSheets = res.pressFactSheets.filter(filterVisible);
      exports.pressLogos = res.pressLogos.filter(filterVisible);
      initializing = false;
    }, function(err) {
      initializing = false;
    });
  }

  function filterVisible(item) {
    return item.visible;
  }

  return exports;
}]).
factory('pressItemSvc', ['$rootScope', 'resource', 'notifySvc', 'mrNgUtils', function($rootScope, resource, notifySvc, mrNgUtils) {

  var httpSvc = resource('/rest/press', {}, {
    getPressItems: { method: 'GET', url: '/api/press/getPressItems', isArray: true },
    getPagePressItems: { method: 'GET', url: '/api/press/getPagePressItems', isArray: true },
    getPressItemCount: { method: 'GET', url: '/api/press/getPressItemCount' },
    loadFeaturedPress: { method: 'GET', url: '/api/press/loadFeaturedPress', isArray: true }
  });

  var exports = {};
  var topSortOrder = 0; // track pagination by this property
  exports.maxPageCount = 0;
  exports.pageNr = 0;
  exports.pageSize = 0;
  exports.pressItems = [];
  exports.featuredPress = [];
  exports.initializePressPage = initializePressPage;
  exports.getNextPagePressItems = getNextPagePressItems;
  exports.getPreviousPagePressItems = getPreviousPagePressItems;
  exports.loadFeaturedPress = loadFeaturedPress;

  function initializePressPage() {
    getPressItemCount(function() {
      getNextPagePressItems(exports.pageNr);
    });
  }

  function getPressItemCount(callback) {
    httpSvc.getPressItemCount(function(res) {
      exports.maxPageCount = Math.ceil(res.count / exports.pageSize);
      callback();
    });
  }

  function getPressItems() {
    httpSvc.getPressItems({}, function(res) {
      exports.pressItems = res;
    });
  }

  function loadFeaturedPress() {
    httpSvc.loadFeaturedPress(function(res) {
      exports.featuredPress = res;
    });
  }

  function getNextPagePressItems() {
    if (!topSortOrder) {
      topSortOrder = exports.pressItems[0] ? exports.pressItems[0].sort_order : 0;
    }

    if (exports.pageNr < exports.maxPageCount) {
      exports.pageNr += 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      pageNr: exports.pageNr,
      sortOrder: topSortOrder
    };

    getPagePressItems(payload);
  }

  function getPreviousPagePressItems() {
    if (exports.pageNr > 1) {
      exports.pageNr -= 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      pageNr: exports.pageNr,
      sortOrder: topSortOrder
    };

    getPagePressItems(payload);
  }

  function getPagePressItems(payload) {
    httpSvc.getPagePressItems(payload, function(res) {
      exports.pressItems = res;
    });
  }

  return exports;
}])
.
factory('pressReleaseSvc', ['$rootScope', 'resource', 'notifySvc', 'mrNgUtils', function($rootScope, resource, notifySvc, mrNgUtils) {

  var httpSvc = resource('/rest/press', {}, {
    getPagePressReleases: { method: 'GET', url: '/api/press/getPagePressReleases', isArray: true },
  });

  var exports = {};
  var lastSortOrder = 0;
  exports.pageSize = 0;
  exports.pressReleases = [];
  exports.noMoreRecords = true;

  exports.initializePressReleases = initializePressReleases;
  exports.getPressReleaseBatch = getPressReleaseBatch;

  function initializePressReleases() {
    getPressReleaseBatch();
  }

  function getPressReleaseBatch() {
    exports.noMoreRecords = true;

    if (exports.pageNr < exports.maxPageCount) {
      exports.pageNr += 1;
    }

    var payload = {
      pageSize: exports.pageSize,
      sortOrder: lastSortOrder
    };

    httpSvc.getPagePressReleases(payload, function(res) {
      if (!res.length) {
        return;
      }
      if (res.length < exports.pageSize) {
        exports.noMoreRecords = true;
      } else {
        exports.noMoreRecords = false;
      }

      lastSortOrder = res[res.length -1].sort_order;
      exports.pressReleases = exports.pressReleases.concat(res);
    });
  }

  return exports;
}]).
factory('productCatalogSvc', ['resource', function(resource) {
  return resource('/api/product', {}, {
    getColorsSortedByLevel: { method: 'GET', url: '/api/product/getColorsSortedByLevel', isArray: true },
    getProductsByType: {method: 'GET', url: '/api/product/getProductsByType', isArray: true },
    getProductByCode: {method: 'GET', url: '/api/product/getProductByCode' },
    getProductById: {method: 'GET', url: '/api/product/getProductById' },
    getProductByUrlKey: {method: 'GET', url: '/api/product/getProductByUrlKey' },
    getProductPrices: {method: 'GET', url: '/api/product/getProductPrices' },
    getAverageReviewsByProductId: {method: 'GET', url: '/api/product/getAverageReviewsByProductId'},
    getProductSummaryByCode: {method: 'GET', url: '/api/product/getProductSummaryByCode'}
  });
}])
.
factory('productTypeSvc', ['resource', function(resource) {
  return resource('/api/productTypes', {}, {
    getById: { method: 'GET', url: '/api/productTypes/getById' }
  });
}]).
factory('promoSvc', ['resource', function(resource) {
  var promoHttpSvc = resource('api/cart', {}, {
    applyTestPromo: { method: 'POST', url: '/api/cart/applyTestPromo', isArray: false }
  });

  var exports = {
    testPromo: {}
  };

  exports.extractDiscounts = extractDiscounts;
  exports.applyTestPromo = applyTestPromo;

  function applyTestPromo() {
    promoHttpSvc.applyTestPromo(function(res) {
      exports.testPromo = res;
    });
  }

  function extractDiscounts(promos, selectedShipping) {
    var discounts = [];
    promos.forEach(function(promo) {
      if (promo.asCredits) {
        return;
      }
      
      if (promo.offers && promo.offers.length > 1) {
        //list for promos that contain more than one offer
        displayPromoAsOfferList(promo, discounts, selectedShipping);
      } else {
        //creates a header row where the promo assumes the values of the offer
        displayPromoAsOffer(promo, discounts, selectedShipping);
      }
    });
    return discounts;
  }

  function displayPromoAsOfferList(promo, discounts, selectedShipping) {
    // Filter out the 2-3 day free shipping if selected shipping is 1-2 day for site wide shipping
    promo.offers = promo.offers.filter(function(offer) {
      if (selectedShipping && selectedShipping.price && offer.type === 'freeShipping') {
        return false;
      }
      return true;
    });

    if (!promo.id) { //- promos in confirmation page, order history do not have ids
      //- thats all we need to display in confirmation/invoice history page
      discounts.push({
        header: true,
        amt: promo.amount,
        label: promo.displayName,
        showOriginalPrice: true
      });
      return;
    }

    var discHeader = {
      header: true,
      promo_id: promo.id,
      label: promo.displayName,
      can_remove: promo.can_remove,
      showOriginalPrice: promo.showOriginalPrice,
      type: promo.type
    };
    if (discHeader.header && discHeader.label && promo.type === 'bundle' && discHeader.amt === 0) {
      return;
    }

    var discOffers = [];
    var nullAmts = ['customerPromo', 'freeProduct', 'credit'];
    promo.offers.forEach(function(offer) {
      var displayAmount = +offer.amount;
      if (offer.hasOwnProperty('displayAmount')) {
        displayAmount = +offer.displayAmount;
      }

      var display = false;
      if (nullAmts.indexOf(offer.type) > -1) {
        displayAmount = null;
        display = true;
      }

      var amt = offer.showOriginalPrice ? Math.abs(displayAmount) * -1 : 0;

      if (amt) {
        display = true;
      }

      discOffers.push({
        display: display,
        header: false,
        label: offer.display_name || promo.displayName,
        type: offer.type,
        amt: amt,
        can_remove: false,
        showOriginalPrice: Boolean(offer.showOriginalPrice)
      });
    });

    discounts.push(discHeader);
    if (discOffers.length) { //flatten the array, works faster than .concat()
      discounts.push.apply(discounts, discOffers);
    }
  }

  function displayPromoAsOffer(promo, discounts, selectedShipping) {
    var firstChildOffer = promo.offers[0];
    if (selectedShipping && selectedShipping.price && firstChildOffer.type === 'freeShipping') {
      return;
    }

    if (!promo.id) { //- promos in confirmation page, order history do not have ids
      //- thats all we need to display in confirmation/invoice history page
      discounts.push({
        header: true,
        amt: promo.amount,
        label: promo.displayName,
        showOriginalPrice: true
      });
      return;
    }

    var discHeader = {
      header: true,
      promo_id: promo.id,
      amt: promo.displayAmount ? Math.abs(promo.displayAmount) * -1 : Math.abs(firstChildOffer.displayAmount) * -1,
      label: firstChildOffer.display_name ? firstChildOffer.display_name : promo.displayName,
      can_remove: promo.can_remove,
      showOriginalPrice: firstChildOffer.showOriginalPrice,
      type: promo.type
    };

    if (discHeader.header && discHeader.label && promo.type === 'bundle' && discHeader.amt === 0) {
      return;
    }
    discounts.push(discHeader);
  }

  return exports;
}])
.
factory('quizSvc', ['resource', function(resource, loader) {
  return resource('/api/quiz', {}, {
    syncQuizAndGetAnswersForType: { method: 'POST', url: '/api/quiz/syncQuizAndGetAnswersForType'},
    getQuestionsAndAnswersForQuizType: { method: 'POST', url: '/api/quiz/getQuestionsAndAnswersForQuizType'},
    saveQuizAnswers: { method: 'POST', url: '/api/quiz/saveQuizAnswers'},
    getAnswersForQuiz: { method: 'GET', url: '/api/quiz/getAnswersForQuiz'},
    isAnyAnswerRecordedForQuiz: { method: 'GET', url: '/api/quiz/isAnyAnswerRecordedForQuiz'},
    emailAdvisorAnswers: { method: 'GET', url: '/api/quiz/emailAdvisorAnswers'}
  });
}])
.
factory('refillCartSvc', ['resource', 'notifySvc', '$rootScope', 'Modal',  function(resource, notifySvc, $rootScope, Modal) {
  var httpSvc = resource('/api/cart', {}, {
    addToCart: { method: 'POST', url: '/api/refillCart/addToCart', isArray: false },
    setShippingMethod: { method: 'POST', url: '/api/refillCart/setShippingMethod' },
    getCartItems: { method: 'POST', url: '/api/refillCart/getCartItems', isArray: true },
    getAddons: { method: 'POST', url: '/api/refillCart/getAddons', isArray: true },
    removeItemFromCart: { method: 'POST', url: '/api/refillCart/removeItemFromCart', isArray: false },
    shipRefillWithCart: { method: 'POST', url: '/api/cart/shipRefillWithCart', isArray: false },
    shipAllSubsWithCart: { method: 'POST', url: '/api/cart/shipAllSubsWithCart', isArray: false },
    getRefillCartDataForView: { method: 'POST', url: '/api/refillCart/getRefillCartDataForView', isArray: false },
    getProductByUrlKey: { method: 'GET', url: '/api/refillCart/getProductByUrlKey', isArray: false}
  });

  var exports = {};

  exports.addToCart = addToCart;
  exports.removeItemFromCart = removeItemFromCart;
  exports.getRefillCartDataForView = getRefillCartDataForView;
  exports.shipNow = shipNow;
  exports.shipAllSubsNow = shipAllSubsNow;
  exports.getProductByUrlKey = getProductByUrlKey;
  exports.addToCartFromEmail = addToCartFromEmail;

  exports.addProductToRefillCartModal = Modal.newModal('addProductToRefillCartModal');

  exports.refillCart = {};
  exports.loadingRefillCart = true;
  exports.subscriptionId = null;
  exports.addonProduct = {};
  exports.emailCtaSource = {
    name: null,
    idx: null
  };
  exports.addingToCart = false;

  function getProductByUrlKey(payload, onSuccess, onFail) {
    return httpSvc.getProductByUrlKey(payload, function(product) {
      exports.addonProduct = product;
      exports.addProductToRefillCartModal.show = true;

      if (onSuccess) {
        onSuccess(product);
      }
    }, onFail);
  }

  function getRefillCartDataForView(subscriptionId) {
    exports.loadingRefillCart = true;
    exports.subscriptionId = subscriptionId;
    var payload = {
      subscriptionId: subscriptionId
    };
    httpSvc.getRefillCartDataForView(payload, function(res) {
      exports.refillCart = res;
      exports.loadingRefillCart = false;
    }, function(err) {
      exports.loadingRefillCart = false;
    });
  }

  function removeItemFromCart(index) {
    var payload = {
      subscriptionId: exports.subscriptionId,
      index: index
    };
    httpSvc.removeItemFromCart(payload, function (res) {
      exports.refillCart = res;
      notifySvc.notify('success', 'Successfully removed product from your refill cart.');
    }, function() {
      notifySvc.notify('error', 'We were not able to remove this item to your delivery. Please try again or call Color Crew');
    });
  }

  function addToCart(addonItem) {
    var payload = {
      subscriptionId: exports.subscriptionId,
      product_id: addonItem.prod.id,
      qty: 1,
      ctaSource: addonItem.ctaSource
    };

    if (addonItem.validOffer) {
      payload.validOffer = addonItem.validOffer;
    }

    doAddToCart(payload);
  }

  function addToCartFromEmail() {
    if (!exports.emailCtaSource.name) {
      exports.emailCtaSource.name = 'upcomingSubscriptionEmail';
    }

    var payload = {
      subscriptionId: exports.subscriptionId,
      product_id: exports.addonProduct.id,
      qty: 1,
      ctaSource: exports.emailCtaSource
    };

    doAddToCart(payload);
  }

  function doAddToCart(payload) {
    if (exports.addingToCart) {
      return;
    }

    exports.addingToCart = true;
    httpSvc.addToCart(payload, function(res) {
      exports.refillCart = res;
      notifySvc.notify('success', 'Successfully added product to your upcoming shipment.');
      $rootScope.$broadcast('prod_added_to_refill');
      exports.addingToCart = false;
    }, function() {
      notifySvc.notify('error', 'We were not able to add this item to your delivery. Please try again or call Color Crew');
      exports.addingToCart = false;
    });
  }

  function shipNow(subId) {
    var payload = {
      subscriptionId: subId || exports.subscriptionId,
      nonPersistant: true
    };

    httpSvc.shipRefillWithCart(payload, function() {
      redirect('/checkout');
    }, function(err) {
      if (err.data && err.data.code == 'PENDING_ORDERS') {
        notifySvc.notify('warn', 'An order with these items is already being processed and will get to you in 3-10 business days.');
      } else {
        notifySvc.notify('error', 'We were not able to ship this delivery now. Please try again or call Color Crew');
      }
    });
  }

  function shipAllSubsNow() {
    var payload = {
      nonPersistant: true
    };

    httpSvc.shipAllSubsWithCart(payload, function() {
      redirect('/checkout');
    }, function(err) {
      if (err.data && err.data.code == 'PENDING_ORDERS') {
        notifySvc.notify('warn', 'An order with these items is already being processed and will get to you in 3-10 business days.');
      } else {
        notifySvc.notify('error', 'We were not able to ship this delivery now. Please try again or call Color Crew');
      }
    });
  }

  return exports;
}])
.
service('resource', ['$resource', 'loader', 'mrNgUtils', function($resource, loader, mrNgUtils) {
  return function(url, params, actions) {
    params = params || {};
    angular.forEach(actions, function(v, k) {
      var isPOST = v.method === 'POST';

      try {
        window.dispatchEvent(new CustomEvent('ajaxEvent', { 'detail' : url } ));
      } catch (e) {
        // IE doesn't support dispatchEvent
      }

      v.transformRequest = function(data) {
        // Only show spinner for POST requests and if hideSpinner is falsy
        if (isPOST && (data && !data.hideSpinner)) {
          loader.start();
        }

        params._ts = Date.now();

        return data ? angular.toJson(data) : data;
      };

      v.transformResponse = function(data) {
        if (isPOST) {
          loader.finish();
        }

        return data ? (mrNgUtils.isJson(data) ? angular.fromJson(data) : data) : data;
      };
    });

    return $resource(url, params, actions);
  };
}])
.
factory('reviewSvc', ['resource', function(resource) {
  return resource('/api/review', {}, {
    submitReview: { method: 'POST', url: 'api/review/submitReview' },
    getCustomerReviewForProduct: { method: 'GET', url: '/api/review/getCustomerReviewForProduct' },
    getApprovedReviewsByProdId: { method: 'GET', url: '/api/getApprovedReviewsByProdId', isArray: true },
    getSortByConstants: { method: 'GET', url: '/api/review/getSortByConstants' }
  });
}])
.
factory('scrollToSvc', [function() {
  var exports = {};
  exports.scrollToTop = scrollToTop;
  exports.scrollToElement = scrollToElement;

  function scrollToTop() {
    return $("body").animate({scrollTop: $("body").offset().top}, "slow");
  }

  function scrollToElement(el, offset) {
    if (!el || !$(el).length) {
      return scrollToTop();
    }

    offset ? offset : 0;
    return $("body").animate({scrollTop: $(el).offset().top - offset}, "slow");
  }
  return exports;
}]).
/**
 * @module searchSvc
 * @moduleType ngFactory
 */
factory('searchSvc', ['resource', function(resource) {
  return resource('/api/search', {}, {
    searchAll: {method: 'GET', url: '/api/search/searchAll', isArray: false},
    queryAll: {method: 'POST', url: '/api/search/queryAll', isArray: false},
    searchContent: {method: 'GET', url: '/api/search/searchContent', isArray: false},
    queryContent: {method: 'POST', url: '/api/search/queryContent', isArray: false},
    searchBlogPost: {method: 'GET', url: '/api/search/searchBlogPost', isArray: false},
    queryBlogPost: {method: 'POST', url: '/api/search/queryBlogPost', isArray: false},
    searchByFields: {method: 'GET', url: '/api/search/searchByFields', isArray: false}
  });
}])
.
factory('siteMessagesSvc', ['$rootScope', 'resource', 'notifySvc', function($rootScope, resource, notifySvc) {
  var httpSvc = resource('/api/siteMessages', {}, {
    getByTopics: { method: 'GET', url: '/api/siteMessages/getByTopics', isArray: true}
  });

  var exports = {};

  exports.getByTopics = getByTopics;

  function getByTopics(topics) {
    return httpSvc.getByTopics({topics: topics});
  }

  return exports;
}]).
factory('subscriptionSvc', ['$rootScope', 'resource', 'notifySvc', 'advisorSvc', 'productCatalogSvc', function($rootScope, resource, notifySvc, advisorSvc, productCatalogSvc) {
  var httpSvc = resource('/api/subscription', {}, {
    getSubs: { method: 'GET', url: '/api/subscription/getSubscriptionsByCustomerId' },
    cancelSubscription: { method: 'POST', url: '/api/subscription/cancelSubscription' },
    updateSubscription: { method: 'POST', url: '/api/subscription/updateSubscription' },
    updateMultipleSubscriptions: { method: 'POST', url: '/api/subscription/updateMultipleSubscriptions' },
    getCancelReasons: { method: 'GET', url: '/api/subscription/getCancelReasons' },
    getSubscriptionsWithItemsByAddressId: { method: 'GET', url: '/api/subscription/getSubscriptionsWithItemsByAddressId', isArray: true },
    getClosedDates: { method: 'GET', url: '/api/subscription/getClosedDates', isArray: true },
    getSubPauseDates: { method: 'GET', url: '/api/subscription/getSubPauseDates', isArray: true },
    getSubDateOptions: { method: 'GET', url: '/api/subscription/getSubDateOptions' },
    updateSubscriptionColor: { method: 'POST', url: '/api/subscription/updateSubscriptionColor' }
  });

  var exports = {};

  exports.subscriptions = [];
  exports.subMap = {};
  exports.subInEdit = {};
  exports.savingSub = false;
  exports.cancelReasons = [];
  exports.cancelSubPayload = {};
  exports.invalidDates = [];
  exports.subAddressIds = [];
  exports.updateAll = {
    showForm: false,
    next: null
  };
  exports.maxSkipDays = 12 * 7 //- 12 weeks;

  //- global option for product qty dropdown
  exports.prodQtyOption = [];
  for (var qty = 1; qty <= 10; qty++) {
    exports.prodQtyOption.push(qty);
  }

  //- options to cofigure available date range for next shipment date
  var future = new Date();
  var minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);
  future.setMonth(future.getMonth() + 3);
  exports.nextDateOptions = {
    minDate: new Date(),
    maxDate: exports.maxSkipDays,
    beforeShowDay: function(date) {
      return [isDateValid(date), "", null];
    }
  };

  $rootScope.$on('reload_subs', function() {
    getSubscriptions();
  });

  exports.getClosedDates = httpSvc.getClosedDates;
  exports.getSubscriptionsWithItemsByAddressId = httpSvc.getSubscriptionsWithItemsByAddressId;
  exports.cancelSubscription = httpSvc.cancelSubscription;

  exports.editSub = editSub;
  exports.getSubscriptions = getSubscriptions;
  exports.updateSubscription = updateSubscription;
  exports.getCancelReasons = getCancelReasons;
  exports.cancelEditSub = cancelEditSub;
  exports.cancelSub = cancelSub;
  exports.savingsCalc = savingsCalc;
  exports.prepSubSkipDates = prepSubSkipDates;
  exports.updateSubscriptionColor = updateSubscriptionColor;
  exports.updateNextDateForAllSubscriptions = updateNextDateForAllSubscriptions;

  getSubscriptions();

  function getSubscriptions(cb) {
    cb = cb || angular.noop;
    var todaysDate = new Date();
    todaysDate = todaysDate.setHours(0, 0, 0, 0);
    var payload = {
      subStatus: 'active',
      sortOrder: 'asc'
    };

    httpSvc.getSubs(payload, function(res) {
      exports.subscriptions = res.subs || [];
      mapSubs();
      $rootScope.$broadcast('all_subs_loaded');
      cb();
    }, function(err) {
      //- no error shown here. Otherwise it will show up on /support page
      // when we check for user subs if user is not logged in
      cb();
    });
  }

  function getCancelReasons() {
    httpSvc.getCancelReasons({
      product_type: exports.subInEdit.product_type,
      randomize: true
    }, function(res) {
      var hasNNN = exports.subInEdit.code.indexOf('NNN') < -1;
      exports.cancelReasons = res.reasons.map(function(reason) {
        reason.mention_nnn = !hasNNN && reason.mention_nnn;
        return reason;
      });
    });
  }

  function mapSubs() {
    exports.subAddressIds = [];
    var subs = exports.subscriptions;
    if (!subs) {
      return;
    }

    for (var i = 0; i < subs.length; i++) {
      //- collect unique address ids from all subs
      if (!~exports.subAddressIds.indexOf(subs[i].shipping_address_id)) {
        exports.subAddressIds.push(subs[i].shipping_address_id);
      }
      exports.subMap[subs[i].id] = subs[i];
    }
  }

  function editSub(subId) {
    httpSvc.getSubDateOptions({sub_id: subId}, function(res) {
      //- if we don't get invalid dates no need for panic
      exports.invalidDates = res.closeDates;
      //- maxSkipDays has a default val. Used for maximum furthest date in next date picker
      exports.maxSkipDays = res.maxSkipDays;
    });
    exports.subInEdit = angular.copy(exports.subMap[subId] || {});
    //- need to track original next date
    exports.subInEdit.initialNext = exports.subInEdit.next;
    if (exports.subInEdit.inactive) {
      exports.subInEdit.status = 'active';
    }
    getRecsForProductType(exports.subInEdit.product_type);
    savingsCalc(exports.subInEdit);
  }

  function getRecsForProductType(productType) {
    switch (productType) {
      case 'color_kit':
        advisorSvc.syncSession({}, function() {
          advisorSvc.getCompareShadesData({}, function(results) {
            exports.subInEdit.compareShadesTool = results;

            if (!results.bestMatch) {
              exports.subInEdit.noColorAdvisor = true;
            }

            exports.subInEdit.compareShadesTool.colorsByLevel.forEach(function(level) {
              level.products.forEach(function(color) {
                if (exports.subInEdit.code == color.code) {
                  exports.subInEdit.compareShadesTool.currentProduct = color;
                }
              });
            });
          });
        });
        break;
      case 'gloss':
      case 'root_reboot':
      case 'root_touch_up':
        productCatalogSvc.getProductsByType({
          productType: productType
        }, function(res) {
          exports.subInEdit.availableColors = res.sort(sortProducts);
          exports.subInEdit.availableColors.forEach(function(color, index) {
            if (color.code == exports.subInEdit.code) {
              exports.subInEdit.selectedIdx = index;
            }
          });
        });
        break;
    }
  }

  function updateSubscriptionColor(productId) {
    if (exports.savingSub) {
      return;
    }
    exports.savingSub = true;

    var payload = {
      subscriptionId: exports.subInEdit.id,
      productId: productId
    };

    httpSvc.updateSubscriptionColor(payload, function() {
      exports.savingSub = false;
      getSubscriptions();
      $rootScope.$broadcast('sub_updated', exports.subInEdit.id);
      notifySvc.notify('success', 'You have succesfully updated your auto-delivery.');
    }, function() {
      exports.savingSub = false;
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function sortProducts(a, b) {
    var cmpA = a.color_number;
    var cmpB = b.color_number;

    return cmpA - cmpB;
  }

  function cancelEditSub() {
    exports.subInEdit = {};
  }

  function updateSubscription() {
    if (!exports.subInEdit.id) {
      notifySvc.notify('warn', notifySvc.messages.canNotCompleteTransaction);
    }
    var payload = {
      sub_id: exports.subInEdit.id,
      changes: angular.copy(exports.subInEdit) //- we are sending back the whole sub object, backend will figure out what to save
    };

    if (!payload.changes.next) {
      payload.changes.next = new Date(); //- default to today
    } else {
      //-make sure its a date obj
      payload.changes.next = new Date(payload.changes.next) == 'Invalid Date' ? new Date() : new Date(payload.changes.next);
    }

    //- check for weekends and 3pl blackout days
    if (!isDateValid(payload.changes.next)) {
      return notifySvc.notify('warn', 'Next ship date cannot be on weekends or select holidays. Please use the calendar for available dates.');
    }
    //- have to convert next date to string to avoid any funny business with servers and timezones
    payload.changes.next = getDateString(exports.subInEdit.next);
    exports.savingSub = true;

    httpSvc.updateSubscription(payload, function() {
      exports.savingSub = false;
      getSubscriptions();
      $rootScope.$broadcast('sub_updated', exports.subInEdit.id);
      $rootScope.$broadcast('reload_addresses');
      notifySvc.notify('success', 'You have succesfully updated your auto-delivery.');
    }, function(err) {
      exports.savingSub = false;
      var errMsg = notifySvc.messages.canNotCompleteTransaction;
      if (err.data && err.data.message) {
        errMsg = err.data.message;
      }
      notifySvc.notify('error', errMsg);
    });
  }

  function cancelSub(callback) {
    callback = callback || angular.noop;
    exports.cancelSubPayload.sub_id = exports.subInEdit.id;

    httpSvc.cancelSubscription(exports.cancelSubPayload, function() {
      exports.cancelSubPayload = {};
      notifySvc.notify('info', 'You have successfully canceled your Auto Delivery.');
      getSubscriptions();
      $rootScope.$broadcast('sub_canceled');
      $rootScope.$broadcast('reload_addresses');
      callback();
    }, function() {
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  function prepSubSkipDates(subId) {
    //- always reset subInEdit in case there are some unsaved changes
    editSub(subId);

    httpSvc.getSubPauseDates({sub_id: subId}, function(dates) {
      exports.subInEdit.pauseDates = dates;
    });
  }

  function getDateString(date) {
    date = new Date(date);
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  function savingsCalc(subInfo) {
    if (!subInfo || !subInfo.product_info) {
      return;
    }

    subInfo.annualSavings = Math.ceil((subInfo.product_info.price - subInfo.product_info.sub_price) * (52 / subInfo.frequency) * subInfo.qty);
  }

  //- date helpers
  function isSameDate(dateOne, dateTwo) {
    dateOne = new Date(dateOne);
    dateTwo = new Date(dateTwo);
    return !(dateOne.getFullYear() != dateTwo.getFullYear() || dateOne.getMonth() != dateTwo.getMonth() || dateOne.getDate() != dateTwo.getDate());
  }

  function isDateValid(date) {
    var weekend = [0, 6];
    if (!date || weekend.indexOf(new Date(date).getDay()) != -1) {
      return false;
    }

    return !exports.invalidDates.some(function(invalidDate) {
      return isSameDate(invalidDate, date);
    });
  }

  function updateNextDateForAllSubscriptions() {
    if (!exports.updateAll.next) {
      return notifySvc.notify('warn', 'Please select a date');
    }

    if (!isDateValid(exports.updateAll.next)) {
      return notifySvc.notify('warn', 'Next ship date cannot be on weekends or select holidays. Please use the calendar for available dates.');
    }

    exports.savingSub = true;
    var subIds = exports.subscriptions.map(function(sub) {
      return sub.id;
    });

    var payload = {
      subIds: subIds,
      changes: { next: getDateString(exports.updateAll.next) }
    };

    httpSvc.updateMultipleSubscriptions(payload, function(res) {
      $rootScope.$broadcast('sub_updated');
      exports.savingSub = false;
      getSubscriptions();
      exports.updateAll.showForm = false;
      exports.updateAll.next = null;
      notifySvc.notify('success', 'Successfully updated all your auto deliveries.');
    }, function(err) {
      exports.savingSub = false;
      notifySvc.notify('error', notifySvc.messages.canNotCompleteTransaction);
    });
  }

  return exports;
}])
.
/**
 * @module trackerSvc
 * @moduleType ngFactory
 */
factory('trackerSvc', ['cdata', function(cdata) {
  function trackEvent(eventName, properties) {
    if (!properties) {
      properties = {};
    }
    appendStdProps(properties);
    if (!properties.user_id) {
      return window.analytics.track(eventName, properties, {anonymousId: cdata.dig});
    }
    window.analytics.track(eventName, properties);
  }

  function appendStdProps(properties) {
    properties.dig = cdata.dig;
    properties.dug = cdata.dug;
    properties.isIOS = cdata.isIOS;
    properties.sessionId = cdata.sessionId;
    properties.agent_id = cdata.agent_id;
    if (cdata.user && cdata.user.id) {
      properties.user_id = cdata.user.id;
      if (cdata.user.email) {
        properties.email = cdata.user.email;
      }
    }
  };

  return {
    trackEvent: trackEvent
  };
}]).
factory('waitlistSvc', ['resource', function(resource, loader) {
  return resource('/api/waitlist', {}, {
    addToWaitlist: { method: 'POST', url: '/api/waitlist/addToWaitlist' }
  });
}]).
factory('xsellSvc', ['resource', function(resource) {
  return resource('/api/xsell', {}, {
    getXsellItemsForProduct: { method: 'GET', url: '/api/xsell/getXsellItemsForProduct', isArray: true },
    getSystemRecommendations: { method: 'GET', url: '/api/xsell/getSystemRecommendations', isArray: true },
    getRoutineRecommendations: { method: 'POST', url: '/api/xsell/getRoutineRecommendations', isArray: false }
  });
}])
;
/* global analytics */
angular.module('mrWebsite', [
  'ngResource',
  'ngRoute',
  'ngAnimate',
  'ngTouch',
  'ngCookies',
  'ngSanitize',
  'mrShared.controllers',
  'mrShared.directives',
  'mrShared.filters',
  'mrShared.services',
  'mrWebsite.directives',
  'mrWebsite.filters',
  'mrWebsite.services',
  'angularFileUpload',
  'iso',
  'ui.date',
  'ui.mask',
  '720kb.socialshare'
])

// Angular global error handler
.factory('$exceptionHandler', [function() {
  return function(exception, cause) {
    // Output to console
    console.error(exception.stack);

    // Send angular errors to raygun with timeout to make sure raygun loads
    if (window.Raygun) {
      Raygun
        .withTags(['angular'])
        .send(exception);
    }
  };
}])

.config(['$sceDelegateProvider', '$compileProvider', function($sceDelegateProvider, $compileProvider) {
  performance.mark('angularConfigInit'); // custom perf metric
  if (env === 'production') {
    $compileProvider.debugInfoEnabled(false);
  }

  $sceDelegateProvider.resourceUrlWhitelist([
    'self',
    'https://www.youtube.com/**'
  ]);
}])

.controller('mrMainCtl', [
  '$scope',
  '$location',
  '$route',
  '$window',
  '$timeout',
  '$compile',
  'customerSvc',
  'newCartSvc',
  'productCatalogSvc',
  'Modal',
  '$cookies',
  'notifySvc',
  'cdata',
  'contentData',
  'trackerSvc',
  'mrNgUtils',
  function(
    $scope,
    $location,
    $route,
    $window,
    $timeout,
    $compile,
    customerSvc,
    newCartSvc,
    productCatalogSvc,
    Modal,
    $cookies,
    notifySvc,
    cdata,
    contentData,
    trackerSvc,
    mrNgUtils
  ) {
  performance.mark('angularInit'); // custom perf metric
  $scope.$location = $location;
  $scope.$window = $window;
  $scope.$cookies = $cookies; // this is also exposed as cookies without the $ but that has been deprecated
  $scope.$timeout = $timeout;
  $scope.params = mrNgUtils.locationSearchParams();
  $scope.mrtest = '';
  $scope.cart = { summary: {} };
  $scope.shippingAddress = false;
  $scope.env = env;
  $scope.notifySvc = notifySvc;
  $scope.cookies = $cookies; // $scope.cookies has been deprecated, use $scope.$cookies instead
  $scope.cdata = cdata;
  $scope.trackerSvc = trackerSvc;
  $scope.customerSvc = customerSvc;
  performance.mark('angularInit'); // custom perf metric

  // Adjust recent product added cookie for xsell modal on cart
  $scope.cdata.recentAddedProduct = 0;
  if ($cookies.recentAddedProduct) {
    $scope.cdata.recentAddedProduct = +$cookies.recentAddedProduct;
    delete $cookies.recentAddedProduct;
  }

  if (window.notifications) {
    // Displays any messages found in the notifications array passed from the backend
    notifications.forEach(function(notification) {
      notifySvc.notify(notification.class, notification.message, notification.displayTime);
    });
  }

  // All notificatgions sent from the backend have been displayed, so now we proceed to
  // remove them to avoid showing them on other pages.
  notifySvc.emptyBackendNotificationsArray();

  if (!cdata.user || !cdata.user.authed) {
    $cookies.ajs_user_id = null;
  } else if (cdata.user && cdata.user.authed && cdata.user.id != $cookies.ajs_user_id) {
    $cookies.ajs_user_id = cdata.user.id;
  }

  if ($cookies.cic === undefined) {
    newCartSvc.setCartItemCountInCookie();
  }

  // top nav stuff
  $scope.topNav = {};
  $scope.signInControl = {
    open: false
  };

  $scope.hoverOpen = function(section) {
    // hover only works on desktop breakpoint
    if ($scope.windowData.breakpoint == 'desktop') {
      $scope.topNav.hovered = section;
      setTimeout(function() {
        if ($scope.topNav.hovered == section) {
          $scope.topNav.selected = section;
          $scope.safeApply();
        }
      }, 500);
    }
  };

  $scope.hoverClose = function(section) {
    // hover only works on desktop breakpoint
    if ($scope.windowData.breakpoint == 'desktop') {
      $scope.topNav.hovered = 0;
      setTimeout(function() {
        if ($scope.topNav.hovered != section) {
          $scope.topNav.selected = 0;
          $scope.safeApply();
        }
      }, 500);
    }
  };

  $scope.clickOpen = function(section) {
    // click open works as a toggle on the mobile design but not desktop
    if ($scope.windowData.breakpoint == 'mobile' || $scope.windowData.breakpoint == 'tablet' || $scope.windowData.breakpoint == 'desktop-md') {
      $scope.topNav.selected == section ? $scope.topNav.selected = 0 : $scope.topNav.selected = section;
    } else {
      $scope.topNav.selected = section;
    }
  };

  // modal stuff
  $scope.Modal = Modal;
  $scope.mobileMenuOpen = false;

  // mobile device
  $scope.isMobileDevice = isMobile;
  $scope.isIOS = isIOS;

  $scope.isEmptyObject = function isEmptyObject(obj) {
    return angular.equals({}, obj);
  };

  $scope.$on('$locationChangeSuccess', function(event, url) {
    var path, pageTitle, pageName, origPath, fullUrl;
    var props = {
      dig: cdata.dig,
      dug: cdata.dug,
      isIOSApp: cdata.isIOS,
      sessionId: cdata.sessionId,
      agent_id: cdata.agentId
    };

    if ($route.current && $route.current.$$route) {
      origPath = $route.current.originalPath;
      path = origPath.split('/').filter(function(segment) {
        return segment.indexOf(':') !== 0;
      });
    } else {
      path = url.split('?')[0].split('/').slice(3);
      // for all the pages that get here we need to specifically pass absolute url to segment (some angular quirk)
      props.url = url;
    }
    pageTitle = path.pop() || 'Home Page';
    path.push(pageTitle);
    pageName = path.join(' ');
    path = path.join('/');

    props.title = pageTitle;
    props.path = path;

    if (origPath) {
      props.originalPath = origPath;
    }
    var opts = {};
    if (!cdata.user || !cdata.user.id) {
      opts.anonymousId = cdata.dig;
    }
    //analytics.user().anonymousId(cdata.dug);
    if (/^[0-9]+$/.test(cdata.userId) && !cdata.agentId) {
      var props = angular.copy(cdata.user) || {};
      props.dig = cdata.dig ? cdata.dig : null;
      props.dug = cdata.dug ? cdata.dug : null;
      props.agentId = cdata.agentId;
      props.isIOSApp = cdata.isIOS;
      props.sessionId = cdata.sessionId;
      if (cdata.user) {
        analytics.identify(cdata.user.id, props);
      }
    }

    var lyticsTimeout;
    //- need to wait for Lytics to load in so we can grab segmentsArray
    var lyticsWatcher = $scope.$watch('$window.lio', function(newVal) {
      if (!newVal) {
        return;
      }
      //- clear the lyticsTimeout so we don't get extra page event
      clearTimeout(lyticsTimeout);
      props.lyticsAudiences = newVal.segmentsArray;
      //- this destroys watcher after it has done its part
      lyticsWatcher();
      analytics.page(pageName, props, opts);
    });
    //- if for some reason Lytics does not load, we want to fire page event
    //- anyway and destroy the watcher so we do not get two page events
    lyticsTimeout = setTimeout(function() {
      lyticsWatcher();
      analytics.page(pageName, props, opts);
    }, 1000);


    if (cdata.trackExperiment) {
      var trackData = {
        experiment_id: cdata.trackExperiment.experiment_id,
        experiment_name: cdata.trackExperiment.experiment_name,
        variation_id: cdata.trackExperiment.variation_id,
        variation_name: cdata.trackExperiment.variation_name,
        dig: cdata.dig,
        dug: cdata.dug,
        agentId: cdata.agentId,
        isIOSApp: cdata.isIOS,
        sessionId: cdata.sessionId
      };
      analytics.track('Experiment Viewed', trackData);
      delete cdata.trackExperiment.recorded;
    }
    $('link').each(function() {
      if (this.rel === 'canonical') {
        if (this.href !== url) {
          this.href = url.split('?')[0];
        }
      }
    });
  });

  /** `$scope.notifications` is an array containing all the currently displaying notifications. **/
  $scope.notifications = [];

  //- Use goToPath with angular when you want to get outside of angular routing (reloads page)
  $scope.goToPath = function goToPath(path, newTab) {
    if (newTab) {
      window.open(path);
      return false;
    }
    location.href = path;
  };
  //- angular way to go using angular routing (does not reload page)
  $scope.go = function(path) {
    $location.path(path);
    $scope.scrollTop();
  };

  $scope.goBack = function() {
    window.history.back();
  };

  $scope.setFocus = function(id) {
    window.setTimeout(function() {
      document.getElementById(id).focus();
    }, 10);
  };

  //sets a cookie on a key:value pair in (n) hours
  $scope.setCookie = function setCookie(key, value, hours) {
    var d = new Date();
    d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
    var expireString = "expires=" + d.toUTCString();
    //must access the jquery collection of document
    $(document)[0].cookie = key + "=" + value + "; " + expireString;
  };

  $scope.deleteCookie = function deleteCookie(key) {
    $scope.setCookie(key, '', -1);
  };

  //- checks error is user not logged in error, if so will redirect to signin and return true
  $scope.checkUserLoginError = customerSvc.checkUserLoginError;

  // makes logging available to cms jade templates.
  // very useful when creating components that us DynoCtl
  $scope.consoleLog = function(message) {
    console.log(message);
  };

  // used for A/B testing
  if ($scope.params.mrt) {
    $scope.mrtest = $scope.params.mrt;
  }

  $scope.scrollTo = function scrollTo(selector, animateDuration, delay) {
    if (!$(selector).length) {
      return;
    }
    var timeoutDelay = delay || 10;
    setTimeout(function() {
      //Default is to use scroll animation
      if (animateDuration === false) {
        $("body, html").scrollTop($(selector).offset().top);
      } else {
        // Convert string ms into a number else default to 'slow' animation
        animateDuration = ++animateDuration || 'slow';
        $("body, html").animate({ scrollTop: $(selector).offset().top }, animateDuration);
      }
    }, timeoutDelay);
  };

  if ($scope.params.scrollTo) {
    $scope.scrollTo('#' + $scope.params.scrollTo);
  }

  $scope.stopScroll = function() {
    $("body, html").stop(true, false);
  };

  //On mobile you cannot do both href and ng-click on an 'a' tag
  //Instead do:
  //a(ng-click="scrollTo('.sections','/account/auto-delivery')")
  $scope.linkScrollTo = function linkScrollTo(selector, url, flag, animateDuration) {
    //Change route
    $location.path(url);

    // Flag whether to scroll or not
    // Example: In my account we only want to scroll on mobile but not desktop
    if (flag) {
      //Scroll to selector passed in
      $scope.scrollTo(selector, animateDuration);
    }
  };

  $scope.scrollTop = function scrollTop() {
    $("body, html").animate({ scrollTop: $(".angular-div").offset().top }, "slow");
  };

  // scrolls the selected div right by the width of it's children
  $scope.scrollRight = function scrollRight(selector, animateDuration) {
    animateDuration = ++animateDuration || 'fast';
    $(selector).animate({ scrollLeft: $(selector).scrollLeft() + $(selector + ' > div').width() }, animateDuration);
  };

  // scrolls the selected div left by the width of it's children
  $scope.scrollLeft = function scrollLeft(selector, animateDuration) {
    animateDuration = ++animateDuration || 'fast';
    $(selector).animate({ scrollLeft: $(selector).scrollLeft() - $(selector + ' > div').width() }, animateDuration);
  };

  $scope.logOut = function logOut() {
    delete $cookies.amazon_Login_state_cache;
    delete $cookies.amazon_Login_accessToken;
    delete $cookies.amazon_Address_consentToken;

    localStorage.removeItem('ajs_group_properties');
    localStorage.removeItem('ajs_user_traits');

    customerSvc.logOut(function() {
      var trackData = {
        dig: cdata.dig,
        dug: cdata.dug,
        agentId: cdata.agentId,
        isIOSApp: cdata.isIOS,
        sessionId: cdata.sessionId
      };
      analytics.track('Logged Out', trackData);
      analytics.reset();
      location.href = '/';
    });
  };

  $scope.setCartShipAddress = function setCartShipAddress(address) {
    newCartSvc.setShippingAddress({ address: address }, function() {
      $scope.shippingAddress = address;
    });
  };

  $scope.addToBag = function(productId, qty, isSubscription, ctaSource) {
    var payload = {
      id: productId,
      qty: qty,
      ctaSource: ctaSource,
      subscription: isSubscription
    };

    newCartSvc.addProduct(payload, function(res) {
      $cookies.recentAddedProduct = payload.id;

      // Adding AddToCart event for Facebook Pixel Tracking
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Shopping Cart',
          content_ids: [res.product_type_name + ' - ' + res.name],
          content_type: 'product',
          value: '' + res.price,
          currency: 'USD',
          order_type: payload.subscription ? 'subscription' : 'non-subscription'
        });
      }

      redirect('/cart', {
        product_code: res.code
      });
    });
  };

  $scope.getProductById = function (productId) {
    return productCatalogSvc.getProductById({id: productId});
  };

  $scope.getProductByCode = function (productCode) {
    return productCatalogSvc.getProductByCode({code: productCode});
  };

  $scope.getProductByUrlKey = function (urlKey) {
    return productCatalogSvc.getProductByUrlKey({urlKey: urlKey});
  };

  /**
   Provides a way to call `$scope.$apply` in a 'safe' manner. That is... it will only
   call it if one isn't already in progress.
   **/
  $scope.safeApply = function safeApply(fn) {
    var phase = this.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
      if (fn && (typeof(fn) === 'function')) {
        fn();
      }
    } else {
      this.$apply(fn);
    }
  };
  //- when using 'scroll' param in url, scroll to tag with 'scroll' value
  if ($scope.params.scroll) {
    setTimeout(function() {
      $scope.scrollTo('#' + $scope.params.scroll, 300);
    }, 5); // slight timeout needed to prevent Chrome to scroll to old location
  }

  // TODO: put windowWatcher code into a window watcher service that uses events
  var wndw = $(window);

  $scope.windowData = {
    noScroll: false, // used to disable scrolling when a modal is active
    breakpoint: null,
    width: null,
    scrollTop: null,
    scrollBottom: null,
    scrollDirection: 0, // defaults to 0, 1 if scrolling down, -1 if scrolling up
    scrollDepth: 0, // how deep the user has scrolled down the page
    hash: null
  };

  windowSizeWatcher();
  setInterval(windowScrollWatcher, 250);
  wndw.resize(windowSizeWatcher);

  function windowSizeWatcher() {
    var width = wndw.width();
    var previousBreakpoint = $scope.windowData.breakpoint;
    $scope.windowData.width = width;

    // NOTE: these values are based on bp-mobile-max, bp-tablet-max,
    // bp-desktop-md-max from variables.styl
    if (width <= 559) {
      $scope.windowData.breakpoint = 'mobile';
    } else if (width <= 759) {
      $scope.windowData.breakpoint = 'tablet';
    } else if (width <= 959) {
      $scope.windowData.breakpoint = 'desktop-md';
    } else {
      $scope.windowData.breakpoint = 'desktop';
      $scope.mobileNavOpen = false;
      $scope.windowData.noScroll = false;
    }
    
    setTimeout(function() {
      if (previousBreakpoint != $scope.windowData.breakpoint) {
        $scope.$broadcast('breakpointChange', $scope.windowData);
        $scope.safeApply();
      }
    }, 500);
    
    $scope.safeApply();
  }

  $scope.setHash = function setHash(hash) {
    window.location.hash = hash;
  };

  $scope.$watch(function() {
    return window.location.hash;
  }, function(value) {
    $scope.windowData.hash = value.replace('#', '');
  });

  function windowScrollWatcher() {
    var windowScrollTop = wndw.scrollTop();
    if ($scope.windowData.scrollTop != windowScrollTop) {
      var oldScrollTop = $scope.windowData.scrollTop;
      var oldScrollDepth = $scope.windowData.scrollDepth;

      $scope.windowData.scrollTop = windowScrollTop;
      $scope.windowData.scrollBottom = windowScrollTop + wndw.height();
      $scope.windowData.scrollDirection = oldScrollTop > $scope.windowData.scrollTop ? -1 : 1;

      var currentScrollDepth = $scope.windowData.scrollBottom / $('.angular-div').height() * 100;
      if (currentScrollDepth > $scope.windowData.scrollDepth) {
        $scope.windowData.scrollDepth = currentScrollDepth;
        // Scroll depth tracking
        if (contentData && contentData.depthTracking) {
          var trackingData = {
            url: window.location.href,
            breakpoint: $scope.windowData.breakpoint,
            uri: contentData.uri,
            variationId: contentData.variationId,
            targetPlatform: contentData.targetPlatform,
            variationKey: contentData.variationKey,
            variationName: contentData.variationName,
            experimentId: contentData.experimentId,
            experimentName: contentData.experimentName
          };

          if ($scope.windowData.scrollDepth > 25 && oldScrollDepth < 25) {
            trackingData.percent = 25;
            trackerSvc.trackEvent('Scroll Depth', trackingData);
          }
          if ($scope.windowData.scrollDepth > 50 && oldScrollDepth < 50) {
            trackingData.percent = 50;
            trackerSvc.trackEvent('Scroll Depth', trackingData);
          }
          if ($scope.windowData.scrollDepth > 75 && oldScrollDepth < 75) {
            trackingData.percent = 75;
            trackerSvc.trackEvent('Scroll Depth', trackingData);
          }
          if ($scope.windowData.scrollDepth > 100 && oldScrollDepth < 100) {
            trackingData.percent = 100;
            trackerSvc.trackEvent('Scroll Depth', trackingData);
          }
        }
      }

      $scope.$broadcast('windowScroll', $scope.windowData);
    }
  }

  function locationSearchParams() {
    var search = window.location.search;
    if (!search) {
      return {};
    }
    var params = {};
    search.replace(/^\?/, '').split('&').forEach(function(paramStr) {
      var part = paramStr.split('=');
      params[part[0]] = part[1];
    });
    return params;
  }

  $scope.locationSearchParams = locationSearchParams;

  $scope.showAmbassadorWidget = function() {
    window.ambassadorWidgetFlag = true;
    setTimeout(function() {
      window.ambassadorWidgetFlag = false;
    }, 500);
  };
  window.ambassadorWidgetFlag = false;

  $scope.showAmbassadorOnloadWidget = function() {
    window.ambassadorOnloadFlag = false;
    setTimeout(function() {
      window.ambassadorOnloadFlag = true;
    }, 500);
  };

  if (window.Raygun && !cdata.totalAllTimeOrders == null) {
    Raygun
      .withTags(['ambassador'])
      .send(new Error('Customer has incomplete cdata.'), { email: window.email, cdata: cdata });
  }

  var url = $location.absUrl().split('?')[0].split('/');

  if (window.Raygun && !window.referralCampaign && url.indexOf('refer') > -1) {
    Raygun
      .withTags(['ambassador'])
      .send(new Error('Campaign id is not present on the page.'), { email: window.email, cdata: cdata });
  }

  // Reopening the Ambassador sharing gate to see if we get parity with Extole
  // window.ambassadorOnloadFlag = cdata.totalAllTimeOrders > 0;
  window.ambassadorOnloadFlag = true;
  $scope.ambassadorValid = window.ambassadorValid;
  $scope.referralCampaign = window.referralCampaign;
  $scope.referralCampaignName = window.referralCampaignName;
  $scope.referralCampaignGroup = window.referralCampaignGroup;
}])

window.inventory = window.inventory || {};

window.isMobileDevice = isMobileDevice();
window.createUser = createUser;

var evt = document.createEvent("Event");
evt.initEvent("breakpointUpdate",true,true);

(function( window ) {
  window.currentBreakpoint = null;
  var checkInt = 100;

  window.mobileMin = 320;
  window.tabletMin = 560;
  window.mediumMin = 760;
  window.desktopMin = 960;
  window.desktopMax = 1300;

  window.breakpoints = {};
  window.breakpoints[mobileMin] = 'mobile';
  window.breakpoints[tabletMin] = 'tablet';
  window.breakpoints[mediumMin] = 'medium';
  window.breakpoints[desktopMin] = 'desktop';
  window.breakpoints[desktopMax] = 'max';

  window.watchResize = function(callback) {
    var resizing;

    function done() {
      var currSize = window.innerWidth || document.body.offsetWidth;
      clearTimeout(resizing);
      resizing = null;

      // only run on a true resize
      callback(currSize);
    }

    window.addEventListener('resize', function(e) {
      if (resizing) {
        clearTimeout(resizing);
        resizing = null;
      }
      resizing = setTimeout(done, checkInt);
    });

    // init
    callback();
  };

  // do stuff after breakpoint
  window.watchResize(function(size) {
    if (size < tabletMin && currentBreakpoint != breakpoints[mobileMin]) {
      currentBreakpoint = breakpoints[mobileMin];
      return triggerImgResize();
    }

    if (size >= tabletMin && size < mediumMin && currentBreakpoint != breakpoints[tabletMin]) {
      currentBreakpoint = breakpoints[tabletMin];
      return triggerImgResize();
    }

    if (size >= mediumMin && size < desktopMin && currentBreakpoint != breakpoints[mediumMin]) {
      currentBreakpoint = breakpoints[mediumMin];
      return triggerImgResize();
    }

    if (size >= desktopMin && size < desktopMax && currentBreakpoint != breakpoints[desktopMin]) {
      currentBreakpoint = breakpoints[desktopMin];
      return triggerImgResize();
    }

    if (size >= desktopMax && currentBreakpoint != breakpoints[desktopMax]) {
      currentBreakpoint = breakpoints[desktopMax];
      return triggerImgResize();
    }

  });

  window.triggerImgResize = function() {
    document.dispatchEvent(evt);
  }

}(window));

//- var data = {
//-   api_key: value,
//-   email: value,
//-   list_id: value,
//-   source: value
//- };
function createUser(data) {
  if (!data.api_key && !data.email) {
    return false;
  }

  $.ajax({
    type: "POST",
    url: "/api/customer/createCustomer",
    data: data,
    async: false,
    success:function() {
      return true;
    },
    error: function() {
      return false;
    }
  });
}

function isMobileDevice() {
  var check = false;
  (function(a,b) {if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

// Pluralizes a string
// argument `plural` is optional
// $.pluralize(4, 'car') // 'cars'
// $.pluralize('4', 'goose', 'geese') // 'geese'
$.pluralize = function(num, single, plural) {
  return +num === 1 ? single :
    arguments.length > 2 ? plural :
    single + 's';
};

$.dollar = function(amount, forceNumber) {
  amount = isNaN(amount) ? 0 : +amount;
  if (amount === 0 && !forceNumber) {
    return 'Free';
  } else {
    return ((amount < 0) ? '-' : '') + '$' + Math.abs(amount).toFixed(2);
  }
};

$.isMobile = function() {
  return window.innerWidth <= 568;
};

$.isTablet = function() {
  return !$.isMobile() && window.innerWidth <= 768;
};

// Custom dropdown code.
var dropdownTyping = {
  search: '',
  timeout: null
};
$.fn.customDropdown = function() {
  var realDropdown = this;
  var data = [];
  var selected;
  var customId;

  if (!realDropdown.is('select')) {
    return;
  }

  realDropdown.children('option').each(function() {
    var self = $(this);
    var classAttr = self.attr('class');
    var item = {
      val: self.val(),
      text: self.text(),
      selected: false,
      classes: classAttr ? classAttr : null
    };

    if (!selected) {
      selected = item;
    }

    if (self.is(':selected')) {
      selected = item;
      item.selected = true;
    }
    if (item.val != "?"){
      data.push(item);
    }
  });

  customId = realDropdown.data('custom-id');
  if (customId) {
    $('[data-custom-rel="' + customId + '"]').remove();
    realDropdown.removeClass('hiddenButPresent');
  }

  var cssProps = [
    'vertical-align',
    'float',
    'display'
  ];

  var cont = $('<div/>')
    .addClass('customDropdown')
    .css(realDropdown.css(cssProps))
    .addClass(realDropdown.attr('class'));

  if (cont.css('min-width') === '0px') {
    cont.css('min-width', realDropdown.outerWidth());
  }

  if (realDropdown.is(':disabled')) {
    cont.addClass('disabled');
  }

  realDropdown.addClass('hiddenButPresent');

  customId = new Date().getTime().toString(36);
  realDropdown.data('custom-id', customId);
  // Since this isn't real we have to set it as an attribute and not use data... for reasons?
  cont.attr('data-custom-rel', customId);

  var select = $('<div/>')
    .addClass('select')
    .append(
      $('<div/>').html(selected.text).addClass(selected.classes),
      $('<div/>').addClass('arrow down')
    );

  var options = $('<ul/>').addClass('option');

  $.each(data, function() {
    var opt = $('<li/>')
      .data('val', this.val)
      .html(this.text);

    if (this.selected) {
      opt.addClass('selected');
    }

    if (this.classes) {
      opt.addClass(this.classes);
    }

    options.append(opt);
  });

  select.mousedown(function() {
    select.data("mousedown", true);
  });

  select.mouseup(function() {
    select.data("mousedown", false);
  });

  select.focus(function() {
    if (!select.data("mousedown")) {
      select.click();
    }
  });

  select.on('click', function(e) {
    e.stopPropagation();

    if (realDropdown.is(':disabled')) {
      return;
    }

    if (options.is('.expanded')) {
      contractOptions();
    } else {
      expandOptions();
    }
  });

  realDropdown.change(function() {
    var sel = $(this).children(':selected');

    select
      .children('div:first')
      .html(sel.text());

    options
      .children('li')
      .removeClass('selected');

    options
      .children('li')
      .each(function() {
        var li = $(this);

        if (li.data('val') == sel.val()) {
          li.addClass('selected');
          return false;
        }
      });
    contractOptions();
  });

  cont
    .append(select)
    .append(options);

  realDropdown.after(cont);

  $("#container :input, #container .customDropdown > .select").not('.hide').each(function (i) {
    $(this).attr('tabindex', i + 1);
    if ($(this).is('.select')) {
      $(':input[tabindex="' + (i + 1) + '"]').removeAttr('tabindex');
    }
  });

  function keyPress(e) {
    var current = options.children('li.selected');
    var selected;

    // Special control keys
    switch (e.which) {
      case 27: // Escape
        contractOptions();
        break;

      case 9: // Tab
      case 13: // Return
        triggerOptionSelect();
        contractOptions();
        break;

      case 38: // Up
        selected = current.prev();
        if (selected.length === 0) {
          selected = options.children('li').last();
        }
        break;

      case 40: // Down
        selected = current.next();
        if (selected.length === 0) {
          selected = options.children('li').first();
        }
        break;
    }


    // Detect typing
    if (!selected && e.which >= 48 && e.which <= 90) {
      clearTimeout(dropdownTyping.timeout);
      dropdownTyping.search += String.fromCharCode(e.which);
      dropdownTyping.timeout = setTimeout(clearTextSearch, 600);
      selected = searchOptions();
    }

    if (selected) {
      selectOption(selected);
    }
  }

  function selectOption(elem) {
    elem
      .addClass('selected')
      .siblings()
      .removeClass('selected');

    options.scrollTop(0).scrollTop(elem.position().top);
  }

  function clearTextSearch() {
    clearTimeout(dropdownTyping.timeout);
    dropdownTyping.search = '';
  }

  function searchOptions() {
    var search = new RegExp('^' + dropdownTyping.search, 'i');

    // We'd use filter here if it was supported in more browsers.
    var selected;
    options.children('li').each(function() {
      if (search.test($(this).text())) {
        selected = $(this);
        return false;
      }
    });
    return selected;
  }

  function stopScroll(e) {
    if (e.which == 40 || e.which == 38) {
      e.preventDefault();
      return false;
    }
  }

  function triggerOptionSelect() {
    var selected = options.children('li.selected');
    realDropdown
      .val(selected.data('val'))
      .change();
  }

  function contractOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.off('keydown', keyPress);
    $(window).off('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    $('body').off('click');

    arrow
      .removeClass('up')
      .addClass('down');

    options.removeClass('expanded');
  }

  function expandOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.on('keydown', keyPress);
    $(window).on('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    arrow.addClass('up').removeClass('down');

    options.addClass('expanded');
    $('body').off('click').on('click', function() {
      contractOptions();
    });
    options.children().off('mousedown').on('mousedown', function(e) {
      e.stopPropagation();
      selectOption($(this));
      triggerOptionSelect();
    });
  }

  return cont;
};

// Used to create a callback func that will auto-deal with server errors first
// The following are the ways you can pass arguments:
// (callback)
// (errContainer, callback)
// (errContainer, callback, errCallback)
// (options) -> options.errContainer, options.elementMap, options.callback, options.errCallback
// options.elementMap keys are the input .desc()s, and values are .desc, .input, .handler
!function() {
  var slice = Array.prototype.slice;
  var toString = Object.prototype.toString;
  var noOp = function() {};
  var genericTimout;

  $.dealWithIssues = function() {
    var args = slice.call(arguments);
    var errContainer, callback, errCallback, elementMap;
    var usingGeneric = false;

    if (args.length === 1) {
      if (toString.call(args[0]) === '[object Object]') {
        errContainer = args[0].errContainer;
        callback = args[0].callback;
        errCallback = args[0].errCallback;
        elementMap = args[0].elementMap;
      } else {
        callback = args[0];
      }
    } else {
      errContainer = args[0];
      callback = args[1];
      errCallback = args[2];
    }

    errContainer = errContainer || (usingGeneric = true && '#genericErrors');
    callback = callback || noOp;
    errCallback = errCallback || noOp;
    elementMap = elementMap || {};

    errContainer = $(errContainer);

    return function(res) {
      var keys;
      var list;
      var err = res.err;
      var errRedirect = res.errRedirect;
      var validation = res.validation;
      var count;

      if (!err && errRedirect) {
        return redirect(errRedirect);
      }

      if (!validation) {
        // checking if not successful, but without errors
        if (res.success === 0) {
          if (!err) {
            err = 'An error occurred';
          }
        } else {
          errContainer.addClass('hide');
          callback(res);
          return;
        }
      }

      errContainer = $(errContainer);
      list = $('<ul></ul>');

      if (err) {
        if (!validation) {
          list.append(
            $('<li></li>')
              .addClass('summary')
              .text(err)
          );
        }
      } else if (validation) {
        count = validation instanceof Array ? count.length :
          typeof Object.keys === 'function' ? Object.keys(validation).length :
          $.map(validation, function(value, key) {
            return key;
          }).length;

        list.append(
          $('<li></li>').text(
            $.pluralize(count, '1 error has', keys.length + ' errors have') +
              ' been found. Please correct the ' + $.pluralize(keys.length, 'field') +
              ' below.'
          )
        );
      }

      if (validation) {
        if (validation instanceof Array) {
          $.each(validation, function(key, value) {
            list.append(
              $('<li></li>').text(value)
            );
          });
        } else {
          keys = $.map(validation, function(value, key) {
            return {
              key: key,
              value: value
            };
          });

          $.each(keys, function(index, obj) {
            var input = $('#' + obj.key);
            var desc = input.desc();
            var mapped = elementMap[obj.key];
            var label;

            if (mapped) {
              input = mapped.input || input;
              // allowing mapped inputs of '#someid' instead of $('#someid')
              input = typeof input === 'string' ? $(input) : input,
              desc = mapped.desc ? mapped.desc : input.desc();
            } else if (!desc) {
              desc = obj.key;
            }

            list.append(
              $('<li></li>').text(desc + ' ' + obj.value)
            );

            if (mapped && mapped.handler) {
              mapped.handler();
            } else if (input) {
              input.addClass('incorrect');
            }
          });
        }
      }

      list
        .find('li')
        .first()
        .addClass('first');

      if (usingGeneric) {
        showAlertModal('Oops!', list, [{
          text: 'OK',
          action: errRedirect
        }]);
      } else {
        errContainer.find('ul').empty().append(list.children('li'));
        list = undefined;
        errContainer.removeClass('hide');
        errContainer.fadeIn(520);
      }

      errCallback(res, validation);
    };
  };
}();

function closeEmailList() {
  $.post('/portal/user/emailListSignup', $.dealWithIssues);

  $('#emailList').fadeOut('fast', function() {
    $(this).remove();
  });
}

function showModal(modalElem) {
  var container = $('#container');
  var modalName = modalElem.attr('id');

  if (modalElem.length > 0) {
    if (modalName === 'photo-modal') {
      modalName = modalElem.find('.prod_name').html() + ' photo-modal';
    }

    dataLayer.push({
      'event': 'MRCustom',
      'category': 'modal',
      'action': 'show',
      'label': modalName + ', ' + window.location.pathname
    });

    $('#veil').removeClass('hide');
    $('body').addClass('no-scroll');
    $('.modal').not(modalElem).fadeOut('fast', function() {
      modalElem.fadeIn('fast');
      modalElem.find('input:first').focus();
    });

    if (modalElem.find('input[type="email"]') && modalElem.find('input[type="email"]').val()) {
      modalElem.find('input[type="password"]').focus();
    }

    container.bind('touchmove', function(e){
      e.preventDefault();
    }).addClass('no-scroll').removeClass('nav-open');
  }
}

function showAlertModal(header, content, buttons) {
  var defaultButton = {
    text: 'OK',
    action: null,
    className: ''
  };

  if (!buttons || buttons.length === 0) {
    buttons = [defaultButton];
  }

  var alertModal = $('#pseudo_alert');
  alertModal.find('.header').html(header);
  alertModal.find('.text').html(content);

  var buttonArea = alertModal.find('.buttons');
  buttonArea.empty();

  $.each(buttons, function(index, button) {
    var text = button.text || defaultButton.text;
    var className = button.className || defaultButton.className;
    var action = button.action || defaultButton.action;

    var btn = $('<a/>');
    btn.text(text);
    btn.addClass('button');
    btn.addClass(className);
    btn.attr('href', '');
    btn.on('click', function(e) {
      e.preventDefault();
      if (!action) {
        hideModal();
      } else {
        if (typeof action === 'function') {
          hideModal();
          action();
        } else {
          redirect(action);
        }
      }
    });
    buttonArea.append(btn);
  });

  showModal(alertModal);
}

function hideModal() {
  $('.modal').fadeOut('fast', function() {
    $('#veil').addClass('hide');
    $('body').removeClass('no-scroll');
    $('#youtube_modal_iframe').removeAttr('src');
    $(document).unbind('keyup');
    $('#container').unbind('touchmove').removeClass('no-scroll');
  });
}

function photoModal(id){
  var prod;

  if (inventory[id]) {
    prod = inventory[id];
    photoModalContent(prod);
    return;
  }

  $.get('/portal/photo-modal/getProductInfo', {
    prod_id: id
  }, $.dealWithIssues(function(data) {
    var info = data.info;
    inventory[info.id] = info;
    photoModalContent(info);
  }));
}

function photoModalContent(data) {
  var modal = $('#photo-modal');
  var stars = '';
  var i, l;
  var hearts, filled, percent;

  modal.find('.prod_img').attr('src', data.images.pdp);
  modal.find('.prod_name').text(data.name);
  modal.find('.prod_desc').text(data.desc.short);
  modal.find('.button').attr('href', '/product/' + data.url_key);

  $('.similar-products').empty();
  $(modal).find('.rating').empty();

  for (i = 0; i < 5; i++) {
    filled = Math.floor(data.avgReview);
    percent = Math.ceil((data.avgReview - filled) * 100);

    if (i < filled) {
      stars += '<div class="star"><div class="filled"></div></div>';
    } else {
      if (percent > 0 && i === Math.floor(data.avgReview)){
        stars += '<div class="star"><div class="filled", style="width:' + percent + '%"></div></div>';
      } else {
        stars += '<div class="star"></div>';
      }
    }
  }
  $(modal).find('.rating').append(stars);

  for (i = 0, l = data.similarImages.length; i < l; i++) {
    if (!!~data.userLikes.indexOf(data.similarImages[i].id)) {
      hearts = '<ins class="filled"></ins>';
    } else {
      hearts = '<ins></ins>';
    }

    $('<div class="product"><img src="' + MR.config.s3_host + '/' + data.similarImages[i].image + '"><span><a class="like" rel="' + data.similarImages[i].id +  '", href="">' + hearts + '<p>' + data.similarImages[i].count + '</p></span></div>').appendTo('.similar-products');
  }

  $('.product .like')
    .off('click')
    .on('click', function(e) {
      e.preventDefault();

      var self = $(this);
      var photo_id = self.attr('rel');
      var count;

      if (self.find('ins').is('.filled')) {
        return;
      }

      delete inventory[data.id];

      self.find('ins').addClass('filled');
      count = $(self).find('p').text();
      self.find('p').text(+count + 1);

      $.post('/portal/photo-modal/likePhoto', {
        prod_id: data.id,
        photo_id: photo_id,
      });
    });

  showModal(modal);
}

function scrollToElem(elem, speed, offset) {
  if (elem.length === 0) {
    return;
  }

  speed = speed || 2000;
  offset = offset || 0;

  $('html, body').animate({
    scrollTop: elem.offset().top + offset
  }, speed);
}

function redirect(location, carry) {
  if (arguments.length > 1) {
    var cookieStr = 'carriedFromRedirect=' + JSON.stringify(carry) + '; ';
    cookieStr += 'path=/;';
    document.cookie = cookieStr;
  }

  window.location = location;
}

function mod10Check(num) {
  var parts = ('' + num).replace(/\D/g, '').split('').reverse();

  var sum = 0;
  for (var i = 0; i < parts.length; i++) {
    var part = +parts[i];
    if (i % 2) {
      part = (+part) * 2;
      if (part > 9) {
        part = 1 + (part % 10);
      }
    }
    sum += part;
  }

  return sum % 10 === 0;
}

var ccTypes = {
  visa: {
    regex: /^4/,
    cvc: 3,
    cvcMask: '000',
    size: 16,
    formSize: 19,
    mask: '0000 0000 0000 0000'
  },
  mc: {
    regex: /^5[1-5]/,
    cvc: 3,
    cvcMask: '000',
    size: 16,
    formSize: 19,
    mask: '0000 0000 0000 0000'
  },
  amex: {
    regex: /^3[47]/,
    cvc: 4,
    cvcMask: '0000',
    size: 15,
    formSize: 18,
    mask: '0000 000000 00000'
  },
  discover: {
    regex: /^6(?:011|5)/,
    cvc: 3,
    cvcMask: '000',
    size: 16,
    formSize: 19,
    mask: '0000 0000 0000 0000'
  },
  default: {
    regex: /^[0-9]/,
    cvc: 3,
    cvcMask: '000',
    size: 16,
    formSize: 19,
    mask: '0000 0000 0000 0000'
  }
};

!function() {
  var msie = /MSIE ([0-9]{1,}[\.0-9]{0,})/;

  window.getInternetExplorerVersion = function() {
    var resp = -1; // Return value assumes failure.

    if (navigator.appName === 'Microsoft Internet Explorer') {
      if (msie.exec(navigator.userAgent) != null) {
        resp = +(RegExp.$1);
      }
    }

    return resp;
  };
}();

// Add format method to Date objects
!function(){
  /*
  * Date Format 1.2.3
  * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
  * MIT license
  *
  * Includes enhancements by Scott Trenda <scott.trenda.net>
  * and Kris Kowal <cixar.com/~kris.kowal/>
  *
  * Accepts a date, a mask, or a date and a mask.
  * Returns a formatted version of the given date.
  * The date defaults to the current date/time.
  * The mask defaults to dateFormat.masks.default.
  */

  // if some future version of javascript has this method, don't do anything.
  if (Date.prototype.format) {
    return;
  }
  var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(L > 99 ? Math.round(L / 10) : L),
          t:    H < 12 ? "a"  : "p",
          tt:   H < 12 ? "am" : "pm",
          T:    H < 12 ? "A"  : "P",
          TT:   H < 12 ? "AM" : "PM",
          Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
  };
}();

$(function() {
  var emailList = $('#emailList');

  if ($('#photo-modal').length > 0) {
    new iScroll('photo-scroll', {
      hideScrollbar: true,
      momentum: true
    });
  }

  // Any custom dropdowns, make 'em custom here
  $('select[data-custom]').each(function() {
    $(this).customDropdown();
  });

  // unmunge all anchors
  var mungedExpression = /\s*\{\{\s*(\w+)\s*\}\}\s*/g;
  $('.mungedEmail').each(function(i, a) {
    a = $(a);

    var href = a.attr('href');

    href = href.replace(mungedExpression, function(full, kind) {
      kind = kind.toLowerCase();

      return kind === 'colon' ? ':' :
        kind === 'at' ? '@' :
        kind === 'dot' ? '.' :
        kind === 'dash' ? '-' :
        '';
    });

    a.attr('href', href);
  });

  emailList[ MR.emailListRegistered === 1 ? 'remove' : 'show' ]();

  $('#emailList .close').on('click', function(e) {
    e.preventDefault();
    closeEmailList();
  });

  $('#emailList .button').on('click', function(e) {
    e.preventDefault();
    $.post('/portal/green/signup', {
      email: $('#emailList input[type="text"]:visible').val()
    }, $.dealWithIssues(function(res) {

      // Track signup in Google Analytics
      dataLayer.push({
        'event': 'MRCustom',
        'category': 'join newsletter',
        'action': 'click',
        'label': 'Email Signup in ' + window.location.pathname
      });

      emailList.children().fadeOut('fast', function() {
        var text = $('<p style="display: none">Thanks for registering your email address!</p>');
        emailList.append(text);
        $('#emailList p').fadeIn('fast');
      });

      setTimeout(function() {
        closeEmailList();
      }, 5000);
    }));
  });

  $('.dropdownWrapper').on('click', function(e) {
    $(this).toggleClass('active');
    e.stopPropagation();
  });

  $('.showYoutubeModal').on('click', function() {
    var modal = $('#youtube_modal');
    $('#youtube_modal_iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).attr('rel') + '?autoplay=1&wmode=transparent');
    showModal(modal);
  });

  $('.showYoutubeFullscreen').first().on('click', function() {
    var self = $(this);
    var frame = self.attr('rev');
    var method = self.find('img').attr('rev');

    if (frame) {
      frame = $(frame);
    } else {
      frame = $('#youtube-fullscreen-iframe').appendTo('body'); // make sure it's absolute to body
    }

    frame
      .attr('src', 'https://www.youtube.com/embed/' + $(this).attr('rel') + '?autoplay=1&wmode=transparent')
      .removeClass('hide');

    if (method && window[method]) {
      window[method]();
    }
  });

  // Modal binds
  $('[showModal]').on('click', function(e) {
    e.preventDefault();

    var modalId = $(this).attr('showModal');
    showModal($(modalId));
  });

  $('[photoModal]').on('click', function(e) {
    e.preventDefault();
    var id = $(this).attr('photoModal');
    photoModal(id);
  });

  $('.modal .close').on('click', function(e) {
    e.preventDefault();
    if ($(this).attr('href').length) {
      redirect($(this).attr('href'));
    } else {
      hideModal();
    }
  });

  $('.newTabCloseModal').click(function() {
    hideModal();
  })

  // Global binds
  $('input,select').change(function() {
    $(this).removeClass('incorrect');
    var name = $(this).attr('name');
    $('[name="'+name+'"]').removeClass('incorrect');
  });

  $('[enter]').keyup(function(e) {
    var self = $(this);
    var nope, method;

    if (e.which == 13) {
      nope = $.data(self, 'no[enter]');

      if (nope === true) {
        return;
      }

      // preventing another enter for 100ms
      $.data(self, 'no[enter]', true);
      setTimeout(function() {
        $.data(self, 'no[enter]', false);
      }, 100);

      method = self.attr('enter').split('|');

      if (method.length == 1) {
        window[ method[0] ](self);
      } else {
        $(method[0]).trigger(method[1]);
      }
    }
  });

  $('i.info').hover(function() {
    var self = $(this);
    var popover = self.siblings('.popover');
    var arrow = popover.children('.arrow');
    popover.css({
      top: -(popover.height())
    });
    arrow.css({
      left: self.position().left + self.width()
    });
    popover.fadeIn('fast');
  }, function() {
    $(this).siblings('.popover').fadeOut('fast');
  });

  $('.supportToggle, .close-support').on('click', function(e) {
    e.preventDefault();
    var container = $('#container');
    if (container.is(e.target)) {
      return;
    }

    if ($('.fixedBottom .support').is('.expanded')) {
      $('.fixedBottom .support').removeClass('expanded');
    } else {
      $('.fixedBottom .support').addClass('expanded');
    }
  });

  $('.backLink').on('click', function(e) {
    e.preventDefault();
    window.history.back();
  });

  var hideLoaderTimeout;
  var showLoaderTimeout;
  var redirecting = false;
  var loaderBG = $('#ajaxLoaderBG');
  var loaderContent = $('#ajaxLoaderContent');

  $('.scrollToTop .back2top').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 500, 'swing');
  });

  (function($) {
  // $(':radio').checkboxVal();
  // returns the selected radio value, or null
  $.fn.radioVal = function() {
    var name = this.attr('name');
    if (name !== undefined) {
      var selected = $('[name="'+name+'"]:checked');
      return selected.length ? selected.val() : null;
    }
    return null;
  };

  // $('[name]').mixedVal();
  // returns the value of an input
  // boolean if checkedbox
  // selected value of a radio button (or null)
  $.fn.mixedVal = function() {
    return this.is(':radio') ? this.radioVal() :
      this.is(':checkbox') ? this.is(':checked') :
      this.val();
  };

  $.fn.desc = function () {
    var desc = this.attr('desc');
    var name;
    var label;

    if (desc) {
      return desc;
    }

    name = this.attr('name');

    // if no desc found, try to find a label
    if (name && (label = $('label[for="' + name + '"]'))) {
      return label.text();
    }

    return name;
  };

}(jQuery));


});
